var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtoilesBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1529,
    viewBox: "0 0 1440 1529",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1250.59 1214.79C1251.86 1214.79 1251.86 1212.97 1250.59 1212.97C1249.33 1212.97 1249.32 1214.79 1250.59 1214.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1225.49 1260.86C1226.75 1260.86 1226.75 1259.04 1225.49 1259.04C1224.22 1259.04 1224.22 1260.86 1225.49 1260.86Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.86 1192.92C1315.13 1192.92 1315.13 1191.1 1313.86 1191.1C1312.6 1191.1 1312.59 1192.92 1313.86 1192.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1224.56 1178.26C1225.33 1178.26 1225.33 1177.16 1224.56 1177.16C1223.8 1177.16 1223.8 1178.26 1224.56 1178.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1226.86 1072.37C1227.62 1072.37 1227.62 1071.28 1226.86 1071.28C1226.1 1071.28 1226.09 1072.37 1226.86 1072.37Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1319.77 1115.44C1320.53 1115.44 1320.54 1114.34 1319.77 1114.34C1319.01 1114.34 1319.01 1115.44 1319.77 1115.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1281.69 986.958C1282.45 986.958 1282.45 985.859 1281.69 985.859C1280.93 985.859 1280.92 986.958 1281.69 986.958Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1266.46 908.6C1267.22 908.6 1267.22 907.502 1266.46 907.502C1265.69 907.502 1265.69 908.6 1266.46 908.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1235.65 890.721C1235.39 890.485 1235.14 890.25 1234.88 890.016C1234.34 889.514 1233.51 890.291 1234.05 890.792C1234.3 891.028 1234.55 891.263 1234.81 891.498C1235.35 891.999 1236.19 891.222 1235.65 890.721Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1267.98 1114.02C1268.74 1114.02 1268.74 1112.93 1267.98 1112.93C1267.22 1112.93 1267.21 1114.02 1267.98 1114.02Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1293.88 1043.98C1295.4 1043.98 1295.4 1041.78 1293.88 1041.78C1292.35 1041.78 1292.35 1043.98 1293.88 1043.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1240.56 1003.74C1242.08 1003.74 1242.09 1001.54 1240.56 1001.54C1239.03 1001.54 1239.03 1003.74 1240.56 1003.74Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1261.89 1144.22C1263.41 1144.22 1263.41 1142.02 1261.89 1142.02C1260.36 1142.02 1260.36 1144.22 1261.89 1144.22Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1319.77 1166.1C1321.3 1166.1 1321.3 1163.91 1319.77 1163.91C1318.25 1163.91 1318.24 1166.1 1319.77 1166.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.16 967.038C1313.68 967.038 1313.68 964.84 1312.16 964.84C1310.63 964.84 1310.63 967.038 1312.16 967.038Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245.13 945.858C1246.65 945.858 1246.66 943.66 1245.13 943.66C1243.6 943.66 1243.6 945.858 1245.13 945.858Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1408.24 1217.12C1409.51 1217.12 1409.51 1215.29 1408.24 1215.29C1406.98 1215.29 1406.97 1217.12 1408.24 1217.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1427.32 1221.3C1428.59 1221.3 1428.59 1219.48 1427.32 1219.48C1426.05 1219.48 1426.05 1221.3 1427.32 1221.3Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1423.81 1230.14C1425.07 1230.14 1425.07 1228.32 1423.81 1228.32C1422.54 1228.32 1422.54 1230.14 1423.81 1230.14Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1357.53 1197.11C1358.8 1197.11 1358.8 1195.29 1357.53 1195.29C1356.27 1195.29 1356.26 1197.11 1357.53 1197.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1391.17 1414.88C1392.44 1414.88 1392.44 1413.06 1391.17 1413.06C1389.91 1413.06 1389.9 1414.88 1391.17 1414.88Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1362.55 1449.78C1362.72 1449.78 1362.89 1449.78 1363.05 1449.78C1363.57 1449.78 1364.06 1449.36 1364.04 1448.87C1364.01 1448.37 1363.61 1447.96 1363.05 1447.96C1362.89 1447.96 1362.72 1447.96 1362.55 1447.96C1362.04 1447.96 1361.55 1448.38 1361.57 1448.87C1361.59 1449.36 1362 1449.78 1362.55 1449.78Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1403.22 1454.43C1404.49 1454.43 1404.49 1452.61 1403.22 1452.61C1401.96 1452.61 1401.95 1454.43 1403.22 1454.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1420.79 1399.99C1422.06 1399.99 1422.06 1398.17 1420.79 1398.17C1419.53 1398.17 1419.53 1399.99 1420.79 1399.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1422.8 1417.67C1424.07 1417.67 1424.07 1415.85 1422.8 1415.85C1421.54 1415.85 1421.53 1417.67 1422.8 1417.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1414.27 1319.95C1415.53 1319.95 1415.53 1318.13 1414.27 1318.13C1413 1318.13 1413 1319.95 1414.27 1319.95Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1383.64 1246.9C1384.9 1246.9 1384.91 1245.07 1383.64 1245.07C1382.37 1245.07 1382.37 1246.9 1383.64 1246.9Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1339.46 1275.75C1340.72 1275.75 1340.72 1273.92 1339.46 1273.92C1338.19 1273.92 1338.19 1275.75 1339.46 1275.75Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1371.09 1364.16C1372.35 1364.16 1372.36 1362.34 1371.09 1362.34C1369.82 1362.34 1369.82 1364.16 1371.09 1364.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1358.85 1226.89C1359.03 1227.06 1359.2 1227.22 1359.38 1227.39C1359.92 1227.89 1360.76 1227.11 1360.22 1226.61C1360.04 1226.44 1359.86 1226.28 1359.69 1226.12C1359.15 1225.62 1358.31 1226.39 1358.85 1226.89Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1388.48 1296.47C1389.24 1296.47 1389.25 1295.37 1388.48 1295.37C1387.72 1295.37 1387.72 1296.47 1388.48 1296.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1428.85 1440.22C1429.61 1440.22 1429.61 1439.12 1428.85 1439.12C1428.09 1439.12 1428.09 1440.22 1428.85 1440.22Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1411.17 1042.73C1411.93 1042.73 1411.94 1041.63 1411.17 1041.63C1410.41 1041.63 1410.41 1042.73 1411.17 1042.73Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1371.57 974.957C1372.33 974.957 1372.33 973.857 1371.57 973.857C1370.8 973.857 1370.8 974.957 1371.57 974.957Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1354.51 1072.76C1354 1073 1353.49 1073.23 1352.99 1073.47C1352.3 1073.79 1352.9 1074.73 1353.58 1074.42C1354.09 1074.18 1354.6 1073.95 1355.11 1073.71C1355.79 1073.4 1355.19 1072.45 1354.51 1072.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1338.81 1016.61C1339.58 1016.61 1339.58 1015.51 1338.81 1015.51C1338.05 1015.51 1338.05 1016.61 1338.81 1016.61Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1358.62 1151.99C1360.14 1151.99 1360.15 1149.79 1358.62 1149.79C1357.09 1149.79 1357.09 1151.99 1358.62 1151.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1330.44 1229.64C1331.96 1229.64 1331.96 1227.44 1330.44 1227.44C1328.91 1227.44 1328.91 1229.64 1330.44 1229.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1410.41 1175.99C1411.94 1175.99 1411.94 1173.79 1410.41 1173.79C1408.88 1173.79 1408.88 1175.99 1410.41 1175.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1417.27 1089.87C1418.79 1089.87 1418.79 1087.67 1417.27 1087.67C1415.74 1087.67 1415.74 1089.87 1417.27 1089.87Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1367.76 1029.16C1369.28 1029.16 1369.29 1026.96 1367.76 1026.96C1366.23 1026.96 1366.23 1029.16 1367.76 1029.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1392.89 1137.16C1394.42 1137.16 1394.42 1134.96 1392.89 1134.96C1391.37 1134.96 1391.36 1137.16 1392.89 1137.16Z",
    fill: "#FFFFFE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M889.589 1214.79C890.859 1214.79 890.859 1212.97 889.589 1212.97C888.329 1212.97 888.319 1214.79 889.589 1214.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M864.492 1260.86C865.752 1260.86 865.752 1259.04 864.492 1259.04C863.222 1259.04 863.222 1260.86 864.492 1260.86Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M952.855 1192.92C954.125 1192.92 954.125 1191.1 952.855 1191.1C951.595 1191.1 951.585 1192.92 952.855 1192.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M863.562 1178.26C864.332 1178.26 864.332 1177.16 863.562 1177.16C862.802 1177.16 862.802 1178.26 863.562 1178.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865.855 1072.37C866.615 1072.37 866.615 1071.28 865.855 1071.28C865.095 1071.28 865.085 1072.37 865.855 1072.37Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M958.773 1115.44C959.533 1115.44 959.543 1114.34 958.773 1114.34C958.013 1114.34 958.013 1115.44 958.773 1115.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M920.691 986.958C921.451 986.958 921.451 985.859 920.691 985.859C919.931 985.859 919.921 986.958 920.691 986.958Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M905.46 908.6C906.22 908.6 906.22 907.502 905.46 907.502C904.69 907.502 904.69 908.6 905.46 908.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M874.65 890.721C874.39 890.485 874.14 890.25 873.88 890.016C873.34 889.514 872.51 890.291 873.05 890.792C873.3 891.028 873.55 891.263 873.81 891.498C874.35 891.999 875.19 891.222 874.65 890.721Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M906.98 1114.02C907.74 1114.02 907.74 1112.93 906.98 1112.93C906.22 1112.93 906.21 1114.02 906.98 1114.02Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M932.882 1043.98C934.402 1043.98 934.402 1041.78 932.882 1041.78C931.352 1041.78 931.352 1043.98 932.882 1043.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879.562 1003.74C881.082 1003.74 881.092 1001.54 879.562 1001.54C878.032 1001.54 878.032 1003.74 879.562 1003.74Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M900.89 1144.22C902.41 1144.22 902.41 1142.02 900.89 1142.02C899.36 1142.02 899.36 1144.22 900.89 1144.22Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M958.773 1166.1C960.303 1166.1 960.303 1163.91 958.773 1163.91C957.253 1163.91 957.243 1166.1 958.773 1166.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M951.163 967.038C952.683 967.038 952.683 964.84 951.163 964.84C949.633 964.84 949.633 967.038 951.163 967.038Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.132 945.858C885.652 945.858 885.662 943.66 884.132 943.66C882.602 943.66 882.602 945.858 884.132 945.858Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1047.24 1217.12C1048.51 1217.12 1048.51 1215.29 1047.24 1215.29C1045.98 1215.29 1045.97 1217.12 1047.24 1217.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1066.32 1221.3C1067.59 1221.3 1067.59 1219.48 1066.32 1219.48C1065.05 1219.48 1065.05 1221.3 1066.32 1221.3Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1062.81 1230.14C1064.07 1230.14 1064.07 1228.32 1062.81 1228.32C1061.54 1228.32 1061.54 1230.14 1062.81 1230.14Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1089.92 1290.17C1091.18 1290.17 1091.18 1288.35 1089.92 1288.35C1088.65 1288.35 1088.65 1290.17 1089.92 1290.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1106.99 1330.66C1108.25 1330.66 1108.26 1328.83 1106.99 1328.83C1105.72 1328.83 1105.72 1330.66 1106.99 1330.66Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1102.47 1267.84C1103.73 1267.84 1103.74 1266.02 1102.47 1266.02C1101.2 1266.02 1101.2 1267.84 1102.47 1267.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.535 1197.11C997.805 1197.11 997.805 1195.29 996.535 1195.29C995.275 1195.29 995.265 1197.11 996.535 1197.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1089.92 1362.76C1091.18 1362.76 1091.18 1360.94 1089.92 1360.94C1088.65 1360.94 1088.65 1362.76 1089.92 1362.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1030.17 1414.88C1031.44 1414.88 1031.44 1413.06 1030.17 1413.06C1028.91 1413.06 1028.9 1414.88 1030.17 1414.88Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1001.55 1449.78C1001.72 1449.78 1001.89 1449.78 1002.05 1449.78C1002.57 1449.78 1003.06 1449.36 1003.04 1448.87C1003.01 1448.37 1002.61 1447.96 1002.05 1447.96C1001.89 1447.96 1001.72 1447.96 1001.55 1447.96C1001.04 1447.96 1000.55 1448.38 1000.57 1448.87C1000.59 1449.36 1001 1449.78 1001.55 1449.78Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1042.22 1454.43C1043.49 1454.43 1043.49 1452.61 1042.22 1452.61C1040.96 1452.61 1040.95 1454.43 1042.22 1454.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1093.93 1412.09C1095.2 1412.09 1095.2 1410.27 1093.93 1410.27C1092.67 1410.27 1092.67 1412.09 1093.93 1412.09Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1059.79 1399.99C1061.06 1399.99 1061.06 1398.17 1059.79 1398.17C1058.53 1398.17 1058.53 1399.99 1059.79 1399.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.8 1417.67C1063.07 1417.67 1063.07 1415.85 1061.8 1415.85C1060.54 1415.85 1060.53 1417.67 1061.8 1417.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1115.52 1351.13C1116.79 1351.13 1116.79 1349.31 1115.52 1349.31C1114.26 1349.31 1114.26 1351.13 1115.52 1351.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1053.27 1319.95C1054.53 1319.95 1054.53 1318.13 1053.27 1318.13C1052 1318.13 1052 1319.95 1053.27 1319.95Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1022.64 1246.9C1023.9 1246.9 1023.91 1245.07 1022.64 1245.07C1021.37 1245.07 1021.37 1246.9 1022.64 1246.9Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.46 1275.75C979.72 1275.75 979.72 1273.92 978.46 1273.92C977.19 1273.92 977.19 1275.75 978.46 1275.75Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1010.09 1364.16C1011.35 1364.16 1011.36 1362.34 1010.09 1362.34C1008.82 1362.34 1008.82 1364.16 1010.09 1364.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1182.58 1307.79C1183.34 1307.79 1183.35 1306.69 1182.58 1306.69C1181.82 1306.69 1181.82 1307.79 1182.58 1307.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1166.11 1341.76C1166.88 1341.76 1166.88 1340.66 1166.11 1340.66C1165.35 1340.66 1165.35 1341.76 1166.11 1341.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1209.67 1359.97C1210.43 1359.97 1210.43 1358.87 1209.67 1358.87C1208.91 1358.87 1208.91 1359.97 1209.67 1359.97Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1174.08 1397.88C1174.85 1397.88 1174.85 1396.78 1174.08 1396.78C1173.32 1396.78 1173.32 1397.88 1174.08 1397.88Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1125.22 1411.17C1125.98 1411.17 1125.98 1410.07 1125.22 1410.07C1124.45 1410.07 1124.45 1411.17 1125.22 1411.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1156.55 1370.31C1157.32 1370.31 1157.32 1369.21 1156.55 1369.21C1155.79 1369.21 1155.79 1370.31 1156.55 1370.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1152.84 1277.27C1153.6 1277.27 1153.6 1276.17 1152.84 1276.17C1152.07 1276.17 1152.07 1277.27 1152.84 1277.27Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1196.39 1215.24C1197.15 1215.24 1197.16 1214.14 1196.39 1214.14C1195.63 1214.14 1195.63 1215.24 1196.39 1215.24Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1119.9 1202.44C1120.08 1202.44 1120.26 1202.44 1120.43 1202.44C1121.2 1202.44 1121.2 1201.34 1120.43 1201.34C1120.26 1201.34 1120.08 1201.34 1119.9 1201.34C1119.14 1201.34 1119.14 1202.44 1119.9 1202.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M997.854 1226.89C998.034 1227.06 998.204 1227.22 998.384 1227.39C998.924 1227.89 999.764 1227.11 999.224 1226.61C999.044 1226.44 998.864 1226.28 998.694 1226.12C998.154 1225.62 997.314 1226.39 997.854 1226.89Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1027.48 1296.47C1028.24 1296.47 1028.25 1295.37 1027.48 1295.37C1026.72 1295.37 1026.72 1296.47 1027.48 1296.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1161.87 1423.48C1162.63 1423.48 1162.63 1422.38 1161.87 1422.38C1161.1 1422.38 1161.1 1423.48 1161.87 1423.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1205.42 1434.8C1206.18 1434.8 1206.19 1433.7 1205.42 1433.7C1204.66 1433.7 1204.66 1434.8 1205.42 1434.8Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1104.5 1447.11C1105.26 1447.11 1105.26 1446.01 1104.5 1446.01C1103.74 1446.01 1103.74 1447.11 1104.5 1447.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1067.85 1440.22C1068.61 1440.22 1068.61 1439.12 1067.85 1439.12C1067.09 1439.12 1067.09 1440.22 1067.85 1440.22Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1161.87 1442.68C1162.63 1442.68 1162.63 1441.58 1161.87 1441.58C1161.1 1441.58 1161.1 1442.68 1161.87 1442.68Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1082.92 1152.14C1083.69 1152.14 1083.69 1151.04 1082.92 1151.04C1082.16 1151.04 1082.16 1152.14 1082.92 1152.14Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1183.46 1145.79C1184.23 1145.79 1184.23 1144.69 1183.46 1144.69C1182.7 1144.69 1182.7 1145.79 1183.46 1145.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1050.17 1042.73C1050.93 1042.73 1050.94 1041.63 1050.17 1041.63C1049.41 1041.63 1049.41 1042.73 1050.17 1042.73Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1114.91 1058.96C1115.68 1058.96 1115.68 1057.86 1114.91 1057.86C1114.15 1057.86 1114.15 1058.96 1114.91 1058.96Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1186.51 1058.96C1187.27 1058.96 1187.27 1057.86 1186.51 1057.86C1185.75 1057.86 1185.75 1058.96 1186.51 1058.96Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1010.57 974.957C1011.33 974.957 1011.33 973.857 1010.57 973.857C1009.8 973.857 1009.8 974.957 1010.57 974.957Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M993.513 1072.76C993.003 1073 992.493 1073.23 991.993 1073.47C991.303 1073.79 991.903 1074.73 992.583 1074.42C993.093 1074.18 993.603 1073.95 994.113 1073.71C994.793 1073.4 994.193 1072.45 993.513 1072.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M977.812 1016.61C978.582 1016.61 978.582 1015.51 977.812 1015.51C977.052 1015.51 977.052 1016.61 977.812 1016.61Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1133.96 1115.44C1134.72 1115.44 1134.72 1114.34 1133.96 1114.34C1133.19 1114.34 1133.19 1115.44 1133.96 1115.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1181.18 1266.5C1181.94 1266.5 1181.94 1265.4 1181.18 1265.4C1180.42 1265.4 1180.41 1266.5 1181.18 1266.5Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1107.3 1185.17C1108.82 1185.17 1108.83 1182.97 1107.3 1182.97C1105.77 1182.97 1105.77 1185.17 1107.3 1185.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M997.624 1151.99C999.144 1151.99 999.154 1149.79 997.624 1149.79C996.094 1149.79 996.094 1151.99 997.624 1151.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M969.444 1229.64C970.964 1229.64 970.964 1227.44 969.444 1227.44C967.914 1227.44 967.914 1229.64 969.444 1229.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1188.03 1332.7C1189.56 1332.7 1189.56 1330.51 1188.03 1330.51C1186.51 1330.51 1186.51 1332.7 1188.03 1332.7Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1210.88 1404C1212.41 1404 1212.41 1401.8 1210.88 1401.8C1209.36 1401.8 1209.36 1404 1210.88 1404Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.27 1446.36C1188.8 1446.36 1188.8 1444.16 1187.27 1444.16C1185.75 1444.16 1185.74 1446.36 1187.27 1446.36Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1151.47 1225.4C1153 1225.4 1153 1223.21 1151.47 1223.21C1149.95 1223.21 1149.94 1225.4 1151.47 1225.4Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1049.41 1175.99C1050.94 1175.99 1050.94 1173.79 1049.41 1173.79C1047.88 1173.79 1047.88 1175.99 1049.41 1175.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1056.27 1089.87C1057.79 1089.87 1057.79 1087.67 1056.27 1087.67C1054.74 1087.67 1054.74 1089.87 1056.27 1089.87Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1006.76 1029.16C1008.28 1029.16 1008.29 1026.96 1006.76 1026.96C1005.23 1026.96 1005.23 1029.16 1006.76 1029.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1031.89 1137.16C1033.42 1137.16 1033.42 1134.96 1031.89 1134.96C1030.37 1134.96 1030.36 1137.16 1031.89 1137.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1133.19 1148.46C1134.72 1148.46 1134.72 1146.26 1133.19 1146.26C1131.67 1146.26 1131.67 1148.46 1133.19 1148.46Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1193.7 1082.41C1193.7 1083.12 1193.7 1083.82 1193.7 1084.53C1193.7 1085.94 1196.07 1085.95 1196.07 1084.53C1196.07 1083.82 1196.07 1083.12 1196.07 1082.41C1196.07 1081 1193.7 1081 1193.7 1082.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1081.14 1013.79C1081.39 1014.26 1081.65 1014.73 1081.9 1015.2C1082.58 1016.46 1084.63 1015.35 1083.95 1014.09C1083.69 1013.62 1083.44 1013.15 1083.19 1012.68C1082.5 1011.41 1080.46 1012.53 1081.14 1013.79Z",
    fill: "#FFFFFE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.597 1214.79C529.867 1214.79 529.867 1212.97 528.597 1212.97C527.337 1212.97 527.327 1214.79 528.597 1214.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.499 1260.86C504.759 1260.86 504.759 1259.04 503.499 1259.04C502.229 1259.04 502.229 1260.86 503.499 1260.86Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.863 1192.92C593.133 1192.92 593.133 1191.1 591.863 1191.1C590.603 1191.1 590.593 1192.92 591.863 1192.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.57 1178.26C503.34 1178.26 503.34 1177.16 502.57 1177.16C501.81 1177.16 501.81 1178.26 502.57 1178.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.863 1072.37C505.623 1072.37 505.623 1071.28 504.863 1071.28C504.103 1071.28 504.093 1072.37 504.863 1072.37Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.781 1115.44C598.541 1115.44 598.551 1114.34 597.781 1114.34C597.021 1114.34 597.021 1115.44 597.781 1115.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.699 986.958C560.459 986.958 560.459 985.859 559.699 985.859C558.939 985.859 558.929 986.958 559.699 986.958Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.468 908.6C545.228 908.6 545.228 907.502 544.468 907.502C543.698 907.502 543.698 908.6 544.468 908.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.658 890.721C513.398 890.485 513.148 890.25 512.888 890.016C512.348 889.514 511.518 890.291 512.058 890.792C512.308 891.028 512.558 891.263 512.818 891.498C513.358 891.999 514.198 891.222 513.658 890.721Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545.988 1114.02C546.748 1114.02 546.748 1112.93 545.988 1112.93C545.228 1112.93 545.218 1114.02 545.988 1114.02Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.89 1043.98C573.41 1043.98 573.41 1041.78 571.89 1041.78C570.36 1041.78 570.36 1043.98 571.89 1043.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.569 1003.74C520.089 1003.74 520.099 1001.54 518.569 1001.54C517.039 1001.54 517.039 1003.74 518.569 1003.74Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.898 1144.22C541.418 1144.22 541.418 1142.02 539.898 1142.02C538.368 1142.02 538.368 1144.22 539.898 1144.22Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.78 1166.1C599.31 1166.1 599.31 1163.91 597.78 1163.91C596.26 1163.91 596.25 1166.1 597.78 1166.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.171 967.038C591.691 967.038 591.691 964.84 590.171 964.84C588.641 964.84 588.641 967.038 590.171 967.038Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.14 945.858C524.66 945.858 524.67 943.66 523.14 943.66C521.61 943.66 521.61 945.858 523.14 945.858Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.25 1217.12C687.52 1217.12 687.52 1215.29 686.25 1215.29C684.99 1215.29 684.98 1217.12 686.25 1217.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M705.327 1221.3C706.597 1221.3 706.597 1219.48 705.327 1219.48C704.058 1219.48 704.058 1221.3 705.327 1221.3Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M701.82 1230.14C703.08 1230.14 703.08 1228.32 701.82 1228.32C700.55 1228.32 700.55 1230.14 701.82 1230.14Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M728.929 1290.17C730.189 1290.17 730.189 1288.35 728.929 1288.35C727.659 1288.35 727.659 1290.17 728.929 1290.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M745.999 1330.66C747.259 1330.66 747.269 1328.83 745.999 1328.83C744.729 1328.83 744.729 1330.66 745.999 1330.66Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M741.48 1267.84C742.74 1267.84 742.75 1266.02 741.48 1266.02C740.21 1266.02 740.21 1267.84 741.48 1267.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M635.543 1197.11C636.813 1197.11 636.813 1195.29 635.543 1195.29C634.283 1195.29 634.273 1197.11 635.543 1197.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M728.929 1362.76C730.189 1362.76 730.189 1360.94 728.929 1360.94C727.659 1360.94 727.659 1362.76 728.929 1362.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M669.179 1414.88C670.449 1414.88 670.449 1413.06 669.179 1413.06C667.919 1413.06 667.909 1414.88 669.179 1414.88Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640.559 1449.78C640.729 1449.78 640.899 1449.78 641.059 1449.78C641.579 1449.78 642.069 1449.36 642.049 1448.87C642.019 1448.37 641.619 1447.96 641.059 1447.96C640.899 1447.96 640.729 1447.96 640.559 1447.96C640.049 1447.96 639.559 1448.38 639.579 1448.87C639.599 1449.36 640.009 1449.78 640.559 1449.78Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M681.23 1454.43C682.5 1454.43 682.5 1452.61 681.23 1452.61C679.97 1452.61 679.96 1454.43 681.23 1454.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M732.937 1412.09C734.207 1412.09 734.207 1410.27 732.937 1410.27C731.677 1410.27 731.677 1412.09 732.937 1412.09Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M698.8 1399.99C700.07 1399.99 700.07 1398.17 698.8 1398.17C697.54 1398.17 697.54 1399.99 698.8 1399.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.808 1417.67C702.078 1417.67 702.078 1415.85 700.808 1415.85C699.548 1415.85 699.538 1417.67 700.808 1417.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M754.531 1351.13C755.801 1351.13 755.801 1349.31 754.531 1349.31C753.271 1349.31 753.271 1351.13 754.531 1351.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M692.281 1319.95C693.541 1319.95 693.541 1318.13 692.281 1318.13C691.011 1318.13 691.011 1319.95 692.281 1319.95Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M661.648 1246.9C662.908 1246.9 662.918 1245.07 661.648 1245.07C660.378 1245.07 660.378 1246.9 661.648 1246.9Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.468 1275.75C618.728 1275.75 618.728 1273.92 617.468 1273.92C616.198 1273.92 616.198 1275.75 617.468 1275.75Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.101 1364.16C650.361 1364.16 650.371 1362.34 649.101 1362.34C647.831 1362.34 647.831 1364.16 649.101 1364.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821.59 1307.79C822.35 1307.79 822.36 1306.69 821.59 1306.69C820.83 1306.69 820.83 1307.79 821.59 1307.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M805.121 1341.76C805.891 1341.76 805.891 1340.66 805.121 1340.66C804.361 1340.66 804.361 1341.76 805.121 1341.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M848.679 1359.97C849.439 1359.97 849.439 1358.87 848.679 1358.87C847.919 1358.87 847.919 1359.97 848.679 1359.97Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M813.09 1397.88C813.86 1397.88 813.86 1396.78 813.09 1396.78C812.33 1396.78 812.33 1397.88 813.09 1397.88Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M764.23 1411.17C764.99 1411.17 764.99 1410.07 764.23 1410.07C763.46 1410.07 763.46 1411.17 764.23 1411.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M795.562 1370.31C796.332 1370.31 796.332 1369.21 795.562 1369.21C794.802 1369.21 794.802 1370.31 795.562 1370.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M791.851 1277.27C792.611 1277.27 792.611 1276.17 791.851 1276.17C791.081 1276.17 791.081 1277.27 791.851 1277.27Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M835.398 1215.24C836.158 1215.24 836.168 1214.14 835.398 1214.14C834.638 1214.14 834.638 1215.24 835.398 1215.24Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M758.91 1202.44C759.09 1202.44 759.27 1202.44 759.44 1202.44C760.21 1202.44 760.21 1201.34 759.44 1201.34C759.27 1201.34 759.09 1201.34 758.91 1201.34C758.15 1201.34 758.15 1202.44 758.91 1202.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M636.862 1226.89C637.042 1227.06 637.212 1227.22 637.392 1227.39C637.932 1227.89 638.772 1227.11 638.232 1226.61C638.052 1226.44 637.872 1226.28 637.702 1226.12C637.162 1225.62 636.322 1226.39 636.862 1226.89Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M666.492 1296.47C667.252 1296.47 667.262 1295.37 666.492 1295.37C665.732 1295.37 665.732 1296.47 666.492 1296.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M800.882 1423.48C801.642 1423.48 801.642 1422.38 800.882 1422.38C800.112 1422.38 800.112 1423.48 800.882 1423.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.429 1434.8C845.189 1434.8 845.199 1433.7 844.429 1433.7C843.669 1433.7 843.669 1434.8 844.429 1434.8Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M743.507 1447.11C744.267 1447.11 744.267 1446.01 743.507 1446.01C742.748 1446.01 742.748 1447.11 743.507 1447.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.859 1440.22C707.619 1440.22 707.619 1439.12 706.859 1439.12C706.099 1439.12 706.099 1440.22 706.859 1440.22Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M800.882 1442.68C801.642 1442.68 801.642 1441.58 800.882 1441.58C800.112 1441.58 800.112 1442.68 800.882 1442.68Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M721.929 1152.14C722.699 1152.14 722.699 1151.04 721.929 1151.04C721.169 1151.04 721.169 1152.14 721.929 1152.14Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.468 1145.79C823.238 1145.79 823.238 1144.69 822.468 1144.69C821.708 1144.69 821.708 1145.79 822.468 1145.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M689.179 1042.73C689.939 1042.73 689.949 1041.63 689.179 1041.63C688.419 1041.63 688.419 1042.73 689.179 1042.73Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M753.922 1058.96C754.692 1058.96 754.692 1057.86 753.922 1057.86C753.162 1057.86 753.162 1058.96 753.922 1058.96Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M825.519 1058.96C826.279 1058.96 826.279 1057.86 825.519 1057.86C824.759 1057.86 824.759 1058.96 825.519 1058.96Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.577 974.957C650.337 974.957 650.337 973.857 649.577 973.857C648.808 973.857 648.808 974.957 649.577 974.957Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632.521 1072.76C632.011 1073 631.501 1073.23 631.001 1073.47C630.311 1073.79 630.911 1074.73 631.591 1074.42C632.101 1074.18 632.611 1073.95 633.121 1073.71C633.801 1073.4 633.201 1072.45 632.521 1072.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.82 1016.61C617.59 1016.61 617.59 1015.51 616.82 1015.51C616.06 1015.51 616.06 1016.61 616.82 1016.61Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M772.968 1115.44C773.728 1115.44 773.728 1114.34 772.968 1114.34C772.198 1114.34 772.198 1115.44 772.968 1115.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M820.191 1266.5C820.951 1266.5 820.951 1265.4 820.191 1265.4C819.431 1265.4 819.421 1266.5 820.191 1266.5Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.312 1185.17C747.832 1185.17 747.842 1182.97 746.312 1182.97C744.782 1182.97 744.782 1185.17 746.312 1185.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M636.632 1151.99C638.152 1151.99 638.162 1149.79 636.632 1149.79C635.102 1149.79 635.102 1151.99 636.632 1151.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.452 1229.64C609.972 1229.64 609.972 1227.44 608.452 1227.44C606.922 1227.44 606.922 1229.64 608.452 1229.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M827.038 1332.7C828.568 1332.7 828.568 1330.51 827.038 1330.51C825.518 1330.51 825.518 1332.7 827.038 1332.7Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.89 1404C851.42 1404 851.42 1401.8 849.89 1401.8C848.37 1401.8 848.37 1404 849.89 1404Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.28 1446.36C827.81 1446.36 827.81 1444.16 826.28 1444.16C824.76 1444.16 824.75 1446.36 826.28 1446.36Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M790.48 1225.4C792.01 1225.4 792.01 1223.21 790.48 1223.21C788.96 1223.21 788.95 1225.4 790.48 1225.4Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M688.421 1175.99C689.951 1175.99 689.951 1173.79 688.421 1173.79C686.891 1173.79 686.891 1175.99 688.421 1175.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M695.28 1089.87C696.8 1089.87 696.8 1087.67 695.28 1087.67C693.75 1087.67 693.75 1089.87 695.28 1089.87Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M645.773 1029.16C647.293 1029.16 647.303 1026.96 645.773 1026.96C644.243 1026.96 644.243 1029.16 645.773 1029.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M670.902 1137.16C672.432 1137.16 672.432 1134.96 670.902 1134.96C669.382 1134.96 669.372 1137.16 670.902 1137.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M772.202 1148.46C773.733 1148.46 773.733 1146.26 772.202 1146.26C770.683 1146.26 770.683 1148.46 772.202 1148.46Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M832.711 1082.41C832.711 1083.12 832.711 1083.82 832.711 1084.53C832.711 1085.94 835.081 1085.95 835.081 1084.53C835.081 1083.82 835.081 1083.12 835.081 1082.41C835.081 1081 832.711 1081 832.711 1082.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M720.152 1013.79C720.402 1014.26 720.662 1014.73 720.912 1015.2C721.592 1016.46 723.642 1015.35 722.962 1014.09C722.702 1013.62 722.452 1013.15 722.202 1012.68C721.512 1011.41 719.472 1012.53 720.152 1013.79Z",
    fill: "#FFFFFE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.597 1214.79C168.867 1214.79 168.867 1212.97 167.597 1212.97C166.337 1212.97 166.327 1214.79 167.597 1214.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.499 1260.86C143.759 1260.86 143.759 1259.04 142.499 1259.04C141.229 1259.04 141.229 1260.86 142.499 1260.86Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.863 1192.92C232.133 1192.92 232.133 1191.1 230.863 1191.1C229.603 1191.1 229.593 1192.92 230.863 1192.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.57 1178.26C142.34 1178.26 142.34 1177.16 141.57 1177.16C140.81 1177.16 140.81 1178.26 141.57 1178.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.863 1072.37C144.623 1072.37 144.623 1071.28 143.863 1071.28C143.103 1071.28 143.093 1072.37 143.863 1072.37Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.781 1115.44C237.541 1115.44 237.551 1114.34 236.781 1114.34C236.021 1114.34 236.021 1115.44 236.781 1115.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.699 986.958C199.459 986.958 199.459 985.859 198.699 985.859C197.939 985.859 197.929 986.958 198.699 986.958Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.468 908.6C184.228 908.6 184.228 907.502 183.468 907.502C182.698 907.502 182.698 908.6 183.468 908.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.658 890.721C152.398 890.485 152.148 890.25 151.888 890.016C151.348 889.514 150.518 890.291 151.058 890.792C151.308 891.028 151.558 891.263 151.818 891.498C152.358 891.999 153.198 891.222 152.658 890.721Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.988 1114.02C185.748 1114.02 185.748 1112.93 184.988 1112.93C184.228 1112.93 184.218 1114.02 184.988 1114.02Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.89 1043.98C212.41 1043.98 212.41 1041.78 210.89 1041.78C209.36 1041.78 209.36 1043.98 210.89 1043.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.569 1003.74C159.089 1003.74 159.099 1001.54 157.569 1001.54C156.039 1001.54 156.039 1003.74 157.569 1003.74Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.898 1144.22C180.418 1144.22 180.418 1142.02 178.898 1142.02C177.368 1142.02 177.368 1144.22 178.898 1144.22Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.78 1166.1C238.31 1166.1 238.31 1163.91 236.78 1163.91C235.26 1163.91 235.25 1166.1 236.78 1166.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.171 967.038C230.691 967.038 230.691 964.84 229.171 964.84C227.641 964.84 227.641 967.038 229.171 967.038Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.14 945.858C163.66 945.858 163.67 943.66 162.14 943.66C160.61 943.66 160.61 945.858 162.14 945.858Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.25 1217.12C326.52 1217.12 326.52 1215.29 325.25 1215.29C323.99 1215.29 323.98 1217.12 325.25 1217.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.327 1221.3C345.597 1221.3 345.597 1219.48 344.327 1219.48C343.058 1219.48 343.058 1221.3 344.327 1221.3Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.82 1230.14C342.08 1230.14 342.08 1228.32 340.82 1228.32C339.55 1228.32 339.55 1230.14 340.82 1230.14Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.929 1290.17C369.189 1290.17 369.189 1288.35 367.929 1288.35C366.659 1288.35 366.659 1290.17 367.929 1290.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.999 1330.66C386.259 1330.66 386.269 1328.83 384.999 1328.83C383.729 1328.83 383.729 1330.66 384.999 1330.66Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.48 1267.84C381.74 1267.84 381.75 1266.02 380.48 1266.02C379.21 1266.02 379.21 1267.84 380.48 1267.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.543 1197.11C275.813 1197.11 275.813 1195.29 274.543 1195.29C273.283 1195.29 273.273 1197.11 274.543 1197.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.929 1362.76C369.189 1362.76 369.189 1360.94 367.929 1360.94C366.659 1360.94 366.659 1362.76 367.929 1362.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.179 1414.88C309.449 1414.88 309.449 1413.06 308.179 1413.06C306.919 1413.06 306.909 1414.88 308.179 1414.88Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.559 1449.78C279.729 1449.78 279.899 1449.78 280.059 1449.78C280.579 1449.78 281.069 1449.36 281.049 1448.87C281.019 1448.37 280.619 1447.96 280.059 1447.96C279.899 1447.96 279.729 1447.96 279.559 1447.96C279.049 1447.96 278.559 1448.38 278.579 1448.87C278.599 1449.36 279.009 1449.78 279.559 1449.78Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.23 1454.43C321.5 1454.43 321.5 1452.61 320.23 1452.61C318.97 1452.61 318.96 1454.43 320.23 1454.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.937 1412.09C373.207 1412.09 373.207 1410.27 371.937 1410.27C370.677 1410.27 370.677 1412.09 371.937 1412.09Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.8 1399.99C339.07 1399.99 339.07 1398.17 337.8 1398.17C336.54 1398.17 336.54 1399.99 337.8 1399.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.808 1417.67C341.078 1417.67 341.078 1415.85 339.808 1415.85C338.548 1415.85 338.538 1417.67 339.808 1417.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.531 1351.13C394.801 1351.13 394.801 1349.31 393.531 1349.31C392.271 1349.31 392.271 1351.13 393.531 1351.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.281 1319.95C332.541 1319.95 332.541 1318.13 331.281 1318.13C330.011 1318.13 330.011 1319.95 331.281 1319.95Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.648 1246.9C301.908 1246.9 301.918 1245.07 300.648 1245.07C299.378 1245.07 299.378 1246.9 300.648 1246.9Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.468 1275.75C257.728 1275.75 257.728 1273.92 256.468 1273.92C255.198 1273.92 255.198 1275.75 256.468 1275.75Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.101 1364.16C289.361 1364.16 289.371 1362.34 288.101 1362.34C286.831 1362.34 286.831 1364.16 288.101 1364.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.59 1307.79C461.35 1307.79 461.36 1306.69 460.59 1306.69C459.83 1306.69 459.83 1307.79 460.59 1307.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.121 1341.76C444.891 1341.76 444.891 1340.66 444.121 1340.66C443.361 1340.66 443.361 1341.76 444.121 1341.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.679 1359.97C488.439 1359.97 488.439 1358.87 487.679 1358.87C486.919 1358.87 486.919 1359.97 487.679 1359.97Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.09 1397.88C452.86 1397.88 452.86 1396.78 452.09 1396.78C451.33 1396.78 451.33 1397.88 452.09 1397.88Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.23 1411.17C403.99 1411.17 403.99 1410.07 403.23 1410.07C402.46 1410.07 402.46 1411.17 403.23 1411.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.562 1370.31C435.332 1370.31 435.332 1369.21 434.562 1369.21C433.802 1369.21 433.802 1370.31 434.562 1370.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.851 1277.27C431.611 1277.27 431.611 1276.17 430.851 1276.17C430.081 1276.17 430.081 1277.27 430.851 1277.27Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.398 1215.24C475.158 1215.24 475.168 1214.14 474.398 1214.14C473.638 1214.14 473.638 1215.24 474.398 1215.24Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.91 1202.44C398.09 1202.44 398.27 1202.44 398.44 1202.44C399.21 1202.44 399.21 1201.34 398.44 1201.34C398.27 1201.34 398.09 1201.34 397.91 1201.34C397.15 1201.34 397.15 1202.44 397.91 1202.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.862 1226.89C276.042 1227.06 276.212 1227.22 276.392 1227.39C276.932 1227.89 277.772 1227.11 277.232 1226.61C277.052 1226.44 276.872 1226.28 276.702 1226.12C276.162 1225.62 275.322 1226.39 275.862 1226.89Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.492 1296.47C306.252 1296.47 306.262 1295.37 305.492 1295.37C304.732 1295.37 304.732 1296.47 305.492 1296.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.882 1423.48C440.642 1423.48 440.642 1422.38 439.882 1422.38C439.112 1422.38 439.112 1423.48 439.882 1423.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.429 1434.8C484.189 1434.8 484.199 1433.7 483.429 1433.7C482.669 1433.7 482.669 1434.8 483.429 1434.8Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.507 1447.11C383.267 1447.11 383.267 1446.01 382.507 1446.01C381.748 1446.01 381.748 1447.11 382.507 1447.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.859 1440.22C346.619 1440.22 346.619 1439.12 345.859 1439.12C345.099 1439.12 345.099 1440.22 345.859 1440.22Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.882 1442.68C440.642 1442.68 440.642 1441.58 439.882 1441.58C439.112 1441.58 439.112 1442.68 439.882 1442.68Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.929 1152.14C361.699 1152.14 361.699 1151.04 360.929 1151.04C360.169 1151.04 360.169 1152.14 360.929 1152.14Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.468 1145.79C462.238 1145.79 462.238 1144.69 461.468 1144.69C460.708 1144.69 460.708 1145.79 461.468 1145.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.179 1042.73C328.939 1042.73 328.949 1041.63 328.179 1041.63C327.419 1041.63 327.419 1042.73 328.179 1042.73Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.922 1058.96C393.692 1058.96 393.692 1057.86 392.922 1057.86C392.162 1057.86 392.162 1058.96 392.922 1058.96Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.519 1058.96C465.279 1058.96 465.279 1057.86 464.519 1057.86C463.759 1057.86 463.759 1058.96 464.519 1058.96Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.577 974.957C289.337 974.957 289.337 973.857 288.577 973.857C287.808 973.857 287.808 974.957 288.577 974.957Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.521 1072.76C271.011 1073 270.501 1073.23 270.001 1073.47C269.311 1073.79 269.911 1074.73 270.591 1074.42C271.101 1074.18 271.611 1073.95 272.121 1073.71C272.801 1073.4 272.201 1072.45 271.521 1072.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.82 1016.61C256.59 1016.61 256.59 1015.51 255.82 1015.51C255.06 1015.51 255.06 1016.61 255.82 1016.61Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.968 1115.44C412.728 1115.44 412.728 1114.34 411.968 1114.34C411.198 1114.34 411.198 1115.44 411.968 1115.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.191 1266.5C459.951 1266.5 459.951 1265.4 459.191 1265.4C458.431 1265.4 458.421 1266.5 459.191 1266.5Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.312 1185.17C386.832 1185.17 386.842 1182.97 385.312 1182.97C383.782 1182.97 383.782 1185.17 385.312 1185.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.632 1151.99C277.152 1151.99 277.162 1149.79 275.632 1149.79C274.102 1149.79 274.102 1151.99 275.632 1151.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.452 1229.64C248.972 1229.64 248.972 1227.44 247.452 1227.44C245.922 1227.44 245.922 1229.64 247.452 1229.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M466.038 1332.7C467.568 1332.7 467.568 1330.51 466.038 1330.51C464.518 1330.51 464.518 1332.7 466.038 1332.7Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.89 1404C490.42 1404 490.42 1401.8 488.89 1401.8C487.37 1401.8 487.37 1404 488.89 1404Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.28 1446.36C466.81 1446.36 466.81 1444.16 465.28 1444.16C463.76 1444.16 463.75 1446.36 465.28 1446.36Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.48 1225.4C431.01 1225.4 431.01 1223.21 429.48 1223.21C427.96 1223.21 427.95 1225.4 429.48 1225.4Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.421 1175.99C328.951 1175.99 328.951 1173.79 327.421 1173.79C325.891 1173.79 325.891 1175.99 327.421 1175.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.28 1089.87C335.8 1089.87 335.8 1087.67 334.28 1087.67C332.75 1087.67 332.75 1089.87 334.28 1089.87Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.773 1029.16C286.293 1029.16 286.303 1026.96 284.773 1026.96C283.243 1026.96 283.243 1029.16 284.773 1029.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.902 1137.16C311.432 1137.16 311.432 1134.96 309.902 1134.96C308.382 1134.96 308.372 1137.16 309.902 1137.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.202 1148.46C412.733 1148.46 412.733 1146.26 411.202 1146.26C409.683 1146.26 409.683 1148.46 411.202 1148.46Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.711 1082.41C471.711 1083.12 471.711 1083.82 471.711 1084.53C471.711 1085.94 474.081 1085.95 474.081 1084.53C474.081 1083.82 474.081 1083.12 474.081 1082.41C474.081 1081 471.711 1081 471.711 1082.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.152 1013.79C359.402 1014.26 359.662 1014.73 359.912 1015.2C360.592 1016.46 362.642 1015.35 361.962 1014.09C361.702 1013.62 361.452 1013.15 361.202 1012.68C360.512 1011.41 358.472 1012.53 359.152 1013.79Z",
    fill: "#FFFFFE"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1250.59 639.126C1251.86 639.126 1251.86 637.303 1250.59 637.303C1249.33 637.303 1249.32 639.126 1250.59 639.126Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1225.49 685.192C1226.75 685.192 1226.75 683.369 1225.49 683.369C1224.22 683.369 1224.22 685.192 1225.49 685.192Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1313.86 617.256C1315.13 617.256 1315.13 615.434 1313.86 615.434C1312.6 615.434 1312.59 617.256 1313.86 617.256Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1224.56 602.598C1225.33 602.598 1225.33 601.5 1224.56 601.5C1223.8 601.5 1223.8 602.598 1224.56 602.598Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1226.86 496.712C1227.62 496.712 1227.62 495.613 1226.86 495.613C1226.1 495.613 1226.09 496.712 1226.86 496.712Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1319.77 539.772C1320.53 539.772 1320.54 538.674 1319.77 538.674C1319.01 538.674 1319.01 539.772 1319.77 539.772Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1281.69 411.294C1282.45 411.294 1282.45 410.195 1281.69 410.195C1280.93 410.195 1280.92 411.294 1281.69 411.294Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1266.46 332.938C1267.22 332.938 1267.22 331.84 1266.46 331.84C1265.69 331.84 1265.69 332.938 1266.46 332.938Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1235.65 315.057C1235.39 314.821 1235.14 314.586 1234.88 314.352C1234.34 313.85 1233.51 314.627 1234.05 315.128C1234.3 315.364 1234.55 315.599 1234.81 315.834C1235.35 316.335 1236.19 315.558 1235.65 315.057Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1267.98 538.359C1268.74 538.359 1268.74 537.26 1267.98 537.26C1267.22 537.26 1267.21 538.359 1267.98 538.359Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1293.88 468.319C1295.4 468.319 1295.4 466.121 1293.88 466.121C1292.35 466.121 1292.35 468.319 1293.88 468.319Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1240.56 428.08C1242.08 428.08 1242.09 425.883 1240.56 425.883C1239.03 425.883 1239.03 428.08 1240.56 428.08Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1261.89 568.558C1263.41 568.558 1263.41 566.359 1261.89 566.359C1260.36 566.359 1260.36 568.558 1261.89 568.558Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1319.77 590.442C1321.3 590.442 1321.3 588.244 1319.77 588.244C1318.25 588.244 1318.24 590.442 1319.77 590.442Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.16 391.372C1313.68 391.372 1313.68 389.174 1312.16 389.174C1310.63 389.174 1310.63 391.372 1312.16 391.372Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245.13 370.194C1246.65 370.194 1246.66 367.996 1245.13 367.996C1243.6 367.996 1243.6 370.194 1245.13 370.194Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1408.24 641.452C1409.51 641.452 1409.51 639.629 1408.24 639.629C1406.98 639.629 1406.97 641.452 1408.24 641.452Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1427.32 645.641C1428.59 645.641 1428.59 643.818 1427.32 643.818C1426.05 643.818 1426.05 645.641 1427.32 645.641Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1423.81 654.482C1425.07 654.482 1425.07 652.66 1423.81 652.66C1422.54 652.66 1422.54 654.482 1423.81 654.482Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1357.53 621.443C1358.8 621.443 1358.8 619.621 1357.53 619.621C1356.27 619.621 1356.26 621.443 1357.53 621.443Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1391.17 839.218C1392.44 839.218 1392.44 837.395 1391.17 837.395C1389.91 837.395 1389.9 839.218 1391.17 839.218Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1362.55 874.115C1362.72 874.115 1362.89 874.115 1363.05 874.115C1363.57 874.115 1364.06 873.696 1364.04 873.204C1364.01 872.71 1363.61 872.293 1363.05 872.293C1362.89 872.293 1362.72 872.293 1362.55 872.293C1362.04 872.293 1361.55 872.712 1361.57 873.204C1361.59 873.698 1362 874.115 1362.55 874.115Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1403.22 878.769C1404.49 878.769 1404.49 876.947 1403.22 876.947C1401.96 876.947 1401.95 878.769 1403.22 878.769Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1420.79 824.326C1422.06 824.326 1422.06 822.504 1420.79 822.504C1419.53 822.504 1419.53 824.326 1420.79 824.326Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1422.8 842.008C1424.07 842.008 1424.07 840.186 1422.8 840.186C1421.54 840.186 1421.53 842.008 1422.8 842.008Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1414.27 744.29C1415.53 744.29 1415.53 742.467 1414.27 742.467C1413 742.467 1413 744.29 1414.27 744.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1383.64 671.233C1384.9 671.233 1384.91 669.41 1383.64 669.41C1382.37 669.41 1382.37 671.233 1383.64 671.233Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1339.46 700.084C1340.72 700.084 1340.72 698.262 1339.46 698.262C1338.19 698.262 1338.19 700.084 1339.46 700.084Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1371.09 788.496C1372.35 788.496 1372.36 786.674 1371.09 786.674C1369.82 786.674 1369.82 788.496 1371.09 788.496Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1358.85 651.23C1359.03 651.393 1359.2 651.558 1359.38 651.721C1359.92 652.223 1360.76 651.445 1360.22 650.945C1360.04 650.781 1359.86 650.617 1359.69 650.453C1359.15 649.952 1358.31 650.729 1358.85 651.23Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1388.48 720.802C1389.24 720.802 1389.25 719.703 1388.48 719.703C1387.72 719.703 1387.72 720.802 1388.48 720.802Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1428.85 864.552C1429.61 864.552 1429.61 863.453 1428.85 863.453C1428.09 863.453 1428.09 864.552 1428.85 864.552Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1411.17 467.062C1411.93 467.062 1411.94 465.963 1411.17 465.963C1410.41 465.963 1410.41 467.062 1411.17 467.062Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1371.57 399.295C1372.33 399.295 1372.33 398.195 1371.57 398.195C1370.8 398.195 1370.8 399.295 1371.57 399.295Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1354.51 497.099C1354 497.334 1353.49 497.57 1352.99 497.805C1352.3 498.121 1352.9 499.069 1353.58 498.753C1354.09 498.519 1354.6 498.283 1355.11 498.048C1355.79 497.732 1355.19 496.783 1354.51 497.099Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1338.81 440.943C1339.58 440.943 1339.58 439.844 1338.81 439.844C1338.05 439.844 1338.05 440.943 1338.81 440.943Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1358.62 576.324C1360.14 576.324 1360.15 574.127 1358.62 574.127C1357.09 574.127 1357.09 576.324 1358.62 576.324Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1330.44 653.975C1331.96 653.975 1331.96 651.777 1330.44 651.777C1328.91 651.777 1328.91 653.975 1330.44 653.975Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1410.41 600.323C1411.94 600.323 1411.94 598.125 1410.41 598.125C1408.88 598.125 1408.88 600.323 1410.41 600.323Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1417.27 514.201C1418.79 514.201 1418.79 512.004 1417.27 512.004C1415.74 512.004 1415.74 514.201 1417.27 514.201Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1367.76 453.494C1369.28 453.494 1369.29 451.297 1367.76 451.297C1366.23 451.297 1366.23 453.494 1367.76 453.494Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1392.89 561.498C1394.42 561.498 1394.42 559.301 1392.89 559.301C1391.37 559.301 1391.36 561.498 1392.89 561.498Z",
    fill: "#FFFFFE"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M889.589 639.126C890.859 639.126 890.859 637.303 889.589 637.303C888.329 637.303 888.319 639.126 889.589 639.126Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M864.492 685.192C865.752 685.192 865.752 683.369 864.492 683.369C863.222 683.369 863.222 685.192 864.492 685.192Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M952.855 617.256C954.125 617.256 954.125 615.434 952.855 615.434C951.595 615.434 951.585 617.256 952.855 617.256Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M863.562 602.598C864.332 602.598 864.332 601.5 863.562 601.5C862.802 601.5 862.802 602.598 863.562 602.598Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865.855 496.712C866.615 496.712 866.615 495.613 865.855 495.613C865.095 495.613 865.085 496.712 865.855 496.712Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M958.773 539.772C959.533 539.772 959.543 538.674 958.773 538.674C958.013 538.674 958.013 539.772 958.773 539.772Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M920.691 411.294C921.451 411.294 921.451 410.195 920.691 410.195C919.931 410.195 919.921 411.294 920.691 411.294Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M905.46 332.938C906.22 332.938 906.22 331.84 905.46 331.84C904.69 331.84 904.69 332.938 905.46 332.938Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M874.65 315.057C874.39 314.821 874.14 314.586 873.88 314.352C873.34 313.85 872.51 314.627 873.05 315.128C873.3 315.364 873.55 315.599 873.81 315.834C874.35 316.335 875.19 315.558 874.65 315.057Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M906.98 538.359C907.74 538.359 907.74 537.26 906.98 537.26C906.22 537.26 906.21 538.359 906.98 538.359Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M932.882 468.319C934.402 468.319 934.402 466.121 932.882 466.121C931.352 466.121 931.352 468.319 932.882 468.319Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879.562 428.08C881.082 428.08 881.092 425.883 879.562 425.883C878.032 425.883 878.032 428.08 879.562 428.08Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M900.89 568.558C902.41 568.558 902.41 566.359 900.89 566.359C899.36 566.359 899.36 568.558 900.89 568.558Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M958.773 590.442C960.303 590.442 960.303 588.244 958.773 588.244C957.253 588.244 957.243 590.442 958.773 590.442Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M951.163 391.372C952.683 391.372 952.683 389.174 951.163 389.174C949.633 389.174 949.633 391.372 951.163 391.372Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.132 370.194C885.652 370.194 885.662 367.996 884.132 367.996C882.602 367.996 882.602 370.194 884.132 370.194Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1047.24 641.452C1048.51 641.452 1048.51 639.629 1047.24 639.629C1045.98 639.629 1045.97 641.452 1047.24 641.452Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1066.32 645.641C1067.59 645.641 1067.59 643.818 1066.32 643.818C1065.05 643.818 1065.05 645.641 1066.32 645.641Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1062.81 654.482C1064.07 654.482 1064.07 652.66 1062.81 652.66C1061.54 652.66 1061.54 654.482 1062.81 654.482Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1089.92 714.51C1091.18 714.51 1091.18 712.688 1089.92 712.688C1088.65 712.688 1088.65 714.51 1089.92 714.51Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1106.99 754.991C1108.25 754.991 1108.26 753.168 1106.99 753.168C1105.72 753.168 1105.72 754.991 1106.99 754.991Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1102.47 692.173C1103.73 692.173 1103.74 690.35 1102.47 690.35C1101.2 690.35 1101.2 692.173 1102.47 692.173Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.535 621.443C997.805 621.443 997.805 619.621 996.535 619.621C995.275 619.621 995.265 621.443 996.535 621.443Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1089.92 787.1C1091.18 787.1 1091.18 785.277 1089.92 785.277C1088.65 785.277 1088.65 787.1 1089.92 787.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1030.17 839.218C1031.44 839.218 1031.44 837.395 1030.17 837.395C1028.91 837.395 1028.9 839.218 1030.17 839.218Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1001.55 874.115C1001.72 874.115 1001.89 874.115 1002.05 874.115C1002.57 874.115 1003.06 873.696 1003.04 873.204C1003.01 872.71 1002.61 872.293 1002.05 872.293C1001.89 872.293 1001.72 872.293 1001.55 872.293C1001.04 872.293 1000.55 872.712 1000.57 873.204C1000.59 873.698 1001 874.115 1001.55 874.115Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1042.22 878.769C1043.49 878.769 1043.49 876.947 1042.22 876.947C1040.96 876.947 1040.95 878.769 1042.22 878.769Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1093.93 836.424C1095.2 836.424 1095.2 834.602 1093.93 834.602C1092.67 834.602 1092.67 836.424 1093.93 836.424Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1059.79 824.326C1061.06 824.326 1061.06 822.504 1059.79 822.504C1058.53 822.504 1058.53 824.326 1059.79 824.326Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.8 842.008C1063.07 842.008 1063.07 840.186 1061.8 840.186C1060.54 840.186 1060.53 842.008 1061.8 842.008Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1115.52 775.467C1116.79 775.467 1116.79 773.645 1115.52 773.645C1114.26 773.645 1114.26 775.467 1115.52 775.467Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1053.27 744.29C1054.53 744.29 1054.53 742.467 1053.27 742.467C1052 742.467 1052 744.29 1053.27 744.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1022.64 671.233C1023.9 671.233 1023.91 669.41 1022.64 669.41C1021.37 669.41 1021.37 671.233 1022.64 671.233Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.46 700.084C979.72 700.084 979.72 698.262 978.46 698.262C977.19 698.262 977.19 700.084 978.46 700.084Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1010.09 788.496C1011.35 788.496 1011.36 786.674 1010.09 786.674C1008.82 786.674 1008.82 788.496 1010.09 788.496Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1182.58 732.125C1183.34 732.125 1183.35 731.025 1182.58 731.025C1181.82 731.025 1181.82 732.125 1182.58 732.125Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1166.11 766.094C1166.88 766.094 1166.88 764.996 1166.11 764.996C1165.35 764.996 1165.35 766.094 1166.11 766.094Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1209.67 784.306C1210.43 784.306 1210.43 783.207 1209.67 783.207C1208.91 783.207 1208.91 784.306 1209.67 784.306Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1174.08 822.214C1174.85 822.214 1174.85 821.115 1174.08 821.115C1173.32 821.115 1173.32 822.214 1174.08 822.214Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1125.22 835.506C1125.98 835.506 1125.98 834.408 1125.22 834.408C1124.45 834.408 1124.45 835.506 1125.22 835.506Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1156.55 794.646C1157.32 794.646 1157.32 793.547 1156.55 793.547C1155.79 793.547 1155.79 794.646 1156.55 794.646Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1152.84 701.605C1153.6 701.605 1153.6 700.506 1152.84 700.506C1152.07 700.506 1152.07 701.605 1152.84 701.605Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1196.39 639.576C1197.15 639.576 1197.16 638.477 1196.39 638.477C1195.63 638.477 1195.63 639.576 1196.39 639.576Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1119.9 626.775C1120.08 626.775 1120.26 626.775 1120.43 626.775C1121.2 626.775 1121.2 625.676 1120.43 625.676C1120.26 625.676 1120.08 625.676 1119.9 625.676C1119.14 625.676 1119.14 626.775 1119.9 626.775Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M997.854 651.23C998.034 651.393 998.204 651.558 998.384 651.721C998.924 652.223 999.764 651.445 999.224 650.945C999.044 650.781 998.864 650.617 998.694 650.453C998.154 649.952 997.314 650.729 997.854 651.23Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1027.48 720.802C1028.24 720.802 1028.25 719.703 1027.48 719.703C1026.72 719.703 1026.72 720.802 1027.48 720.802Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1161.87 847.813C1162.63 847.813 1162.63 846.715 1161.87 846.715C1161.1 846.715 1161.1 847.813 1161.87 847.813Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1205.42 859.137C1206.18 859.137 1206.19 858.039 1205.42 858.039C1204.66 858.039 1204.66 859.137 1205.42 859.137Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1104.5 871.446C1105.26 871.446 1105.26 870.346 1104.5 870.346C1103.74 870.346 1103.74 871.446 1104.5 871.446Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1067.85 864.552C1068.61 864.552 1068.61 863.453 1067.85 863.453C1067.09 863.453 1067.09 864.552 1067.85 864.552Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1161.87 867.013C1162.63 867.013 1162.63 865.914 1161.87 865.914C1161.1 865.914 1161.1 867.013 1161.87 867.013Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1082.92 576.48C1083.69 576.48 1083.69 575.381 1082.92 575.381C1082.16 575.381 1082.16 576.48 1082.92 576.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1183.46 570.126C1184.23 570.126 1184.23 569.027 1183.46 569.027C1182.7 569.027 1182.7 570.126 1183.46 570.126Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1050.17 467.062C1050.93 467.062 1050.94 465.963 1050.17 465.963C1049.41 465.963 1049.41 467.062 1050.17 467.062Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1114.91 483.298C1115.68 483.298 1115.68 482.199 1114.91 482.199C1114.15 482.199 1114.15 483.298 1114.91 483.298Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1186.51 483.298C1187.27 483.298 1187.27 482.199 1186.51 482.199C1185.75 482.199 1185.75 483.298 1186.51 483.298Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1010.57 399.295C1011.33 399.295 1011.33 398.195 1010.57 398.195C1009.8 398.195 1009.8 399.295 1010.57 399.295Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M993.513 497.099C993.003 497.334 992.493 497.57 991.993 497.805C991.303 498.121 991.903 499.069 992.583 498.753C993.093 498.519 993.603 498.283 994.113 498.048C994.793 497.732 994.193 496.783 993.513 497.099Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M977.812 440.943C978.582 440.943 978.582 439.844 977.812 439.844C977.052 439.844 977.052 440.943 977.812 440.943Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1133.96 539.772C1134.72 539.772 1134.72 538.674 1133.96 538.674C1133.19 538.674 1133.19 539.772 1133.96 539.772Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1181.18 690.839C1181.94 690.839 1181.94 689.74 1181.18 689.74C1180.42 689.74 1180.41 690.839 1181.18 690.839Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1107.3 609.502C1108.82 609.502 1108.83 607.305 1107.3 607.305C1105.77 607.305 1105.77 609.502 1107.3 609.502Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M997.624 576.324C999.144 576.324 999.154 574.127 997.624 574.127C996.094 574.127 996.094 576.324 997.624 576.324Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M969.444 653.975C970.964 653.975 970.964 651.777 969.444 651.777C967.914 651.777 967.914 653.975 969.444 653.975Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1188.03 757.037C1189.56 757.037 1189.56 754.84 1188.03 754.84C1186.51 754.84 1186.51 757.037 1188.03 757.037Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1210.88 828.337C1212.41 828.337 1212.41 826.139 1210.88 826.139C1209.36 826.139 1209.36 828.337 1210.88 828.337Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.27 870.692C1188.8 870.692 1188.8 868.494 1187.27 868.494C1185.75 868.494 1185.74 870.692 1187.27 870.692Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1151.47 649.738C1153 649.738 1153 647.541 1151.47 647.541C1149.95 647.541 1149.94 649.738 1151.47 649.738Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1049.41 600.323C1050.94 600.323 1050.94 598.125 1049.41 598.125C1047.88 598.125 1047.88 600.323 1049.41 600.323Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1056.27 514.201C1057.79 514.201 1057.79 512.004 1056.27 512.004C1054.74 512.004 1054.74 514.201 1056.27 514.201Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1006.76 453.494C1008.28 453.494 1008.29 451.297 1006.76 451.297C1005.23 451.297 1005.23 453.494 1006.76 453.494Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1031.89 561.498C1033.42 561.498 1033.42 559.301 1031.89 559.301C1030.37 559.301 1030.36 561.498 1031.89 561.498Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1133.19 572.795C1134.72 572.795 1134.72 570.598 1133.19 570.598C1131.67 570.598 1131.67 572.795 1133.19 572.795Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1193.7 506.749C1193.7 507.455 1193.7 508.16 1193.7 508.867C1193.7 510.28 1196.07 510.283 1196.07 508.867C1196.07 508.16 1196.07 507.455 1196.07 506.749C1196.07 505.335 1193.7 505.333 1193.7 506.749Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1081.14 438.124C1081.39 438.595 1081.65 439.066 1081.9 439.535C1082.58 440.801 1084.63 439.689 1083.95 438.427C1083.69 437.956 1083.44 437.485 1083.19 437.015C1082.5 435.749 1080.46 436.862 1081.14 438.124Z",
    fill: "#FFFFFE"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.597 639.126C529.867 639.126 529.867 637.303 528.597 637.303C527.337 637.303 527.327 639.126 528.597 639.126Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.499 685.192C504.759 685.192 504.759 683.369 503.499 683.369C502.229 683.369 502.229 685.192 503.499 685.192Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.863 617.256C593.133 617.256 593.133 615.434 591.863 615.434C590.603 615.434 590.593 617.256 591.863 617.256Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.57 602.598C503.34 602.598 503.34 601.5 502.57 601.5C501.81 601.5 501.81 602.598 502.57 602.598Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.863 496.712C505.623 496.712 505.623 495.613 504.863 495.613C504.103 495.613 504.093 496.712 504.863 496.712Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.781 539.772C598.541 539.772 598.551 538.674 597.781 538.674C597.021 538.674 597.021 539.772 597.781 539.772Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.699 411.294C560.459 411.294 560.459 410.195 559.699 410.195C558.939 410.195 558.929 411.294 559.699 411.294Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.468 332.938C545.228 332.938 545.228 331.84 544.468 331.84C543.698 331.84 543.698 332.938 544.468 332.938Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.658 315.057C513.398 314.821 513.148 314.586 512.888 314.352C512.348 313.85 511.518 314.627 512.058 315.128C512.308 315.364 512.558 315.599 512.818 315.834C513.358 316.335 514.198 315.558 513.658 315.057Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545.988 538.359C546.748 538.359 546.748 537.26 545.988 537.26C545.228 537.26 545.218 538.359 545.988 538.359Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571.89 468.319C573.41 468.319 573.41 466.121 571.89 466.121C570.36 466.121 570.36 468.319 571.89 468.319Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.569 428.08C520.089 428.08 520.099 425.883 518.569 425.883C517.039 425.883 517.039 428.08 518.569 428.08Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.898 568.558C541.418 568.558 541.418 566.359 539.898 566.359C538.368 566.359 538.368 568.558 539.898 568.558Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.78 590.442C599.31 590.442 599.31 588.244 597.78 588.244C596.26 588.244 596.25 590.442 597.78 590.442Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.171 391.372C591.691 391.372 591.691 389.174 590.171 389.174C588.641 389.174 588.641 391.372 590.171 391.372Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.14 370.194C524.66 370.194 524.67 367.996 523.14 367.996C521.61 367.996 521.61 370.194 523.14 370.194Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M686.25 641.452C687.52 641.452 687.52 639.629 686.25 639.629C684.99 639.629 684.98 641.452 686.25 641.452Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M705.327 645.641C706.597 645.641 706.597 643.818 705.327 643.818C704.058 643.818 704.058 645.641 705.327 645.641Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M701.82 654.482C703.08 654.482 703.08 652.66 701.82 652.66C700.55 652.66 700.55 654.482 701.82 654.482Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M728.929 714.51C730.189 714.51 730.189 712.688 728.929 712.688C727.659 712.688 727.659 714.51 728.929 714.51Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M745.999 754.991C747.259 754.991 747.269 753.168 745.999 753.168C744.729 753.168 744.729 754.991 745.999 754.991Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M741.48 692.173C742.74 692.173 742.75 690.35 741.48 690.35C740.21 690.35 740.21 692.173 741.48 692.173Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M635.543 621.443C636.813 621.443 636.813 619.621 635.543 619.621C634.283 619.621 634.273 621.443 635.543 621.443Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M728.929 787.1C730.189 787.1 730.189 785.277 728.929 785.277C727.659 785.277 727.659 787.1 728.929 787.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M669.179 839.218C670.449 839.218 670.449 837.395 669.179 837.395C667.919 837.395 667.909 839.218 669.179 839.218Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640.559 874.115C640.729 874.115 640.899 874.115 641.059 874.115C641.579 874.115 642.069 873.696 642.049 873.204C642.019 872.71 641.619 872.293 641.059 872.293C640.899 872.293 640.729 872.293 640.559 872.293C640.049 872.293 639.559 872.712 639.579 873.204C639.599 873.698 640.009 874.115 640.559 874.115Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M681.23 878.769C682.5 878.769 682.5 876.947 681.23 876.947C679.97 876.947 679.96 878.769 681.23 878.769Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M732.937 836.424C734.207 836.424 734.207 834.602 732.937 834.602C731.677 834.602 731.677 836.424 732.937 836.424Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M698.8 824.326C700.07 824.326 700.07 822.504 698.8 822.504C697.54 822.504 697.54 824.326 698.8 824.326Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.808 842.008C702.078 842.008 702.078 840.186 700.808 840.186C699.548 840.186 699.538 842.008 700.808 842.008Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M754.531 775.467C755.801 775.467 755.801 773.645 754.531 773.645C753.271 773.645 753.271 775.467 754.531 775.467Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M692.281 744.29C693.541 744.29 693.541 742.467 692.281 742.467C691.011 742.467 691.011 744.29 692.281 744.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M661.648 671.233C662.908 671.233 662.918 669.41 661.648 669.41C660.378 669.41 660.378 671.233 661.648 671.233Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.468 700.084C618.728 700.084 618.728 698.262 617.468 698.262C616.198 698.262 616.198 700.084 617.468 700.084Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.101 788.496C650.361 788.496 650.371 786.674 649.101 786.674C647.831 786.674 647.831 788.496 649.101 788.496Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821.59 732.125C822.35 732.125 822.36 731.025 821.59 731.025C820.83 731.025 820.83 732.125 821.59 732.125Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M805.121 766.094C805.891 766.094 805.891 764.996 805.121 764.996C804.361 764.996 804.361 766.094 805.121 766.094Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M848.679 784.306C849.439 784.306 849.439 783.207 848.679 783.207C847.919 783.207 847.919 784.306 848.679 784.306Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M813.09 822.214C813.86 822.214 813.86 821.115 813.09 821.115C812.33 821.115 812.33 822.214 813.09 822.214Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M764.23 835.506C764.99 835.506 764.99 834.408 764.23 834.408C763.46 834.408 763.46 835.506 764.23 835.506Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M795.562 794.646C796.332 794.646 796.332 793.547 795.562 793.547C794.802 793.547 794.802 794.646 795.562 794.646Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M791.851 701.605C792.611 701.605 792.611 700.506 791.851 700.506C791.081 700.506 791.081 701.605 791.851 701.605Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M835.398 639.576C836.158 639.576 836.168 638.477 835.398 638.477C834.638 638.477 834.638 639.576 835.398 639.576Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M758.91 626.775C759.09 626.775 759.27 626.775 759.44 626.775C760.21 626.775 760.21 625.676 759.44 625.676C759.27 625.676 759.09 625.676 758.91 625.676C758.15 625.676 758.15 626.775 758.91 626.775Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M636.862 651.23C637.042 651.393 637.212 651.558 637.392 651.721C637.932 652.223 638.772 651.445 638.232 650.945C638.052 650.781 637.872 650.617 637.702 650.453C637.162 649.952 636.322 650.729 636.862 651.23Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M666.492 720.802C667.252 720.802 667.262 719.703 666.492 719.703C665.732 719.703 665.732 720.802 666.492 720.802Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M800.882 847.813C801.642 847.813 801.642 846.715 800.882 846.715C800.112 846.715 800.112 847.813 800.882 847.813Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.429 859.137C845.189 859.137 845.199 858.039 844.429 858.039C843.669 858.039 843.669 859.137 844.429 859.137Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M743.507 871.446C744.267 871.446 744.267 870.346 743.507 870.346C742.748 870.346 742.748 871.446 743.507 871.446Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.859 864.552C707.619 864.552 707.619 863.453 706.859 863.453C706.099 863.453 706.099 864.552 706.859 864.552Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M800.882 867.013C801.642 867.013 801.642 865.914 800.882 865.914C800.112 865.914 800.112 867.013 800.882 867.013Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M721.929 576.48C722.699 576.48 722.699 575.381 721.929 575.381C721.169 575.381 721.169 576.48 721.929 576.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.468 570.126C823.238 570.126 823.238 569.027 822.468 569.027C821.708 569.027 821.708 570.126 822.468 570.126Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M689.179 467.062C689.939 467.062 689.949 465.963 689.179 465.963C688.419 465.963 688.419 467.062 689.179 467.062Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M753.922 483.298C754.692 483.298 754.692 482.199 753.922 482.199C753.162 482.199 753.162 483.298 753.922 483.298Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M825.519 483.298C826.279 483.298 826.279 482.199 825.519 482.199C824.759 482.199 824.759 483.298 825.519 483.298Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.577 399.295C650.337 399.295 650.337 398.195 649.577 398.195C648.808 398.195 648.808 399.295 649.577 399.295Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632.521 497.099C632.011 497.334 631.501 497.57 631.001 497.805C630.311 498.121 630.911 499.069 631.591 498.753C632.101 498.519 632.611 498.283 633.121 498.048C633.801 497.732 633.201 496.783 632.521 497.099Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.82 440.943C617.59 440.943 617.59 439.844 616.82 439.844C616.06 439.844 616.06 440.943 616.82 440.943Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M772.968 539.772C773.728 539.772 773.728 538.674 772.968 538.674C772.198 538.674 772.198 539.772 772.968 539.772Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M820.191 690.839C820.951 690.839 820.951 689.74 820.191 689.74C819.431 689.74 819.421 690.839 820.191 690.839Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.312 609.502C747.832 609.502 747.842 607.305 746.312 607.305C744.782 607.305 744.782 609.502 746.312 609.502Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M636.632 576.324C638.152 576.324 638.162 574.127 636.632 574.127C635.102 574.127 635.102 576.324 636.632 576.324Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.452 653.975C609.972 653.975 609.972 651.777 608.452 651.777C606.922 651.777 606.922 653.975 608.452 653.975Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M827.038 757.037C828.568 757.037 828.568 754.84 827.038 754.84C825.518 754.84 825.518 757.037 827.038 757.037Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.89 828.337C851.42 828.337 851.42 826.139 849.89 826.139C848.37 826.139 848.37 828.337 849.89 828.337Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.28 870.692C827.81 870.692 827.81 868.494 826.28 868.494C824.76 868.494 824.75 870.692 826.28 870.692Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M790.48 649.738C792.01 649.738 792.01 647.541 790.48 647.541C788.96 647.541 788.95 649.738 790.48 649.738Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M688.421 600.323C689.951 600.323 689.951 598.125 688.421 598.125C686.891 598.125 686.891 600.323 688.421 600.323Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M695.28 514.201C696.8 514.201 696.8 512.004 695.28 512.004C693.75 512.004 693.75 514.201 695.28 514.201Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M645.773 453.494C647.293 453.494 647.303 451.297 645.773 451.297C644.243 451.297 644.243 453.494 645.773 453.494Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M670.902 561.498C672.432 561.498 672.432 559.301 670.902 559.301C669.382 559.301 669.372 561.498 670.902 561.498Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M772.202 572.795C773.733 572.795 773.733 570.598 772.202 570.598C770.683 570.598 770.683 572.795 772.202 572.795Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M832.711 506.749C832.711 507.455 832.711 508.16 832.711 508.867C832.711 510.28 835.081 510.283 835.081 508.867C835.081 508.16 835.081 507.455 835.081 506.749C835.081 505.335 832.711 505.333 832.711 506.749Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M720.152 438.124C720.402 438.595 720.662 439.066 720.912 439.535C721.592 440.801 723.642 439.689 722.962 438.427C722.702 437.956 722.452 437.485 722.202 437.015C721.512 435.749 719.472 436.862 720.152 438.124Z",
    fill: "#FFFFFE"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.597 639.126C168.867 639.126 168.867 637.303 167.597 637.303C166.337 637.303 166.327 639.126 167.597 639.126Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.499 685.192C143.759 685.192 143.759 683.369 142.499 683.369C141.229 683.369 141.229 685.192 142.499 685.192Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.863 617.256C232.133 617.256 232.133 615.434 230.863 615.434C229.603 615.434 229.593 617.256 230.863 617.256Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.57 602.598C142.34 602.598 142.34 601.5 141.57 601.5C140.81 601.5 140.81 602.598 141.57 602.598Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.863 496.712C144.623 496.712 144.623 495.613 143.863 495.613C143.103 495.613 143.093 496.712 143.863 496.712Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.781 539.772C237.541 539.772 237.551 538.674 236.781 538.674C236.021 538.674 236.021 539.772 236.781 539.772Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.699 411.294C199.459 411.294 199.459 410.195 198.699 410.195C197.939 410.195 197.929 411.294 198.699 411.294Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.468 332.938C184.228 332.938 184.228 331.84 183.468 331.84C182.698 331.84 182.698 332.938 183.468 332.938Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.658 315.057C152.398 314.821 152.148 314.586 151.888 314.352C151.348 313.85 150.518 314.627 151.058 315.128C151.308 315.364 151.558 315.599 151.818 315.834C152.358 316.335 153.198 315.558 152.658 315.057Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.988 538.359C185.748 538.359 185.748 537.26 184.988 537.26C184.228 537.26 184.218 538.359 184.988 538.359Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.89 468.319C212.41 468.319 212.41 466.121 210.89 466.121C209.36 466.121 209.36 468.319 210.89 468.319Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.569 428.08C159.089 428.08 159.099 425.883 157.569 425.883C156.039 425.883 156.039 428.08 157.569 428.08Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.898 568.558C180.418 568.558 180.418 566.359 178.898 566.359C177.368 566.359 177.368 568.558 178.898 568.558Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.78 590.442C238.31 590.442 238.31 588.244 236.78 588.244C235.26 588.244 235.25 590.442 236.78 590.442Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.171 391.372C230.691 391.372 230.691 389.174 229.171 389.174C227.641 389.174 227.641 391.372 229.171 391.372Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.14 370.194C163.66 370.194 163.67 367.996 162.14 367.996C160.61 367.996 160.61 370.194 162.14 370.194Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.25 641.452C326.52 641.452 326.52 639.629 325.25 639.629C323.99 639.629 323.98 641.452 325.25 641.452Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.327 645.641C345.597 645.641 345.597 643.818 344.327 643.818C343.058 643.818 343.058 645.641 344.327 645.641Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.82 654.482C342.08 654.482 342.08 652.66 340.82 652.66C339.55 652.66 339.55 654.482 340.82 654.482Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.929 714.51C369.189 714.51 369.189 712.688 367.929 712.688C366.659 712.688 366.659 714.51 367.929 714.51Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.999 754.991C386.259 754.991 386.269 753.168 384.999 753.168C383.729 753.168 383.729 754.991 384.999 754.991Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.48 692.173C381.74 692.173 381.75 690.35 380.48 690.35C379.21 690.35 379.21 692.173 380.48 692.173Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.543 621.443C275.813 621.443 275.813 619.621 274.543 619.621C273.283 619.621 273.273 621.443 274.543 621.443Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.929 787.1C369.189 787.1 369.189 785.277 367.929 785.277C366.659 785.277 366.659 787.1 367.929 787.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.179 839.218C309.449 839.218 309.449 837.395 308.179 837.395C306.919 837.395 306.909 839.218 308.179 839.218Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.559 874.115C279.729 874.115 279.899 874.115 280.059 874.115C280.579 874.115 281.069 873.696 281.049 873.204C281.019 872.71 280.619 872.293 280.059 872.293C279.899 872.293 279.729 872.293 279.559 872.293C279.049 872.293 278.559 872.712 278.579 873.204C278.599 873.698 279.009 874.115 279.559 874.115Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.23 878.769C321.5 878.769 321.5 876.947 320.23 876.947C318.97 876.947 318.96 878.769 320.23 878.769Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.937 836.424C373.207 836.424 373.207 834.602 371.937 834.602C370.677 834.602 370.677 836.424 371.937 836.424Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.8 824.326C339.07 824.326 339.07 822.504 337.8 822.504C336.54 822.504 336.54 824.326 337.8 824.326Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.808 842.008C341.078 842.008 341.078 840.186 339.808 840.186C338.548 840.186 338.538 842.008 339.808 842.008Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.531 775.467C394.801 775.467 394.801 773.645 393.531 773.645C392.271 773.645 392.271 775.467 393.531 775.467Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.281 744.29C332.541 744.29 332.541 742.467 331.281 742.467C330.011 742.467 330.011 744.29 331.281 744.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.648 671.233C301.908 671.233 301.918 669.41 300.648 669.41C299.378 669.41 299.378 671.233 300.648 671.233Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.468 700.084C257.728 700.084 257.728 698.262 256.468 698.262C255.198 698.262 255.198 700.084 256.468 700.084Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.101 788.496C289.361 788.496 289.371 786.674 288.101 786.674C286.831 786.674 286.831 788.496 288.101 788.496Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.59 732.125C461.35 732.125 461.36 731.025 460.59 731.025C459.83 731.025 459.83 732.125 460.59 732.125Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.121 766.094C444.891 766.094 444.891 764.996 444.121 764.996C443.361 764.996 443.361 766.094 444.121 766.094Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.679 784.306C488.439 784.306 488.439 783.207 487.679 783.207C486.919 783.207 486.919 784.306 487.679 784.306Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.09 822.214C452.86 822.214 452.86 821.115 452.09 821.115C451.33 821.115 451.33 822.214 452.09 822.214Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.23 835.506C403.99 835.506 403.99 834.408 403.23 834.408C402.46 834.408 402.46 835.506 403.23 835.506Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.562 794.646C435.332 794.646 435.332 793.547 434.562 793.547C433.802 793.547 433.802 794.646 434.562 794.646Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.851 701.605C431.611 701.605 431.611 700.506 430.851 700.506C430.081 700.506 430.081 701.605 430.851 701.605Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.398 639.576C475.158 639.576 475.168 638.477 474.398 638.477C473.638 638.477 473.638 639.576 474.398 639.576Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.91 626.775C398.09 626.775 398.27 626.775 398.44 626.775C399.21 626.775 399.21 625.676 398.44 625.676C398.27 625.676 398.09 625.676 397.91 625.676C397.15 625.676 397.15 626.775 397.91 626.775Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.862 651.23C276.042 651.393 276.212 651.558 276.392 651.721C276.932 652.223 277.772 651.445 277.232 650.945C277.052 650.781 276.872 650.617 276.702 650.453C276.162 649.952 275.322 650.729 275.862 651.23Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.492 720.802C306.252 720.802 306.262 719.703 305.492 719.703C304.732 719.703 304.732 720.802 305.492 720.802Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.882 847.813C440.642 847.813 440.642 846.715 439.882 846.715C439.112 846.715 439.112 847.813 439.882 847.813Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.429 859.137C484.189 859.137 484.199 858.039 483.429 858.039C482.669 858.039 482.669 859.137 483.429 859.137Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.507 871.446C383.267 871.446 383.267 870.346 382.507 870.346C381.748 870.346 381.748 871.446 382.507 871.446Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.859 864.552C346.619 864.552 346.619 863.453 345.859 863.453C345.099 863.453 345.099 864.552 345.859 864.552Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.882 867.013C440.642 867.013 440.642 865.914 439.882 865.914C439.112 865.914 439.112 867.013 439.882 867.013Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.929 576.48C361.699 576.48 361.699 575.381 360.929 575.381C360.169 575.381 360.169 576.48 360.929 576.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.468 570.126C462.238 570.126 462.238 569.027 461.468 569.027C460.708 569.027 460.708 570.126 461.468 570.126Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.179 467.062C328.939 467.062 328.949 465.963 328.179 465.963C327.419 465.963 327.419 467.062 328.179 467.062Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.922 483.298C393.692 483.298 393.692 482.199 392.922 482.199C392.162 482.199 392.162 483.298 392.922 483.298Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.519 483.298C465.279 483.298 465.279 482.199 464.519 482.199C463.759 482.199 463.759 483.298 464.519 483.298Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.577 399.295C289.337 399.295 289.337 398.195 288.577 398.195C287.808 398.195 287.808 399.295 288.577 399.295Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.521 497.099C271.011 497.334 270.501 497.57 270.001 497.805C269.311 498.121 269.911 499.069 270.591 498.753C271.101 498.519 271.611 498.283 272.121 498.048C272.801 497.732 272.201 496.783 271.521 497.099Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.82 440.943C256.59 440.943 256.59 439.844 255.82 439.844C255.06 439.844 255.06 440.943 255.82 440.943Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.968 539.772C412.728 539.772 412.728 538.674 411.968 538.674C411.198 538.674 411.198 539.772 411.968 539.772Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.191 690.839C459.951 690.839 459.951 689.74 459.191 689.74C458.431 689.74 458.421 690.839 459.191 690.839Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.312 609.502C386.832 609.502 386.842 607.305 385.312 607.305C383.782 607.305 383.782 609.502 385.312 609.502Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.632 576.324C277.152 576.324 277.162 574.127 275.632 574.127C274.102 574.127 274.102 576.324 275.632 576.324Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.452 653.975C248.972 653.975 248.972 651.777 247.452 651.777C245.922 651.777 245.922 653.975 247.452 653.975Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M466.038 757.037C467.568 757.037 467.568 754.84 466.038 754.84C464.518 754.84 464.518 757.037 466.038 757.037Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.89 828.337C490.42 828.337 490.42 826.139 488.89 826.139C487.37 826.139 487.37 828.337 488.89 828.337Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.28 870.692C466.81 870.692 466.81 868.494 465.28 868.494C463.76 868.494 463.75 870.692 465.28 870.692Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.48 649.738C431.01 649.738 431.01 647.541 429.48 647.541C427.96 647.541 427.95 649.738 429.48 649.738Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.421 600.323C328.951 600.323 328.951 598.125 327.421 598.125C325.891 598.125 325.891 600.323 327.421 600.323Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.28 514.201C335.8 514.201 335.8 512.004 334.28 512.004C332.75 512.004 332.75 514.201 334.28 514.201Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.773 453.494C286.293 453.494 286.303 451.297 284.773 451.297C283.243 451.297 283.243 453.494 284.773 453.494Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.902 561.498C311.432 561.498 311.432 559.301 309.902 559.301C308.382 559.301 308.372 561.498 309.902 561.498Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.202 572.795C412.733 572.795 412.733 570.598 411.202 570.598C409.683 570.598 409.683 572.795 411.202 572.795Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.711 506.749C471.711 507.455 471.711 508.16 471.711 508.867C471.711 510.28 474.081 510.283 474.081 508.867C474.081 508.16 474.081 507.455 474.081 506.749C474.081 505.335 471.711 505.333 471.711 506.749Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.152 438.124C359.402 438.595 359.662 439.066 359.912 439.535C360.592 440.801 362.642 439.689 361.962 438.427C361.702 437.956 361.452 437.485 361.202 437.015C360.512 435.749 358.472 436.862 359.152 438.124Z",
    fill: "#FFFFFE"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5972 866.194C71.8672 866.194 71.8672 864.371 70.5972 864.371C69.3372 864.371 69.3272 866.194 70.5972 866.194Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4994 912.261C46.7594 912.261 46.7594 910.438 45.4994 910.438C44.2294 910.438 44.2294 912.261 45.4994 912.261Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.863 844.324C135.133 844.324 135.133 842.502 133.863 842.502C132.603 842.502 132.593 844.324 133.863 844.324Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.57 829.667C45.34 829.667 45.34 828.568 44.57 828.568C43.81 828.568 43.81 829.667 44.57 829.667Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8628 723.78C47.6228 723.78 47.6228 722.682 46.8628 722.682C46.1028 722.682 46.0928 723.78 46.8628 723.78Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.781 766.84C140.541 766.84 140.551 765.742 139.781 765.742C139.021 765.742 139.021 766.84 139.781 766.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.699 638.362C102.459 638.362 102.459 637.264 101.699 637.264C100.939 637.264 100.929 638.362 101.699 638.362Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4681 560.006C87.2281 560.006 87.2281 558.908 86.4681 558.908C85.6981 558.908 85.6981 560.006 86.4681 560.006Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6582 542.125C55.3982 541.89 55.1482 541.654 54.8882 541.42C54.3482 540.918 53.5182 541.695 54.0582 542.197C54.3082 542.432 54.5582 542.667 54.8182 542.903C55.3582 543.403 56.1982 542.627 55.6582 542.125Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9878 765.427C88.7478 765.427 88.7478 764.328 87.9878 764.328C87.2278 764.328 87.2178 765.427 87.9878 765.427Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.89 695.385C115.41 695.385 115.41 693.188 113.89 693.188C112.36 693.188 112.36 695.385 113.89 695.385Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5694 655.149C62.0894 655.149 62.0994 652.951 60.5694 652.951C59.0394 652.951 59.0394 655.149 60.5694 655.149Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8975 795.628C83.4175 795.628 83.4175 793.43 81.8975 793.43C80.3675 793.43 80.3675 795.628 81.8975 795.628Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.78 817.51C141.31 817.51 141.31 815.313 139.78 815.313C138.26 815.313 138.25 817.51 139.78 817.51Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.171 618.441C133.691 618.441 133.691 616.242 132.171 616.242C130.641 616.242 130.641 618.441 132.171 618.441Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1397 597.262C66.6597 597.262 66.6697 595.064 65.1397 595.064C63.6097 595.064 63.6097 597.262 65.1397 597.262Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.25 868.52C229.52 868.52 229.52 866.697 228.25 866.697C226.99 866.697 226.98 868.52 228.25 868.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.327 872.71C248.597 872.71 248.597 870.887 247.327 870.887C246.058 870.887 246.058 872.71 247.327 872.71Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.82 881.551C245.08 881.551 245.08 879.729 243.82 879.729C242.55 879.729 242.55 881.551 243.82 881.551Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.929 941.576C272.189 941.576 272.189 939.754 270.929 939.754C269.659 939.754 269.659 941.576 270.929 941.576Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.999 982.059C289.259 982.059 289.269 980.236 287.999 980.236C286.729 980.236 286.729 982.059 287.999 982.059Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.48 919.241C284.74 919.241 284.75 917.418 283.48 917.418C282.21 917.418 282.21 919.241 283.48 919.241Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.543 848.512C178.813 848.512 178.813 846.69 177.543 846.69C176.283 846.69 176.273 848.512 177.543 848.512Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.929 1014.17C272.189 1014.17 272.189 1012.35 270.929 1012.35C269.659 1012.35 269.659 1014.17 270.929 1014.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.179 1066.28C212.449 1066.28 212.449 1064.46 211.179 1064.46C209.919 1064.46 209.909 1066.28 211.179 1066.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.559 1101.18C182.729 1101.18 182.899 1101.18 183.059 1101.18C183.579 1101.18 184.069 1100.76 184.049 1100.27C184.019 1099.78 183.619 1099.36 183.059 1099.36C182.899 1099.36 182.729 1099.36 182.559 1099.36C182.049 1099.36 181.559 1099.78 181.579 1100.27C181.599 1100.77 182.009 1101.18 182.559 1101.18Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.23 1105.84C224.5 1105.84 224.5 1104.02 223.23 1104.02C221.97 1104.02 221.96 1105.84 223.23 1105.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.937 1063.49C276.207 1063.49 276.207 1061.67 274.937 1061.67C273.677 1061.67 273.677 1063.49 274.937 1063.49Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.8 1051.39C242.07 1051.39 242.07 1049.57 240.8 1049.57C239.54 1049.57 239.54 1051.39 240.8 1051.39Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.808 1069.08C244.078 1069.08 244.078 1067.25 242.808 1067.25C241.548 1067.25 241.538 1069.08 242.808 1069.08Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.531 1002.54C297.801 1002.54 297.801 1000.71 296.531 1000.71C295.271 1000.71 295.271 1002.54 296.531 1002.54Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.281 971.358C235.541 971.358 235.541 969.535 234.281 969.535C233.011 969.535 233.011 971.358 234.281 971.358Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.648 898.302C204.908 898.302 204.918 896.479 203.648 896.479C202.378 896.479 202.378 898.302 203.648 898.302Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.468 927.15C160.728 927.15 160.728 925.328 159.468 925.328C158.198 925.328 158.198 927.15 159.468 927.15Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.101 1015.56C192.361 1015.56 192.371 1013.74 191.101 1013.74C189.831 1013.74 189.831 1015.56 191.101 1015.56Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.59 959.195C364.35 959.195 364.36 958.096 363.59 958.096C362.83 958.096 362.83 959.195 363.59 959.195Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.121 993.161C347.891 993.161 347.891 992.062 347.121 992.062C346.361 992.062 346.361 993.161 347.121 993.161Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.679 1011.38C391.439 1011.38 391.439 1010.28 390.679 1010.28C389.919 1010.28 389.919 1011.38 390.679 1011.38Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.09 1049.28C355.86 1049.28 355.86 1048.18 355.09 1048.18C354.33 1048.18 354.33 1049.28 355.09 1049.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.23 1062.57C306.99 1062.57 306.99 1061.48 306.23 1061.48C305.46 1061.48 305.46 1062.57 306.23 1062.57Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.562 1021.71C338.332 1021.71 338.332 1020.62 337.562 1020.62C336.802 1020.62 336.802 1021.71 337.562 1021.71Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.851 928.673C334.611 928.673 334.611 927.574 333.851 927.574C333.081 927.574 333.081 928.673 333.851 928.673Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.398 866.644C378.158 866.644 378.168 865.545 377.398 865.545C376.638 865.545 376.638 866.644 377.398 866.644Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.91 853.845C301.09 853.845 301.27 853.845 301.44 853.845C302.21 853.845 302.21 852.746 301.44 852.746C301.27 852.746 301.09 852.746 300.91 852.746C300.15 852.746 300.15 853.845 300.91 853.845Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.862 878.299C179.042 878.462 179.212 878.627 179.392 878.79C179.932 879.291 180.772 878.514 180.232 878.013C180.052 877.849 179.872 877.685 179.702 877.521C179.162 877.02 178.322 877.797 178.862 878.299Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.492 947.873C209.252 947.873 209.262 946.773 208.492 946.773C207.732 946.773 207.732 947.873 208.492 947.873Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.882 1074.88C343.642 1074.88 343.642 1073.79 342.882 1073.79C342.112 1073.79 342.112 1074.88 342.882 1074.88Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.429 1086.21C387.189 1086.21 387.199 1085.11 386.429 1085.11C385.669 1085.11 385.669 1086.21 386.429 1086.21Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.507 1098.51C286.267 1098.51 286.267 1097.41 285.507 1097.41C284.748 1097.41 284.748 1098.51 285.507 1098.51Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.859 1091.62C249.619 1091.62 249.619 1090.52 248.859 1090.52C248.099 1090.52 248.099 1091.62 248.859 1091.62Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.882 1094.08C343.642 1094.08 343.642 1092.98 342.882 1092.98C342.112 1092.98 342.112 1094.08 342.882 1094.08Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.929 803.548C264.699 803.548 264.699 802.449 263.929 802.449C263.169 802.449 263.169 803.548 263.929 803.548Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.468 797.195C365.238 797.195 365.238 796.096 364.468 796.096C363.708 796.096 363.708 797.195 364.468 797.195Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.179 694.13C231.939 694.13 231.949 693.031 231.179 693.031C230.419 693.031 230.419 694.13 231.179 694.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.922 710.367C296.692 710.367 296.692 709.268 295.922 709.268C295.162 709.268 295.162 710.367 295.922 710.367Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.519 710.367C368.279 710.367 368.279 709.268 367.519 709.268C366.759 709.268 366.759 710.367 367.519 710.367Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.577 626.363C192.337 626.363 192.337 625.264 191.577 625.264C190.808 625.264 190.808 626.363 191.577 626.363Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.521 724.167C174.011 724.402 173.501 724.638 173.001 724.873C172.311 725.189 172.911 726.137 173.591 725.821C174.101 725.587 174.611 725.352 175.121 725.116C175.801 724.8 175.201 723.851 174.521 724.167Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.82 668.011C159.59 668.011 159.59 666.912 158.82 666.912C158.06 666.912 158.06 668.011 158.82 668.011Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.968 766.84C315.728 766.84 315.728 765.742 314.968 765.742C314.198 765.742 314.198 766.84 314.968 766.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.191 917.908C362.951 917.908 362.951 916.809 362.191 916.809C361.431 916.809 361.421 917.908 362.191 917.908Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.312 836.569C289.832 836.569 289.842 834.371 288.312 834.371C286.782 834.371 286.782 836.569 288.312 836.569Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.632 803.393C180.152 803.393 180.162 801.195 178.632 801.195C177.102 801.195 177.102 803.393 178.632 803.393Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.452 881.043C151.972 881.043 151.972 878.846 150.452 878.846C148.922 878.846 148.922 881.043 150.452 881.043Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.038 984.108C370.568 984.108 370.568 981.91 369.038 981.91C367.518 981.91 367.518 984.108 369.038 984.108Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.89 1055.41C393.42 1055.41 393.42 1053.21 391.89 1053.21C390.37 1053.21 390.37 1055.41 391.89 1055.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.28 1097.76C369.81 1097.76 369.81 1095.56 368.28 1095.56C366.76 1095.56 366.75 1097.76 368.28 1097.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.48 876.807C334.01 876.807 334.01 874.609 332.48 874.609C330.96 874.609 330.95 876.807 332.48 876.807Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.421 827.394C231.951 827.394 231.951 825.195 230.421 825.195C228.891 825.195 228.891 827.394 230.421 827.394Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.28 741.27C238.8 741.27 238.8 739.072 237.28 739.072C235.75 739.072 235.75 741.27 237.28 741.27Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.773 680.561C189.293 680.561 189.303 678.363 187.773 678.363C186.243 678.363 186.243 680.561 187.773 680.561Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.902 788.567C214.432 788.567 214.432 786.369 212.902 786.369C211.382 786.369 211.372 788.567 212.902 788.567Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.202 799.862C315.733 799.862 315.733 797.664 314.202 797.664C312.683 797.664 312.683 799.862 314.202 799.862Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.711 733.817C374.711 734.524 374.711 735.229 374.711 735.935C374.711 737.348 377.081 737.351 377.081 735.935C377.081 735.229 377.081 734.524 377.081 733.817C377.081 732.403 374.711 732.401 374.711 733.817Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.152 665.192C262.402 665.663 262.662 666.134 262.912 666.604C263.592 667.869 265.642 666.758 264.962 665.495C264.702 665.025 264.452 664.554 264.202 664.083C263.512 662.818 261.472 663.93 262.152 665.192Z",
    fill: "#FFFFFE"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.597 841.169C475.867 841.169 475.867 839.346 474.597 839.346C473.337 839.346 473.327 841.169 474.597 841.169Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.499 887.235C450.759 887.235 450.759 885.412 449.499 885.412C448.229 885.412 448.229 887.235 449.499 887.235Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.863 819.299C539.133 819.299 539.133 817.477 537.863 817.477C536.603 817.477 536.593 819.299 537.863 819.299Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.57 804.641C449.34 804.641 449.34 803.543 448.57 803.543C447.81 803.543 447.81 804.641 448.57 804.641Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.863 698.753C451.623 698.753 451.623 697.655 450.863 697.655C450.103 697.655 450.093 698.753 450.863 698.753Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.781 741.815C544.541 741.815 544.551 740.717 543.781 740.717C543.021 740.717 543.021 741.815 543.781 741.815Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.699 613.337C506.459 613.337 506.459 612.238 505.699 612.238C504.939 612.238 504.929 613.337 505.699 613.337Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.468 534.981C491.228 534.981 491.228 533.883 490.468 533.883C489.698 533.883 489.698 534.981 490.468 534.981Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.658 517.1C459.398 516.864 459.148 516.629 458.888 516.394C458.348 515.893 457.518 516.67 458.058 517.171C458.308 517.407 458.558 517.642 458.818 517.877C459.358 518.378 460.198 517.601 459.658 517.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.988 740.402C492.748 740.402 492.748 739.303 491.988 739.303C491.228 739.303 491.218 740.402 491.988 740.402Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.89 670.362C519.41 670.362 519.41 668.164 517.89 668.164C516.36 668.164 516.36 670.362 517.89 670.362Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.569 630.123C466.089 630.123 466.099 627.926 464.569 627.926C463.039 627.926 463.039 630.123 464.569 630.123Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.898 770.601C487.418 770.601 487.418 768.402 485.898 768.402C484.368 768.402 484.368 770.601 485.898 770.601Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.78 792.485C545.31 792.485 545.31 790.287 543.78 790.287C542.26 790.287 542.25 792.485 543.78 792.485Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.171 593.415C537.691 593.415 537.691 591.217 536.171 591.217C534.641 591.217 534.641 593.415 536.171 593.415Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.14 572.237C470.66 572.237 470.67 570.039 469.14 570.039C467.61 570.039 467.61 572.237 469.14 572.237Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632.25 843.495C633.52 843.495 633.52 841.672 632.25 841.672C630.99 841.672 630.98 843.495 632.25 843.495Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M651.327 847.684C652.597 847.684 652.597 845.861 651.327 845.861C650.058 845.861 650.058 847.684 651.327 847.684Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647.82 856.525C649.08 856.525 649.08 854.703 647.82 854.703C646.55 854.703 646.55 856.525 647.82 856.525Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.929 916.553C676.189 916.553 676.189 914.73 674.929 914.73C673.659 914.73 673.659 916.553 674.929 916.553Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M691.999 957.034C693.259 957.034 693.269 955.211 691.999 955.211C690.729 955.211 690.729 957.034 691.999 957.034Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M687.48 894.216C688.74 894.216 688.75 892.393 687.48 892.393C686.21 892.393 686.21 894.216 687.48 894.216Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.543 823.486C582.813 823.486 582.813 821.664 581.543 821.664C580.283 821.664 580.273 823.486 581.543 823.486Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.929 989.143C676.189 989.143 676.189 987.32 674.929 987.32C673.659 987.32 673.659 989.143 674.929 989.143Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M615.179 1041.26C616.449 1041.26 616.449 1039.44 615.179 1039.44C613.919 1039.44 613.909 1041.26 615.179 1041.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.559 1076.16C586.729 1076.16 586.899 1076.16 587.059 1076.16C587.579 1076.16 588.069 1075.74 588.049 1075.25C588.019 1074.75 587.619 1074.34 587.059 1074.34C586.899 1074.34 586.729 1074.34 586.559 1074.34C586.049 1074.34 585.559 1074.75 585.579 1075.25C585.599 1075.74 586.009 1076.16 586.559 1076.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.23 1080.81C628.5 1080.81 628.5 1078.99 627.23 1078.99C625.97 1078.99 625.96 1080.81 627.23 1080.81Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M678.937 1038.47C680.207 1038.47 680.207 1036.64 678.937 1036.64C677.677 1036.64 677.677 1038.47 678.937 1038.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.8 1026.37C646.07 1026.37 646.07 1024.55 644.8 1024.55C643.54 1024.55 643.54 1026.37 644.8 1026.37Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M646.808 1044.05C648.078 1044.05 648.078 1042.23 646.808 1042.23C645.548 1042.23 645.538 1044.05 646.808 1044.05Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.531 977.51C701.801 977.51 701.801 975.688 700.531 975.688C699.271 975.688 699.271 977.51 700.531 977.51Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.281 946.331C639.541 946.331 639.541 944.508 638.281 944.508C637.011 944.508 637.011 946.331 638.281 946.331Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M607.648 873.276C608.908 873.276 608.918 871.453 607.648 871.453C606.378 871.453 606.378 873.276 607.648 873.276Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.468 902.127C564.728 902.127 564.728 900.305 563.468 900.305C562.198 900.305 562.198 902.127 563.468 902.127Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.101 990.539C596.361 990.539 596.371 988.717 595.101 988.717C593.831 988.717 593.831 990.539 595.101 990.539Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M767.59 934.168C768.35 934.168 768.36 933.068 767.59 933.068C766.83 933.068 766.83 934.168 767.59 934.168Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M751.121 968.137C751.891 968.137 751.891 967.039 751.121 967.039C750.361 967.039 750.361 968.137 751.121 968.137Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M794.679 986.349C795.439 986.349 795.439 985.25 794.679 985.25C793.919 985.25 793.919 986.349 794.679 986.349Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M759.09 1024.26C759.86 1024.26 759.86 1023.16 759.09 1023.16C758.33 1023.16 758.33 1024.26 759.09 1024.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.23 1037.55C710.99 1037.55 710.99 1036.45 710.23 1036.45C709.46 1036.45 709.46 1037.55 710.23 1037.55Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M741.562 996.689C742.332 996.689 742.332 995.59 741.562 995.59C740.802 995.59 740.802 996.689 741.562 996.689Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M737.851 903.646C738.611 903.646 738.611 902.547 737.851 902.547C737.081 902.547 737.081 903.646 737.851 903.646Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M781.398 841.619C782.158 841.619 782.168 840.52 781.398 840.52C780.638 840.52 780.638 841.619 781.398 841.619Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M704.91 828.818C705.09 828.818 705.27 828.818 705.44 828.818C706.21 828.818 706.21 827.719 705.44 827.719C705.27 827.719 705.09 827.719 704.91 827.719C704.15 827.719 704.15 828.818 704.91 828.818Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.862 853.271C583.042 853.434 583.212 853.599 583.392 853.762C583.932 854.264 584.772 853.486 584.232 852.986C584.052 852.822 583.872 852.658 583.702 852.494C583.162 851.993 582.322 852.77 582.862 853.271Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.492 922.845C613.252 922.845 613.262 921.746 612.492 921.746C611.732 921.746 611.732 922.845 612.492 922.845Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.882 1049.86C747.642 1049.86 747.642 1048.76 746.882 1048.76C746.112 1048.76 746.112 1049.86 746.882 1049.86Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M790.429 1061.18C791.189 1061.18 791.199 1060.08 790.429 1060.08C789.669 1060.08 789.669 1061.18 790.429 1061.18Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M689.507 1073.49C690.267 1073.49 690.267 1072.39 689.507 1072.39C688.748 1072.39 688.748 1073.49 689.507 1073.49Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.859 1066.6C653.619 1066.6 653.619 1065.5 652.859 1065.5C652.099 1065.5 652.099 1066.6 652.859 1066.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.882 1069.06C747.642 1069.06 747.642 1067.96 746.882 1067.96C746.112 1067.96 746.112 1069.06 746.882 1069.06Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M667.929 778.523C668.699 778.523 668.699 777.424 667.929 777.424C667.169 777.424 667.169 778.523 667.929 778.523Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M768.468 772.169C769.238 772.169 769.238 771.07 768.468 771.07C767.708 771.07 767.708 772.169 768.468 772.169Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M635.179 669.105C635.939 669.105 635.949 668.006 635.179 668.006C634.419 668.006 634.419 669.105 635.179 669.105Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M699.922 685.341C700.692 685.341 700.692 684.242 699.922 684.242C699.162 684.242 699.162 685.341 699.922 685.341Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M771.519 685.341C772.279 685.341 772.279 684.242 771.519 684.242C770.759 684.242 770.759 685.341 771.519 685.341Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.577 601.337C596.337 601.337 596.337 600.238 595.577 600.238C594.808 600.238 594.808 601.337 595.577 601.337Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.521 699.142C578.011 699.377 577.501 699.613 577.001 699.848C576.311 700.164 576.911 701.112 577.591 700.796C578.101 700.562 578.611 700.326 579.121 700.091C579.801 699.775 579.201 698.826 578.521 699.142Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M562.82 642.986C563.59 642.986 563.59 641.887 562.82 641.887C562.06 641.887 562.06 642.986 562.82 642.986Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.968 741.815C719.728 741.815 719.728 740.717 718.968 740.717C718.198 740.717 718.198 741.815 718.968 741.815Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.191 892.882C766.951 892.882 766.951 891.783 766.191 891.783C765.431 891.783 765.421 892.882 766.191 892.882Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M692.312 811.545C693.832 811.545 693.842 809.348 692.312 809.348C690.782 809.348 690.782 811.545 692.312 811.545Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.632 778.366C584.152 778.366 584.162 776.168 582.632 776.168C581.102 776.168 581.102 778.366 582.632 778.366Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M554.452 856.018C555.972 856.018 555.972 853.82 554.452 853.82C552.922 853.82 552.922 856.018 554.452 856.018Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M773.038 959.08C774.568 959.08 774.568 956.883 773.038 956.883C771.518 956.883 771.518 959.08 773.038 959.08Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M795.89 1030.38C797.42 1030.38 797.42 1028.18 795.89 1028.18C794.37 1028.18 794.37 1030.38 795.89 1030.38Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M772.28 1072.73C773.81 1072.73 773.81 1070.54 772.28 1070.54C770.76 1070.54 770.75 1072.73 772.28 1072.73Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M736.48 851.781C738.01 851.781 738.01 849.584 736.48 849.584C734.96 849.584 734.95 851.781 736.48 851.781Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M634.421 802.366C635.951 802.366 635.951 800.168 634.421 800.168C632.891 800.168 632.891 802.366 634.421 802.366Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M641.28 716.244C642.8 716.244 642.8 714.047 641.28 714.047C639.75 714.047 639.75 716.244 641.28 716.244Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.773 655.537C593.293 655.537 593.303 653.34 591.773 653.34C590.243 653.34 590.243 655.537 591.773 655.537Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.902 763.541C618.432 763.541 618.432 761.344 616.902 761.344C615.382 761.344 615.372 763.541 616.902 763.541Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.202 774.838C719.733 774.838 719.733 772.641 718.202 772.641C716.683 772.641 716.683 774.838 718.202 774.838Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M778.711 708.792C778.711 709.498 778.711 710.203 778.711 710.91C778.711 712.323 781.081 712.326 781.081 710.91C781.081 710.203 781.081 709.498 781.081 708.792C781.081 707.378 778.711 707.376 778.711 708.792Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M666.152 640.167C666.402 640.638 666.662 641.108 666.912 641.578C667.592 642.843 669.642 641.732 668.962 640.47C668.702 639.999 668.452 639.528 668.202 639.057C667.512 637.792 665.472 638.904 666.152 640.167Z",
    fill: "#FFFFFE"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1178.6 866.194C1179.87 866.194 1179.87 864.371 1178.6 864.371C1177.34 864.371 1177.33 866.194 1178.6 866.194Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1153.5 912.261C1154.76 912.261 1154.76 910.438 1153.5 910.438C1152.23 910.438 1152.23 912.261 1153.5 912.261Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1241.86 844.324C1243.13 844.324 1243.13 842.502 1241.86 842.502C1240.6 842.502 1240.59 844.324 1241.86 844.324Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1152.57 829.667C1153.34 829.667 1153.34 828.568 1152.57 828.568C1151.81 828.568 1151.81 829.667 1152.57 829.667Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1154.86 723.78C1155.62 723.78 1155.62 722.682 1154.86 722.682C1154.1 722.682 1154.09 723.78 1154.86 723.78Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1247.78 766.84C1248.54 766.84 1248.55 765.742 1247.78 765.742C1247.02 765.742 1247.02 766.84 1247.78 766.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1209.7 638.362C1210.46 638.362 1210.46 637.264 1209.7 637.264C1208.94 637.264 1208.93 638.362 1209.7 638.362Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1194.47 560.006C1195.23 560.006 1195.23 558.908 1194.47 558.908C1193.7 558.908 1193.7 560.006 1194.47 560.006Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1163.66 542.125C1163.4 541.89 1163.15 541.654 1162.89 541.42C1162.35 540.918 1161.52 541.695 1162.06 542.197C1162.31 542.432 1162.56 542.667 1162.82 542.903C1163.36 543.403 1164.2 542.627 1163.66 542.125Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1195.99 765.427C1196.75 765.427 1196.75 764.328 1195.99 764.328C1195.23 764.328 1195.22 765.427 1195.99 765.427Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1221.89 695.385C1223.41 695.385 1223.41 693.188 1221.89 693.188C1220.36 693.188 1220.36 695.385 1221.89 695.385Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1168.57 655.149C1170.09 655.149 1170.1 652.951 1168.57 652.951C1167.04 652.951 1167.04 655.149 1168.57 655.149Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1189.9 795.628C1191.42 795.628 1191.42 793.43 1189.9 793.43C1188.37 793.43 1188.37 795.628 1189.9 795.628Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1247.78 817.51C1249.31 817.51 1249.31 815.313 1247.78 815.313C1246.26 815.313 1246.25 817.51 1247.78 817.51Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1240.17 618.441C1241.69 618.441 1241.69 616.242 1240.17 616.242C1238.64 616.242 1238.64 618.441 1240.17 618.441Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1173.14 597.262C1174.66 597.262 1174.67 595.064 1173.14 595.064C1171.61 595.064 1171.61 597.262 1173.14 597.262Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1336.25 868.52C1337.52 868.52 1337.52 866.697 1336.25 866.697C1334.99 866.697 1334.98 868.52 1336.25 868.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1355.33 872.71C1356.6 872.71 1356.6 870.887 1355.33 870.887C1354.06 870.887 1354.06 872.71 1355.33 872.71Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1351.82 881.551C1353.08 881.551 1353.08 879.729 1351.82 879.729C1350.55 879.729 1350.55 881.551 1351.82 881.551Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1378.93 941.576C1380.19 941.576 1380.19 939.754 1378.93 939.754C1377.66 939.754 1377.66 941.576 1378.93 941.576Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1396 982.059C1397.26 982.059 1397.27 980.236 1396 980.236C1394.73 980.236 1394.73 982.059 1396 982.059Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1391.48 919.241C1392.74 919.241 1392.75 917.418 1391.48 917.418C1390.21 917.418 1390.21 919.241 1391.48 919.241Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1285.54 848.512C1286.81 848.512 1286.81 846.69 1285.54 846.69C1284.28 846.69 1284.27 848.512 1285.54 848.512Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1378.93 1014.17C1380.19 1014.17 1380.19 1012.35 1378.93 1012.35C1377.66 1012.35 1377.66 1014.17 1378.93 1014.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1319.18 1066.28C1320.45 1066.28 1320.45 1064.46 1319.18 1064.46C1317.92 1064.46 1317.91 1066.28 1319.18 1066.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1290.56 1101.18C1290.73 1101.18 1290.9 1101.18 1291.06 1101.18C1291.58 1101.18 1292.07 1100.76 1292.05 1100.27C1292.02 1099.78 1291.62 1099.36 1291.06 1099.36C1290.9 1099.36 1290.73 1099.36 1290.56 1099.36C1290.05 1099.36 1289.56 1099.78 1289.58 1100.27C1289.6 1100.77 1290.01 1101.18 1290.56 1101.18Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1331.23 1105.84C1332.5 1105.84 1332.5 1104.02 1331.23 1104.02C1329.97 1104.02 1329.96 1105.84 1331.23 1105.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1382.94 1063.49C1384.21 1063.49 1384.21 1061.67 1382.94 1061.67C1381.68 1061.67 1381.68 1063.49 1382.94 1063.49Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1348.8 1051.39C1350.07 1051.39 1350.07 1049.57 1348.8 1049.57C1347.54 1049.57 1347.54 1051.39 1348.8 1051.39Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1350.81 1069.08C1352.08 1069.08 1352.08 1067.25 1350.81 1067.25C1349.55 1067.25 1349.54 1069.08 1350.81 1069.08Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1404.53 1002.54C1405.8 1002.54 1405.8 1000.71 1404.53 1000.71C1403.27 1000.71 1403.27 1002.54 1404.53 1002.54Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1342.28 971.358C1343.54 971.358 1343.54 969.535 1342.28 969.535C1341.01 969.535 1341.01 971.358 1342.28 971.358Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1311.65 898.302C1312.91 898.302 1312.92 896.479 1311.65 896.479C1310.38 896.479 1310.38 898.302 1311.65 898.302Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1267.47 927.15C1268.73 927.15 1268.73 925.328 1267.47 925.328C1266.2 925.328 1266.2 927.15 1267.47 927.15Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1299.1 1015.56C1300.36 1015.56 1300.37 1013.74 1299.1 1013.74C1297.83 1013.74 1297.83 1015.56 1299.1 1015.56Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1414.23 1062.57C1414.99 1062.57 1414.99 1061.48 1414.23 1061.48C1413.46 1061.48 1413.46 1062.57 1414.23 1062.57Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1408.91 853.845C1409.09 853.845 1409.27 853.845 1409.44 853.845C1410.21 853.845 1410.21 852.746 1409.44 852.746C1409.27 852.746 1409.09 852.746 1408.91 852.746C1408.15 852.746 1408.15 853.845 1408.91 853.845Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1286.86 878.299C1287.04 878.462 1287.21 878.627 1287.39 878.79C1287.93 879.291 1288.77 878.514 1288.23 878.013C1288.05 877.849 1287.87 877.685 1287.7 877.521C1287.16 877.02 1286.32 877.797 1286.86 878.299Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1316.49 947.873C1317.25 947.873 1317.26 946.773 1316.49 946.773C1315.73 946.773 1315.73 947.873 1316.49 947.873Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1393.51 1098.51C1394.27 1098.51 1394.27 1097.41 1393.51 1097.41C1392.75 1097.41 1392.75 1098.51 1393.51 1098.51Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1356.86 1091.62C1357.62 1091.62 1357.62 1090.52 1356.86 1090.52C1356.1 1090.52 1356.1 1091.62 1356.86 1091.62Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1371.93 803.548C1372.7 803.548 1372.7 802.449 1371.93 802.449C1371.17 802.449 1371.17 803.548 1371.93 803.548Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1339.18 694.13C1339.94 694.13 1339.95 693.031 1339.18 693.031C1338.42 693.031 1338.42 694.13 1339.18 694.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1403.92 710.367C1404.69 710.367 1404.69 709.268 1403.92 709.268C1403.16 709.268 1403.16 710.367 1403.92 710.367Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1299.58 626.363C1300.34 626.363 1300.34 625.264 1299.58 625.264C1298.81 625.264 1298.81 626.363 1299.58 626.363Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1282.52 724.167C1282.01 724.402 1281.5 724.638 1281 724.873C1280.31 725.189 1280.91 726.137 1281.59 725.821C1282.1 725.587 1282.61 725.352 1283.12 725.116C1283.8 724.8 1283.2 723.851 1282.52 724.167Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1266.82 668.011C1267.59 668.011 1267.59 666.912 1266.82 666.912C1266.06 666.912 1266.06 668.011 1266.82 668.011Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1422.97 766.84C1423.73 766.84 1423.73 765.742 1422.97 765.742C1422.2 765.742 1422.2 766.84 1422.97 766.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1396.31 836.569C1397.83 836.569 1397.84 834.371 1396.31 834.371C1394.78 834.371 1394.78 836.569 1396.31 836.569Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1286.63 803.393C1288.15 803.393 1288.16 801.195 1286.63 801.195C1285.1 801.195 1285.1 803.393 1286.63 803.393Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1258.45 881.043C1259.97 881.043 1259.97 878.846 1258.45 878.846C1256.92 878.846 1256.92 881.043 1258.45 881.043Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440.48 876.807C1442.01 876.807 1442.01 874.609 1440.48 874.609C1438.96 874.609 1438.95 876.807 1440.48 876.807Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1338.42 827.394C1339.95 827.394 1339.95 825.195 1338.42 825.195C1336.89 825.195 1336.89 827.394 1338.42 827.394Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1345.28 741.27C1346.8 741.27 1346.8 739.072 1345.28 739.072C1343.75 739.072 1343.75 741.27 1345.28 741.27Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1295.77 680.561C1297.29 680.561 1297.3 678.363 1295.77 678.363C1294.24 678.363 1294.24 680.561 1295.77 680.561Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1320.9 788.567C1322.43 788.567 1322.43 786.369 1320.9 786.369C1319.38 786.369 1319.37 788.567 1320.9 788.567Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1422.2 799.862C1423.73 799.862 1423.73 797.664 1422.2 797.664C1420.68 797.664 1420.68 799.862 1422.2 799.862Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1370.15 665.192C1370.4 665.663 1370.66 666.134 1370.91 666.604C1371.59 667.869 1373.64 666.758 1372.96 665.495C1372.7 665.025 1372.45 664.554 1372.2 664.083C1371.51 662.818 1369.47 663.93 1370.15 665.192Z",
    fill: "#FFFFFE"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1320.6 904.194C1321.87 904.194 1321.87 902.371 1320.6 902.371C1319.34 902.371 1319.33 904.194 1320.6 904.194Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1295.5 950.261C1296.76 950.261 1296.76 948.438 1295.5 948.438C1294.23 948.438 1294.23 950.261 1295.5 950.261Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1383.86 882.324C1385.13 882.324 1385.13 880.502 1383.86 880.502C1382.6 880.502 1382.59 882.324 1383.86 882.324Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1294.57 867.666C1295.34 867.666 1295.34 866.568 1294.57 866.568C1293.81 866.568 1293.81 867.666 1294.57 867.666Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1296.86 761.778C1297.62 761.778 1297.62 760.68 1296.86 760.68C1296.1 760.68 1296.09 761.778 1296.86 761.778Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1389.78 804.84C1390.54 804.84 1390.55 803.742 1389.78 803.742C1389.02 803.742 1389.02 804.84 1389.78 804.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1351.7 676.362C1352.46 676.362 1352.46 675.264 1351.7 675.264C1350.94 675.264 1350.93 676.362 1351.7 676.362Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1336.47 598.006C1337.23 598.006 1337.23 596.908 1336.47 596.908C1335.7 596.908 1335.7 598.006 1336.47 598.006Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1305.66 580.125C1305.4 579.89 1305.15 579.654 1304.89 579.42C1304.35 578.918 1303.52 579.695 1304.06 580.197C1304.31 580.432 1304.56 580.667 1304.82 580.903C1305.36 581.403 1306.2 580.627 1305.66 580.125Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1337.99 803.427C1338.75 803.427 1338.75 802.328 1337.99 802.328C1337.23 802.328 1337.22 803.427 1337.99 803.427Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1363.89 733.385C1365.41 733.385 1365.41 731.188 1363.89 731.188C1362.36 731.188 1362.36 733.385 1363.89 733.385Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1310.57 693.149C1312.09 693.149 1312.1 690.951 1310.57 690.951C1309.04 690.951 1309.04 693.149 1310.57 693.149Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1331.9 833.628C1333.42 833.628 1333.42 831.43 1331.9 831.43C1330.37 831.43 1330.37 833.628 1331.9 833.628Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1389.78 855.51C1391.31 855.51 1391.31 853.313 1389.78 853.313C1388.26 853.313 1388.25 855.51 1389.78 855.51Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1382.17 656.441C1383.69 656.441 1383.69 654.242 1382.17 654.242C1380.64 654.242 1380.64 656.441 1382.17 656.441Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1315.14 635.262C1316.66 635.262 1316.67 633.064 1315.14 633.064C1313.61 633.064 1313.61 635.262 1315.14 635.262Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1427.54 886.512C1428.81 886.512 1428.81 884.69 1427.54 884.69C1426.28 884.69 1426.27 886.512 1427.54 886.512Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1432.56 1139.18C1432.73 1139.18 1432.9 1139.18 1433.06 1139.18C1433.58 1139.18 1434.07 1138.76 1434.05 1138.27C1434.02 1137.78 1433.62 1137.36 1433.06 1137.36C1432.9 1137.36 1432.73 1137.36 1432.56 1137.36C1432.05 1137.36 1431.56 1137.78 1431.58 1138.27C1431.6 1138.77 1432.01 1139.18 1432.56 1139.18Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1409.47 965.15C1410.73 965.15 1410.73 963.328 1409.47 963.328C1408.2 963.328 1408.2 965.15 1409.47 965.15Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1441.1 1053.56C1442.36 1053.56 1442.37 1051.74 1441.1 1051.74C1439.83 1051.74 1439.83 1053.56 1441.1 1053.56Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1428.86 916.299C1429.04 916.462 1429.21 916.627 1429.39 916.79C1429.93 917.291 1430.77 916.514 1430.23 916.013C1430.05 915.849 1429.87 915.685 1429.7 915.521C1429.16 915.02 1428.32 915.797 1428.86 916.299Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1424.52 762.165C1424.01 762.401 1423.5 762.636 1423 762.871C1422.31 763.187 1422.91 764.136 1423.59 763.819C1424.1 763.585 1424.61 763.35 1425.12 763.114C1425.8 762.798 1425.2 761.849 1424.52 762.165Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1408.82 706.011C1409.59 706.011 1409.59 704.912 1408.82 704.912C1408.06 704.912 1408.06 706.011 1408.82 706.011Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1428.63 841.391C1430.15 841.391 1430.16 839.194 1428.63 839.194C1427.1 839.194 1427.1 841.391 1428.63 841.391Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1400.45 919.043C1401.97 919.043 1401.97 916.846 1400.45 916.846C1398.92 916.846 1398.92 919.043 1400.45 919.043Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1437.77 718.561C1439.29 718.561 1439.3 716.363 1437.77 716.363C1436.24 716.363 1436.24 718.561 1437.77 718.561Z",
    fill: "#FFFFFE"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1320.6 436.155C1321.87 436.155 1321.87 434.332 1320.6 434.332C1319.34 434.332 1319.33 436.155 1320.6 436.155Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1295.5 482.221C1296.76 482.221 1296.76 480.398 1295.5 480.398C1294.23 480.398 1294.23 482.221 1295.5 482.221Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1383.86 414.283C1385.13 414.283 1385.13 412.461 1383.86 412.461C1382.6 412.461 1382.59 414.283 1383.86 414.283Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1294.57 399.628C1295.34 399.628 1295.34 398.529 1294.57 398.529C1293.81 398.529 1293.81 399.628 1294.57 399.628Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1296.86 293.739C1297.62 293.739 1297.62 292.641 1296.86 292.641C1296.1 292.641 1296.09 293.739 1296.86 293.739Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1389.78 336.801C1390.54 336.801 1390.55 335.703 1389.78 335.703C1389.02 335.703 1389.02 336.801 1389.78 336.801Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1351.7 208.323C1352.46 208.323 1352.46 207.225 1351.7 207.225C1350.94 207.225 1350.93 208.323 1351.7 208.323Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1336.47 129.967C1337.23 129.967 1337.23 128.869 1336.47 128.869C1335.7 128.869 1335.7 129.967 1336.47 129.967Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1305.66 112.086C1305.4 111.851 1305.15 111.615 1304.89 111.381C1304.35 110.879 1303.52 111.656 1304.06 112.157C1304.31 112.393 1304.56 112.628 1304.82 112.864C1305.36 113.364 1306.2 112.588 1305.66 112.086Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1337.99 335.388C1338.75 335.388 1338.75 334.289 1337.99 334.289C1337.23 334.289 1337.22 335.388 1337.99 335.388Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1363.89 265.346C1365.41 265.346 1365.41 263.148 1363.89 263.148C1362.36 263.148 1362.36 265.346 1363.89 265.346Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1310.57 225.11C1312.09 225.11 1312.1 222.912 1310.57 222.912C1309.04 222.912 1309.04 225.11 1310.57 225.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1331.9 365.587C1333.42 365.587 1333.42 363.389 1331.9 363.389C1330.37 363.389 1330.37 365.587 1331.9 365.587Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1389.78 387.471C1391.31 387.471 1391.31 385.273 1389.78 385.273C1388.26 385.273 1388.25 387.471 1389.78 387.471Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1382.17 188.402C1383.69 188.402 1383.69 186.203 1382.17 186.203C1380.64 186.203 1380.64 188.402 1382.17 188.402Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1315.14 167.223C1316.66 167.223 1316.67 165.025 1315.14 165.025C1313.61 165.025 1313.61 167.223 1315.14 167.223Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1427.54 418.472C1428.81 418.472 1428.81 416.65 1427.54 416.65C1426.28 416.65 1426.27 418.472 1427.54 418.472Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1432.56 671.144C1432.73 671.144 1432.9 671.144 1433.06 671.144C1433.58 671.144 1434.07 670.725 1434.05 670.233C1434.02 669.739 1433.62 669.322 1433.06 669.322C1432.9 669.322 1432.73 669.322 1432.56 669.322C1432.05 669.322 1431.56 669.741 1431.58 670.233C1431.6 670.727 1432.01 671.144 1432.56 671.144Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1409.47 497.113C1410.73 497.113 1410.73 495.291 1409.47 495.291C1408.2 495.291 1408.2 497.113 1409.47 497.113Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1441.1 585.525C1442.36 585.525 1442.37 583.703 1441.1 583.703C1439.83 583.703 1439.83 585.525 1441.1 585.525Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1428.86 448.259C1429.04 448.422 1429.21 448.587 1429.39 448.751C1429.93 449.252 1430.77 448.474 1430.23 447.974C1430.05 447.81 1429.87 447.646 1429.7 447.482C1429.16 446.981 1428.32 447.758 1428.86 448.259Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1424.52 294.128C1424.01 294.363 1423.5 294.599 1423 294.834C1422.31 295.15 1422.91 296.098 1423.59 295.782C1424.1 295.548 1424.61 295.312 1425.12 295.077C1425.8 294.761 1425.2 293.812 1424.52 294.128Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1408.82 237.972C1409.59 237.972 1409.59 236.873 1408.82 236.873C1408.06 236.873 1408.06 237.972 1408.82 237.972Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1428.63 373.354C1430.15 373.354 1430.16 371.156 1428.63 371.156C1427.1 371.156 1427.1 373.354 1428.63 373.354Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1400.45 451.004C1401.97 451.004 1401.97 448.807 1400.45 448.807C1398.92 448.807 1398.92 451.004 1400.45 451.004Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1437.77 250.522C1439.29 250.522 1439.3 248.324 1437.77 248.324C1436.24 248.324 1436.24 250.522 1437.77 250.522Z",
    fill: "#FFFFFE"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.597 324.936C114.867 324.936 114.867 323.113 113.597 323.113C112.337 323.113 112.327 324.936 113.597 324.936Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4994 371.003C89.7594 371.003 89.7594 369.18 88.4994 369.18C87.2294 369.18 87.2294 371.003 88.4994 371.003Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.863 303.066C178.133 303.066 178.133 301.244 176.863 301.244C175.603 301.244 175.593 303.066 176.863 303.066Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.57 288.409C88.34 288.409 88.34 287.311 87.57 287.311C86.81 287.311 86.81 288.409 87.57 288.409Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8628 182.52C90.6228 182.52 90.6228 181.422 89.8628 181.422C89.1028 181.422 89.0928 182.52 89.8628 182.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.781 225.583C183.541 225.583 183.551 224.484 182.781 224.484C182.021 224.484 182.021 225.583 182.781 225.583Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.699 97.1041C145.459 97.1041 145.459 96.0059 144.699 96.0059C143.939 96.0059 143.929 97.1041 144.699 97.1041Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.468 18.7467C130.228 18.7467 130.228 17.6484 129.468 17.6484C128.698 17.6484 128.698 18.7467 129.468 18.7467Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6582 0.867358C98.3982 0.631947 98.1482 0.396537 97.8882 0.162054C97.3482 -0.339351 96.5182 0.437317 97.0582 0.938722C97.3082 1.17413 97.5582 1.40954 97.8182 1.64495C98.3582 2.14543 99.1982 1.36876 98.6582 0.867358Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.988 224.171C131.748 224.171 131.748 223.072 130.988 223.072C130.228 223.072 130.218 224.171 130.988 224.171Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.89 154.127C158.41 154.127 158.41 151.93 156.89 151.93C155.36 151.93 155.36 154.127 156.89 154.127Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.569 113.889C105.089 113.889 105.099 111.691 103.569 111.691C102.039 111.691 102.039 113.889 103.569 113.889Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.898 254.37C126.418 254.37 126.418 252.172 124.898 252.172C123.368 252.172 123.368 254.37 124.898 254.37Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.78 276.252C184.31 276.252 184.31 274.055 182.78 274.055C181.26 274.055 181.25 276.252 182.78 276.252Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.171 77.1829C176.691 77.1829 176.691 74.9845 175.171 74.9845C173.641 74.9845 173.641 77.1829 175.171 77.1829Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.14 56.0039C109.66 56.0039 109.67 53.8064 108.14 53.8064C106.61 53.8064 106.61 56.0039 108.14 56.0039Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.25 327.262C272.52 327.262 272.52 325.439 271.25 325.439C269.99 325.439 269.98 327.262 271.25 327.262Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.327 331.45C291.597 331.45 291.597 329.627 290.327 329.627C289.058 329.627 289.058 331.45 290.327 331.45Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.82 340.291C288.08 340.291 288.08 338.469 286.82 338.469C285.55 338.469 285.55 340.291 286.82 340.291Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.929 400.318C315.189 400.318 315.189 398.496 313.929 398.496C312.659 398.496 312.659 400.318 313.929 400.318Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.999 440.804C332.259 440.804 332.269 438.98 330.999 438.98C329.729 438.98 329.729 440.804 330.999 440.804Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.48 377.983C327.74 377.983 327.75 376.16 326.48 376.16C325.21 376.16 325.21 377.983 326.48 377.983Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.543 307.254C221.813 307.254 221.813 305.432 220.543 305.432C219.283 305.432 219.273 307.254 220.543 307.254Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.929 472.911C315.189 472.911 315.189 471.088 313.929 471.088C312.659 471.088 312.659 472.911 313.929 472.911Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.179 525.026C255.449 525.026 255.449 523.203 254.179 523.203C252.919 523.203 252.909 525.026 254.179 525.026Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.559 559.926C225.729 559.926 225.899 559.926 226.059 559.926C226.579 559.926 227.069 559.507 227.049 559.015C227.019 558.521 226.619 558.104 226.059 558.104C225.899 558.104 225.729 558.104 225.559 558.104C225.049 558.104 224.559 558.522 224.579 559.015C224.599 559.509 225.009 559.926 225.559 559.926Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.23 564.58C267.5 564.58 267.5 562.758 266.23 562.758C264.97 562.758 264.96 564.58 266.23 564.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.937 522.234C319.207 522.234 319.207 520.412 317.937 520.412C316.677 520.412 316.677 522.234 317.937 522.234Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.8 510.137C285.07 510.137 285.07 508.314 283.8 508.314C282.54 508.314 282.54 510.137 283.8 510.137Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.808 527.818C287.078 527.818 287.078 525.996 285.808 525.996C284.548 525.996 284.538 527.818 285.808 527.818Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.531 461.275C340.801 461.275 340.801 459.453 339.531 459.453C338.271 459.453 338.271 461.275 339.531 461.275Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.281 430.1C278.541 430.1 278.541 428.277 277.281 428.277C276.011 428.277 276.011 430.1 277.281 430.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.648 357.044C247.908 357.044 247.918 355.221 246.648 355.221C245.378 355.221 245.378 357.044 246.648 357.044Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.468 385.892C203.728 385.892 203.728 384.07 202.468 384.07C201.198 384.07 201.198 385.892 202.468 385.892Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.101 474.306C235.361 474.306 235.371 472.484 234.101 472.484C232.831 472.484 232.831 474.306 234.101 474.306Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.59 417.937C407.35 417.937 407.36 416.838 406.59 416.838C405.83 416.838 405.83 417.937 406.59 417.937Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.121 451.903C390.891 451.903 390.891 450.805 390.121 450.805C389.361 450.805 389.361 451.903 390.121 451.903Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.679 470.119C434.439 470.119 434.439 469.02 433.679 469.02C432.919 469.02 432.919 470.119 433.679 470.119Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.09 508.025C398.86 508.025 398.86 506.926 398.09 506.926C397.33 506.926 397.33 508.025 398.09 508.025Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.23 521.317C349.99 521.317 349.99 520.219 349.23 520.219C348.46 520.219 348.46 521.317 349.23 521.317Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.562 480.457C381.332 480.457 381.332 479.357 380.562 479.357C379.802 479.357 379.802 480.457 380.562 480.457Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.851 387.414C377.611 387.414 377.611 386.314 376.851 386.314C376.081 386.314 376.081 387.414 376.851 387.414Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.398 325.384C421.158 325.384 421.168 324.285 420.398 324.285C419.638 324.285 419.638 325.384 420.398 325.384Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.91 312.587C344.09 312.587 344.27 312.587 344.44 312.587C345.21 312.587 345.21 311.488 344.44 311.488C344.27 311.488 344.09 311.488 343.91 311.488C343.15 311.488 343.15 312.587 343.91 312.587Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.862 337.041C222.042 337.204 222.212 337.369 222.392 337.532C222.932 338.033 223.772 337.256 223.232 336.755C223.052 336.591 222.872 336.427 222.702 336.263C222.162 335.763 221.322 336.539 221.862 337.041Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.492 406.615C252.252 406.615 252.262 405.516 251.492 405.516C250.732 405.516 250.732 406.615 251.492 406.615Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.882 533.624C386.642 533.624 386.642 532.525 385.882 532.525C385.112 532.525 385.112 533.624 385.882 533.624Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.429 544.946C430.189 544.946 430.199 543.848 429.429 543.848C428.669 543.848 428.669 544.946 429.429 544.946Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.507 557.254C329.267 557.254 329.267 556.154 328.507 556.154C327.748 556.154 327.748 557.254 328.507 557.254Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.859 550.363C292.619 550.363 292.619 549.264 291.859 549.264C291.099 549.264 291.099 550.363 291.859 550.363Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.882 552.824C386.642 552.824 386.642 551.725 385.882 551.725C385.112 551.725 385.112 552.824 385.882 552.824Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.929 262.291C307.699 262.291 307.699 261.191 306.929 261.191C306.169 261.191 306.169 262.291 306.929 262.291Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.468 255.937C408.238 255.937 408.238 254.838 407.468 254.838C406.708 254.838 406.708 255.937 407.468 255.937Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.179 152.873C274.939 152.873 274.949 151.774 274.179 151.774C273.419 151.774 273.419 152.873 274.179 152.873Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.922 169.109C339.692 169.109 339.692 168.01 338.922 168.01C338.162 168.01 338.162 169.109 338.922 169.109Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.519 169.109C411.279 169.109 411.279 168.01 410.519 168.01C409.759 168.01 409.759 169.109 410.519 169.109Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.577 85.1051C235.337 85.1051 235.337 84.0059 234.577 84.0059C233.808 84.0059 233.808 85.1051 234.577 85.1051Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.521 182.909C217.011 183.145 216.501 183.38 216.001 183.615C215.311 183.932 215.911 184.88 216.591 184.564C217.101 184.329 217.611 184.094 218.121 183.858C218.801 183.542 218.201 182.593 217.521 182.909Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.82 126.753C202.59 126.753 202.59 125.654 201.82 125.654C201.06 125.654 201.06 126.753 201.82 126.753Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.968 225.583C358.728 225.583 358.728 224.484 357.968 224.484C357.198 224.484 357.198 225.583 357.968 225.583Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.191 376.65C405.951 376.65 405.951 375.551 405.191 375.551C404.431 375.551 404.421 376.65 405.191 376.65Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.312 295.311C332.832 295.311 332.842 293.113 331.312 293.113C329.782 293.113 329.782 295.311 331.312 295.311Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.632 262.135C223.152 262.135 223.162 259.938 221.632 259.938C220.102 259.938 220.102 262.135 221.632 262.135Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.452 339.783C194.972 339.783 194.972 337.586 193.452 337.586C191.922 337.586 191.922 339.783 193.452 339.783Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.038 442.848C413.568 442.848 413.568 440.65 412.038 440.65C410.518 440.65 410.518 442.848 412.038 442.848Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.89 514.148C436.42 514.148 436.42 511.949 434.89 511.949C433.37 511.949 433.37 514.148 434.89 514.148Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.28 556.502C412.81 556.502 412.81 554.305 411.28 554.305C409.76 554.305 409.75 556.502 411.28 556.502Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.48 335.549C377.01 335.549 377.01 333.352 375.48 333.352C373.96 333.352 373.95 335.549 375.48 335.549Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.421 286.136C274.951 286.136 274.951 283.938 273.421 283.938C271.891 283.938 271.891 286.136 273.421 286.136Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.28 200.014C281.8 200.014 281.8 197.816 280.28 197.816C278.75 197.816 278.75 200.014 280.28 200.014Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.773 139.303C232.293 139.303 232.303 137.105 230.773 137.105C229.243 137.105 229.243 139.303 230.773 139.303Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.902 247.311C257.432 247.311 257.432 245.113 255.902 245.113C254.382 245.113 254.372 247.311 255.902 247.311Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.202 258.604C358.733 258.604 358.733 256.406 357.202 256.406C355.683 256.406 355.683 258.604 357.202 258.604Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.711 192.561C417.711 193.268 417.711 193.973 417.711 194.679C417.711 196.093 420.081 196.095 420.081 194.679C420.081 193.973 420.081 193.268 420.081 192.561C420.081 191.147 417.711 191.145 417.711 192.561Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.152 123.936C305.402 124.407 305.662 124.878 305.912 125.348C306.592 126.613 308.642 125.502 307.962 124.24C307.702 123.769 307.452 123.298 307.202 122.827C306.512 121.562 304.472 122.674 305.152 123.936Z",
    fill: "#FFFFFE"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5972 523.274C13.8672 523.274 13.8672 521.451 12.5972 521.451C11.3372 521.451 11.3272 523.274 12.5972 523.274Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8628 501.404C77.1328 501.404 77.1328 499.582 75.8628 499.582C74.6028 499.582 74.5928 501.404 75.8628 501.404Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7809 423.92C82.5409 423.92 82.5509 422.822 81.7809 422.822C81.0209 422.822 81.0209 423.92 81.7809 423.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6988 295.442C44.4588 295.442 44.4588 294.344 43.6988 294.344C42.9388 294.344 42.9288 295.442 43.6988 295.442Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4681 217.084C29.2281 217.084 29.2281 215.986 28.4681 215.986C27.6981 215.986 27.6981 217.084 28.4681 217.084Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9878 422.509C30.7478 422.509 30.7478 421.41 29.9878 421.41C29.2278 421.41 29.2178 422.509 29.9878 422.509Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8897 352.465C57.4097 352.465 57.4097 350.267 55.8897 350.267C54.3597 350.267 54.3597 352.465 55.8897 352.465Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56938 312.227C4.08938 312.227 4.09938 310.029 2.56938 310.029C1.03938 310.029 1.03938 312.227 2.56938 312.227Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8975 452.706C25.4175 452.706 25.4175 450.508 23.8975 450.508C22.3675 450.508 22.3675 452.706 23.8975 452.706Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7805 474.59C83.3105 474.59 83.3105 472.392 81.7805 472.392C80.2605 472.392 80.2505 474.59 81.7805 474.59Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1709 275.52C75.6909 275.52 75.6909 273.322 74.1709 273.322C72.6409 273.322 72.6409 275.52 74.1709 275.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13969 254.342C8.65969 254.342 8.66969 252.144 7.13969 252.144C5.60969 252.144 5.60969 254.342 7.13969 254.342Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.25 525.6C171.52 525.6 171.52 523.777 170.25 523.777C168.99 523.777 168.98 525.6 170.25 525.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.327 529.788C190.597 529.788 190.597 527.965 189.327 527.965C188.058 527.965 188.058 529.788 189.327 529.788Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.82 538.629C187.08 538.629 187.08 536.806 185.82 536.806C184.55 536.806 184.55 538.629 185.82 538.629Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.929 598.656C214.189 598.656 214.189 596.834 212.929 596.834C211.659 596.834 211.659 598.656 212.929 598.656Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.999 639.139C231.259 639.139 231.269 637.316 229.999 637.316C228.729 637.316 228.729 639.139 229.999 639.139Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.48 576.323C226.74 576.323 226.75 574.5 225.48 574.5C224.21 574.5 224.21 576.323 225.48 576.323Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.543 505.591C120.813 505.591 120.813 503.769 119.543 503.769C118.283 503.769 118.273 505.591 119.543 505.591Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.929 671.249C214.189 671.249 214.189 669.426 212.929 669.426C211.659 669.426 211.659 671.249 212.929 671.249Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.179 723.364C154.449 723.364 154.449 721.541 153.179 721.541C151.919 721.541 151.909 723.364 153.179 723.364Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.559 758.263C124.729 758.263 124.899 758.263 125.059 758.263C125.579 758.263 126.069 757.844 126.049 757.352C126.019 756.858 125.619 756.441 125.059 756.441C124.899 756.441 124.729 756.441 124.559 756.441C124.049 756.441 123.559 756.86 123.579 757.352C123.599 757.846 124.009 758.263 124.559 758.263Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.23 762.918C166.5 762.918 166.5 761.095 165.23 761.095C163.97 761.095 163.96 762.918 165.23 762.918Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.937 720.572C218.207 720.572 218.207 718.75 216.937 718.75C215.677 718.75 215.677 720.572 216.937 720.572Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.8 708.474C184.07 708.474 184.07 706.652 182.8 706.652C181.54 706.652 181.54 708.474 182.8 708.474Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.808 726.156C186.078 726.156 186.078 724.334 184.808 724.334C183.548 724.334 183.538 726.156 184.808 726.156Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.531 659.615C239.801 659.615 239.801 657.793 238.531 657.793C237.271 657.793 237.271 659.615 238.531 659.615Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.281 628.436C177.541 628.436 177.541 626.613 176.281 626.613C175.011 626.613 175.011 628.436 176.281 628.436Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.648 555.381C146.908 555.381 146.918 553.558 145.648 553.558C144.378 553.558 144.378 555.381 145.648 555.381Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.468 584.23C102.728 584.23 102.728 582.408 101.468 582.408C100.198 582.408 100.198 584.23 101.468 584.23Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.101 672.642C134.361 672.642 134.371 670.82 133.101 670.82C131.831 670.82 131.831 672.642 133.101 672.642Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.59 616.275C306.35 616.275 306.36 615.176 305.59 615.176C304.83 615.176 304.83 616.275 305.59 616.275Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.121 650.243C289.891 650.243 289.891 649.144 289.121 649.144C288.361 649.144 288.361 650.243 289.121 650.243Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.679 668.456C333.439 668.456 333.439 667.357 332.679 667.357C331.919 667.357 331.919 668.456 332.679 668.456Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.09 706.363C297.86 706.363 297.86 705.263 297.09 705.263C296.33 705.263 296.33 706.363 297.09 706.363Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.23 719.655C248.99 719.655 248.99 718.556 248.23 718.556C247.46 718.556 247.46 719.655 248.23 719.655Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.562 678.794C280.332 678.794 280.332 677.695 279.562 677.695C278.802 677.695 278.802 678.794 279.562 678.794Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.851 585.751C276.611 585.751 276.611 584.652 275.851 584.652C275.081 584.652 275.081 585.751 275.851 585.751Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.398 523.724C320.158 523.724 320.168 522.625 319.398 522.625C318.638 522.625 318.638 523.724 319.398 523.724Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.91 510.925C243.09 510.925 243.27 510.925 243.44 510.925C244.21 510.925 244.21 509.826 243.44 509.826C243.27 509.826 243.09 509.826 242.91 509.826C242.15 509.826 242.15 510.925 242.91 510.925Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.862 535.378C121.042 535.542 121.212 535.706 121.392 535.87C121.932 536.371 122.772 535.593 122.232 535.093C122.052 534.929 121.872 534.765 121.702 534.601C121.162 534.1 120.322 534.877 120.862 535.378Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.492 604.951C151.252 604.951 151.262 603.851 150.492 603.851C149.732 603.851 149.732 604.951 150.492 604.951Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.882 731.961C285.642 731.961 285.642 730.863 284.882 730.863C284.112 730.863 284.112 731.961 284.882 731.961Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.429 743.284C329.189 743.284 329.199 742.185 328.429 742.185C327.669 742.185 327.669 743.284 328.429 743.284Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.507 755.592C228.267 755.592 228.267 754.492 227.507 754.492C226.748 754.492 226.748 755.592 227.507 755.592Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.859 748.699C191.619 748.699 191.619 747.599 190.859 747.599C190.099 747.599 190.099 748.699 190.859 748.699Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.882 751.161C285.642 751.161 285.642 750.062 284.882 750.062C284.112 750.062 284.112 751.161 284.882 751.161Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.929 460.628C206.699 460.628 206.699 459.529 205.929 459.529C205.169 459.529 205.169 460.628 205.929 460.628Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.468 454.275C307.238 454.275 307.238 453.176 306.468 453.176C305.708 453.176 305.708 454.275 306.468 454.275Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.179 351.21C173.939 351.21 173.949 350.111 173.179 350.111C172.419 350.111 172.419 351.21 173.179 351.21Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.922 367.447C238.692 367.447 238.692 366.347 237.922 366.347C237.162 366.347 237.162 367.447 237.922 367.447Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.519 367.447C310.279 367.447 310.279 366.347 309.519 366.347C308.759 366.347 308.759 367.447 309.519 367.447Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.577 283.441C134.337 283.441 134.337 282.342 133.577 282.342C132.808 282.342 132.808 283.441 133.577 283.441Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.521 381.247C116.011 381.482 115.501 381.718 115.001 381.953C114.311 382.269 114.911 383.217 115.591 382.901C116.101 382.667 116.611 382.431 117.121 382.196C117.801 381.88 117.201 380.931 116.521 381.247Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.82 325.091C101.59 325.091 101.59 323.992 100.82 323.992C100.06 323.992 100.06 325.091 100.82 325.091Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.968 423.92C257.728 423.92 257.728 422.822 256.968 422.822C256.198 422.822 256.198 423.92 256.968 423.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.191 574.988C304.951 574.988 304.951 573.888 304.191 573.888C303.431 573.888 303.421 574.988 304.191 574.988Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.312 493.65C231.832 493.65 231.842 491.453 230.312 491.453C228.782 491.453 228.782 493.65 230.312 493.65Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.632 460.473C122.152 460.473 122.162 458.275 120.632 458.275C119.102 458.275 119.102 460.473 120.632 460.473Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4522 538.123C93.9722 538.123 93.9722 535.926 92.4522 535.926C90.9222 535.926 90.9222 538.123 92.4522 538.123Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.038 641.187C312.568 641.187 312.568 638.99 311.038 638.99C309.518 638.99 309.518 641.187 311.038 641.187Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.89 712.485C335.42 712.485 335.42 710.287 333.89 710.287C332.37 710.287 332.37 712.485 333.89 712.485Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.28 754.84C311.81 754.84 311.81 752.642 310.28 752.642C308.76 752.642 308.75 754.84 310.28 754.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.48 533.887C276.01 533.887 276.01 531.689 274.48 531.689C272.96 531.689 272.95 533.887 274.48 533.887Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.421 484.472C173.951 484.472 173.951 482.273 172.421 482.273C170.891 482.273 170.891 484.472 172.421 484.472Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.28 398.35C180.8 398.35 180.8 396.152 179.28 396.152C177.75 396.152 177.75 398.35 179.28 398.35Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.773 337.641C131.293 337.641 131.303 335.443 129.773 335.443C128.243 335.443 128.243 337.641 129.773 337.641Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.902 445.647C156.432 445.647 156.432 443.449 154.902 443.449C153.382 443.449 153.372 445.647 154.902 445.647Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.202 456.941C257.733 456.941 257.733 454.744 256.202 454.744C254.683 454.744 254.683 456.941 256.202 456.941Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.711 390.899C316.711 391.605 316.711 392.311 316.711 393.017C316.711 394.43 319.081 394.433 319.081 393.017C319.081 392.311 319.081 391.605 319.081 390.899C319.081 389.485 316.711 389.483 316.711 390.899Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.152 322.272C204.402 322.743 204.662 323.214 204.912 323.684C205.592 324.949 207.642 323.838 206.962 322.575C206.702 322.104 206.452 321.634 206.202 321.163C205.512 319.898 203.472 321.01 204.152 322.272Z",
    fill: "#FFFFFE"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1343.59 1269.47C1344.86 1269.47 1344.86 1267.65 1343.59 1267.65C1342.33 1267.65 1342.32 1269.47 1343.59 1269.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1318.49 1315.54C1319.75 1315.54 1319.75 1313.71 1318.49 1313.71C1317.22 1313.71 1317.22 1315.54 1318.49 1315.54Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1406.86 1247.6C1408.13 1247.6 1408.13 1245.78 1406.86 1245.78C1405.6 1245.78 1405.59 1247.6 1406.86 1247.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1317.56 1232.94C1318.33 1232.94 1318.33 1231.85 1317.56 1231.85C1316.8 1231.85 1316.8 1232.94 1317.56 1232.94Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1319.86 1127.06C1320.62 1127.06 1320.62 1125.96 1319.86 1125.96C1319.1 1125.96 1319.09 1127.06 1319.86 1127.06Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1412.77 1170.12C1413.53 1170.12 1413.54 1169.02 1412.77 1169.02C1412.01 1169.02 1412.01 1170.12 1412.77 1170.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1374.69 1041.64C1375.45 1041.64 1375.45 1040.54 1374.69 1040.54C1373.93 1040.54 1373.92 1041.64 1374.69 1041.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1359.46 963.284C1360.22 963.284 1360.22 962.186 1359.46 962.186C1358.69 962.186 1358.69 963.284 1359.46 963.284Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1328.65 945.403C1328.39 945.167 1328.14 944.932 1327.88 944.697C1327.34 944.196 1326.51 944.972 1327.05 945.474C1327.3 945.709 1327.55 945.945 1327.81 946.18C1328.35 946.681 1329.19 945.904 1328.65 945.403Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1360.98 1168.7C1361.74 1168.7 1361.74 1167.61 1360.98 1167.61C1360.22 1167.61 1360.21 1168.7 1360.98 1168.7Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1386.88 1098.66C1388.4 1098.66 1388.4 1096.46 1386.88 1096.46C1385.35 1096.46 1385.35 1098.66 1386.88 1098.66Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1333.56 1058.43C1335.08 1058.43 1335.09 1056.23 1333.56 1056.23C1332.03 1056.23 1332.03 1058.43 1333.56 1058.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1354.89 1198.91C1356.41 1198.91 1356.41 1196.71 1354.89 1196.71C1353.36 1196.71 1353.36 1198.91 1354.89 1198.91Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1412.77 1220.79C1414.3 1220.79 1414.3 1218.59 1412.77 1218.59C1411.25 1218.59 1411.24 1220.79 1412.77 1220.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1405.16 1021.72C1406.68 1021.72 1406.68 1019.52 1405.16 1019.52C1403.63 1019.52 1403.63 1021.72 1405.16 1021.72Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1338.13 1000.54C1339.65 1000.54 1339.66 998.342 1338.13 998.342C1336.6 998.342 1336.6 1000.54 1338.13 1000.54Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1432.46 1330.43C1433.72 1330.43 1433.72 1328.61 1432.46 1328.61C1431.19 1328.61 1431.19 1330.43 1432.46 1330.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1431.81 1071.29C1432.58 1071.29 1432.58 1070.19 1431.81 1070.19C1431.05 1070.19 1431.05 1071.29 1431.81 1071.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1423.44 1284.32C1424.96 1284.32 1424.96 1282.12 1423.44 1282.12C1421.91 1282.12 1421.91 1284.32 1423.44 1284.32Z",
    fill: "#FFFFFE"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M982.589 1269.47C983.859 1269.47 983.859 1267.65 982.589 1267.65C981.329 1267.65 981.319 1269.47 982.589 1269.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M957.492 1315.54C958.752 1315.54 958.752 1313.71 957.492 1313.71C956.222 1313.71 956.222 1315.54 957.492 1315.54Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1045.86 1247.6C1047.13 1247.6 1047.13 1245.78 1045.86 1245.78C1044.6 1245.78 1044.59 1247.6 1045.86 1247.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M956.562 1232.94C957.332 1232.94 957.332 1231.85 956.562 1231.85C955.802 1231.85 955.802 1232.94 956.562 1232.94Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M958.855 1127.06C959.615 1127.06 959.615 1125.96 958.855 1125.96C958.095 1125.96 958.085 1127.06 958.855 1127.06Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1051.77 1170.12C1052.53 1170.12 1052.54 1169.02 1051.77 1169.02C1051.01 1169.02 1051.01 1170.12 1051.77 1170.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1013.69 1041.64C1014.45 1041.64 1014.45 1040.54 1013.69 1040.54C1012.93 1040.54 1012.92 1041.64 1013.69 1041.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M998.46 963.284C999.22 963.284 999.22 962.186 998.46 962.186C997.69 962.186 997.69 963.284 998.46 963.284Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.65 945.403C967.39 945.167 967.14 944.932 966.88 944.697C966.34 944.196 965.51 944.972 966.05 945.474C966.3 945.709 966.55 945.945 966.81 946.18C967.35 946.681 968.19 945.904 967.65 945.403Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M999.98 1168.7C1000.74 1168.7 1000.74 1167.61 999.98 1167.61C999.22 1167.61 999.21 1168.7 999.98 1168.7Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1025.88 1098.66C1027.4 1098.66 1027.4 1096.46 1025.88 1096.46C1024.35 1096.46 1024.35 1098.66 1025.88 1098.66Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M972.562 1058.43C974.082 1058.43 974.092 1056.23 972.562 1056.23C971.032 1056.23 971.032 1058.43 972.562 1058.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M993.89 1198.91C995.41 1198.91 995.41 1196.71 993.89 1196.71C992.36 1196.71 992.36 1198.91 993.89 1198.91Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1051.77 1220.79C1053.3 1220.79 1053.3 1218.59 1051.77 1218.59C1050.25 1218.59 1050.24 1220.79 1051.77 1220.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1044.16 1021.72C1045.68 1021.72 1045.68 1019.52 1044.16 1019.52C1042.63 1019.52 1042.63 1021.72 1044.16 1021.72Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M977.132 1000.54C978.652 1000.54 978.662 998.342 977.132 998.342C975.602 998.342 975.602 1000.54 977.132 1000.54Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1140.24 1271.8C1141.51 1271.8 1141.51 1269.97 1140.24 1269.97C1138.98 1269.97 1138.97 1271.8 1140.24 1271.8Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1159.32 1275.99C1160.59 1275.99 1160.59 1274.16 1159.32 1274.16C1158.05 1274.16 1158.05 1275.99 1159.32 1275.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1155.81 1284.83C1157.07 1284.83 1157.07 1283.01 1155.81 1283.01C1154.54 1283.01 1154.54 1284.83 1155.81 1284.83Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1182.92 1344.85C1184.18 1344.85 1184.18 1343.03 1182.92 1343.03C1181.65 1343.03 1181.65 1344.85 1182.92 1344.85Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1199.99 1385.34C1201.25 1385.34 1201.26 1383.51 1199.99 1383.51C1198.72 1383.51 1198.72 1385.34 1199.99 1385.34Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1195.47 1322.52C1196.73 1322.52 1196.74 1320.7 1195.47 1320.7C1194.2 1320.7 1194.2 1322.52 1195.47 1322.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1089.53 1251.79C1090.8 1251.79 1090.8 1249.97 1089.53 1249.97C1088.27 1249.97 1088.26 1251.79 1089.53 1251.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1182.92 1417.45C1184.18 1417.45 1184.18 1415.62 1182.92 1415.62C1181.65 1415.62 1181.65 1417.45 1182.92 1417.45Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1123.17 1469.56C1124.44 1469.56 1124.44 1467.74 1123.17 1467.74C1121.91 1467.74 1121.9 1469.56 1123.17 1469.56Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1094.55 1504.46C1094.72 1504.46 1094.89 1504.46 1095.05 1504.46C1095.57 1504.46 1096.06 1504.04 1096.04 1503.55C1096.01 1503.06 1095.61 1502.64 1095.05 1502.64C1094.89 1502.64 1094.72 1502.64 1094.55 1502.64C1094.04 1502.64 1093.55 1503.06 1093.57 1503.55C1093.59 1504.04 1094 1504.46 1094.55 1504.46Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1135.22 1509.12C1136.49 1509.12 1136.49 1507.29 1135.22 1507.29C1133.96 1507.29 1133.95 1509.12 1135.22 1509.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1186.93 1466.77C1188.2 1466.77 1188.2 1464.95 1186.93 1464.95C1185.67 1464.95 1185.67 1466.77 1186.93 1466.77Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1152.79 1454.67C1154.06 1454.67 1154.06 1452.85 1152.79 1452.85C1151.53 1452.85 1151.53 1454.67 1152.79 1454.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1154.8 1472.35C1156.07 1472.35 1156.07 1470.53 1154.8 1470.53C1153.54 1470.53 1153.53 1472.35 1154.8 1472.35Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1208.52 1405.81C1209.79 1405.81 1209.79 1403.99 1208.52 1403.99C1207.26 1403.99 1207.26 1405.81 1208.52 1405.81Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1146.27 1374.64C1147.53 1374.64 1147.53 1372.81 1146.27 1372.81C1145 1372.81 1145 1374.64 1146.27 1374.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1115.64 1301.58C1116.9 1301.58 1116.91 1299.76 1115.64 1299.76C1114.37 1299.76 1114.37 1301.58 1115.64 1301.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1071.46 1330.43C1072.72 1330.43 1072.72 1328.61 1071.46 1328.61C1070.19 1328.61 1070.19 1330.43 1071.46 1330.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.09 1418.84C1104.35 1418.84 1104.36 1417.02 1103.09 1417.02C1101.82 1417.02 1101.82 1418.84 1103.09 1418.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1275.58 1362.47C1276.34 1362.47 1276.35 1361.37 1275.58 1361.37C1274.82 1361.37 1274.82 1362.47 1275.58 1362.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1259.11 1396.44C1259.88 1396.44 1259.88 1395.34 1259.11 1395.34C1258.35 1395.34 1258.35 1396.44 1259.11 1396.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1302.67 1414.65C1303.43 1414.65 1303.43 1413.55 1302.67 1413.55C1301.91 1413.55 1301.91 1414.65 1302.67 1414.65Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1267.08 1452.56C1267.85 1452.56 1267.85 1451.46 1267.08 1451.46C1266.32 1451.46 1266.32 1452.56 1267.08 1452.56Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1218.22 1465.85C1218.98 1465.85 1218.98 1464.75 1218.22 1464.75C1217.45 1464.75 1217.45 1465.85 1218.22 1465.85Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1249.55 1424.99C1250.32 1424.99 1250.32 1423.89 1249.55 1423.89C1248.79 1423.89 1248.79 1424.99 1249.55 1424.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245.84 1331.95C1246.6 1331.95 1246.6 1330.85 1245.84 1330.85C1245.07 1330.85 1245.07 1331.95 1245.84 1331.95Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1289.39 1269.92C1290.15 1269.92 1290.16 1268.82 1289.39 1268.82C1288.63 1268.82 1288.63 1269.92 1289.39 1269.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1212.9 1257.12C1213.08 1257.12 1213.26 1257.12 1213.43 1257.12C1214.2 1257.12 1214.2 1256.02 1213.43 1256.02C1213.26 1256.02 1213.08 1256.02 1212.9 1256.02C1212.14 1256.02 1212.14 1257.12 1212.9 1257.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1090.85 1281.58C1091.03 1281.74 1091.2 1281.9 1091.38 1282.07C1091.92 1282.57 1092.76 1281.79 1092.22 1281.29C1092.04 1281.13 1091.86 1280.96 1091.69 1280.8C1091.15 1280.3 1090.31 1281.07 1090.85 1281.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1120.48 1351.15C1121.24 1351.15 1121.25 1350.05 1120.48 1350.05C1119.72 1350.05 1119.72 1351.15 1120.48 1351.15Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1254.87 1478.16C1255.63 1478.16 1255.63 1477.06 1254.87 1477.06C1254.1 1477.06 1254.1 1478.16 1254.87 1478.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1298.42 1489.48C1299.18 1489.48 1299.19 1488.38 1298.42 1488.38C1297.66 1488.38 1297.66 1489.48 1298.42 1489.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1197.5 1501.79C1198.26 1501.79 1198.26 1500.69 1197.5 1500.69C1196.74 1500.69 1196.74 1501.79 1197.5 1501.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1160.85 1494.9C1161.61 1494.9 1161.61 1493.8 1160.85 1493.8C1160.09 1493.8 1160.09 1494.9 1160.85 1494.9Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1254.87 1497.36C1255.63 1497.36 1255.63 1496.26 1254.87 1496.26C1254.1 1496.26 1254.1 1497.36 1254.87 1497.36Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1175.92 1206.83C1176.69 1206.83 1176.69 1205.73 1175.92 1205.73C1175.16 1205.73 1175.16 1206.83 1175.92 1206.83Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.46 1200.47C1277.23 1200.47 1277.23 1199.37 1276.46 1199.37C1275.7 1199.37 1275.7 1200.47 1276.46 1200.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1143.17 1097.41C1143.93 1097.41 1143.94 1096.31 1143.17 1096.31C1142.41 1096.31 1142.41 1097.41 1143.17 1097.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1207.91 1113.64C1208.68 1113.64 1208.68 1112.54 1207.91 1112.54C1207.15 1112.54 1207.15 1113.64 1207.91 1113.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1279.51 1113.64C1280.27 1113.64 1280.27 1112.54 1279.51 1112.54C1278.75 1112.54 1278.75 1113.64 1279.51 1113.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.57 1029.64C1104.33 1029.64 1104.33 1028.54 1103.57 1028.54C1102.8 1028.54 1102.8 1029.64 1103.57 1029.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1086.51 1127.44C1086 1127.68 1085.49 1127.91 1084.99 1128.15C1084.3 1128.46 1084.9 1129.41 1085.58 1129.1C1086.09 1128.86 1086.6 1128.63 1087.11 1128.39C1087.79 1128.08 1087.19 1127.13 1086.51 1127.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1070.81 1071.29C1071.58 1071.29 1071.58 1070.19 1070.81 1070.19C1070.05 1070.19 1070.05 1071.29 1070.81 1071.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1226.96 1170.12C1227.72 1170.12 1227.72 1169.02 1226.96 1169.02C1226.19 1169.02 1226.19 1170.12 1226.96 1170.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1274.18 1321.19C1274.94 1321.19 1274.94 1320.09 1274.18 1320.09C1273.42 1320.09 1273.41 1321.19 1274.18 1321.19Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1200.3 1239.85C1201.82 1239.85 1201.83 1237.65 1200.3 1237.65C1198.77 1237.65 1198.77 1239.85 1200.3 1239.85Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1090.62 1206.67C1092.14 1206.67 1092.15 1204.47 1090.62 1204.47C1089.09 1204.47 1089.09 1206.67 1090.62 1206.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1062.44 1284.32C1063.96 1284.32 1063.96 1282.12 1062.44 1282.12C1060.91 1282.12 1060.91 1284.32 1062.44 1284.32Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1281.03 1387.38C1282.56 1387.38 1282.56 1385.19 1281.03 1385.19C1279.51 1385.19 1279.51 1387.38 1281.03 1387.38Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1303.88 1458.68C1305.41 1458.68 1305.41 1456.48 1303.88 1456.48C1302.36 1456.48 1302.36 1458.68 1303.88 1458.68Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1280.27 1501.04C1281.8 1501.04 1281.8 1498.84 1280.27 1498.84C1278.75 1498.84 1278.74 1501.04 1280.27 1501.04Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1244.47 1280.08C1246 1280.08 1246 1277.89 1244.47 1277.89C1242.95 1277.89 1242.94 1280.08 1244.47 1280.08Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1142.41 1230.67C1143.94 1230.67 1143.94 1228.47 1142.41 1228.47C1140.88 1228.47 1140.88 1230.67 1142.41 1230.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1149.27 1144.55C1150.79 1144.55 1150.79 1142.35 1149.27 1142.35C1147.74 1142.35 1147.74 1144.55 1149.27 1144.55Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1099.76 1083.84C1101.28 1083.84 1101.29 1081.64 1099.76 1081.64C1098.23 1081.64 1098.23 1083.84 1099.76 1083.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.89 1191.84C1126.42 1191.84 1126.42 1189.65 1124.89 1189.65C1123.37 1189.65 1123.36 1191.84 1124.89 1191.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1226.19 1203.14C1227.72 1203.14 1227.72 1200.94 1226.19 1200.94C1224.67 1200.94 1224.67 1203.14 1226.19 1203.14Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1286.7 1137.09C1286.7 1137.8 1286.7 1138.51 1286.7 1139.21C1286.7 1140.63 1289.07 1140.63 1289.07 1139.21C1289.07 1138.51 1289.07 1137.8 1289.07 1137.09C1289.07 1135.68 1286.7 1135.68 1286.7 1137.09Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1174.14 1068.47C1174.39 1068.94 1174.65 1069.41 1174.9 1069.88C1175.58 1071.15 1177.63 1070.03 1176.95 1068.77C1176.69 1068.3 1176.44 1067.83 1176.19 1067.36C1175.5 1066.09 1173.46 1067.21 1174.14 1068.47Z",
    fill: "#FFFFFE"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621.597 1269.47C622.867 1269.47 622.867 1267.65 621.597 1267.65C620.337 1267.65 620.327 1269.47 621.597 1269.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M596.499 1315.54C597.759 1315.54 597.759 1313.71 596.499 1313.71C595.229 1313.71 595.229 1315.54 596.499 1315.54Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.863 1247.6C686.133 1247.6 686.133 1245.78 684.863 1245.78C683.603 1245.78 683.593 1247.6 684.863 1247.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.57 1232.94C596.34 1232.94 596.34 1231.85 595.57 1231.85C594.81 1231.85 594.81 1232.94 595.57 1232.94Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.863 1127.06C598.623 1127.06 598.623 1125.96 597.863 1125.96C597.103 1125.96 597.093 1127.06 597.863 1127.06Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M690.781 1170.12C691.541 1170.12 691.551 1169.02 690.781 1169.02C690.021 1169.02 690.021 1170.12 690.781 1170.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.699 1041.64C653.459 1041.64 653.459 1040.54 652.699 1040.54C651.939 1040.54 651.929 1041.64 652.699 1041.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M637.468 963.284C638.228 963.284 638.228 962.186 637.468 962.186C636.698 962.186 636.698 963.284 637.468 963.284Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M606.658 945.403C606.398 945.167 606.148 944.932 605.888 944.697C605.348 944.196 604.518 944.972 605.058 945.474C605.308 945.709 605.558 945.945 605.818 946.18C606.358 946.681 607.198 945.904 606.658 945.403Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.988 1168.7C639.748 1168.7 639.748 1167.61 638.988 1167.61C638.228 1167.61 638.218 1168.7 638.988 1168.7Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M664.89 1098.66C666.41 1098.66 666.41 1096.46 664.89 1096.46C663.36 1096.46 663.36 1098.66 664.89 1098.66Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M611.569 1058.43C613.089 1058.43 613.099 1056.23 611.569 1056.23C610.039 1056.23 610.039 1058.43 611.569 1058.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632.898 1198.91C634.418 1198.91 634.418 1196.71 632.898 1196.71C631.368 1196.71 631.368 1198.91 632.898 1198.91Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M690.78 1220.79C692.31 1220.79 692.31 1218.59 690.78 1218.59C689.26 1218.59 689.25 1220.79 690.78 1220.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.171 1021.72C684.691 1021.72 684.691 1019.52 683.171 1019.52C681.641 1019.52 681.641 1021.72 683.171 1021.72Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.14 1000.54C617.66 1000.54 617.67 998.342 616.14 998.342C614.61 998.342 614.61 1000.54 616.14 1000.54Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M779.25 1271.8C780.52 1271.8 780.52 1269.97 779.25 1269.97C777.99 1269.97 777.98 1271.8 779.25 1271.8Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M798.327 1275.99C799.597 1275.99 799.597 1274.16 798.327 1274.16C797.058 1274.16 797.058 1275.99 798.327 1275.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M794.82 1284.83C796.08 1284.83 796.08 1283.01 794.82 1283.01C793.55 1283.01 793.55 1284.83 794.82 1284.83Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821.929 1344.85C823.189 1344.85 823.189 1343.03 821.929 1343.03C820.659 1343.03 820.659 1344.85 821.929 1344.85Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M838.999 1385.34C840.259 1385.34 840.269 1383.51 838.999 1383.51C837.729 1383.51 837.729 1385.34 838.999 1385.34Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.48 1322.52C835.74 1322.52 835.75 1320.7 834.48 1320.7C833.21 1320.7 833.21 1322.52 834.48 1322.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M728.543 1251.79C729.813 1251.79 729.813 1249.97 728.543 1249.97C727.283 1249.97 727.273 1251.79 728.543 1251.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821.929 1417.45C823.189 1417.45 823.189 1415.62 821.929 1415.62C820.659 1415.62 820.659 1417.45 821.929 1417.45Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M762.179 1469.56C763.449 1469.56 763.449 1467.74 762.179 1467.74C760.919 1467.74 760.909 1469.56 762.179 1469.56Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.559 1504.46C733.729 1504.46 733.899 1504.46 734.059 1504.46C734.579 1504.46 735.069 1504.04 735.049 1503.55C735.019 1503.06 734.619 1502.64 734.059 1502.64C733.899 1502.64 733.729 1502.64 733.559 1502.64C733.049 1502.64 732.559 1503.06 732.579 1503.55C732.599 1504.04 733.009 1504.46 733.559 1504.46Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M774.23 1509.12C775.5 1509.12 775.5 1507.29 774.23 1507.29C772.97 1507.29 772.96 1509.12 774.23 1509.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M825.937 1466.77C827.207 1466.77 827.207 1464.95 825.937 1464.95C824.677 1464.95 824.677 1466.77 825.937 1466.77Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M791.8 1454.67C793.07 1454.67 793.07 1452.85 791.8 1452.85C790.54 1452.85 790.54 1454.67 791.8 1454.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M793.808 1472.35C795.078 1472.35 795.078 1470.53 793.808 1470.53C792.548 1470.53 792.538 1472.35 793.808 1472.35Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.531 1405.81C848.801 1405.81 848.801 1403.99 847.531 1403.99C846.271 1403.99 846.271 1405.81 847.531 1405.81Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M785.281 1374.64C786.541 1374.64 786.541 1372.81 785.281 1372.81C784.011 1372.81 784.011 1374.64 785.281 1374.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M754.648 1301.58C755.908 1301.58 755.918 1299.76 754.648 1299.76C753.378 1299.76 753.378 1301.58 754.648 1301.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.468 1330.43C711.728 1330.43 711.728 1328.61 710.468 1328.61C709.198 1328.61 709.198 1330.43 710.468 1330.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M742.101 1418.84C743.361 1418.84 743.371 1417.02 742.101 1417.02C740.831 1417.02 740.831 1418.84 742.101 1418.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.59 1362.47C915.35 1362.47 915.36 1361.37 914.59 1361.37C913.83 1361.37 913.83 1362.47 914.59 1362.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M898.121 1396.44C898.891 1396.44 898.891 1395.34 898.121 1395.34C897.361 1395.34 897.361 1396.44 898.121 1396.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M941.679 1414.65C942.439 1414.65 942.439 1413.55 941.679 1413.55C940.919 1413.55 940.919 1414.65 941.679 1414.65Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M906.09 1452.56C906.86 1452.56 906.86 1451.46 906.09 1451.46C905.33 1451.46 905.33 1452.56 906.09 1452.56Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M857.23 1465.85C857.99 1465.85 857.99 1464.75 857.23 1464.75C856.46 1464.75 856.46 1465.85 857.23 1465.85Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M888.562 1424.99C889.332 1424.99 889.332 1423.89 888.562 1423.89C887.802 1423.89 887.802 1424.99 888.562 1424.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.851 1331.95C885.611 1331.95 885.611 1330.85 884.851 1330.85C884.081 1330.85 884.081 1331.95 884.851 1331.95Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.398 1269.92C929.158 1269.92 929.168 1268.82 928.398 1268.82C927.638 1268.82 927.638 1269.92 928.398 1269.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.91 1257.12C852.09 1257.12 852.27 1257.12 852.44 1257.12C853.21 1257.12 853.21 1256.02 852.44 1256.02C852.27 1256.02 852.09 1256.02 851.91 1256.02C851.15 1256.02 851.15 1257.12 851.91 1257.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M729.862 1281.58C730.042 1281.74 730.212 1281.9 730.392 1282.07C730.932 1282.57 731.772 1281.79 731.232 1281.29C731.052 1281.13 730.872 1280.96 730.702 1280.8C730.162 1280.3 729.322 1281.07 729.862 1281.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M759.492 1351.15C760.252 1351.15 760.262 1350.05 759.492 1350.05C758.732 1350.05 758.732 1351.15 759.492 1351.15Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M893.882 1478.16C894.642 1478.16 894.642 1477.06 893.882 1477.06C893.112 1477.06 893.112 1478.16 893.882 1478.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M937.429 1489.48C938.189 1489.48 938.199 1488.38 937.429 1488.38C936.669 1488.38 936.669 1489.48 937.429 1489.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M836.507 1501.79C837.267 1501.79 837.267 1500.69 836.507 1500.69C835.748 1500.69 835.748 1501.79 836.507 1501.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M799.859 1494.9C800.619 1494.9 800.619 1493.8 799.859 1493.8C799.099 1493.8 799.099 1494.9 799.859 1494.9Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M893.882 1497.36C894.642 1497.36 894.642 1496.26 893.882 1496.26C893.112 1496.26 893.112 1497.36 893.882 1497.36Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M814.929 1206.83C815.699 1206.83 815.699 1205.73 814.929 1205.73C814.169 1205.73 814.169 1206.83 814.929 1206.83Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M915.468 1200.47C916.238 1200.47 916.238 1199.37 915.468 1199.37C914.708 1199.37 914.708 1200.47 915.468 1200.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M782.179 1097.41C782.939 1097.41 782.949 1096.31 782.179 1096.31C781.419 1096.31 781.419 1097.41 782.179 1097.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M846.922 1113.64C847.692 1113.64 847.692 1112.54 846.922 1112.54C846.162 1112.54 846.162 1113.64 846.922 1113.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M918.519 1113.64C919.279 1113.64 919.279 1112.54 918.519 1112.54C917.759 1112.54 917.759 1113.64 918.519 1113.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M742.577 1029.64C743.337 1029.64 743.337 1028.54 742.577 1028.54C741.808 1028.54 741.808 1029.64 742.577 1029.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M725.521 1127.44C725.011 1127.68 724.501 1127.91 724.001 1128.15C723.311 1128.46 723.911 1129.41 724.591 1129.1C725.101 1128.86 725.611 1128.63 726.121 1128.39C726.801 1128.08 726.201 1127.13 725.521 1127.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M709.82 1071.29C710.59 1071.29 710.59 1070.19 709.82 1070.19C709.06 1070.19 709.06 1071.29 709.82 1071.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865.968 1170.12C866.728 1170.12 866.728 1169.02 865.968 1169.02C865.198 1169.02 865.198 1170.12 865.968 1170.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M913.191 1321.19C913.951 1321.19 913.951 1320.09 913.191 1320.09C912.431 1320.09 912.421 1321.19 913.191 1321.19Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M839.312 1239.85C840.832 1239.85 840.842 1237.65 839.312 1237.65C837.782 1237.65 837.782 1239.85 839.312 1239.85Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M729.632 1206.67C731.152 1206.67 731.162 1204.47 729.632 1204.47C728.102 1204.47 728.102 1206.67 729.632 1206.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M701.452 1284.32C702.972 1284.32 702.972 1282.12 701.452 1282.12C699.922 1282.12 699.922 1284.32 701.452 1284.32Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M920.038 1387.38C921.568 1387.38 921.568 1385.19 920.038 1385.19C918.518 1385.19 918.518 1387.38 920.038 1387.38Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.89 1458.68C944.42 1458.68 944.42 1456.48 942.89 1456.48C941.37 1456.48 941.37 1458.68 942.89 1458.68Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.28 1501.04C920.81 1501.04 920.81 1498.84 919.28 1498.84C917.76 1498.84 917.75 1501.04 919.28 1501.04Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M883.48 1280.08C885.01 1280.08 885.01 1277.89 883.48 1277.89C881.96 1277.89 881.95 1280.08 883.48 1280.08Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M781.421 1230.67C782.951 1230.67 782.951 1228.47 781.421 1228.47C779.891 1228.47 779.891 1230.67 781.421 1230.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M788.28 1144.55C789.8 1144.55 789.8 1142.35 788.28 1142.35C786.75 1142.35 786.75 1144.55 788.28 1144.55Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M738.773 1083.84C740.293 1083.84 740.303 1081.64 738.773 1081.64C737.243 1081.64 737.243 1083.84 738.773 1083.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M763.902 1191.84C765.432 1191.84 765.432 1189.65 763.902 1189.65C762.382 1189.65 762.372 1191.84 763.902 1191.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865.202 1203.14C866.733 1203.14 866.733 1200.94 865.202 1200.94C863.683 1200.94 863.683 1203.14 865.202 1203.14Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M925.711 1137.09C925.711 1137.8 925.711 1138.51 925.711 1139.21C925.711 1140.63 928.081 1140.63 928.081 1139.21C928.081 1138.51 928.081 1137.8 928.081 1137.09C928.081 1135.68 925.711 1135.68 925.711 1137.09Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M813.152 1068.47C813.402 1068.94 813.662 1069.41 813.912 1069.88C814.592 1071.15 816.642 1070.03 815.962 1068.77C815.702 1068.3 815.452 1067.83 815.202 1067.36C814.512 1066.09 812.472 1067.21 813.152 1068.47Z",
    fill: "#FFFFFE"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.597 1269.47C261.867 1269.47 261.867 1267.65 260.597 1267.65C259.337 1267.65 259.327 1269.47 260.597 1269.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.499 1315.54C236.759 1315.54 236.759 1313.71 235.499 1313.71C234.229 1313.71 234.229 1315.54 235.499 1315.54Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.863 1247.6C325.133 1247.6 325.133 1245.78 323.863 1245.78C322.603 1245.78 322.593 1247.6 323.863 1247.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.57 1232.94C235.34 1232.94 235.34 1231.85 234.57 1231.85C233.81 1231.85 233.81 1232.94 234.57 1232.94Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.863 1127.06C237.623 1127.06 237.623 1125.96 236.863 1125.96C236.103 1125.96 236.093 1127.06 236.863 1127.06Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.781 1170.12C330.541 1170.12 330.551 1169.02 329.781 1169.02C329.021 1169.02 329.021 1170.12 329.781 1170.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.699 1041.64C292.459 1041.64 292.459 1040.54 291.699 1040.54C290.939 1040.54 290.929 1041.64 291.699 1041.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.468 963.284C277.228 963.284 277.228 962.186 276.468 962.186C275.698 962.186 275.698 963.284 276.468 963.284Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.658 945.403C245.398 945.167 245.148 944.932 244.888 944.697C244.348 944.196 243.518 944.972 244.058 945.474C244.308 945.709 244.558 945.945 244.818 946.18C245.358 946.681 246.198 945.904 245.658 945.403Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.988 1168.7C278.748 1168.7 278.748 1167.61 277.988 1167.61C277.228 1167.61 277.218 1168.7 277.988 1168.7Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.89 1098.66C305.41 1098.66 305.41 1096.46 303.89 1096.46C302.36 1096.46 302.36 1098.66 303.89 1098.66Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.569 1058.43C252.089 1058.43 252.099 1056.23 250.569 1056.23C249.039 1056.23 249.039 1058.43 250.569 1058.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.898 1198.91C273.418 1198.91 273.418 1196.71 271.898 1196.71C270.368 1196.71 270.368 1198.91 271.898 1198.91Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.78 1220.79C331.31 1220.79 331.31 1218.59 329.78 1218.59C328.26 1218.59 328.25 1220.79 329.78 1220.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.171 1021.72C323.691 1021.72 323.691 1019.52 322.171 1019.52C320.641 1019.52 320.641 1021.72 322.171 1021.72Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.14 1000.54C256.66 1000.54 256.67 998.342 255.14 998.342C253.61 998.342 253.61 1000.54 255.14 1000.54Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.25 1271.8C419.52 1271.8 419.52 1269.97 418.25 1269.97C416.99 1269.97 416.98 1271.8 418.25 1271.8Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.327 1275.99C438.597 1275.99 438.597 1274.16 437.327 1274.16C436.058 1274.16 436.058 1275.99 437.327 1275.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.82 1284.83C435.08 1284.83 435.08 1283.01 433.82 1283.01C432.55 1283.01 432.55 1284.83 433.82 1284.83Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.929 1344.85C462.189 1344.85 462.189 1343.03 460.929 1343.03C459.659 1343.03 459.659 1344.85 460.929 1344.85Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.999 1385.34C479.259 1385.34 479.269 1383.51 477.999 1383.51C476.729 1383.51 476.729 1385.34 477.999 1385.34Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473.48 1322.52C474.74 1322.52 474.75 1320.7 473.48 1320.7C472.21 1320.7 472.21 1322.52 473.48 1322.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.543 1251.79C368.813 1251.79 368.813 1249.97 367.543 1249.97C366.283 1249.97 366.273 1251.79 367.543 1251.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.929 1417.45C462.189 1417.45 462.189 1415.62 460.929 1415.62C459.659 1415.62 459.659 1417.45 460.929 1417.45Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.179 1469.56C402.449 1469.56 402.449 1467.74 401.179 1467.74C399.919 1467.74 399.909 1469.56 401.179 1469.56Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.559 1504.46C372.729 1504.46 372.899 1504.46 373.059 1504.46C373.579 1504.46 374.069 1504.04 374.049 1503.55C374.019 1503.06 373.619 1502.64 373.059 1502.64C372.899 1502.64 372.729 1502.64 372.559 1502.64C372.049 1502.64 371.559 1503.06 371.579 1503.55C371.599 1504.04 372.009 1504.46 372.559 1504.46Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.23 1509.12C414.5 1509.12 414.5 1507.29 413.23 1507.29C411.97 1507.29 411.96 1509.12 413.23 1509.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.937 1466.77C466.207 1466.77 466.207 1464.95 464.937 1464.95C463.677 1464.95 463.677 1466.77 464.937 1466.77Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.8 1454.67C432.07 1454.67 432.07 1452.85 430.8 1452.85C429.54 1452.85 429.54 1454.67 430.8 1454.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.808 1472.35C434.078 1472.35 434.078 1470.53 432.808 1470.53C431.548 1470.53 431.538 1472.35 432.808 1472.35Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.531 1405.81C487.801 1405.81 487.801 1403.99 486.531 1403.99C485.271 1403.99 485.271 1405.81 486.531 1405.81Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.281 1374.64C425.541 1374.64 425.541 1372.81 424.281 1372.81C423.011 1372.81 423.011 1374.64 424.281 1374.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.648 1301.58C394.908 1301.58 394.918 1299.76 393.648 1299.76C392.378 1299.76 392.378 1301.58 393.648 1301.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.468 1330.43C350.728 1330.43 350.728 1328.61 349.468 1328.61C348.198 1328.61 348.198 1330.43 349.468 1330.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.101 1418.84C382.361 1418.84 382.371 1417.02 381.101 1417.02C379.831 1417.02 379.831 1418.84 381.101 1418.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.59 1362.47C554.35 1362.47 554.36 1361.37 553.59 1361.37C552.83 1361.37 552.83 1362.47 553.59 1362.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.121 1396.44C537.891 1396.44 537.891 1395.34 537.121 1395.34C536.361 1395.34 536.361 1396.44 537.121 1396.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.679 1414.65C581.439 1414.65 581.439 1413.55 580.679 1413.55C579.919 1413.55 579.919 1414.65 580.679 1414.65Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545.09 1452.56C545.86 1452.56 545.86 1451.46 545.09 1451.46C544.33 1451.46 544.33 1452.56 545.09 1452.56Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.23 1465.85C496.99 1465.85 496.99 1464.75 496.23 1464.75C495.46 1464.75 495.46 1465.85 496.23 1465.85Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.562 1424.99C528.332 1424.99 528.332 1423.89 527.562 1423.89C526.802 1423.89 526.802 1424.99 527.562 1424.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.851 1331.95C524.611 1331.95 524.611 1330.85 523.851 1330.85C523.081 1330.85 523.081 1331.95 523.851 1331.95Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.398 1269.92C568.158 1269.92 568.168 1268.82 567.398 1268.82C566.638 1268.82 566.638 1269.92 567.398 1269.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.91 1257.12C491.09 1257.12 491.27 1257.12 491.44 1257.12C492.21 1257.12 492.21 1256.02 491.44 1256.02C491.27 1256.02 491.09 1256.02 490.91 1256.02C490.15 1256.02 490.15 1257.12 490.91 1257.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.862 1281.58C369.042 1281.74 369.212 1281.9 369.392 1282.07C369.932 1282.57 370.772 1281.79 370.232 1281.29C370.052 1281.13 369.872 1280.96 369.702 1280.8C369.162 1280.3 368.322 1281.07 368.862 1281.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.492 1351.15C399.252 1351.15 399.262 1350.05 398.492 1350.05C397.732 1350.05 397.732 1351.15 398.492 1351.15Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.882 1478.16C533.642 1478.16 533.642 1477.06 532.882 1477.06C532.112 1477.06 532.112 1478.16 532.882 1478.16Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M576.429 1489.48C577.189 1489.48 577.199 1488.38 576.429 1488.38C575.669 1488.38 575.669 1489.48 576.429 1489.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.507 1501.79C476.267 1501.79 476.267 1500.69 475.507 1500.69C474.748 1500.69 474.748 1501.79 475.507 1501.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.859 1494.9C439.619 1494.9 439.619 1493.8 438.859 1493.8C438.099 1493.8 438.099 1494.9 438.859 1494.9Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.882 1497.36C533.642 1497.36 533.642 1496.26 532.882 1496.26C532.112 1496.26 532.112 1497.36 532.882 1497.36Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.929 1206.83C454.699 1206.83 454.699 1205.73 453.929 1205.73C453.169 1205.73 453.169 1206.83 453.929 1206.83Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M554.468 1200.47C555.238 1200.47 555.238 1199.37 554.468 1199.37C553.708 1199.37 553.708 1200.47 554.468 1200.47Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.179 1097.41C421.939 1097.41 421.949 1096.31 421.179 1096.31C420.419 1096.31 420.419 1097.41 421.179 1097.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.922 1113.64C486.692 1113.64 486.692 1112.54 485.922 1112.54C485.162 1112.54 485.162 1113.64 485.922 1113.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M557.519 1113.64C558.279 1113.64 558.279 1112.54 557.519 1112.54C556.759 1112.54 556.759 1113.64 557.519 1113.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.577 1029.64C382.337 1029.64 382.337 1028.54 381.577 1028.54C380.808 1028.54 380.808 1029.64 381.577 1029.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.521 1127.44C364.011 1127.68 363.501 1127.91 363.001 1128.15C362.311 1128.46 362.911 1129.41 363.591 1129.1C364.101 1128.86 364.611 1128.63 365.121 1128.39C365.801 1128.08 365.201 1127.13 364.521 1127.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.82 1071.29C349.59 1071.29 349.59 1070.19 348.82 1070.19C348.06 1070.19 348.06 1071.29 348.82 1071.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.968 1170.12C505.728 1170.12 505.728 1169.02 504.968 1169.02C504.198 1169.02 504.198 1170.12 504.968 1170.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M552.191 1321.19C552.951 1321.19 552.951 1320.09 552.191 1320.09C551.431 1320.09 551.421 1321.19 552.191 1321.19Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.312 1239.85C479.832 1239.85 479.842 1237.65 478.312 1237.65C476.782 1237.65 476.782 1239.85 478.312 1239.85Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.632 1206.67C370.152 1206.67 370.162 1204.47 368.632 1204.47C367.102 1204.47 367.102 1206.67 368.632 1206.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.452 1284.32C341.972 1284.32 341.972 1282.12 340.452 1282.12C338.922 1282.12 338.922 1284.32 340.452 1284.32Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.038 1387.38C560.568 1387.38 560.568 1385.19 559.038 1385.19C557.518 1385.19 557.518 1387.38 559.038 1387.38Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.89 1458.68C583.42 1458.68 583.42 1456.48 581.89 1456.48C580.37 1456.48 580.37 1458.68 581.89 1458.68Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.28 1501.04C559.81 1501.04 559.81 1498.84 558.28 1498.84C556.76 1498.84 556.75 1501.04 558.28 1501.04Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.48 1280.08C524.01 1280.08 524.01 1277.89 522.48 1277.89C520.96 1277.89 520.95 1280.08 522.48 1280.08Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.421 1230.67C421.951 1230.67 421.951 1228.47 420.421 1228.47C418.891 1228.47 418.891 1230.67 420.421 1230.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.28 1144.55C428.8 1144.55 428.8 1142.35 427.28 1142.35C425.75 1142.35 425.75 1144.55 427.28 1144.55Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.773 1083.84C379.293 1083.84 379.303 1081.64 377.773 1081.64C376.243 1081.64 376.243 1083.84 377.773 1083.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.902 1191.84C404.432 1191.84 404.432 1189.65 402.902 1189.65C401.382 1189.65 401.372 1191.84 402.902 1191.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.202 1203.14C505.733 1203.14 505.733 1200.94 504.202 1200.94C502.683 1200.94 502.683 1203.14 504.202 1203.14Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.711 1137.09C564.711 1137.8 564.711 1138.51 564.711 1139.21C564.711 1140.63 567.081 1140.63 567.081 1139.21C567.081 1138.51 567.081 1137.8 567.081 1137.09C567.081 1135.68 564.711 1135.68 564.711 1137.09Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.152 1068.47C452.402 1068.94 452.662 1069.41 452.912 1069.88C453.592 1071.15 455.642 1070.03 454.962 1068.77C454.702 1068.3 454.452 1067.83 454.202 1067.36C453.512 1066.09 451.472 1067.21 452.152 1068.47Z",
    fill: "#FFFFFE"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1343.59 693.807C1344.86 693.807 1344.86 691.984 1343.59 691.984C1342.33 691.984 1342.32 693.807 1343.59 693.807Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1318.49 739.876C1319.75 739.876 1319.75 738.053 1318.49 738.053C1317.22 738.053 1317.22 739.876 1318.49 739.876Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1406.86 671.937C1408.13 671.937 1408.13 670.115 1406.86 670.115C1405.6 670.115 1405.59 671.937 1406.86 671.937Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1317.56 657.28C1318.33 657.28 1318.33 656.182 1317.56 656.182C1316.8 656.182 1316.8 657.28 1317.56 657.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1319.86 551.391C1320.62 551.391 1320.62 550.293 1319.86 550.293C1319.1 550.293 1319.09 551.391 1319.86 551.391Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1412.77 594.452C1413.53 594.452 1413.54 593.354 1412.77 593.354C1412.01 593.354 1412.01 594.452 1412.77 594.452Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1374.69 465.975C1375.45 465.975 1375.45 464.877 1374.69 464.877C1373.93 464.877 1373.92 465.975 1374.69 465.975Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1359.46 387.618C1360.22 387.618 1360.22 386.52 1359.46 386.52C1358.69 386.52 1358.69 387.618 1359.46 387.618Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1328.65 369.738C1328.39 369.503 1328.14 369.268 1327.88 369.033C1327.34 368.532 1326.51 369.308 1327.05 369.81C1327.3 370.045 1327.55 370.281 1327.81 370.516C1328.35 371.017 1329.19 370.24 1328.65 369.738Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1360.98 593.041C1361.74 593.041 1361.74 591.941 1360.98 591.941C1360.22 591.941 1360.21 593.041 1360.98 593.041Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1386.88 522.998C1388.4 522.998 1388.4 520.801 1386.88 520.801C1385.35 520.801 1385.35 522.998 1386.88 522.998Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1333.56 482.762C1335.08 482.762 1335.09 480.564 1333.56 480.564C1332.03 480.564 1332.03 482.762 1333.56 482.762Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1354.89 623.239C1356.41 623.239 1356.41 621.041 1354.89 621.041C1353.36 621.041 1353.36 623.239 1354.89 623.239Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1412.77 645.123C1414.3 645.123 1414.3 642.926 1412.77 642.926C1411.25 642.926 1411.24 645.123 1412.77 645.123Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1405.16 446.054C1406.68 446.054 1406.68 443.855 1405.16 443.855C1403.63 443.855 1403.63 446.054 1405.16 446.054Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1338.13 424.875C1339.65 424.875 1339.66 422.678 1338.13 422.678C1336.6 422.678 1336.6 424.875 1338.13 424.875Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1432.46 754.764C1433.72 754.764 1433.72 752.941 1432.46 752.941C1431.19 752.941 1431.19 754.764 1432.46 754.764Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1431.81 495.625C1432.58 495.625 1432.58 494.525 1431.81 494.525C1431.05 494.525 1431.05 495.625 1431.81 495.625Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1423.44 708.656C1424.96 708.656 1424.96 706.459 1423.44 706.459C1421.91 706.459 1421.91 708.656 1423.44 708.656Z",
    fill: "#FFFFFE"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M982.589 693.807C983.859 693.807 983.859 691.984 982.589 691.984C981.329 691.984 981.319 693.807 982.589 693.807Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M957.492 739.876C958.752 739.876 958.752 738.053 957.492 738.053C956.222 738.053 956.222 739.876 957.492 739.876Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1045.86 671.937C1047.13 671.937 1047.13 670.115 1045.86 670.115C1044.6 670.115 1044.59 671.937 1045.86 671.937Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M956.562 657.28C957.332 657.28 957.332 656.182 956.562 656.182C955.802 656.182 955.802 657.28 956.562 657.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M958.855 551.391C959.615 551.391 959.615 550.293 958.855 550.293C958.095 550.293 958.085 551.391 958.855 551.391Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1051.77 594.452C1052.53 594.452 1052.54 593.354 1051.77 593.354C1051.01 593.354 1051.01 594.452 1051.77 594.452Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1013.69 465.975C1014.45 465.975 1014.45 464.877 1013.69 464.877C1012.93 464.877 1012.92 465.975 1013.69 465.975Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M998.46 387.618C999.22 387.618 999.22 386.52 998.46 386.52C997.69 386.52 997.69 387.618 998.46 387.618Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M967.65 369.738C967.39 369.503 967.14 369.268 966.88 369.033C966.34 368.532 965.51 369.308 966.05 369.81C966.3 370.045 966.55 370.281 966.81 370.516C967.35 371.017 968.19 370.24 967.65 369.738Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M999.98 593.041C1000.74 593.041 1000.74 591.941 999.98 591.941C999.22 591.941 999.21 593.041 999.98 593.041Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1025.88 522.998C1027.4 522.998 1027.4 520.801 1025.88 520.801C1024.35 520.801 1024.35 522.998 1025.88 522.998Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M972.562 482.762C974.082 482.762 974.092 480.564 972.562 480.564C971.032 480.564 971.032 482.762 972.562 482.762Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M993.89 623.239C995.41 623.239 995.41 621.041 993.89 621.041C992.36 621.041 992.36 623.239 993.89 623.239Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1051.77 645.123C1053.3 645.123 1053.3 642.926 1051.77 642.926C1050.25 642.926 1050.24 645.123 1051.77 645.123Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1044.16 446.054C1045.68 446.054 1045.68 443.855 1044.16 443.855C1042.63 443.855 1042.63 446.054 1044.16 446.054Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M977.132 424.875C978.652 424.875 978.662 422.678 977.132 422.678C975.602 422.678 975.602 424.875 977.132 424.875Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1140.24 696.134C1141.51 696.134 1141.51 694.311 1140.24 694.311C1138.98 694.311 1138.97 696.134 1140.24 696.134Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1159.32 700.323C1160.59 700.323 1160.59 698.5 1159.32 698.5C1158.05 698.5 1158.05 700.323 1159.32 700.323Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1155.81 709.164C1157.07 709.164 1157.07 707.342 1155.81 707.342C1154.54 707.342 1154.54 709.164 1155.81 709.164Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1182.92 769.189C1184.18 769.189 1184.18 767.367 1182.92 767.367C1181.65 767.367 1181.65 769.189 1182.92 769.189Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1199.99 809.673C1201.25 809.673 1201.26 807.85 1199.99 807.85C1198.72 807.85 1198.72 809.673 1199.99 809.673Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1195.47 746.854C1196.73 746.854 1196.74 745.031 1195.47 745.031C1194.2 745.031 1194.2 746.854 1195.47 746.854Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1089.53 676.123C1090.8 676.123 1090.8 674.301 1089.53 674.301C1088.27 674.301 1088.26 676.123 1089.53 676.123Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1182.92 841.78C1184.18 841.78 1184.18 839.957 1182.92 839.957C1181.65 839.957 1181.65 841.78 1182.92 841.78Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1123.17 893.897C1124.44 893.897 1124.44 892.074 1123.17 892.074C1121.91 892.074 1121.9 893.897 1123.17 893.897Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1094.55 928.797C1094.72 928.797 1094.89 928.797 1095.05 928.797C1095.57 928.797 1096.06 928.378 1096.04 927.886C1096.01 927.392 1095.61 926.975 1095.05 926.975C1094.89 926.975 1094.72 926.975 1094.55 926.975C1094.04 926.975 1093.55 927.394 1093.57 927.886C1093.59 928.38 1094 928.797 1094.55 928.797Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1135.22 933.451C1136.49 933.451 1136.49 931.629 1135.22 931.629C1133.96 931.629 1133.95 933.451 1135.22 933.451Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1186.93 891.103C1188.2 891.103 1188.2 889.281 1186.93 889.281C1185.67 889.281 1185.67 891.103 1186.93 891.103Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1152.79 879.008C1154.06 879.008 1154.06 877.186 1152.79 877.186C1151.53 877.186 1151.53 879.008 1152.79 879.008Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1154.8 896.689C1156.07 896.689 1156.07 894.867 1154.8 894.867C1153.54 894.867 1153.53 896.689 1154.8 896.689Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1208.52 830.148C1209.79 830.148 1209.79 828.326 1208.52 828.326C1207.26 828.326 1207.26 830.148 1208.52 830.148Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1146.27 798.97C1147.53 798.97 1147.53 797.146 1146.27 797.146C1145 797.146 1145 798.97 1146.27 798.97Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1115.64 725.915C1116.9 725.915 1116.91 724.092 1115.64 724.092C1114.37 724.092 1114.37 725.915 1115.64 725.915Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1071.46 754.764C1072.72 754.764 1072.72 752.941 1071.46 752.941C1070.19 752.941 1070.19 754.764 1071.46 754.764Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.09 843.178C1104.35 843.178 1104.36 841.355 1103.09 841.355C1101.82 841.355 1101.82 843.178 1103.09 843.178Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1275.58 786.806C1276.34 786.806 1276.35 785.707 1275.58 785.707C1274.82 785.707 1274.82 786.806 1275.58 786.806Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1259.11 820.776C1259.88 820.776 1259.88 819.678 1259.11 819.678C1258.35 819.678 1258.35 820.776 1259.11 820.776Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1302.67 838.99C1303.43 838.99 1303.43 837.891 1302.67 837.891C1301.91 837.891 1301.91 838.99 1302.67 838.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1267.08 876.896C1267.85 876.896 1267.85 875.797 1267.08 875.797C1266.32 875.797 1266.32 876.896 1267.08 876.896Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1218.22 890.188C1218.98 890.188 1218.98 889.09 1218.22 889.09C1217.45 889.09 1217.45 890.188 1218.22 890.188Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1249.55 849.33C1250.32 849.33 1250.32 848.23 1249.55 848.23C1248.79 848.23 1248.79 849.33 1249.55 849.33Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245.84 756.287C1246.6 756.287 1246.6 755.188 1245.84 755.188C1245.07 755.188 1245.07 756.287 1245.84 756.287Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1289.39 694.255C1290.15 694.255 1290.16 693.156 1289.39 693.156C1288.63 693.156 1288.63 694.255 1289.39 694.255Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1212.9 681.459C1213.08 681.459 1213.26 681.459 1213.43 681.459C1214.2 681.459 1214.2 680.359 1213.43 680.359C1213.26 680.359 1213.08 680.359 1212.9 680.359C1212.14 680.359 1212.14 681.459 1212.9 681.459Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1090.85 705.912C1091.03 706.075 1091.2 706.24 1091.38 706.403C1091.92 706.904 1092.76 706.127 1092.22 705.626C1092.04 705.462 1091.86 705.298 1091.69 705.134C1091.15 704.634 1090.31 705.41 1090.85 705.912Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1120.48 775.484C1121.24 775.484 1121.25 774.385 1120.48 774.385C1119.72 774.385 1119.72 775.484 1120.48 775.484Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1254.87 902.497C1255.63 902.497 1255.63 901.398 1254.87 901.398C1254.1 901.398 1254.1 902.497 1254.87 902.497Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1298.42 913.817C1299.18 913.817 1299.19 912.719 1298.42 912.719C1297.66 912.719 1297.66 913.817 1298.42 913.817Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1197.5 926.126C1198.26 926.126 1198.26 925.025 1197.5 925.025C1196.74 925.025 1196.74 926.126 1197.5 926.126Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1160.85 919.232C1161.61 919.232 1161.61 918.133 1160.85 918.133C1160.09 918.133 1160.09 919.232 1160.85 919.232Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1254.87 921.695C1255.63 921.695 1255.63 920.596 1254.87 920.596C1254.1 920.596 1254.1 921.695 1254.87 921.695Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1175.92 631.162C1176.69 631.162 1176.69 630.062 1175.92 630.062C1175.16 630.062 1175.16 631.162 1175.92 631.162Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.46 624.808C1277.23 624.808 1277.23 623.709 1276.46 623.709C1275.7 623.709 1275.7 624.808 1276.46 624.808Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1143.17 521.744C1143.93 521.744 1143.94 520.645 1143.17 520.645C1142.41 520.645 1142.41 521.744 1143.17 521.744Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1207.91 537.98C1208.68 537.98 1208.68 536.881 1207.91 536.881C1207.15 536.881 1207.15 537.98 1207.91 537.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1279.51 537.98C1280.27 537.98 1280.27 536.881 1279.51 536.881C1278.75 536.881 1278.75 537.98 1279.51 537.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.57 453.976C1104.33 453.976 1104.33 452.877 1103.57 452.877C1102.8 452.877 1102.8 453.976 1103.57 453.976Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1086.51 551.778C1086 552.014 1085.49 552.249 1084.99 552.485C1084.3 552.801 1084.9 553.749 1085.58 553.433C1086.09 553.198 1086.6 552.963 1087.11 552.727C1087.79 552.411 1087.19 551.462 1086.51 551.778Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1070.81 495.625C1071.58 495.625 1071.58 494.525 1070.81 494.525C1070.05 494.525 1070.05 495.625 1070.81 495.625Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1226.96 594.452C1227.72 594.452 1227.72 593.354 1226.96 593.354C1226.19 593.354 1226.19 594.452 1226.96 594.452Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1274.18 745.521C1274.94 745.521 1274.94 744.422 1274.18 744.422C1273.42 744.422 1273.41 745.521 1274.18 745.521Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1200.3 664.182C1201.82 664.182 1201.83 661.984 1200.3 661.984C1198.77 661.984 1198.77 664.182 1200.3 664.182Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1090.62 631.004C1092.14 631.004 1092.15 628.807 1090.62 628.807C1089.09 628.807 1089.09 631.004 1090.62 631.004Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1062.44 708.656C1063.96 708.656 1063.96 706.459 1062.44 706.459C1060.91 706.459 1060.91 708.656 1062.44 708.656Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1281.03 811.721C1282.56 811.721 1282.56 809.523 1281.03 809.523C1279.51 809.523 1279.51 811.721 1281.03 811.721Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1303.88 883.019C1305.41 883.019 1305.41 880.82 1303.88 880.82C1302.36 880.82 1302.36 883.019 1303.88 883.019Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1280.27 925.373C1281.8 925.373 1281.8 923.176 1280.27 923.176C1278.75 923.176 1278.74 925.373 1280.27 925.373Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1244.47 704.42C1246 704.42 1246 702.223 1244.47 702.223C1242.95 702.223 1242.94 704.42 1244.47 704.42Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1142.41 655.005C1143.94 655.005 1143.94 652.807 1142.41 652.807C1140.88 652.807 1140.88 655.005 1142.41 655.005Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1149.27 568.883C1150.79 568.883 1150.79 566.686 1149.27 566.686C1147.74 566.686 1147.74 568.883 1149.27 568.883Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1099.76 508.174C1101.28 508.174 1101.29 505.977 1099.76 505.977C1098.23 505.977 1098.23 508.174 1099.76 508.174Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124.89 616.18C1126.42 616.18 1126.42 613.982 1124.89 613.982C1123.37 613.982 1123.36 616.18 1124.89 616.18Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1226.19 627.477C1227.72 627.477 1227.72 625.279 1226.19 625.279C1224.67 625.279 1224.67 627.477 1226.19 627.477Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1286.7 561.431C1286.7 562.137 1286.7 562.842 1286.7 563.548C1286.7 564.962 1289.07 564.965 1289.07 563.548C1289.07 562.842 1289.07 562.137 1289.07 561.431C1289.07 560.016 1286.7 560.014 1286.7 561.431Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1174.14 492.806C1174.39 493.276 1174.65 493.747 1174.9 494.217C1175.58 495.482 1177.63 494.371 1176.95 493.109C1176.69 492.638 1176.44 492.167 1176.19 491.696C1175.5 490.431 1173.46 491.543 1174.14 492.806Z",
    fill: "#FFFFFE"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621.597 693.807C622.867 693.807 622.867 691.984 621.597 691.984C620.337 691.984 620.327 693.807 621.597 693.807Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M596.499 739.876C597.759 739.876 597.759 738.053 596.499 738.053C595.229 738.053 595.229 739.876 596.499 739.876Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.863 671.937C686.133 671.937 686.133 670.115 684.863 670.115C683.603 670.115 683.593 671.937 684.863 671.937Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.57 657.28C596.34 657.28 596.34 656.182 595.57 656.182C594.81 656.182 594.81 657.28 595.57 657.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.863 551.391C598.623 551.391 598.623 550.293 597.863 550.293C597.103 550.293 597.093 551.391 597.863 551.391Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M690.781 594.452C691.541 594.452 691.551 593.354 690.781 593.354C690.021 593.354 690.021 594.452 690.781 594.452Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.699 465.975C653.459 465.975 653.459 464.877 652.699 464.877C651.939 464.877 651.929 465.975 652.699 465.975Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M637.468 387.618C638.228 387.618 638.228 386.52 637.468 386.52C636.698 386.52 636.698 387.618 637.468 387.618Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M606.658 369.738C606.398 369.503 606.148 369.268 605.888 369.033C605.348 368.532 604.518 369.308 605.058 369.81C605.308 370.045 605.558 370.281 605.818 370.516C606.358 371.017 607.198 370.24 606.658 369.738Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.988 593.041C639.748 593.041 639.748 591.941 638.988 591.941C638.228 591.941 638.218 593.041 638.988 593.041Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M664.89 522.998C666.41 522.998 666.41 520.801 664.89 520.801C663.36 520.801 663.36 522.998 664.89 522.998Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M611.569 482.762C613.089 482.762 613.099 480.564 611.569 480.564C610.039 480.564 610.039 482.762 611.569 482.762Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632.898 623.239C634.418 623.239 634.418 621.041 632.898 621.041C631.368 621.041 631.368 623.239 632.898 623.239Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M690.78 645.123C692.31 645.123 692.31 642.926 690.78 642.926C689.26 642.926 689.25 645.123 690.78 645.123Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M683.171 446.054C684.691 446.054 684.691 443.855 683.171 443.855C681.641 443.855 681.641 446.054 683.171 446.054Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.14 424.875C617.66 424.875 617.67 422.678 616.14 422.678C614.61 422.678 614.61 424.875 616.14 424.875Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M779.25 696.134C780.52 696.134 780.52 694.311 779.25 694.311C777.99 694.311 777.98 696.134 779.25 696.134Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M798.327 700.323C799.597 700.323 799.597 698.5 798.327 698.5C797.058 698.5 797.058 700.323 798.327 700.323Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M794.82 709.164C796.08 709.164 796.08 707.342 794.82 707.342C793.55 707.342 793.55 709.164 794.82 709.164Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821.929 769.189C823.189 769.189 823.189 767.367 821.929 767.367C820.659 767.367 820.659 769.189 821.929 769.189Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M838.999 809.673C840.259 809.673 840.269 807.85 838.999 807.85C837.729 807.85 837.729 809.673 838.999 809.673Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.48 746.854C835.74 746.854 835.75 745.031 834.48 745.031C833.21 745.031 833.21 746.854 834.48 746.854Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M728.543 676.123C729.813 676.123 729.813 674.301 728.543 674.301C727.283 674.301 727.273 676.123 728.543 676.123Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821.929 841.78C823.189 841.78 823.189 839.957 821.929 839.957C820.659 839.957 820.659 841.78 821.929 841.78Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M762.179 893.897C763.449 893.897 763.449 892.074 762.179 892.074C760.919 892.074 760.909 893.897 762.179 893.897Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.559 928.797C733.729 928.797 733.899 928.797 734.059 928.797C734.579 928.797 735.069 928.378 735.049 927.886C735.019 927.392 734.619 926.975 734.059 926.975C733.899 926.975 733.729 926.975 733.559 926.975C733.049 926.975 732.559 927.394 732.579 927.886C732.599 928.38 733.009 928.797 733.559 928.797Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M774.23 933.451C775.5 933.451 775.5 931.629 774.23 931.629C772.97 931.629 772.96 933.451 774.23 933.451Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M825.937 891.103C827.207 891.103 827.207 889.281 825.937 889.281C824.677 889.281 824.677 891.103 825.937 891.103Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M791.8 879.008C793.07 879.008 793.07 877.186 791.8 877.186C790.54 877.186 790.54 879.008 791.8 879.008Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M793.808 896.689C795.078 896.689 795.078 894.867 793.808 894.867C792.548 894.867 792.538 896.689 793.808 896.689Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.531 830.148C848.801 830.148 848.801 828.326 847.531 828.326C846.271 828.326 846.271 830.148 847.531 830.148Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M785.281 798.97C786.541 798.97 786.541 797.146 785.281 797.146C784.011 797.146 784.011 798.97 785.281 798.97Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M754.648 725.915C755.908 725.915 755.918 724.092 754.648 724.092C753.378 724.092 753.378 725.915 754.648 725.915Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.468 754.764C711.728 754.764 711.728 752.941 710.468 752.941C709.198 752.941 709.198 754.764 710.468 754.764Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M742.101 843.178C743.361 843.178 743.371 841.355 742.101 841.355C740.831 841.355 740.831 843.178 742.101 843.178Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.59 786.806C915.35 786.806 915.36 785.707 914.59 785.707C913.83 785.707 913.83 786.806 914.59 786.806Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M898.121 820.776C898.891 820.776 898.891 819.678 898.121 819.678C897.361 819.678 897.361 820.776 898.121 820.776Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M941.679 838.99C942.439 838.99 942.439 837.891 941.679 837.891C940.919 837.891 940.919 838.99 941.679 838.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M906.09 876.896C906.86 876.896 906.86 875.797 906.09 875.797C905.33 875.797 905.33 876.896 906.09 876.896Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M857.23 890.188C857.99 890.188 857.99 889.09 857.23 889.09C856.46 889.09 856.46 890.188 857.23 890.188Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M888.562 849.33C889.332 849.33 889.332 848.23 888.562 848.23C887.802 848.23 887.802 849.33 888.562 849.33Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.851 756.287C885.611 756.287 885.611 755.188 884.851 755.188C884.081 755.188 884.081 756.287 884.851 756.287Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.398 694.255C929.158 694.255 929.168 693.156 928.398 693.156C927.638 693.156 927.638 694.255 928.398 694.255Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.91 681.459C852.09 681.459 852.27 681.459 852.44 681.459C853.21 681.459 853.21 680.359 852.44 680.359C852.27 680.359 852.09 680.359 851.91 680.359C851.15 680.359 851.15 681.459 851.91 681.459Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M729.862 705.912C730.042 706.075 730.212 706.24 730.392 706.403C730.932 706.904 731.772 706.127 731.232 705.626C731.052 705.462 730.872 705.298 730.702 705.134C730.162 704.634 729.322 705.41 729.862 705.912Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M759.492 775.484C760.252 775.484 760.262 774.385 759.492 774.385C758.732 774.385 758.732 775.484 759.492 775.484Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M893.882 902.497C894.642 902.497 894.642 901.398 893.882 901.398C893.112 901.398 893.112 902.497 893.882 902.497Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M937.429 913.817C938.189 913.817 938.199 912.719 937.429 912.719C936.669 912.719 936.669 913.817 937.429 913.817Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M836.507 926.126C837.267 926.126 837.267 925.025 836.507 925.025C835.748 925.025 835.748 926.126 836.507 926.126Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M799.859 919.232C800.619 919.232 800.619 918.133 799.859 918.133C799.099 918.133 799.099 919.232 799.859 919.232Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M893.882 921.695C894.642 921.695 894.642 920.596 893.882 920.596C893.112 920.596 893.112 921.695 893.882 921.695Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M814.929 631.162C815.699 631.162 815.699 630.062 814.929 630.062C814.169 630.062 814.169 631.162 814.929 631.162Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M915.468 624.808C916.238 624.808 916.238 623.709 915.468 623.709C914.708 623.709 914.708 624.808 915.468 624.808Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M782.179 521.744C782.939 521.744 782.949 520.645 782.179 520.645C781.419 520.645 781.419 521.744 782.179 521.744Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M846.922 537.98C847.692 537.98 847.692 536.881 846.922 536.881C846.162 536.881 846.162 537.98 846.922 537.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M918.519 537.98C919.279 537.98 919.279 536.881 918.519 536.881C917.759 536.881 917.759 537.98 918.519 537.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M742.577 453.976C743.337 453.976 743.337 452.877 742.577 452.877C741.808 452.877 741.808 453.976 742.577 453.976Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M725.521 551.778C725.011 552.014 724.501 552.249 724.001 552.485C723.311 552.801 723.911 553.749 724.591 553.433C725.101 553.198 725.611 552.963 726.121 552.727C726.801 552.411 726.201 551.462 725.521 551.778Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M709.82 495.625C710.59 495.625 710.59 494.525 709.82 494.525C709.06 494.525 709.06 495.625 709.82 495.625Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865.968 594.452C866.728 594.452 866.728 593.354 865.968 593.354C865.198 593.354 865.198 594.452 865.968 594.452Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M913.191 745.521C913.951 745.521 913.951 744.422 913.191 744.422C912.431 744.422 912.421 745.521 913.191 745.521Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M839.312 664.182C840.832 664.182 840.842 661.984 839.312 661.984C837.782 661.984 837.782 664.182 839.312 664.182Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M729.632 631.004C731.152 631.004 731.162 628.807 729.632 628.807C728.102 628.807 728.102 631.004 729.632 631.004Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M701.452 708.656C702.972 708.656 702.972 706.459 701.452 706.459C699.922 706.459 699.922 708.656 701.452 708.656Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M920.038 811.721C921.568 811.721 921.568 809.523 920.038 809.523C918.518 809.523 918.518 811.721 920.038 811.721Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M942.89 883.019C944.42 883.019 944.42 880.82 942.89 880.82C941.37 880.82 941.37 883.019 942.89 883.019Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M919.28 925.373C920.81 925.373 920.81 923.176 919.28 923.176C917.76 923.176 917.75 925.373 919.28 925.373Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M883.48 704.42C885.01 704.42 885.01 702.223 883.48 702.223C881.96 702.223 881.95 704.42 883.48 704.42Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M781.421 655.005C782.951 655.005 782.951 652.807 781.421 652.807C779.891 652.807 779.891 655.005 781.421 655.005Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M788.28 568.883C789.8 568.883 789.8 566.686 788.28 566.686C786.75 566.686 786.75 568.883 788.28 568.883Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M738.773 508.174C740.293 508.174 740.303 505.977 738.773 505.977C737.243 505.977 737.243 508.174 738.773 508.174Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M763.902 616.18C765.432 616.18 765.432 613.982 763.902 613.982C762.382 613.982 762.372 616.18 763.902 616.18Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865.202 627.477C866.733 627.477 866.733 625.279 865.202 625.279C863.683 625.279 863.683 627.477 865.202 627.477Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M925.711 561.431C925.711 562.137 925.711 562.842 925.711 563.548C925.711 564.962 928.081 564.965 928.081 563.548C928.081 562.842 928.081 562.137 928.081 561.431C928.081 560.016 925.711 560.014 925.711 561.431Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M813.152 492.806C813.402 493.276 813.662 493.747 813.912 494.217C814.592 495.482 816.642 494.371 815.962 493.109C815.702 492.638 815.452 492.167 815.202 491.696C814.512 490.431 812.472 491.543 813.152 492.806Z",
    fill: "#FFFFFE"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.597 693.807C261.867 693.807 261.867 691.984 260.597 691.984C259.337 691.984 259.327 693.807 260.597 693.807Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.499 739.876C236.759 739.876 236.759 738.053 235.499 738.053C234.229 738.053 234.229 739.876 235.499 739.876Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.863 671.937C325.133 671.937 325.133 670.115 323.863 670.115C322.603 670.115 322.593 671.937 323.863 671.937Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.57 657.28C235.34 657.28 235.34 656.182 234.57 656.182C233.81 656.182 233.81 657.28 234.57 657.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.863 551.391C237.623 551.391 237.623 550.293 236.863 550.293C236.103 550.293 236.093 551.391 236.863 551.391Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.781 594.452C330.541 594.452 330.551 593.354 329.781 593.354C329.021 593.354 329.021 594.452 329.781 594.452Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.699 465.975C292.459 465.975 292.459 464.877 291.699 464.877C290.939 464.877 290.929 465.975 291.699 465.975Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.468 387.618C277.228 387.618 277.228 386.52 276.468 386.52C275.698 386.52 275.698 387.618 276.468 387.618Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.658 369.738C245.398 369.503 245.148 369.268 244.888 369.033C244.348 368.532 243.518 369.308 244.058 369.81C244.308 370.045 244.558 370.281 244.818 370.516C245.358 371.017 246.198 370.24 245.658 369.738Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.988 593.041C278.748 593.041 278.748 591.941 277.988 591.941C277.228 591.941 277.218 593.041 277.988 593.041Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.89 522.998C305.41 522.998 305.41 520.801 303.89 520.801C302.36 520.801 302.36 522.998 303.89 522.998Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.569 482.762C252.089 482.762 252.099 480.564 250.569 480.564C249.039 480.564 249.039 482.762 250.569 482.762Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.898 623.239C273.418 623.239 273.418 621.041 271.898 621.041C270.368 621.041 270.368 623.239 271.898 623.239Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.78 645.123C331.31 645.123 331.31 642.926 329.78 642.926C328.26 642.926 328.25 645.123 329.78 645.123Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.171 446.054C323.691 446.054 323.691 443.855 322.171 443.855C320.641 443.855 320.641 446.054 322.171 446.054Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.14 424.875C256.66 424.875 256.67 422.678 255.14 422.678C253.61 422.678 253.61 424.875 255.14 424.875Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.25 696.134C419.52 696.134 419.52 694.311 418.25 694.311C416.99 694.311 416.98 696.134 418.25 696.134Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.327 700.323C438.597 700.323 438.597 698.5 437.327 698.5C436.058 698.5 436.058 700.323 437.327 700.323Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.82 709.164C435.08 709.164 435.08 707.342 433.82 707.342C432.55 707.342 432.55 709.164 433.82 709.164Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.929 769.189C462.189 769.189 462.189 767.367 460.929 767.367C459.659 767.367 459.659 769.189 460.929 769.189Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.999 809.673C479.259 809.673 479.269 807.85 477.999 807.85C476.729 807.85 476.729 809.673 477.999 809.673Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473.48 746.854C474.74 746.854 474.75 745.031 473.48 745.031C472.21 745.031 472.21 746.854 473.48 746.854Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.543 676.123C368.813 676.123 368.813 674.301 367.543 674.301C366.283 674.301 366.273 676.123 367.543 676.123Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.929 841.78C462.189 841.78 462.189 839.957 460.929 839.957C459.659 839.957 459.659 841.78 460.929 841.78Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.179 893.897C402.449 893.897 402.449 892.074 401.179 892.074C399.919 892.074 399.909 893.897 401.179 893.897Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.559 928.797C372.729 928.797 372.899 928.797 373.059 928.797C373.579 928.797 374.069 928.378 374.049 927.886C374.019 927.392 373.619 926.975 373.059 926.975C372.899 926.975 372.729 926.975 372.559 926.975C372.049 926.975 371.559 927.394 371.579 927.886C371.599 928.38 372.009 928.797 372.559 928.797Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.23 933.451C414.5 933.451 414.5 931.629 413.23 931.629C411.97 931.629 411.96 933.451 413.23 933.451Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.937 891.103C466.207 891.103 466.207 889.281 464.937 889.281C463.677 889.281 463.677 891.103 464.937 891.103Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.8 879.008C432.07 879.008 432.07 877.186 430.8 877.186C429.54 877.186 429.54 879.008 430.8 879.008Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.808 896.689C434.078 896.689 434.078 894.867 432.808 894.867C431.548 894.867 431.538 896.689 432.808 896.689Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.531 830.148C487.801 830.148 487.801 828.326 486.531 828.326C485.271 828.326 485.271 830.148 486.531 830.148Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.281 798.97C425.541 798.97 425.541 797.146 424.281 797.146C423.011 797.146 423.011 798.97 424.281 798.97Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.648 725.915C394.908 725.915 394.918 724.092 393.648 724.092C392.378 724.092 392.378 725.915 393.648 725.915Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.468 754.764C350.728 754.764 350.728 752.941 349.468 752.941C348.198 752.941 348.198 754.764 349.468 754.764Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.101 843.178C382.361 843.178 382.371 841.355 381.101 841.355C379.831 841.355 379.831 843.178 381.101 843.178Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.59 786.806C554.35 786.806 554.36 785.707 553.59 785.707C552.83 785.707 552.83 786.806 553.59 786.806Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.121 820.776C537.891 820.776 537.891 819.678 537.121 819.678C536.361 819.678 536.361 820.776 537.121 820.776Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.679 838.99C581.439 838.99 581.439 837.891 580.679 837.891C579.919 837.891 579.919 838.99 580.679 838.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545.09 876.896C545.86 876.896 545.86 875.797 545.09 875.797C544.33 875.797 544.33 876.896 545.09 876.896Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.23 890.188C496.99 890.188 496.99 889.09 496.23 889.09C495.46 889.09 495.46 890.188 496.23 890.188Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.562 849.33C528.332 849.33 528.332 848.23 527.562 848.23C526.802 848.23 526.802 849.33 527.562 849.33Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.851 756.287C524.611 756.287 524.611 755.188 523.851 755.188C523.081 755.188 523.081 756.287 523.851 756.287Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.398 694.255C568.158 694.255 568.168 693.156 567.398 693.156C566.638 693.156 566.638 694.255 567.398 694.255Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.91 681.459C491.09 681.459 491.27 681.459 491.44 681.459C492.21 681.459 492.21 680.359 491.44 680.359C491.27 680.359 491.09 680.359 490.91 680.359C490.15 680.359 490.15 681.459 490.91 681.459Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.862 705.912C369.042 706.075 369.212 706.24 369.392 706.403C369.932 706.904 370.772 706.127 370.232 705.626C370.052 705.462 369.872 705.298 369.702 705.134C369.162 704.634 368.322 705.41 368.862 705.912Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.492 775.484C399.252 775.484 399.262 774.385 398.492 774.385C397.732 774.385 397.732 775.484 398.492 775.484Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.882 902.497C533.642 902.497 533.642 901.398 532.882 901.398C532.112 901.398 532.112 902.497 532.882 902.497Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M576.429 913.817C577.189 913.817 577.199 912.719 576.429 912.719C575.669 912.719 575.669 913.817 576.429 913.817Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.507 926.126C476.267 926.126 476.267 925.025 475.507 925.025C474.748 925.025 474.748 926.126 475.507 926.126Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.859 919.232C439.619 919.232 439.619 918.133 438.859 918.133C438.099 918.133 438.099 919.232 438.859 919.232Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.882 921.695C533.642 921.695 533.642 920.596 532.882 920.596C532.112 920.596 532.112 921.695 532.882 921.695Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.929 631.162C454.699 631.162 454.699 630.062 453.929 630.062C453.169 630.062 453.169 631.162 453.929 631.162Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M554.468 624.808C555.238 624.808 555.238 623.709 554.468 623.709C553.708 623.709 553.708 624.808 554.468 624.808Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.179 521.744C421.939 521.744 421.949 520.645 421.179 520.645C420.419 520.645 420.419 521.744 421.179 521.744Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.922 537.98C486.692 537.98 486.692 536.881 485.922 536.881C485.162 536.881 485.162 537.98 485.922 537.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M557.519 537.98C558.279 537.98 558.279 536.881 557.519 536.881C556.759 536.881 556.759 537.98 557.519 537.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.577 453.976C382.337 453.976 382.337 452.877 381.577 452.877C380.808 452.877 380.808 453.976 381.577 453.976Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.521 551.778C364.011 552.014 363.501 552.249 363.001 552.485C362.311 552.801 362.911 553.749 363.591 553.433C364.101 553.198 364.611 552.963 365.121 552.727C365.801 552.411 365.201 551.462 364.521 551.778Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.82 495.625C349.59 495.625 349.59 494.525 348.82 494.525C348.06 494.525 348.06 495.625 348.82 495.625Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.968 594.452C505.728 594.452 505.728 593.354 504.968 593.354C504.198 593.354 504.198 594.452 504.968 594.452Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M552.191 745.521C552.951 745.521 552.951 744.422 552.191 744.422C551.431 744.422 551.421 745.521 552.191 745.521Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.312 664.182C479.832 664.182 479.842 661.984 478.312 661.984C476.782 661.984 476.782 664.182 478.312 664.182Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.632 631.004C370.152 631.004 370.162 628.807 368.632 628.807C367.102 628.807 367.102 631.004 368.632 631.004Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.452 708.656C341.972 708.656 341.972 706.459 340.452 706.459C338.922 706.459 338.922 708.656 340.452 708.656Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.038 811.721C560.568 811.721 560.568 809.523 559.038 809.523C557.518 809.523 557.518 811.721 559.038 811.721Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.89 883.019C583.42 883.019 583.42 880.82 581.89 880.82C580.37 880.82 580.37 883.019 581.89 883.019Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.28 925.373C559.81 925.373 559.81 923.176 558.28 923.176C556.76 923.176 556.75 925.373 558.28 925.373Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.48 704.42C524.01 704.42 524.01 702.223 522.48 702.223C520.96 702.223 520.95 704.42 522.48 704.42Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.421 655.005C421.951 655.005 421.951 652.807 420.421 652.807C418.891 652.807 418.891 655.005 420.421 655.005Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.28 568.883C428.8 568.883 428.8 566.686 427.28 566.686C425.75 566.686 425.75 568.883 427.28 568.883Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.773 508.174C379.293 508.174 379.303 505.977 377.773 505.977C376.243 505.977 376.243 508.174 377.773 508.174Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.902 616.18C404.432 616.18 404.432 613.982 402.902 613.982C401.382 613.982 401.372 616.18 402.902 616.18Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.202 627.477C505.733 627.477 505.733 625.279 504.202 625.279C502.683 625.279 502.683 627.477 504.202 627.477Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.711 561.431C564.711 562.137 564.711 562.842 564.711 563.548C564.711 564.962 567.081 564.965 567.081 563.548C567.081 562.842 567.081 562.137 567.081 561.431C567.081 560.016 564.711 560.014 564.711 561.431Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.152 492.806C452.402 493.276 452.662 493.747 452.912 494.217C453.592 495.482 455.642 494.371 454.962 493.109C454.702 492.638 454.452 492.167 454.202 491.696C453.512 490.431 451.472 491.543 452.152 492.806Z",
    fill: "#FFFFFE"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.597 920.876C164.867 920.876 164.867 919.053 163.597 919.053C162.337 919.053 162.327 920.876 163.597 920.876Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.499 966.942C139.759 966.942 139.759 965.119 138.499 965.119C137.229 965.119 137.229 966.942 138.499 966.942Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.863 899.006C228.133 899.006 228.133 897.184 226.863 897.184C225.603 897.184 225.593 899.006 226.863 899.006Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.57 884.348C138.34 884.348 138.34 883.25 137.57 883.25C136.81 883.25 136.81 884.348 137.57 884.348Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.863 778.46C140.623 778.46 140.623 777.361 139.863 777.361C139.103 777.361 139.093 778.46 139.863 778.46Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.781 821.522C233.541 821.522 233.551 820.424 232.781 820.424C232.021 820.424 232.021 821.522 232.781 821.522Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.699 693.044C195.459 693.044 195.459 691.945 194.699 691.945C193.939 691.945 193.929 693.044 194.699 693.044Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.468 614.688C180.228 614.688 180.228 613.59 179.468 613.59C178.698 613.59 178.698 614.688 179.468 614.688Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.658 596.807C148.398 596.571 148.148 596.336 147.888 596.101C147.348 595.6 146.518 596.377 147.058 596.878C147.308 597.114 147.558 597.349 147.818 597.584C148.358 598.085 149.198 597.308 148.658 596.807Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.988 820.109C181.748 820.109 181.748 819.01 180.988 819.01C180.228 819.01 180.218 820.109 180.988 820.109Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.89 750.067C208.41 750.067 208.41 747.869 206.89 747.869C205.36 747.869 205.36 750.067 206.89 750.067Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.569 709.83C155.089 709.83 155.099 707.633 153.569 707.633C152.039 707.633 152.039 709.83 153.569 709.83Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.898 850.308C176.418 850.308 176.418 848.109 174.898 848.109C173.368 848.109 173.368 850.308 174.898 850.308Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.78 872.192C234.31 872.192 234.31 869.994 232.78 869.994C231.26 869.994 231.25 872.192 232.78 872.192Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.171 673.124C226.691 673.124 226.691 670.926 225.171 670.926C223.641 670.926 223.641 673.124 225.171 673.124Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.14 651.944C159.66 651.944 159.67 649.746 158.14 649.746C156.61 649.746 156.61 651.944 158.14 651.944Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.25 923.202C322.52 923.202 322.52 921.379 321.25 921.379C319.99 921.379 319.98 923.202 321.25 923.202Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.327 927.391C341.597 927.391 341.597 925.568 340.327 925.568C339.058 925.568 339.058 927.391 340.327 927.391Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.82 936.232C338.08 936.232 338.08 934.41 336.82 934.41C335.55 934.41 335.55 936.232 336.82 936.232Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.929 996.26C365.189 996.26 365.189 994.437 363.929 994.437C362.659 994.437 362.659 996.26 363.929 996.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.999 1036.74C382.259 1036.74 382.269 1034.92 380.999 1034.92C379.729 1034.92 379.729 1036.74 380.999 1036.74Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.48 973.923C377.74 973.923 377.75 972.1 376.48 972.1C375.21 972.1 375.21 973.923 376.48 973.923Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.543 903.193C271.813 903.193 271.813 901.371 270.543 901.371C269.283 901.371 269.273 903.193 270.543 903.193Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.929 1068.85C365.189 1068.85 365.189 1067.03 363.929 1067.03C362.659 1067.03 362.659 1068.85 363.929 1068.85Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.179 1120.97C305.449 1120.97 305.449 1119.14 304.179 1119.14C302.919 1119.14 302.909 1120.97 304.179 1120.97Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.559 1155.87C275.729 1155.87 275.899 1155.87 276.059 1155.87C276.579 1155.87 277.069 1155.45 277.049 1154.95C277.019 1154.46 276.619 1154.04 276.059 1154.04C275.899 1154.04 275.729 1154.04 275.559 1154.04C275.049 1154.04 274.559 1154.46 274.579 1154.95C274.599 1155.45 275.009 1155.87 275.559 1155.87Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.23 1160.52C317.5 1160.52 317.5 1158.7 316.23 1158.7C314.97 1158.7 314.96 1160.52 316.23 1160.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.937 1118.17C369.207 1118.17 369.207 1116.35 367.937 1116.35C366.677 1116.35 366.677 1118.17 367.937 1118.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.8 1106.08C335.07 1106.08 335.07 1104.25 333.8 1104.25C332.54 1104.25 332.54 1106.08 333.8 1106.08Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.808 1123.76C337.078 1123.76 337.078 1121.94 335.808 1121.94C334.548 1121.94 334.538 1123.76 335.808 1123.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.531 1057.22C390.801 1057.22 390.801 1055.39 389.531 1055.39C388.271 1055.39 388.271 1057.22 389.531 1057.22Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.281 1026.04C328.541 1026.04 328.541 1024.21 327.281 1024.21C326.011 1024.21 326.011 1026.04 327.281 1026.04Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.648 952.983C297.908 952.983 297.918 951.16 296.648 951.16C295.378 951.16 295.378 952.983 296.648 952.983Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.468 981.834C253.728 981.834 253.728 980.012 252.468 980.012C251.198 980.012 251.198 981.834 252.468 981.834Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.101 1070.24C285.361 1070.24 285.371 1068.42 284.101 1068.42C282.831 1068.42 282.831 1070.24 284.101 1070.24Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.59 1013.87C457.35 1013.87 457.36 1012.78 456.59 1012.78C455.83 1012.78 455.83 1013.87 456.59 1013.87Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.121 1047.84C440.891 1047.84 440.891 1046.75 440.121 1046.75C439.361 1046.75 439.361 1047.84 440.121 1047.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.679 1066.06C484.439 1066.06 484.439 1064.96 483.679 1064.96C482.919 1064.96 482.919 1066.06 483.679 1066.06Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.09 1103.96C448.86 1103.96 448.86 1102.87 448.09 1102.87C447.33 1102.87 447.33 1103.96 448.09 1103.96Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.23 1117.25C399.99 1117.25 399.99 1116.16 399.23 1116.16C398.46 1116.16 398.46 1117.25 399.23 1117.25Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.562 1076.4C431.332 1076.4 431.332 1075.3 430.562 1075.3C429.802 1075.3 429.802 1076.4 430.562 1076.4Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.851 983.353C427.611 983.353 427.611 982.254 426.851 982.254C426.081 982.254 426.081 983.353 426.851 983.353Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.398 921.326C471.158 921.326 471.168 920.227 470.398 920.227C469.638 920.227 469.638 921.326 470.398 921.326Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.91 908.525C394.09 908.525 394.27 908.525 394.44 908.525C395.21 908.525 395.21 907.426 394.44 907.426C394.27 907.426 394.09 907.426 393.91 907.426C393.15 907.426 393.15 908.525 393.91 908.525Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.862 932.978C272.042 933.141 272.212 933.306 272.392 933.469C272.932 933.971 273.772 933.193 273.232 932.693C273.052 932.529 272.872 932.365 272.702 932.201C272.162 931.7 271.322 932.477 271.862 932.978Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.492 1002.55C302.252 1002.55 302.262 1001.45 301.492 1001.45C300.732 1001.45 300.732 1002.55 301.492 1002.55Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.882 1129.56C436.642 1129.56 436.642 1128.46 435.882 1128.46C435.112 1128.46 435.112 1129.56 435.882 1129.56Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.429 1140.89C480.189 1140.89 480.199 1139.79 479.429 1139.79C478.669 1139.79 478.669 1140.89 479.429 1140.89Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.507 1153.19C379.267 1153.19 379.267 1152.09 378.507 1152.09C377.748 1152.09 377.748 1153.19 378.507 1153.19Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.859 1146.3C342.619 1146.3 342.619 1145.2 341.859 1145.2C341.099 1145.2 341.099 1146.3 341.859 1146.3Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.882 1148.76C436.642 1148.76 436.642 1147.66 435.882 1147.66C435.112 1147.66 435.112 1148.76 435.882 1148.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.929 858.23C357.699 858.23 357.699 857.131 356.929 857.131C356.169 857.131 356.169 858.23 356.929 858.23Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.468 851.876C458.238 851.876 458.238 850.777 457.468 850.777C456.708 850.777 456.708 851.876 457.468 851.876Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.179 748.812C324.939 748.812 324.949 747.713 324.179 747.713C323.419 747.713 323.419 748.812 324.179 748.812Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.922 765.048C389.692 765.048 389.692 763.949 388.922 763.949C388.162 763.949 388.162 765.048 388.922 765.048Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.519 765.048C461.279 765.048 461.279 763.949 460.519 763.949C459.759 763.949 459.759 765.048 460.519 765.048Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.577 681.044C285.337 681.044 285.337 679.945 284.577 679.945C283.808 679.945 283.808 681.044 284.577 681.044Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.521 778.849C267.011 779.084 266.501 779.319 266.001 779.555C265.311 779.871 265.911 780.819 266.591 780.503C267.101 780.269 267.611 780.033 268.121 779.798C268.801 779.482 268.201 778.533 267.521 778.849Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.82 722.693C252.59 722.693 252.59 721.594 251.82 721.594C251.06 721.594 251.06 722.693 251.82 722.693Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.968 821.522C408.728 821.522 408.728 820.424 407.968 820.424C407.198 820.424 407.198 821.522 407.968 821.522Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.191 972.587C455.951 972.587 455.951 971.488 455.191 971.488C454.431 971.488 454.421 972.587 455.191 972.587Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.312 891.252C382.832 891.252 382.842 889.055 381.312 889.055C379.782 889.055 379.782 891.252 381.312 891.252Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.632 858.073C273.152 858.073 273.162 855.875 271.632 855.875C270.102 855.875 270.102 858.073 271.632 858.073Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.452 935.725C244.972 935.725 244.972 933.527 243.452 933.527C241.922 933.527 241.922 935.725 243.452 935.725Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.038 1038.79C463.568 1038.79 463.568 1036.59 462.038 1036.59C460.518 1036.59 460.518 1038.79 462.038 1038.79Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.89 1110.09C486.42 1110.09 486.42 1107.89 484.89 1107.89C483.37 1107.89 483.37 1110.09 484.89 1110.09Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.28 1152.44C462.81 1152.44 462.81 1150.24 461.28 1150.24C459.76 1150.24 459.75 1152.44 461.28 1152.44Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.48 931.488C427.01 931.488 427.01 929.291 425.48 929.291C423.96 929.291 423.95 931.488 425.48 931.488Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.421 882.073C324.951 882.073 324.951 879.875 323.421 879.875C321.891 879.875 321.891 882.073 323.421 882.073Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.28 795.951C331.8 795.951 331.8 793.754 330.28 793.754C328.75 793.754 328.75 795.951 330.28 795.951Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.773 735.244C282.293 735.244 282.303 733.047 280.773 733.047C279.243 733.047 279.243 735.244 280.773 735.244Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.902 843.248C307.432 843.248 307.432 841.051 305.902 841.051C304.382 841.051 304.372 843.248 305.902 843.248Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.202 854.543C408.733 854.543 408.733 852.346 407.202 852.346C405.683 852.346 405.683 854.543 407.202 854.543Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.711 788.499C467.711 789.205 467.711 789.91 467.711 790.617C467.711 792.03 470.081 792.033 470.081 790.617C470.081 789.91 470.081 789.205 470.081 788.499C470.081 787.085 467.711 787.083 467.711 788.499Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.152 719.874C355.402 720.345 355.662 720.816 355.912 721.285C356.592 722.551 358.642 721.439 357.962 720.177C357.702 719.706 357.452 719.235 357.202 718.765C356.512 717.499 354.472 718.612 355.152 719.874Z",
    fill: "#FFFFFE"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.597 895.852C568.867 895.852 568.867 894.029 567.597 894.029C566.337 894.029 566.327 895.852 567.597 895.852Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.499 941.921C543.759 941.921 543.759 940.098 542.499 940.098C541.229 940.098 541.229 941.921 542.499 941.921Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M630.863 873.982C632.133 873.982 632.133 872.16 630.863 872.16C629.603 872.16 629.593 873.982 630.863 873.982Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.57 859.325C542.34 859.325 542.34 858.227 541.57 858.227C540.81 858.227 540.81 859.325 541.57 859.325Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.863 753.438C544.623 753.438 544.623 752.34 543.863 752.34C543.103 752.34 543.093 753.438 543.863 753.438Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M636.781 796.499C637.541 796.499 637.551 795.4 636.781 795.4C636.021 795.4 636.021 796.499 636.781 796.499Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M598.699 668.022C599.459 668.022 599.459 666.924 598.699 666.924C597.939 666.924 597.929 668.022 598.699 668.022Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.468 589.665C584.228 589.665 584.228 588.566 583.468 588.566C582.698 588.566 582.698 589.665 583.468 589.665Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M552.658 571.783C552.398 571.548 552.148 571.313 551.888 571.078C551.348 570.577 550.518 571.353 551.058 571.855C551.308 572.09 551.558 572.326 551.818 572.561C552.358 573.061 553.198 572.285 552.658 571.783Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M584.988 795.087C585.748 795.087 585.748 793.988 584.988 793.988C584.228 793.988 584.218 795.087 584.988 795.087Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M610.89 725.045C612.41 725.045 612.41 722.848 610.89 722.848C609.36 722.848 609.36 725.045 610.89 725.045Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M557.569 684.807C559.089 684.807 559.099 682.609 557.569 682.609C556.039 682.609 556.039 684.807 557.569 684.807Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578.898 825.284C580.418 825.284 580.418 823.086 578.898 823.086C577.368 823.086 577.368 825.284 578.898 825.284Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M636.78 847.168C638.31 847.168 638.31 844.971 636.78 844.971C635.26 844.971 635.25 847.168 636.78 847.168Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M629.171 648.099C630.691 648.099 630.691 645.9 629.171 645.9C627.641 645.9 627.641 648.099 629.171 648.099Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M562.14 626.92C563.66 626.92 563.67 624.723 562.14 624.723C560.61 624.723 560.61 626.92 562.14 626.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M725.25 898.179C726.52 898.179 726.52 896.355 725.25 896.355C723.99 896.355 723.98 898.179 725.25 898.179Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M744.327 902.368C745.597 902.368 745.597 900.545 744.327 900.545C743.058 900.545 743.058 902.368 744.327 902.368Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M740.82 911.209C742.08 911.209 742.08 909.387 740.82 909.387C739.55 909.387 739.55 911.209 740.82 911.209Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M767.929 971.234C769.189 971.234 769.189 969.412 767.929 969.412C766.659 969.412 766.659 971.234 767.929 971.234Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M784.999 1011.72C786.259 1011.72 786.269 1009.89 784.999 1009.89C783.729 1009.89 783.729 1011.72 784.999 1011.72Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M780.48 948.901C781.74 948.901 781.75 947.078 780.48 947.078C779.21 947.078 779.21 948.901 780.48 948.901Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.543 878.17C675.813 878.17 675.813 876.348 674.543 876.348C673.283 876.348 673.273 878.17 674.543 878.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M767.929 1043.83C769.189 1043.83 769.189 1042 767.929 1042C766.659 1042 766.659 1043.83 767.929 1043.83Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M708.179 1095.94C709.449 1095.94 709.449 1094.12 708.179 1094.12C706.919 1094.12 706.909 1095.94 708.179 1095.94Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M679.559 1130.84C679.729 1130.84 679.899 1130.84 680.059 1130.84C680.579 1130.84 681.069 1130.42 681.049 1129.93C681.019 1129.44 680.619 1129.02 680.059 1129.02C679.899 1129.02 679.729 1129.02 679.559 1129.02C679.049 1129.02 678.559 1129.44 678.579 1129.93C678.599 1130.42 679.009 1130.84 679.559 1130.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M720.23 1135.5C721.5 1135.5 721.5 1133.67 720.23 1133.67C718.97 1133.67 718.96 1135.5 720.23 1135.5Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M771.937 1093.15C773.207 1093.15 773.207 1091.33 771.937 1091.33C770.677 1091.33 770.677 1093.15 771.937 1093.15Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M737.8 1081.05C739.07 1081.05 739.07 1079.23 737.8 1079.23C736.54 1079.23 736.54 1081.05 737.8 1081.05Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M739.808 1098.73C741.078 1098.73 741.078 1096.91 739.808 1096.91C738.548 1096.91 738.538 1098.73 739.808 1098.73Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M793.531 1032.19C794.801 1032.19 794.801 1030.37 793.531 1030.37C792.271 1030.37 792.271 1032.19 793.531 1032.19Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M731.281 1001.02C732.541 1001.02 732.541 999.193 731.281 999.193C730.011 999.193 730.011 1001.02 731.281 1001.02Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.648 927.96C701.908 927.96 701.918 926.137 700.648 926.137C699.378 926.137 699.378 927.96 700.648 927.96Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M656.468 956.81C657.728 956.81 657.728 954.988 656.468 954.988C655.198 954.988 655.198 956.81 656.468 956.81Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M688.101 1045.22C689.361 1045.22 689.371 1043.4 688.101 1043.4C686.831 1043.4 686.831 1045.22 688.101 1045.22Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M860.59 988.853C861.35 988.853 861.36 987.754 860.59 987.754C859.83 987.754 859.83 988.853 860.59 988.853Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.121 1022.82C844.891 1022.82 844.891 1021.72 844.121 1021.72C843.361 1021.72 843.361 1022.82 844.121 1022.82Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M887.679 1041.03C888.439 1041.03 888.439 1039.94 887.679 1039.94C886.919 1039.94 886.919 1041.03 887.679 1041.03Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M852.09 1078.94C852.86 1078.94 852.86 1077.84 852.09 1077.84C851.33 1077.84 851.33 1078.94 852.09 1078.94Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M803.23 1092.23C803.99 1092.23 803.99 1091.13 803.23 1091.13C802.46 1091.13 802.46 1092.23 803.23 1092.23Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.562 1051.37C835.332 1051.37 835.332 1050.27 834.562 1050.27C833.802 1050.27 833.802 1051.37 834.562 1051.37Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M830.851 958.332C831.611 958.332 831.611 957.233 830.851 957.233C830.081 957.233 830.081 958.332 830.851 958.332Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M874.398 896.302C875.158 896.302 875.168 895.203 874.398 895.203C873.638 895.203 873.638 896.302 874.398 896.302Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M797.91 883.503C798.09 883.503 798.27 883.503 798.44 883.503C799.21 883.503 799.21 882.404 798.44 882.404C798.27 882.404 798.09 882.404 797.91 882.404C797.15 882.404 797.15 883.503 797.91 883.503Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M675.862 907.959C676.042 908.122 676.212 908.287 676.392 908.45C676.932 908.951 677.772 908.174 677.232 907.673C677.052 907.509 676.872 907.345 676.702 907.181C676.162 906.681 675.322 907.457 675.862 907.959Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M705.492 977.531C706.252 977.531 706.262 976.432 705.492 976.432C704.732 976.432 704.732 977.531 705.492 977.531Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M839.882 1104.54C840.642 1104.54 840.642 1103.44 839.882 1103.44C839.112 1103.44 839.112 1104.54 839.882 1104.54Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M883.429 1115.86C884.189 1115.86 884.199 1114.77 883.429 1114.77C882.669 1114.77 882.669 1115.86 883.429 1115.86Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M782.507 1128.17C783.267 1128.17 783.267 1127.07 782.507 1127.07C781.748 1127.07 781.748 1128.17 782.507 1128.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M745.859 1121.28C746.619 1121.28 746.619 1120.18 745.859 1120.18C745.099 1120.18 745.099 1121.28 745.859 1121.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M839.882 1123.74C840.642 1123.74 840.642 1122.64 839.882 1122.64C839.112 1122.64 839.112 1123.74 839.882 1123.74Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M760.929 833.205C761.699 833.205 761.699 832.105 760.929 832.105C760.169 832.105 760.169 833.205 760.929 833.205Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M861.468 826.853C862.238 826.853 862.238 825.754 861.468 825.754C860.708 825.754 860.708 826.853 861.468 826.853Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M728.179 723.791C728.939 723.791 728.949 722.691 728.179 722.691C727.419 722.691 727.419 723.791 728.179 723.791Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M792.922 740.025C793.692 740.025 793.692 738.926 792.922 738.926C792.162 738.926 792.162 740.025 792.922 740.025Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M864.519 740.025C865.279 740.025 865.279 738.926 864.519 738.926C863.759 738.926 863.759 740.025 864.519 740.025Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M688.577 656.021C689.337 656.021 689.337 654.922 688.577 654.922C687.808 654.922 687.808 656.021 688.577 656.021Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M671.521 753.825C671.011 754.061 670.501 754.296 670.001 754.532C669.311 754.848 669.911 755.796 670.591 755.48C671.101 755.245 671.611 755.01 672.121 754.774C672.801 754.458 672.201 753.509 671.521 753.825Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M655.82 697.67C656.59 697.67 656.59 696.57 655.82 696.57C655.06 696.57 655.06 697.67 655.82 697.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811.968 796.499C812.728 796.499 812.728 795.4 811.968 795.4C811.198 795.4 811.198 796.499 811.968 796.499Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M859.191 947.566C859.951 947.566 859.951 946.467 859.191 946.467C858.431 946.467 858.421 947.566 859.191 947.566Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M785.312 866.229C786.832 866.229 786.842 864.031 785.312 864.031C783.782 864.031 783.782 866.229 785.312 866.229Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M675.632 833.049C677.152 833.049 677.162 830.852 675.632 830.852C674.102 830.852 674.102 833.049 675.632 833.049Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647.452 910.701C648.972 910.701 648.972 908.504 647.452 908.504C645.922 908.504 645.922 910.701 647.452 910.701Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M866.038 1013.77C867.568 1013.77 867.568 1011.57 866.038 1011.57C864.518 1011.57 864.518 1013.77 866.038 1013.77Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M888.89 1085.07C890.42 1085.07 890.42 1082.87 888.89 1082.87C887.37 1082.87 887.37 1085.07 888.89 1085.07Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865.28 1127.42C866.81 1127.42 866.81 1125.22 865.28 1125.22C863.76 1125.22 863.75 1127.42 865.28 1127.42Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M829.48 906.465C831.01 906.465 831.01 904.268 829.48 904.268C827.96 904.268 827.95 906.465 829.48 906.465Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M727.421 857.05C728.951 857.05 728.951 854.852 727.421 854.852C725.891 854.852 725.891 857.05 727.421 857.05Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M734.28 770.928C735.8 770.928 735.8 768.73 734.28 768.73C732.75 768.73 732.75 770.928 734.28 770.928Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.773 710.219C686.293 710.219 686.303 708.021 684.773 708.021C683.243 708.021 683.243 710.219 684.773 710.219Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M709.902 818.225C711.432 818.225 711.432 816.027 709.902 816.027C708.382 816.027 708.372 818.225 709.902 818.225Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811.202 829.522C812.733 829.522 812.733 827.324 811.202 827.324C809.683 827.324 809.683 829.522 811.202 829.522Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M871.711 763.475C871.711 764.182 871.711 764.887 871.711 765.593C871.711 767.007 874.081 767.009 874.081 765.593C874.081 764.887 874.081 764.182 874.081 763.475C874.081 762.061 871.711 762.059 871.711 763.475Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M759.152 694.851C759.402 695.321 759.662 695.792 759.912 696.262C760.592 697.527 762.642 696.416 761.962 695.154C761.702 694.683 761.452 694.212 761.202 693.741C760.512 692.476 758.472 693.588 759.152 694.851Z",
    fill: "#FFFFFE"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.6 920.876C1272.87 920.876 1272.87 919.053 1271.6 919.053C1270.34 919.053 1270.33 920.876 1271.6 920.876Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1246.5 966.942C1247.76 966.942 1247.76 965.119 1246.5 965.119C1245.23 965.119 1245.23 966.942 1246.5 966.942Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1334.86 899.006C1336.13 899.006 1336.13 897.184 1334.86 897.184C1333.6 897.184 1333.59 899.006 1334.86 899.006Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245.57 884.348C1246.34 884.348 1246.34 883.25 1245.57 883.25C1244.81 883.25 1244.81 884.348 1245.57 884.348Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1247.86 778.46C1248.62 778.46 1248.62 777.361 1247.86 777.361C1247.1 777.361 1247.09 778.46 1247.86 778.46Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1340.78 821.522C1341.54 821.522 1341.55 820.424 1340.78 820.424C1340.02 820.424 1340.02 821.522 1340.78 821.522Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1302.7 693.044C1303.46 693.044 1303.46 691.945 1302.7 691.945C1301.94 691.945 1301.93 693.044 1302.7 693.044Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1287.47 614.688C1288.23 614.688 1288.23 613.59 1287.47 613.59C1286.7 613.59 1286.7 614.688 1287.47 614.688Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1256.66 596.807C1256.4 596.571 1256.15 596.336 1255.89 596.101C1255.35 595.6 1254.52 596.377 1255.06 596.878C1255.31 597.114 1255.56 597.349 1255.82 597.584C1256.36 598.085 1257.2 597.308 1256.66 596.807Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1288.99 820.109C1289.75 820.109 1289.75 819.01 1288.99 819.01C1288.23 819.01 1288.22 820.109 1288.99 820.109Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1314.89 750.067C1316.41 750.067 1316.41 747.869 1314.89 747.869C1313.36 747.869 1313.36 750.067 1314.89 750.067Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1261.57 709.83C1263.09 709.83 1263.1 707.633 1261.57 707.633C1260.04 707.633 1260.04 709.83 1261.57 709.83Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1282.9 850.308C1284.42 850.308 1284.42 848.109 1282.9 848.109C1281.37 848.109 1281.37 850.308 1282.9 850.308Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1340.78 872.192C1342.31 872.192 1342.31 869.994 1340.78 869.994C1339.26 869.994 1339.25 872.192 1340.78 872.192Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1333.17 673.124C1334.69 673.124 1334.69 670.926 1333.17 670.926C1331.64 670.926 1331.64 673.124 1333.17 673.124Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1266.14 651.944C1267.66 651.944 1267.67 649.746 1266.14 649.746C1264.61 649.746 1264.61 651.944 1266.14 651.944Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1429.25 923.202C1430.52 923.202 1430.52 921.379 1429.25 921.379C1427.99 921.379 1427.98 923.202 1429.25 923.202Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1378.54 903.193C1379.81 903.193 1379.81 901.371 1378.54 901.371C1377.28 901.371 1377.27 903.193 1378.54 903.193Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1412.18 1120.97C1413.45 1120.97 1413.45 1119.14 1412.18 1119.14C1410.92 1119.14 1410.91 1120.97 1412.18 1120.97Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1383.56 1155.87C1383.73 1155.87 1383.9 1155.87 1384.06 1155.87C1384.58 1155.87 1385.07 1155.45 1385.05 1154.95C1385.02 1154.46 1384.62 1154.04 1384.06 1154.04C1383.9 1154.04 1383.73 1154.04 1383.56 1154.04C1383.05 1154.04 1382.56 1154.46 1382.58 1154.95C1382.6 1155.45 1383.01 1155.87 1383.56 1155.87Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1424.23 1160.52C1425.5 1160.52 1425.5 1158.7 1424.23 1158.7C1422.97 1158.7 1422.96 1160.52 1424.23 1160.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1435.28 1026.04C1436.54 1026.04 1436.54 1024.21 1435.28 1024.21C1434.01 1024.21 1434.01 1026.04 1435.28 1026.04Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1404.65 952.983C1405.91 952.983 1405.92 951.16 1404.65 951.16C1403.38 951.16 1403.38 952.983 1404.65 952.983Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1360.47 981.834C1361.73 981.834 1361.73 980.012 1360.47 980.012C1359.2 980.012 1359.2 981.834 1360.47 981.834Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1392.1 1070.24C1393.36 1070.24 1393.37 1068.42 1392.1 1068.42C1390.83 1068.42 1390.83 1070.24 1392.1 1070.24Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1379.86 932.978C1380.04 933.141 1380.21 933.306 1380.39 933.469C1380.93 933.971 1381.77 933.193 1381.23 932.693C1381.05 932.529 1380.87 932.365 1380.7 932.201C1380.16 931.7 1379.32 932.477 1379.86 932.978Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1409.49 1002.55C1410.25 1002.55 1410.26 1001.45 1409.49 1001.45C1408.73 1001.45 1408.73 1002.55 1409.49 1002.55Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1432.18 748.812C1432.94 748.812 1432.95 747.713 1432.18 747.713C1431.42 747.713 1431.42 748.812 1432.18 748.812Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1392.58 681.044C1393.34 681.044 1393.34 679.945 1392.58 679.945C1391.81 679.945 1391.81 681.044 1392.58 681.044Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1375.52 778.849C1375.01 779.084 1374.5 779.319 1374 779.555C1373.31 779.871 1373.91 780.819 1374.59 780.503C1375.1 780.269 1375.61 780.033 1376.12 779.798C1376.8 779.482 1376.2 778.533 1375.52 778.849Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1359.82 722.693C1360.59 722.693 1360.59 721.594 1359.82 721.594C1359.06 721.594 1359.06 722.693 1359.82 722.693Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1379.63 858.073C1381.15 858.073 1381.16 855.875 1379.63 855.875C1378.1 855.875 1378.1 858.073 1379.63 858.073Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1351.45 935.725C1352.97 935.725 1352.97 933.527 1351.45 933.527C1349.92 933.527 1349.92 935.725 1351.45 935.725Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1431.42 882.073C1432.95 882.073 1432.95 879.875 1431.42 879.875C1429.89 879.875 1429.89 882.073 1431.42 882.073Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1438.28 795.951C1439.8 795.951 1439.8 793.754 1438.28 793.754C1436.75 793.754 1436.75 795.951 1438.28 795.951Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1388.77 735.244C1390.29 735.244 1390.3 733.047 1388.77 733.047C1387.24 733.047 1387.24 735.244 1388.77 735.244Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1413.9 843.248C1415.43 843.248 1415.43 841.051 1413.9 841.051C1412.38 841.051 1412.37 843.248 1413.9 843.248Z",
    fill: "#FFFFFE"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1413.6 958.874C1414.87 958.874 1414.87 957.051 1413.6 957.051C1412.34 957.051 1412.33 958.874 1413.6 958.874Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1388.5 1004.94C1389.76 1004.94 1389.76 1003.12 1388.5 1003.12C1387.23 1003.12 1387.23 1004.94 1388.5 1004.94Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1387.57 922.346C1388.34 922.346 1388.34 921.248 1387.57 921.248C1386.81 921.248 1386.81 922.346 1387.57 922.346Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1389.86 816.46C1390.62 816.46 1390.62 815.361 1389.86 815.361C1389.1 815.361 1389.09 816.46 1389.86 816.46Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1429.47 652.686C1430.23 652.686 1430.23 651.588 1429.47 651.588C1428.7 651.588 1428.7 652.686 1429.47 652.686Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1398.66 634.805C1398.4 634.569 1398.15 634.334 1397.89 634.1C1397.35 633.598 1396.52 634.375 1397.06 634.876C1397.31 635.112 1397.56 635.347 1397.82 635.582C1398.36 636.083 1399.2 635.306 1398.66 634.805Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1430.99 858.107C1431.75 858.107 1431.75 857.008 1430.99 857.008C1430.23 857.008 1430.22 858.107 1430.99 858.107Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1403.57 747.828C1405.09 747.828 1405.1 745.631 1403.57 745.631C1402.04 745.631 1402.04 747.828 1403.57 747.828Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1424.9 888.308C1426.42 888.308 1426.42 886.109 1424.9 886.109C1423.37 886.109 1423.37 888.308 1424.9 888.308Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1408.14 689.942C1409.66 689.942 1409.67 687.744 1408.14 687.744C1406.61 687.744 1406.61 689.942 1408.14 689.942Z",
    fill: "#FFFFFE"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1413.6 490.835C1414.87 490.835 1414.87 489.012 1413.6 489.012C1412.34 489.012 1412.33 490.835 1413.6 490.835Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1388.5 536.901C1389.76 536.901 1389.76 535.078 1388.5 535.078C1387.23 535.078 1387.23 536.901 1388.5 536.901Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1387.57 454.307C1388.34 454.307 1388.34 453.209 1387.57 453.209C1386.81 453.209 1386.81 454.307 1387.57 454.307Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1389.86 348.419C1390.62 348.419 1390.62 347.32 1389.86 347.32C1389.1 347.32 1389.09 348.419 1389.86 348.419Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1429.47 184.645C1430.23 184.645 1430.23 183.547 1429.47 183.547C1428.7 183.547 1428.7 184.645 1429.47 184.645Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1398.66 166.766C1398.4 166.53 1398.15 166.295 1397.89 166.06C1397.35 165.559 1396.52 166.336 1397.06 166.837C1397.31 167.073 1397.56 167.308 1397.82 167.543C1398.36 168.044 1399.2 167.267 1398.66 166.766Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1430.99 390.068C1431.75 390.068 1431.75 388.969 1430.99 388.969C1430.23 388.969 1430.22 390.068 1430.99 390.068Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1403.57 279.789C1405.09 279.789 1405.1 277.592 1403.57 277.592C1402.04 277.592 1402.04 279.789 1403.57 279.789Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1424.9 420.267C1426.42 420.267 1426.42 418.068 1424.9 418.068C1423.37 418.068 1423.37 420.267 1424.9 420.267Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1408.14 221.903C1409.66 221.903 1409.67 219.705 1408.14 219.705C1406.61 219.705 1406.61 221.903 1408.14 221.903Z",
    fill: "#FFFFFE"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.597 379.618C207.867 379.618 207.867 377.795 206.597 377.795C205.337 377.795 205.327 379.618 206.597 379.618Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.499 425.684C182.759 425.684 182.759 423.861 181.499 423.861C180.229 423.861 180.229 425.684 181.499 425.684Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.863 357.748C271.133 357.748 271.133 355.926 269.863 355.926C268.603 355.926 268.593 357.748 269.863 357.748Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.57 343.09C181.34 343.09 181.34 341.992 180.57 341.992C179.81 341.992 179.81 343.09 180.57 343.09Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.863 237.202C183.623 237.202 183.623 236.104 182.863 236.104C182.103 236.104 182.093 237.202 182.863 237.202Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.781 280.262C276.541 280.262 276.551 279.164 275.781 279.164C275.021 279.164 275.021 280.262 275.781 280.262Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.699 151.786C238.459 151.786 238.459 150.688 237.699 150.688C236.939 150.688 236.929 151.786 237.699 151.786Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.468 73.4283C223.228 73.4283 223.228 72.3301 222.468 72.3301C221.698 72.3301 221.698 73.4283 222.468 73.4283Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.658 55.549C191.398 55.3136 191.148 55.0782 190.888 54.8437C190.348 54.3423 189.518 55.119 190.058 55.6204C190.308 55.8558 190.558 56.0912 190.818 56.3266C191.358 56.8271 192.198 56.0504 191.658 55.549Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.988 278.853C224.748 278.853 224.748 277.754 223.988 277.754C223.228 277.754 223.218 278.853 223.988 278.853Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.89 208.809C251.41 208.809 251.41 206.611 249.89 206.611C248.36 206.611 248.36 208.809 249.89 208.809Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.569 168.571C198.089 168.571 198.099 166.373 196.569 166.373C195.039 166.373 195.039 168.571 196.569 168.571Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.898 309.05C219.418 309.05 219.418 306.852 217.898 306.852C216.368 306.852 216.368 309.05 217.898 309.05Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.78 330.932C277.31 330.932 277.31 328.734 275.78 328.734C274.26 328.734 274.25 330.932 275.78 330.932Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.171 131.864C269.691 131.864 269.691 129.666 268.171 129.666C266.641 129.666 266.641 131.864 268.171 131.864Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.14 110.686C202.66 110.686 202.67 108.488 201.14 108.488C199.61 108.488 199.61 110.686 201.14 110.686Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.25 381.944C365.52 381.944 365.52 380.121 364.25 380.121C362.99 380.121 362.98 381.944 364.25 381.944Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.327 386.132C384.597 386.132 384.597 384.309 383.327 384.309C382.058 384.309 382.058 386.132 383.327 386.132Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.82 394.973C381.08 394.973 381.08 393.15 379.82 393.15C378.55 393.15 378.55 394.973 379.82 394.973Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.929 455C408.189 455 408.189 453.178 406.929 453.178C405.659 453.178 405.659 455 406.929 455Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.999 495.483C425.259 495.483 425.269 493.66 423.999 493.66C422.729 493.66 422.729 495.483 423.999 495.483Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.48 432.665C420.74 432.665 420.75 430.842 419.48 430.842C418.21 430.842 418.21 432.665 419.48 432.665Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.543 361.935C314.813 361.935 314.813 360.113 313.543 360.113C312.283 360.113 312.273 361.935 313.543 361.935Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.929 527.593C408.189 527.593 408.189 525.77 406.929 525.77C405.659 525.77 405.659 527.593 406.929 527.593Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.179 579.708C348.449 579.708 348.449 577.885 347.179 577.885C345.919 577.885 345.909 579.708 347.179 579.708Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.559 614.607C318.729 614.607 318.899 614.607 319.059 614.607C319.579 614.607 320.069 614.188 320.049 613.696C320.019 613.202 319.619 612.785 319.059 612.785C318.899 612.785 318.729 612.785 318.559 612.785C318.049 612.785 317.559 613.204 317.579 613.696C317.599 614.19 318.009 614.607 318.559 614.607Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.23 619.26C360.5 619.26 360.5 617.438 359.23 617.438C357.97 617.438 357.96 619.26 359.23 619.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.937 576.916C412.207 576.916 412.207 575.094 410.937 575.094C409.677 575.094 409.677 576.916 410.937 576.916Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.8 564.818C378.07 564.818 378.07 562.996 376.8 562.996C375.54 562.996 375.54 564.818 376.8 564.818Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.808 582.502C380.078 582.502 380.078 580.68 378.808 580.68C377.548 580.68 377.538 582.502 378.808 582.502Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.531 515.959C433.801 515.959 433.801 514.137 432.531 514.137C431.271 514.137 431.271 515.959 432.531 515.959Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.281 484.782C371.541 484.782 371.541 482.959 370.281 482.959C369.011 482.959 369.011 484.782 370.281 484.782Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.648 411.725C340.908 411.725 340.918 409.902 339.648 409.902C338.378 409.902 338.378 411.725 339.648 411.725Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.468 440.574C296.728 440.574 296.728 438.752 295.468 438.752C294.198 438.752 294.198 440.574 295.468 440.574Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.101 528.986C328.361 528.986 328.371 527.164 327.101 527.164C325.831 527.164 325.831 528.986 327.101 528.986Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M499.59 472.619C500.35 472.619 500.36 471.52 499.59 471.52C498.83 471.52 498.83 472.619 499.59 472.619Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.121 506.585C483.891 506.585 483.891 505.486 483.121 505.486C482.361 505.486 482.361 506.585 483.121 506.585Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.679 524.8C527.439 524.8 527.439 523.701 526.679 523.701C525.919 523.701 525.919 524.8 526.679 524.8Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.09 562.707C491.86 562.707 491.86 561.607 491.09 561.607C490.33 561.607 490.33 562.707 491.09 562.707Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.23 575.997C442.99 575.997 442.99 574.898 442.23 574.898C441.46 574.898 441.46 575.997 442.23 575.997Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473.562 535.138C474.332 535.138 474.332 534.039 473.562 534.039C472.802 534.039 472.802 535.138 473.562 535.138Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.851 442.095C470.611 442.095 470.611 440.996 469.851 440.996C469.081 440.996 469.081 442.095 469.851 442.095Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.398 380.068C514.158 380.068 514.168 378.969 513.398 378.969C512.638 378.969 512.638 380.068 513.398 380.068Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.91 367.267C437.09 367.267 437.27 367.267 437.44 367.267C438.21 367.267 438.21 366.168 437.44 366.168C437.27 366.168 437.09 366.168 436.91 366.168C436.15 366.168 436.15 367.267 436.91 367.267Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.862 391.722C315.042 391.885 315.212 392.05 315.392 392.214C315.932 392.715 316.772 391.937 316.232 391.437C316.052 391.273 315.872 391.109 315.702 390.945C315.162 390.444 314.322 391.221 314.862 391.722Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.492 461.295C345.252 461.295 345.262 460.195 344.492 460.195C343.732 460.195 343.732 461.295 344.492 461.295Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.882 588.305C479.642 588.305 479.642 587.207 478.882 587.207C478.112 587.207 478.112 588.305 478.882 588.305Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.429 599.628C523.189 599.628 523.199 598.529 522.429 598.529C521.669 598.529 521.669 599.628 522.429 599.628Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.507 611.936C422.267 611.936 422.267 610.836 421.507 610.836C420.748 610.836 420.748 611.936 421.507 611.936Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.859 605.043C385.619 605.043 385.619 603.943 384.859 603.943C384.099 603.943 384.099 605.043 384.859 605.043Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.882 607.505C479.642 607.505 479.642 606.406 478.882 606.406C478.112 606.406 478.112 607.505 478.882 607.505Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.929 316.972C400.699 316.972 400.699 315.873 399.929 315.873C399.169 315.873 399.169 316.972 399.929 316.972Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.468 310.619C501.238 310.619 501.238 309.52 500.468 309.52C499.708 309.52 499.708 310.619 500.468 310.619Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.179 207.554C367.939 207.554 367.949 206.455 367.179 206.455C366.419 206.455 366.419 207.554 367.179 207.554Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.922 223.791C432.692 223.791 432.692 222.691 431.922 222.691C431.162 222.691 431.162 223.791 431.922 223.791Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.519 223.791C504.279 223.791 504.279 222.691 503.519 222.691C502.759 222.691 502.759 223.791 503.519 223.791Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.577 139.787C328.337 139.787 328.337 138.688 327.577 138.688C326.808 138.688 326.808 139.787 327.577 139.787Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.521 237.591C310.011 237.826 309.501 238.062 309.001 238.297C308.311 238.613 308.911 239.561 309.591 239.245C310.101 239.011 310.611 238.775 311.121 238.54C311.801 238.224 311.201 237.275 310.521 237.591Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.82 181.435C295.59 181.435 295.59 180.336 294.82 180.336C294.06 180.336 294.06 181.435 294.82 181.435Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.968 280.262C451.728 280.262 451.728 279.164 450.968 279.164C450.198 279.164 450.198 280.262 450.968 280.262Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.191 431.332C498.951 431.332 498.951 430.232 498.191 430.232C497.431 430.232 497.421 431.332 498.191 431.332Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.312 349.994C425.832 349.994 425.842 347.797 424.312 347.797C422.782 347.797 422.782 349.994 424.312 349.994Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.632 316.815C316.152 316.815 316.162 314.617 314.632 314.617C313.102 314.617 313.102 316.815 314.632 316.815Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.452 394.467C287.972 394.467 287.972 392.27 286.452 392.27C284.922 392.27 284.922 394.467 286.452 394.467Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.038 497.53C506.568 497.53 506.568 495.332 505.038 495.332C503.518 495.332 503.518 497.53 505.038 497.53Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.89 568.829C529.42 568.829 529.42 566.631 527.89 566.631C526.37 566.631 526.37 568.829 527.89 568.829Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.28 611.184C505.81 611.184 505.81 608.986 504.28 608.986C502.76 608.986 502.75 611.184 504.28 611.184Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.48 390.231C470.01 390.231 470.01 388.033 468.48 388.033C466.96 388.033 466.95 390.231 468.48 390.231Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.421 340.818C367.951 340.818 367.951 338.619 366.421 338.619C364.891 338.619 364.891 340.818 366.421 340.818Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.28 254.694C374.8 254.694 374.8 252.496 373.28 252.496C371.75 252.496 371.75 254.694 373.28 254.694Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.773 193.985C325.293 193.985 325.303 191.787 323.773 191.787C322.243 191.787 322.243 193.985 323.773 193.985Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.902 301.991C350.432 301.991 350.432 299.793 348.902 299.793C347.382 299.793 347.372 301.991 348.902 301.991Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.202 313.285C451.733 313.285 451.733 311.088 450.202 311.088C448.683 311.088 448.683 313.285 450.202 313.285Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M510.711 247.243C510.711 247.949 510.711 248.655 510.711 249.361C510.711 250.774 513.081 250.777 513.081 249.361C513.081 248.655 513.081 247.949 513.081 247.243C513.081 245.829 510.711 245.827 510.711 247.243Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.152 178.616C398.402 179.087 398.662 179.558 398.912 180.028C399.592 181.293 401.642 180.182 400.962 178.919C400.702 178.449 400.452 177.978 400.202 177.507C399.512 176.242 397.472 177.354 398.152 178.616Z",
    fill: "#FFFFFE"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.597 577.956C106.867 577.956 106.867 576.133 105.597 576.133C104.337 576.133 104.327 577.956 105.597 577.956Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4994 624.022C81.7594 624.022 81.7594 622.199 80.4994 622.199C79.2294 622.199 79.2294 624.022 80.4994 624.022Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.863 556.084C170.133 556.084 170.133 554.262 168.863 554.262C167.603 554.262 167.593 556.084 168.863 556.084Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.57 541.43C80.34 541.43 80.34 540.332 79.57 540.332C78.81 540.332 78.81 541.43 79.57 541.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8628 435.54C82.6228 435.54 82.6228 434.441 81.8628 434.441C81.1028 434.441 81.0928 435.54 81.8628 435.54Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.781 478.602C175.541 478.602 175.551 477.504 174.781 477.504C174.021 477.504 174.021 478.602 174.781 478.602Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.699 350.124C137.459 350.124 137.459 349.025 136.699 349.025C135.939 349.025 135.929 350.124 136.699 350.124Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.468 271.766C122.228 271.766 122.228 270.668 121.468 270.668C120.698 270.668 120.698 271.766 121.468 271.766Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6582 253.887C90.3982 253.651 90.1482 253.416 89.8882 253.182C89.3482 252.68 88.5182 253.457 89.0582 253.958C89.3082 254.194 89.5582 254.429 89.8182 254.664C90.3582 255.165 91.1982 254.388 90.6582 253.887Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.988 477.189C123.748 477.189 123.748 476.09 122.988 476.09C122.228 476.09 122.218 477.189 122.988 477.189Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.89 407.147C150.41 407.147 150.41 404.949 148.89 404.949C147.36 404.949 147.36 407.147 148.89 407.147Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5694 366.908C97.0894 366.908 97.0994 364.711 95.5694 364.711C94.0394 364.711 94.0394 366.908 95.5694 366.908Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.898 507.39C118.418 507.39 118.418 505.191 116.898 505.191C115.368 505.191 115.368 507.39 116.898 507.39Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.78 529.272C176.31 529.272 176.31 527.074 174.78 527.074C173.26 527.074 173.25 529.272 174.78 529.272Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.171 330.202C168.691 330.202 168.691 328.004 167.171 328.004C165.641 328.004 165.641 330.202 167.171 330.202Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.14 309.024C101.66 309.024 101.67 306.826 100.14 306.826C98.6097 306.826 98.6097 309.024 100.14 309.024Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.25 580.282C264.52 580.282 264.52 578.459 263.25 578.459C261.99 578.459 261.98 580.282 263.25 580.282Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.327 584.471C283.597 584.471 283.597 582.648 282.327 582.648C281.058 582.648 281.058 584.471 282.327 584.471Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.82 593.31C280.08 593.31 280.08 591.488 278.82 591.488C277.55 591.488 277.55 593.31 278.82 593.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.929 653.338C307.189 653.338 307.189 651.516 305.929 651.516C304.659 651.516 304.659 653.338 305.929 653.338Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.999 693.823C324.259 693.823 324.269 692 322.999 692C321.729 692 321.729 693.823 322.999 693.823Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.48 631.003C319.74 631.003 319.75 629.18 318.48 629.18C317.21 629.18 317.21 631.003 318.48 631.003Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.543 560.273C213.813 560.273 213.813 558.451 212.543 558.451C211.283 558.451 211.273 560.273 212.543 560.273Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.929 725.929C307.189 725.929 307.189 724.105 305.929 724.105C304.659 724.105 304.659 725.929 305.929 725.929Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.179 778.046C247.449 778.046 247.449 776.223 246.179 776.223C244.919 776.223 244.909 778.046 246.179 778.046Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.559 812.943C217.729 812.943 217.899 812.943 218.059 812.943C218.579 812.943 219.069 812.524 219.049 812.032C219.019 811.538 218.619 811.121 218.059 811.121C217.899 811.121 217.729 811.121 217.559 811.121C217.049 811.121 216.559 811.54 216.579 812.032C216.599 812.526 217.009 812.943 217.559 812.943Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.23 817.599C259.5 817.599 259.5 815.777 258.23 815.777C256.97 815.777 256.96 817.599 258.23 817.599Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.937 775.252C311.207 775.252 311.207 773.43 309.937 773.43C308.677 773.43 308.677 775.252 309.937 775.252Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.8 763.156C277.07 763.156 277.07 761.334 275.8 761.334C274.54 761.334 274.54 763.156 275.8 763.156Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.808 780.838C279.078 780.838 279.078 779.016 277.808 779.016C276.548 779.016 276.538 780.838 277.808 780.838Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.531 714.297C332.801 714.297 332.801 712.475 331.531 712.475C330.271 712.475 330.271 714.297 331.531 714.297Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.281 683.12C270.541 683.12 270.541 681.297 269.281 681.297C268.011 681.297 268.011 683.12 269.281 683.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.648 610.063C239.908 610.063 239.918 608.24 238.648 608.24C237.378 608.24 237.378 610.063 238.648 610.063Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.468 638.912C195.728 638.912 195.728 637.09 194.468 637.09C193.198 637.09 193.198 638.912 194.468 638.912Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.101 727.326C227.361 727.326 227.371 725.504 226.101 725.504C224.831 725.504 224.831 727.326 226.101 727.326Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.59 670.955C399.35 670.955 399.36 669.855 398.59 669.855C397.83 669.855 397.83 670.955 398.59 670.955Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.121 704.922C382.891 704.922 382.891 703.824 382.121 703.824C381.361 703.824 381.361 704.922 382.121 704.922Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.679 723.138C426.439 723.138 426.439 722.039 425.679 722.039C424.919 722.039 424.919 723.138 425.679 723.138Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.09 761.045C390.86 761.045 390.86 759.945 390.09 759.945C389.33 759.945 389.33 761.045 390.09 761.045Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.23 774.337C341.99 774.337 341.99 773.238 341.23 773.238C340.46 773.238 340.46 774.337 341.23 774.337Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.562 733.478C373.332 733.478 373.332 732.379 372.562 732.379C371.802 732.379 371.802 733.478 372.562 733.478Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.851 640.435C369.611 640.435 369.611 639.336 368.851 639.336C368.081 639.336 368.081 640.435 368.851 640.435Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.398 578.404C413.158 578.404 413.168 577.305 412.398 577.305C411.638 577.305 411.638 578.404 412.398 578.404Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.91 565.607C336.09 565.607 336.27 565.607 336.44 565.607C337.21 565.607 337.21 564.508 336.44 564.508C336.27 564.508 336.09 564.508 335.91 564.508C335.15 564.508 335.15 565.607 335.91 565.607Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.862 590.06C214.042 590.223 214.212 590.388 214.392 590.551C214.932 591.053 215.772 590.275 215.232 589.775C215.052 589.611 214.872 589.447 214.702 589.283C214.162 588.782 213.322 589.559 213.862 590.06Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.492 659.634C244.252 659.634 244.262 658.535 243.492 658.535C242.732 658.535 242.732 659.634 243.492 659.634Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.882 786.645C378.642 786.645 378.642 785.547 377.882 785.547C377.112 785.547 377.112 786.645 377.882 786.645Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.429 797.965C422.189 797.965 422.199 796.867 421.429 796.867C420.669 796.867 420.669 797.965 421.429 797.965Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.507 810.274C321.267 810.274 321.267 809.174 320.507 809.174C319.748 809.174 319.748 810.274 320.507 810.274Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.859 803.38C284.619 803.38 284.619 802.281 283.859 802.281C283.099 802.281 283.099 803.38 283.859 803.38Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.882 805.845C378.642 805.845 378.642 804.746 377.882 804.746C377.112 804.746 377.112 805.845 377.882 805.845Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.929 515.31C299.699 515.31 299.699 514.211 298.929 514.211C298.169 514.211 298.169 515.31 298.929 515.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.468 508.959C400.238 508.959 400.238 507.859 399.468 507.859C398.708 507.859 398.708 508.959 399.468 508.959Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.179 405.892C266.939 405.892 266.949 404.793 266.179 404.793C265.419 404.793 265.419 405.892 266.179 405.892Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.922 422.128C331.692 422.128 331.692 421.029 330.922 421.029C330.162 421.029 330.162 422.128 330.922 422.128Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.519 422.128C403.279 422.128 403.279 421.029 402.519 421.029C401.759 421.029 401.759 422.128 402.519 422.128Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.577 338.125C227.337 338.125 227.337 337.025 226.577 337.025C225.808 337.025 225.808 338.125 226.577 338.125Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.521 435.929C209.011 436.164 208.501 436.4 208.001 436.635C207.311 436.951 207.911 437.899 208.591 437.583C209.101 437.349 209.611 437.113 210.121 436.878C210.801 436.562 210.201 435.613 209.521 435.929Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.82 379.773C194.59 379.773 194.59 378.674 193.82 378.674C193.06 378.674 193.06 379.773 193.82 379.773Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.968 478.602C350.728 478.602 350.728 477.504 349.968 477.504C349.198 477.504 349.198 478.602 349.968 478.602Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.191 629.67C397.951 629.67 397.951 628.57 397.191 628.57C396.431 628.57 396.421 629.67 397.191 629.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.312 548.33C324.832 548.33 324.842 546.133 323.312 546.133C321.782 546.133 321.782 548.33 323.312 548.33Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.632 515.155C215.152 515.155 215.162 512.957 213.632 512.957C212.102 512.957 212.102 515.155 213.632 515.155Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.452 592.803C186.972 592.803 186.972 590.605 185.452 590.605C183.922 590.605 183.922 592.803 185.452 592.803Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.038 695.869C405.568 695.869 405.568 693.672 404.038 693.672C402.518 693.672 402.518 695.869 404.038 695.869Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.89 767.167C428.42 767.167 428.42 764.969 426.89 764.969C425.37 764.969 425.37 767.167 426.89 767.167Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.28 809.522C404.81 809.522 404.81 807.324 403.28 807.324C401.76 807.324 401.75 809.522 403.28 809.522Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.48 588.569C369.01 588.569 369.01 586.371 367.48 586.371C365.96 586.371 365.95 588.569 367.48 588.569Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.421 539.155C266.951 539.155 266.951 536.957 265.421 536.957C263.891 536.957 263.891 539.155 265.421 539.155Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.28 453.033C273.8 453.033 273.8 450.836 272.28 450.836C270.75 450.836 270.75 453.033 272.28 453.033Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.773 392.322C224.293 392.322 224.303 390.125 222.773 390.125C221.243 390.125 221.243 392.322 222.773 392.322Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.902 500.33C249.432 500.33 249.432 498.133 247.902 498.133C246.382 498.133 246.372 500.33 247.902 500.33Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.202 511.623C350.733 511.623 350.733 509.426 349.202 509.426C347.683 509.426 347.683 511.623 349.202 511.623Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.711 445.581C409.711 446.287 409.711 446.992 409.711 447.699C409.711 449.112 412.081 449.115 412.081 447.699C412.081 446.992 412.081 446.287 412.081 445.581C412.081 444.167 409.711 444.165 409.711 445.581Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.152 376.956C297.402 377.427 297.662 377.898 297.912 378.368C298.592 379.633 300.642 378.521 299.962 377.259C299.702 376.788 299.452 376.317 299.202 375.847C298.512 374.581 296.472 375.694 297.152 376.956Z",
    fill: "#FFFFFE"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1406.59 1288.93C1407.86 1288.93 1407.86 1287.11 1406.59 1287.11C1405.33 1287.11 1405.32 1288.93 1406.59 1288.93Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1381.49 1335C1382.75 1335 1382.75 1333.18 1381.49 1333.18C1380.22 1333.18 1380.22 1335 1381.49 1335Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1380.56 1252.41C1381.33 1252.41 1381.33 1251.31 1380.56 1251.31C1379.8 1251.31 1379.8 1252.41 1380.56 1252.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1382.86 1146.52C1383.62 1146.52 1383.62 1145.42 1382.86 1145.42C1382.1 1145.42 1382.09 1146.52 1382.86 1146.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1437.69 1061.1C1438.45 1061.1 1438.45 1060.01 1437.69 1060.01C1436.93 1060.01 1436.92 1061.1 1437.69 1061.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1422.46 982.747C1423.22 982.747 1423.22 981.648 1422.46 981.648C1421.69 981.648 1421.69 982.747 1422.46 982.747Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1391.65 964.865C1391.39 964.63 1391.14 964.395 1390.88 964.16C1390.34 963.659 1389.51 964.435 1390.05 964.937C1390.3 965.172 1390.55 965.408 1390.81 965.643C1391.35 966.143 1392.19 965.367 1391.65 964.865Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1423.98 1188.17C1424.74 1188.17 1424.74 1187.07 1423.98 1187.07C1423.22 1187.07 1423.21 1188.17 1423.98 1188.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1396.56 1077.89C1398.08 1077.89 1398.09 1075.69 1396.56 1075.69C1395.03 1075.69 1395.03 1077.89 1396.56 1077.89Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1417.89 1218.37C1419.41 1218.37 1419.41 1216.17 1417.89 1216.17C1416.36 1216.17 1416.36 1218.37 1417.89 1218.37Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1401.13 1020C1402.65 1020 1402.66 1017.8 1401.13 1017.8C1399.6 1017.8 1399.6 1020 1401.13 1020Z",
    fill: "#FFFFFE"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1045.59 1288.93C1046.86 1288.93 1046.86 1287.11 1045.59 1287.11C1044.33 1287.11 1044.32 1288.93 1045.59 1288.93Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020.49 1335C1021.75 1335 1021.75 1333.18 1020.49 1333.18C1019.22 1333.18 1019.22 1335 1020.49 1335Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1108.86 1267.06C1110.13 1267.06 1110.13 1265.24 1108.86 1265.24C1107.6 1265.24 1107.59 1267.06 1108.86 1267.06Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1019.56 1252.41C1020.33 1252.41 1020.33 1251.31 1019.56 1251.31C1018.8 1251.31 1018.8 1252.41 1019.56 1252.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1021.86 1146.52C1022.62 1146.52 1022.62 1145.42 1021.86 1145.42C1021.1 1145.42 1021.09 1146.52 1021.86 1146.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1114.77 1189.58C1115.53 1189.58 1115.54 1188.48 1114.77 1188.48C1114.01 1188.48 1114.01 1189.58 1114.77 1189.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1076.69 1061.1C1077.45 1061.1 1077.45 1060.01 1076.69 1060.01C1075.93 1060.01 1075.92 1061.1 1076.69 1061.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.46 982.747C1062.22 982.747 1062.22 981.648 1061.46 981.648C1060.69 981.648 1060.69 982.747 1061.46 982.747Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1030.65 964.865C1030.39 964.63 1030.14 964.395 1029.88 964.16C1029.34 963.659 1028.51 964.435 1029.05 964.937C1029.3 965.172 1029.55 965.408 1029.81 965.643C1030.35 966.143 1031.19 965.367 1030.65 964.865Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1062.98 1188.17C1063.74 1188.17 1063.74 1187.07 1062.98 1187.07C1062.22 1187.07 1062.21 1188.17 1062.98 1188.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1088.88 1118.13C1090.4 1118.13 1090.4 1115.93 1088.88 1115.93C1087.35 1115.93 1087.35 1118.13 1088.88 1118.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1035.56 1077.89C1037.08 1077.89 1037.09 1075.69 1035.56 1075.69C1034.03 1075.69 1034.03 1077.89 1035.56 1077.89Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1056.89 1218.37C1058.41 1218.37 1058.41 1216.17 1056.89 1216.17C1055.36 1216.17 1055.36 1218.37 1056.89 1218.37Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1114.77 1240.25C1116.3 1240.25 1116.3 1238.05 1114.77 1238.05C1113.25 1238.05 1113.24 1240.25 1114.77 1240.25Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1107.16 1041.18C1108.68 1041.18 1108.68 1038.98 1107.16 1038.98C1105.63 1038.98 1105.63 1041.18 1107.16 1041.18Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1040.13 1020C1041.65 1020 1041.66 1017.8 1040.13 1017.8C1038.6 1017.8 1038.6 1020 1040.13 1020Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1203.24 1291.26C1204.51 1291.26 1204.51 1289.44 1203.24 1289.44C1201.98 1289.44 1201.97 1291.26 1203.24 1291.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1222.32 1295.45C1223.59 1295.45 1223.59 1293.63 1222.32 1293.63C1221.05 1293.63 1221.05 1295.45 1222.32 1295.45Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1218.81 1304.29C1220.07 1304.29 1220.07 1302.47 1218.81 1302.47C1217.54 1302.47 1217.54 1304.29 1218.81 1304.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245.92 1364.32C1247.18 1364.32 1247.18 1362.49 1245.92 1362.49C1244.65 1362.49 1244.65 1364.32 1245.92 1364.32Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1262.99 1404.8C1264.25 1404.8 1264.26 1402.98 1262.99 1402.98C1261.72 1402.98 1261.72 1404.8 1262.99 1404.8Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1258.47 1341.98C1259.73 1341.98 1259.74 1340.16 1258.47 1340.16C1257.2 1340.16 1257.2 1341.98 1258.47 1341.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1152.53 1271.25C1153.8 1271.25 1153.8 1269.43 1152.53 1269.43C1151.27 1269.43 1151.26 1271.25 1152.53 1271.25Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245.92 1436.91C1247.18 1436.91 1247.18 1435.09 1245.92 1435.09C1244.65 1435.09 1244.65 1436.91 1245.92 1436.91Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1186.17 1489.02C1187.44 1489.02 1187.44 1487.2 1186.17 1487.2C1184.91 1487.2 1184.9 1489.02 1186.17 1489.02Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1157.55 1523.92C1157.72 1523.92 1157.89 1523.92 1158.05 1523.92C1158.57 1523.92 1159.06 1523.5 1159.04 1523.01C1159.01 1522.52 1158.61 1522.1 1158.05 1522.1C1157.89 1522.1 1157.72 1522.1 1157.55 1522.1C1157.04 1522.1 1156.55 1522.52 1156.57 1523.01C1156.59 1523.51 1157 1523.92 1157.55 1523.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1198.22 1528.58C1199.49 1528.58 1199.49 1526.76 1198.22 1526.76C1196.96 1526.76 1196.95 1528.58 1198.22 1528.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1249.93 1486.23C1251.2 1486.23 1251.2 1484.41 1249.93 1484.41C1248.67 1484.41 1248.67 1486.23 1249.93 1486.23Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1215.79 1474.13C1217.06 1474.13 1217.06 1472.31 1215.79 1472.31C1214.53 1472.31 1214.53 1474.13 1215.79 1474.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1217.8 1491.82C1219.07 1491.82 1219.07 1489.99 1217.8 1489.99C1216.54 1489.99 1216.53 1491.82 1217.8 1491.82Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.52 1425.28C1272.79 1425.28 1272.79 1423.45 1271.52 1423.45C1270.26 1423.45 1270.26 1425.28 1271.52 1425.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1209.27 1394.1C1210.53 1394.1 1210.53 1392.27 1209.27 1392.27C1208 1392.27 1208 1394.1 1209.27 1394.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1178.64 1321.04C1179.9 1321.04 1179.91 1319.22 1178.64 1319.22C1177.37 1319.22 1177.37 1321.04 1178.64 1321.04Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1134.46 1349.89C1135.72 1349.89 1135.72 1348.07 1134.46 1348.07C1133.19 1348.07 1133.19 1349.89 1134.46 1349.89Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1166.09 1438.3C1167.35 1438.3 1167.36 1436.48 1166.09 1436.48C1164.82 1436.48 1164.82 1438.3 1166.09 1438.3Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1338.58 1381.94C1339.34 1381.94 1339.35 1380.84 1338.58 1380.84C1337.82 1380.84 1337.82 1381.94 1338.58 1381.94Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1322.11 1415.9C1322.88 1415.9 1322.88 1414.8 1322.11 1414.8C1321.35 1414.8 1321.35 1415.9 1322.11 1415.9Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1365.67 1434.12C1366.43 1434.12 1366.43 1433.02 1365.67 1433.02C1364.91 1433.02 1364.91 1434.12 1365.67 1434.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1330.08 1472.02C1330.85 1472.02 1330.85 1470.92 1330.08 1470.92C1329.32 1470.92 1329.32 1472.02 1330.08 1472.02Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1281.22 1485.32C1281.98 1485.32 1281.98 1484.22 1281.22 1484.22C1280.45 1484.22 1280.45 1485.32 1281.22 1485.32Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.55 1444.45C1313.32 1444.45 1313.32 1443.36 1312.55 1443.36C1311.79 1443.36 1311.79 1444.45 1312.55 1444.45Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1308.84 1351.41C1309.6 1351.41 1309.6 1350.31 1308.84 1350.31C1308.07 1350.31 1308.07 1351.41 1308.84 1351.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1352.39 1289.38C1353.15 1289.38 1353.16 1288.28 1352.39 1288.28C1351.63 1288.28 1351.63 1289.38 1352.39 1289.38Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1275.9 1276.59C1276.08 1276.59 1276.26 1276.59 1276.43 1276.59C1277.2 1276.59 1277.2 1275.49 1276.43 1275.49C1276.26 1275.49 1276.08 1275.49 1275.9 1275.49C1275.14 1275.49 1275.14 1276.59 1275.9 1276.59Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1153.85 1301.04C1154.03 1301.2 1154.2 1301.37 1154.38 1301.53C1154.92 1302.03 1155.76 1301.25 1155.22 1300.75C1155.04 1300.59 1154.86 1300.43 1154.69 1300.26C1154.15 1299.76 1153.31 1300.54 1153.85 1301.04Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1183.48 1370.61C1184.24 1370.61 1184.25 1369.51 1183.48 1369.51C1182.72 1369.51 1182.72 1370.61 1183.48 1370.61Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1317.87 1497.62C1318.63 1497.62 1318.63 1496.52 1317.87 1496.52C1317.1 1496.52 1317.1 1497.62 1317.87 1497.62Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1361.42 1508.95C1362.18 1508.95 1362.19 1507.85 1361.42 1507.85C1360.66 1507.85 1360.66 1508.95 1361.42 1508.95Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1260.5 1521.25C1261.26 1521.25 1261.26 1520.15 1260.5 1520.15C1259.74 1520.15 1259.74 1521.25 1260.5 1521.25Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1223.85 1514.36C1224.61 1514.36 1224.61 1513.26 1223.85 1513.26C1223.09 1513.26 1223.09 1514.36 1223.85 1514.36Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1317.87 1516.82C1318.63 1516.82 1318.63 1515.72 1317.87 1515.72C1317.1 1515.72 1317.1 1516.82 1317.87 1516.82Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1238.92 1226.29C1239.69 1226.29 1239.69 1225.19 1238.92 1225.19C1238.16 1225.19 1238.16 1226.29 1238.92 1226.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1339.46 1219.94C1340.23 1219.94 1340.23 1218.84 1339.46 1218.84C1338.7 1218.84 1338.7 1219.94 1339.46 1219.94Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1206.17 1116.87C1206.93 1116.87 1206.94 1115.77 1206.17 1115.77C1205.41 1115.77 1205.41 1116.87 1206.17 1116.87Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1270.91 1133.11C1271.68 1133.11 1271.68 1132.01 1270.91 1132.01C1270.15 1132.01 1270.15 1133.11 1270.91 1133.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1342.51 1133.11C1343.27 1133.11 1343.27 1132.01 1342.51 1132.01C1341.75 1132.01 1341.75 1133.11 1342.51 1133.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1166.57 1049.1C1167.33 1049.1 1167.33 1048 1166.57 1048C1165.8 1048 1165.8 1049.1 1166.57 1049.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1149.51 1146.91C1149 1147.14 1148.49 1147.38 1147.99 1147.61C1147.3 1147.93 1147.9 1148.88 1148.58 1148.56C1149.09 1148.33 1149.6 1148.09 1150.11 1147.86C1150.79 1147.54 1150.19 1146.59 1149.51 1146.91Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1133.81 1090.75C1134.58 1090.75 1134.58 1089.65 1133.81 1089.65C1133.05 1089.65 1133.05 1090.75 1133.81 1090.75Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1289.96 1189.58C1290.72 1189.58 1290.72 1188.48 1289.96 1188.48C1289.19 1188.48 1289.19 1189.58 1289.96 1189.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1337.18 1340.65C1337.94 1340.65 1337.94 1339.55 1337.18 1339.55C1336.42 1339.55 1336.41 1340.65 1337.18 1340.65Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1263.3 1259.31C1264.82 1259.31 1264.83 1257.11 1263.3 1257.11C1261.77 1257.11 1261.77 1259.31 1263.3 1259.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1153.62 1226.13C1155.14 1226.13 1155.15 1223.93 1153.62 1223.93C1152.09 1223.93 1152.09 1226.13 1153.62 1226.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1125.44 1303.78C1126.96 1303.78 1126.96 1301.59 1125.44 1301.59C1123.91 1301.59 1123.91 1303.78 1125.44 1303.78Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1344.03 1406.85C1345.56 1406.85 1345.56 1404.65 1344.03 1404.65C1342.51 1404.65 1342.51 1406.85 1344.03 1406.85Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1366.88 1478.15C1368.41 1478.15 1368.41 1475.95 1366.88 1475.95C1365.36 1475.95 1365.36 1478.15 1366.88 1478.15Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1343.27 1520.5C1344.8 1520.5 1344.8 1518.3 1343.27 1518.3C1341.75 1518.3 1341.74 1520.5 1343.27 1520.5Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1307.47 1299.55C1309 1299.55 1309 1297.35 1307.47 1297.35C1305.95 1297.35 1305.94 1299.55 1307.47 1299.55Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1205.41 1250.13C1206.94 1250.13 1206.94 1247.94 1205.41 1247.94C1203.88 1247.94 1203.88 1250.13 1205.41 1250.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1212.27 1164.01C1213.79 1164.01 1213.79 1161.81 1212.27 1161.81C1210.74 1161.81 1210.74 1164.01 1212.27 1164.01Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1162.76 1103.3C1164.28 1103.3 1164.29 1101.1 1162.76 1101.1C1161.23 1101.1 1161.23 1103.3 1162.76 1103.3Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.89 1211.31C1189.42 1211.31 1189.42 1209.11 1187.89 1209.11C1186.37 1209.11 1186.36 1211.31 1187.89 1211.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1289.19 1222.6C1290.72 1222.6 1290.72 1220.4 1289.19 1220.4C1287.67 1220.4 1287.67 1222.6 1289.19 1222.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1349.7 1156.56C1349.7 1157.26 1349.7 1157.97 1349.7 1158.68C1349.7 1160.09 1352.07 1160.09 1352.07 1158.68C1352.07 1157.97 1352.07 1157.26 1352.07 1156.56C1352.07 1155.14 1349.7 1155.14 1349.7 1156.56Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1237.14 1087.93C1237.39 1088.4 1237.65 1088.87 1237.9 1089.34C1238.58 1090.61 1240.63 1089.5 1239.95 1088.24C1239.69 1087.76 1239.44 1087.29 1239.19 1086.82C1238.5 1085.56 1236.46 1086.67 1237.14 1087.93Z",
    fill: "#FFFFFE"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.597 1288.93C685.867 1288.93 685.867 1287.11 684.597 1287.11C683.337 1287.11 683.327 1288.93 684.597 1288.93Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.499 1335C660.759 1335 660.759 1333.18 659.499 1333.18C658.229 1333.18 658.229 1335 659.499 1335Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.863 1267.06C749.133 1267.06 749.133 1265.24 747.863 1265.24C746.603 1265.24 746.593 1267.06 747.863 1267.06Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M658.57 1252.41C659.34 1252.41 659.34 1251.31 658.57 1251.31C657.81 1251.31 657.81 1252.41 658.57 1252.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M660.863 1146.52C661.623 1146.52 661.623 1145.42 660.863 1145.42C660.103 1145.42 660.093 1146.52 660.863 1146.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M753.781 1189.58C754.541 1189.58 754.551 1188.48 753.781 1188.48C753.021 1188.48 753.021 1189.58 753.781 1189.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M715.699 1061.1C716.459 1061.1 716.459 1060.01 715.699 1060.01C714.939 1060.01 714.929 1061.1 715.699 1061.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.468 982.747C701.228 982.747 701.228 981.648 700.468 981.648C699.698 981.648 699.698 982.747 700.468 982.747Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M669.658 964.865C669.398 964.63 669.148 964.395 668.888 964.16C668.348 963.659 667.518 964.435 668.058 964.937C668.308 965.172 668.558 965.408 668.818 965.643C669.358 966.143 670.198 965.367 669.658 964.865Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M701.988 1188.17C702.748 1188.17 702.748 1187.07 701.988 1187.07C701.228 1187.07 701.218 1188.17 701.988 1188.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M727.89 1118.13C729.41 1118.13 729.41 1115.93 727.89 1115.93C726.36 1115.93 726.36 1118.13 727.89 1118.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.569 1077.89C676.089 1077.89 676.099 1075.69 674.569 1075.69C673.039 1075.69 673.039 1077.89 674.569 1077.89Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M695.898 1218.37C697.418 1218.37 697.418 1216.17 695.898 1216.17C694.368 1216.17 694.368 1218.37 695.898 1218.37Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M753.78 1240.25C755.31 1240.25 755.31 1238.05 753.78 1238.05C752.26 1238.05 752.25 1240.25 753.78 1240.25Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.171 1041.18C747.691 1041.18 747.691 1038.98 746.171 1038.98C744.641 1038.98 744.641 1041.18 746.171 1041.18Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M679.14 1020C680.66 1020 680.67 1017.8 679.14 1017.8C677.61 1017.8 677.61 1020 679.14 1020Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M842.25 1291.26C843.52 1291.26 843.52 1289.44 842.25 1289.44C840.99 1289.44 840.98 1291.26 842.25 1291.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M861.327 1295.45C862.597 1295.45 862.597 1293.63 861.327 1293.63C860.058 1293.63 860.058 1295.45 861.327 1295.45Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M857.82 1304.29C859.08 1304.29 859.08 1302.47 857.82 1302.47C856.55 1302.47 856.55 1304.29 857.82 1304.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.929 1364.32C886.189 1364.32 886.189 1362.49 884.929 1362.49C883.659 1362.49 883.659 1364.32 884.929 1364.32Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M901.999 1404.8C903.259 1404.8 903.269 1402.98 901.999 1402.98C900.729 1402.98 900.729 1404.8 901.999 1404.8Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M897.48 1341.98C898.74 1341.98 898.75 1340.16 897.48 1340.16C896.21 1340.16 896.21 1341.98 897.48 1341.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M791.543 1271.25C792.813 1271.25 792.813 1269.43 791.543 1269.43C790.283 1269.43 790.273 1271.25 791.543 1271.25Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.929 1436.91C886.189 1436.91 886.189 1435.09 884.929 1435.09C883.659 1435.09 883.659 1436.91 884.929 1436.91Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M825.179 1489.02C826.449 1489.02 826.449 1487.2 825.179 1487.2C823.919 1487.2 823.909 1489.02 825.179 1489.02Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M796.559 1523.92C796.729 1523.92 796.899 1523.92 797.059 1523.92C797.579 1523.92 798.069 1523.5 798.049 1523.01C798.019 1522.52 797.619 1522.1 797.059 1522.1C796.899 1522.1 796.729 1522.1 796.559 1522.1C796.049 1522.1 795.559 1522.52 795.579 1523.01C795.599 1523.51 796.009 1523.92 796.559 1523.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M837.23 1528.58C838.5 1528.58 838.5 1526.76 837.23 1526.76C835.97 1526.76 835.96 1528.58 837.23 1528.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M888.937 1486.23C890.207 1486.23 890.207 1484.41 888.937 1484.41C887.677 1484.41 887.677 1486.23 888.937 1486.23Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M854.8 1474.13C856.07 1474.13 856.07 1472.31 854.8 1472.31C853.54 1472.31 853.54 1474.13 854.8 1474.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M856.808 1491.82C858.078 1491.82 858.078 1489.99 856.808 1489.99C855.548 1489.99 855.538 1491.82 856.808 1491.82Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M910.531 1425.28C911.801 1425.28 911.801 1423.45 910.531 1423.45C909.271 1423.45 909.271 1425.28 910.531 1425.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M848.281 1394.1C849.541 1394.1 849.541 1392.27 848.281 1392.27C847.011 1392.27 847.011 1394.1 848.281 1394.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M817.648 1321.04C818.908 1321.04 818.918 1319.22 817.648 1319.22C816.378 1319.22 816.378 1321.04 817.648 1321.04Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M773.468 1349.89C774.728 1349.89 774.728 1348.07 773.468 1348.07C772.198 1348.07 772.198 1349.89 773.468 1349.89Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M805.101 1438.3C806.361 1438.3 806.371 1436.48 805.101 1436.48C803.831 1436.48 803.831 1438.3 805.101 1438.3Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M977.59 1381.94C978.35 1381.94 978.36 1380.84 977.59 1380.84C976.83 1380.84 976.83 1381.94 977.59 1381.94Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M961.121 1415.9C961.891 1415.9 961.891 1414.8 961.121 1414.8C960.361 1414.8 960.361 1415.9 961.121 1415.9Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1004.68 1434.12C1005.44 1434.12 1005.44 1433.02 1004.68 1433.02C1003.92 1433.02 1003.92 1434.12 1004.68 1434.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M969.09 1472.02C969.86 1472.02 969.86 1470.92 969.09 1470.92C968.33 1470.92 968.33 1472.02 969.09 1472.02Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M920.23 1485.32C920.99 1485.32 920.99 1484.22 920.23 1484.22C919.46 1484.22 919.46 1485.32 920.23 1485.32Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M951.562 1444.45C952.332 1444.45 952.332 1443.36 951.562 1443.36C950.802 1443.36 950.802 1444.45 951.562 1444.45Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M947.851 1351.41C948.611 1351.41 948.611 1350.31 947.851 1350.31C947.081 1350.31 947.081 1351.41 947.851 1351.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M991.398 1289.38C992.158 1289.38 992.168 1288.28 991.398 1288.28C990.638 1288.28 990.638 1289.38 991.398 1289.38Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.91 1276.59C915.09 1276.59 915.27 1276.59 915.44 1276.59C916.21 1276.59 916.21 1275.49 915.44 1275.49C915.27 1275.49 915.09 1275.49 914.91 1275.49C914.15 1275.49 914.15 1276.59 914.91 1276.59Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M792.862 1301.04C793.042 1301.2 793.212 1301.37 793.392 1301.53C793.932 1302.03 794.772 1301.25 794.232 1300.75C794.052 1300.59 793.872 1300.43 793.702 1300.26C793.162 1299.76 792.322 1300.54 792.862 1301.04Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.492 1370.61C823.252 1370.61 823.262 1369.51 822.492 1369.51C821.732 1369.51 821.732 1370.61 822.492 1370.61Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M956.882 1497.62C957.642 1497.62 957.642 1496.52 956.882 1496.52C956.112 1496.52 956.112 1497.62 956.882 1497.62Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1000.43 1508.95C1001.19 1508.95 1001.2 1507.85 1000.43 1507.85C999.669 1507.85 999.669 1508.95 1000.43 1508.95Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899.507 1521.25C900.267 1521.25 900.267 1520.15 899.507 1520.15C898.748 1520.15 898.748 1521.25 899.507 1521.25Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M862.859 1514.36C863.619 1514.36 863.619 1513.26 862.859 1513.26C862.099 1513.26 862.099 1514.36 862.859 1514.36Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M956.882 1516.82C957.642 1516.82 957.642 1515.72 956.882 1515.72C956.112 1515.72 956.112 1516.82 956.882 1516.82Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M877.929 1226.29C878.699 1226.29 878.699 1225.19 877.929 1225.19C877.169 1225.19 877.169 1226.29 877.929 1226.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.468 1219.94C979.238 1219.94 979.238 1218.84 978.468 1218.84C977.708 1218.84 977.708 1219.94 978.468 1219.94Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M845.179 1116.87C845.939 1116.87 845.949 1115.77 845.179 1115.77C844.419 1115.77 844.419 1116.87 845.179 1116.87Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M909.922 1133.11C910.692 1133.11 910.692 1132.01 909.922 1132.01C909.162 1132.01 909.162 1133.11 909.922 1133.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M981.519 1133.11C982.279 1133.11 982.279 1132.01 981.519 1132.01C980.759 1132.01 980.759 1133.11 981.519 1133.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M805.577 1049.1C806.337 1049.1 806.337 1048 805.577 1048C804.808 1048 804.808 1049.1 805.577 1049.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M788.521 1146.91C788.011 1147.14 787.501 1147.38 787.001 1147.61C786.311 1147.93 786.911 1148.88 787.591 1148.56C788.101 1148.33 788.611 1148.09 789.121 1147.86C789.801 1147.54 789.201 1146.59 788.521 1146.91Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M772.82 1090.75C773.59 1090.75 773.59 1089.65 772.82 1089.65C772.06 1089.65 772.06 1090.75 772.82 1090.75Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.968 1189.58C929.728 1189.58 929.728 1188.48 928.968 1188.48C928.198 1188.48 928.198 1189.58 928.968 1189.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.191 1340.65C976.951 1340.65 976.951 1339.55 976.191 1339.55C975.431 1339.55 975.421 1340.65 976.191 1340.65Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M902.312 1259.31C903.832 1259.31 903.842 1257.11 902.312 1257.11C900.782 1257.11 900.782 1259.31 902.312 1259.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M792.632 1226.13C794.152 1226.13 794.162 1223.93 792.632 1223.93C791.102 1223.93 791.102 1226.13 792.632 1226.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M764.452 1303.78C765.972 1303.78 765.972 1301.59 764.452 1301.59C762.922 1301.59 762.922 1303.78 764.452 1303.78Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M983.038 1406.85C984.568 1406.85 984.568 1404.65 983.038 1404.65C981.518 1404.65 981.518 1406.85 983.038 1406.85Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1005.89 1478.15C1007.42 1478.15 1007.42 1475.95 1005.89 1475.95C1004.37 1475.95 1004.37 1478.15 1005.89 1478.15Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M982.28 1520.5C983.81 1520.5 983.81 1518.3 982.28 1518.3C980.76 1518.3 980.75 1520.5 982.28 1520.5Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M946.48 1299.55C948.01 1299.55 948.01 1297.35 946.48 1297.35C944.96 1297.35 944.95 1299.55 946.48 1299.55Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.421 1250.13C845.951 1250.13 845.951 1247.94 844.421 1247.94C842.891 1247.94 842.891 1250.13 844.421 1250.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.28 1164.01C852.8 1164.01 852.8 1161.81 851.28 1161.81C849.75 1161.81 849.75 1164.01 851.28 1164.01Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M801.773 1103.3C803.293 1103.3 803.303 1101.1 801.773 1101.1C800.243 1101.1 800.243 1103.3 801.773 1103.3Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.902 1211.31C828.432 1211.31 828.432 1209.11 826.902 1209.11C825.382 1209.11 825.372 1211.31 826.902 1211.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.202 1222.6C929.733 1222.6 929.733 1220.4 928.202 1220.4C926.683 1220.4 926.683 1222.6 928.202 1222.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M988.711 1156.56C988.711 1157.26 988.711 1157.97 988.711 1158.68C988.711 1160.09 991.081 1160.09 991.081 1158.68C991.081 1157.97 991.081 1157.26 991.081 1156.56C991.081 1155.14 988.711 1155.14 988.711 1156.56Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M876.152 1087.93C876.402 1088.4 876.662 1088.87 876.912 1089.34C877.592 1090.61 879.642 1089.5 878.962 1088.24C878.702 1087.76 878.452 1087.29 878.202 1086.82C877.512 1085.56 875.472 1086.67 876.152 1087.93Z",
    fill: "#FFFFFE"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.597 1288.93C324.867 1288.93 324.867 1287.11 323.597 1287.11C322.337 1287.11 322.327 1288.93 323.597 1288.93Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.499 1335C299.759 1335 299.759 1333.18 298.499 1333.18C297.229 1333.18 297.229 1335 298.499 1335Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.863 1267.06C388.133 1267.06 388.133 1265.24 386.863 1265.24C385.603 1265.24 385.593 1267.06 386.863 1267.06Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.57 1252.41C298.34 1252.41 298.34 1251.31 297.57 1251.31C296.81 1251.31 296.81 1252.41 297.57 1252.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.863 1146.52C300.623 1146.52 300.623 1145.42 299.863 1145.42C299.103 1145.42 299.093 1146.52 299.863 1146.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.781 1189.58C393.541 1189.58 393.551 1188.48 392.781 1188.48C392.021 1188.48 392.021 1189.58 392.781 1189.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.699 1061.1C355.459 1061.1 355.459 1060.01 354.699 1060.01C353.939 1060.01 353.929 1061.1 354.699 1061.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.468 982.747C340.228 982.747 340.228 981.648 339.468 981.648C338.698 981.648 338.698 982.747 339.468 982.747Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.658 964.865C308.398 964.63 308.148 964.395 307.888 964.16C307.348 963.659 306.518 964.435 307.058 964.937C307.308 965.172 307.558 965.408 307.818 965.643C308.358 966.143 309.198 965.367 308.658 964.865Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.988 1188.17C341.748 1188.17 341.748 1187.07 340.988 1187.07C340.228 1187.07 340.218 1188.17 340.988 1188.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.89 1118.13C368.41 1118.13 368.41 1115.93 366.89 1115.93C365.36 1115.93 365.36 1118.13 366.89 1118.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.569 1077.89C315.089 1077.89 315.099 1075.69 313.569 1075.69C312.039 1075.69 312.039 1077.89 313.569 1077.89Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.898 1218.37C336.418 1218.37 336.418 1216.17 334.898 1216.17C333.368 1216.17 333.368 1218.37 334.898 1218.37Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.78 1240.25C394.31 1240.25 394.31 1238.05 392.78 1238.05C391.26 1238.05 391.25 1240.25 392.78 1240.25Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.171 1041.18C386.691 1041.18 386.691 1038.98 385.171 1038.98C383.641 1038.98 383.641 1041.18 385.171 1041.18Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.14 1020C319.66 1020 319.67 1017.8 318.14 1017.8C316.61 1017.8 316.61 1020 318.14 1020Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M481.25 1291.26C482.52 1291.26 482.52 1289.44 481.25 1289.44C479.99 1289.44 479.98 1291.26 481.25 1291.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.327 1295.45C501.597 1295.45 501.597 1293.63 500.327 1293.63C499.058 1293.63 499.058 1295.45 500.327 1295.45Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.82 1304.29C498.08 1304.29 498.08 1302.47 496.82 1302.47C495.55 1302.47 495.55 1304.29 496.82 1304.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.929 1364.32C525.189 1364.32 525.189 1362.49 523.929 1362.49C522.659 1362.49 522.659 1364.32 523.929 1364.32Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.999 1404.8C542.259 1404.8 542.269 1402.98 540.999 1402.98C539.729 1402.98 539.729 1404.8 540.999 1404.8Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.48 1341.98C537.74 1341.98 537.75 1340.16 536.48 1340.16C535.21 1340.16 535.21 1341.98 536.48 1341.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.543 1271.25C431.813 1271.25 431.813 1269.43 430.543 1269.43C429.283 1269.43 429.273 1271.25 430.543 1271.25Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.929 1436.91C525.189 1436.91 525.189 1435.09 523.929 1435.09C522.659 1435.09 522.659 1436.91 523.929 1436.91Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.179 1489.02C465.449 1489.02 465.449 1487.2 464.179 1487.2C462.919 1487.2 462.909 1489.02 464.179 1489.02Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.559 1523.92C435.729 1523.92 435.899 1523.92 436.059 1523.92C436.579 1523.92 437.069 1523.5 437.049 1523.01C437.019 1522.52 436.619 1522.1 436.059 1522.1C435.899 1522.1 435.729 1522.1 435.559 1522.1C435.049 1522.1 434.559 1522.52 434.579 1523.01C434.599 1523.51 435.009 1523.92 435.559 1523.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.23 1528.58C477.5 1528.58 477.5 1526.76 476.23 1526.76C474.97 1526.76 474.96 1528.58 476.23 1528.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.937 1486.23C529.207 1486.23 529.207 1484.41 527.937 1484.41C526.677 1484.41 526.677 1486.23 527.937 1486.23Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.8 1474.13C495.07 1474.13 495.07 1472.31 493.8 1472.31C492.54 1472.31 492.54 1474.13 493.8 1474.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.808 1491.82C497.078 1491.82 497.078 1489.99 495.808 1489.99C494.548 1489.99 494.538 1491.82 495.808 1491.82Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M549.531 1425.28C550.801 1425.28 550.801 1423.45 549.531 1423.45C548.271 1423.45 548.271 1425.28 549.531 1425.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.281 1394.1C488.541 1394.1 488.541 1392.27 487.281 1392.27C486.011 1392.27 486.011 1394.1 487.281 1394.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.648 1321.04C457.908 1321.04 457.918 1319.22 456.648 1319.22C455.378 1319.22 455.378 1321.04 456.648 1321.04Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.468 1349.89C413.728 1349.89 413.728 1348.07 412.468 1348.07C411.198 1348.07 411.198 1349.89 412.468 1349.89Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.101 1438.3C445.361 1438.3 445.371 1436.48 444.101 1436.48C442.831 1436.48 442.831 1438.3 444.101 1438.3Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.59 1381.94C617.35 1381.94 617.36 1380.84 616.59 1380.84C615.83 1380.84 615.83 1381.94 616.59 1381.94Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.121 1415.9C600.891 1415.9 600.891 1414.8 600.121 1414.8C599.361 1414.8 599.361 1415.9 600.121 1415.9Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M643.679 1434.12C644.439 1434.12 644.439 1433.02 643.679 1433.02C642.919 1433.02 642.919 1434.12 643.679 1434.12Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.09 1472.02C608.86 1472.02 608.86 1470.92 608.09 1470.92C607.33 1470.92 607.33 1472.02 608.09 1472.02Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.23 1485.32C559.99 1485.32 559.99 1484.22 559.23 1484.22C558.46 1484.22 558.46 1485.32 559.23 1485.32Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.562 1444.45C591.332 1444.45 591.332 1443.36 590.562 1443.36C589.802 1443.36 589.802 1444.45 590.562 1444.45Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.851 1351.41C587.611 1351.41 587.611 1350.31 586.851 1350.31C586.081 1350.31 586.081 1351.41 586.851 1351.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M630.398 1289.38C631.158 1289.38 631.168 1288.28 630.398 1288.28C629.638 1288.28 629.638 1289.38 630.398 1289.38Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.91 1276.59C554.09 1276.59 554.27 1276.59 554.44 1276.59C555.21 1276.59 555.21 1275.49 554.44 1275.49C554.27 1275.49 554.09 1275.49 553.91 1275.49C553.15 1275.49 553.15 1276.59 553.91 1276.59Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.862 1301.04C432.042 1301.2 432.212 1301.37 432.392 1301.53C432.932 1302.03 433.772 1301.25 433.232 1300.75C433.052 1300.59 432.872 1300.43 432.702 1300.26C432.162 1299.76 431.322 1300.54 431.862 1301.04Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.492 1370.61C462.252 1370.61 462.262 1369.51 461.492 1369.51C460.732 1369.51 460.732 1370.61 461.492 1370.61Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.882 1497.62C596.642 1497.62 596.642 1496.52 595.882 1496.52C595.112 1496.52 595.112 1497.62 595.882 1497.62Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639.429 1508.95C640.189 1508.95 640.199 1507.85 639.429 1507.85C638.669 1507.85 638.669 1508.95 639.429 1508.95Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.507 1521.25C539.267 1521.25 539.267 1520.15 538.507 1520.15C537.748 1520.15 537.748 1521.25 538.507 1521.25Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.859 1514.36C502.619 1514.36 502.619 1513.26 501.859 1513.26C501.099 1513.26 501.099 1514.36 501.859 1514.36Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.882 1516.82C596.642 1516.82 596.642 1515.72 595.882 1515.72C595.112 1515.72 595.112 1516.82 595.882 1516.82Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.929 1226.29C517.699 1226.29 517.699 1225.19 516.929 1225.19C516.169 1225.19 516.169 1226.29 516.929 1226.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.468 1219.94C618.238 1219.94 618.238 1218.84 617.468 1218.84C616.708 1218.84 616.708 1219.94 617.468 1219.94Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.179 1116.87C484.939 1116.87 484.949 1115.77 484.179 1115.77C483.419 1115.77 483.419 1116.87 484.179 1116.87Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.922 1133.11C549.692 1133.11 549.692 1132.01 548.922 1132.01C548.162 1132.01 548.162 1133.11 548.922 1133.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.519 1133.11C621.279 1133.11 621.279 1132.01 620.519 1132.01C619.759 1132.01 619.759 1133.11 620.519 1133.11Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.577 1049.1C445.337 1049.1 445.337 1048 444.577 1048C443.808 1048 443.808 1049.1 444.577 1049.1Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.521 1146.91C427.011 1147.14 426.501 1147.38 426.001 1147.61C425.311 1147.93 425.911 1148.88 426.591 1148.56C427.101 1148.33 427.611 1148.09 428.121 1147.86C428.801 1147.54 428.201 1146.59 427.521 1146.91Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.82 1090.75C412.59 1090.75 412.59 1089.65 411.82 1089.65C411.06 1089.65 411.06 1090.75 411.82 1090.75Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.968 1189.58C568.728 1189.58 568.728 1188.48 567.968 1188.48C567.198 1188.48 567.198 1189.58 567.968 1189.58Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M615.191 1340.65C615.951 1340.65 615.951 1339.55 615.191 1339.55C614.431 1339.55 614.421 1340.65 615.191 1340.65Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.312 1259.31C542.832 1259.31 542.842 1257.11 541.312 1257.11C539.782 1257.11 539.782 1259.31 541.312 1259.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.632 1226.13C433.152 1226.13 433.162 1223.93 431.632 1223.93C430.102 1223.93 430.102 1226.13 431.632 1226.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.452 1303.78C404.972 1303.78 404.972 1301.59 403.452 1301.59C401.922 1301.59 401.922 1303.78 403.452 1303.78Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.038 1406.85C623.568 1406.85 623.568 1404.65 622.038 1404.65C620.518 1404.65 620.518 1406.85 622.038 1406.85Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.89 1478.15C646.42 1478.15 646.42 1475.95 644.89 1475.95C643.37 1475.95 643.37 1478.15 644.89 1478.15Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621.28 1520.5C622.81 1520.5 622.81 1518.3 621.28 1518.3C619.76 1518.3 619.75 1520.5 621.28 1520.5Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.48 1299.55C587.01 1299.55 587.01 1297.35 585.48 1297.35C583.96 1297.35 583.95 1299.55 585.48 1299.55Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.421 1250.13C484.951 1250.13 484.951 1247.94 483.421 1247.94C481.891 1247.94 481.891 1250.13 483.421 1250.13Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.28 1164.01C491.8 1164.01 491.8 1161.81 490.28 1161.81C488.75 1161.81 488.75 1164.01 490.28 1164.01Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.773 1103.3C442.293 1103.3 442.303 1101.1 440.773 1101.1C439.243 1101.1 439.243 1103.3 440.773 1103.3Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.902 1211.31C467.432 1211.31 467.432 1209.11 465.902 1209.11C464.382 1209.11 464.372 1211.31 465.902 1211.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.202 1222.6C568.733 1222.6 568.733 1220.4 567.202 1220.4C565.683 1220.4 565.683 1222.6 567.202 1222.6Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.711 1156.56C627.711 1157.26 627.711 1157.97 627.711 1158.68C627.711 1160.09 630.081 1160.09 630.081 1158.68C630.081 1157.97 630.081 1157.26 630.081 1156.56C630.081 1155.14 627.711 1155.14 627.711 1156.56Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.152 1087.93C515.402 1088.4 515.662 1088.87 515.912 1089.34C516.592 1090.61 518.642 1089.5 517.962 1088.24C517.702 1087.76 517.452 1087.29 517.202 1086.82C516.512 1085.56 514.472 1086.67 515.152 1087.93Z",
    fill: "#FFFFFE"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1406.59 713.268C1407.86 713.268 1407.86 711.445 1406.59 711.445C1405.33 711.445 1405.32 713.268 1406.59 713.268Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1381.49 759.335C1382.75 759.335 1382.75 757.512 1381.49 757.512C1380.22 757.512 1380.22 759.335 1381.49 759.335Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1380.56 676.739C1381.33 676.739 1381.33 675.641 1380.56 675.641C1379.8 675.641 1379.8 676.739 1380.56 676.739Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1382.86 570.852C1383.62 570.852 1383.62 569.754 1382.86 569.754C1382.1 569.754 1382.09 570.852 1382.86 570.852Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1437.69 485.438C1438.45 485.438 1438.45 484.34 1437.69 484.34C1436.93 484.34 1436.92 485.438 1437.69 485.438Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1422.46 407.081C1423.22 407.081 1423.22 405.982 1422.46 405.982C1421.69 405.982 1421.69 407.081 1422.46 407.081Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1391.65 389.199C1391.39 388.964 1391.14 388.729 1390.88 388.494C1390.34 387.993 1389.51 388.769 1390.05 389.271C1390.3 389.506 1390.55 389.742 1390.81 389.977C1391.35 390.477 1392.19 389.701 1391.65 389.199Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1423.98 612.502C1424.74 612.502 1424.74 611.402 1423.98 611.402C1423.22 611.402 1423.21 612.502 1423.98 612.502Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1396.56 502.221C1398.08 502.221 1398.09 500.023 1396.56 500.023C1395.03 500.023 1395.03 502.221 1396.56 502.221Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1417.89 642.702C1419.41 642.702 1419.41 640.504 1417.89 640.504C1416.36 640.504 1416.36 642.702 1417.89 642.702Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1401.13 444.336C1402.65 444.336 1402.66 442.139 1401.13 442.139C1399.6 442.139 1399.6 444.336 1401.13 444.336Z",
    fill: "#FFFFFE"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1045.59 713.268C1046.86 713.268 1046.86 711.445 1045.59 711.445C1044.33 711.445 1044.32 713.268 1045.59 713.268Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1020.49 759.335C1021.75 759.335 1021.75 757.512 1020.49 757.512C1019.22 757.512 1019.22 759.335 1020.49 759.335Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1108.86 691.398C1110.13 691.398 1110.13 689.576 1108.86 689.576C1107.6 689.576 1107.59 691.398 1108.86 691.398Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1019.56 676.739C1020.33 676.739 1020.33 675.641 1019.56 675.641C1018.8 675.641 1018.8 676.739 1019.56 676.739Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1021.86 570.852C1022.62 570.852 1022.62 569.754 1021.86 569.754C1021.1 569.754 1021.09 570.852 1021.86 570.852Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1114.77 613.915C1115.53 613.915 1115.54 612.816 1114.77 612.816C1114.01 612.816 1114.01 613.915 1114.77 613.915Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1076.69 485.438C1077.45 485.438 1077.45 484.34 1076.69 484.34C1075.93 484.34 1075.92 485.438 1076.69 485.438Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1061.46 407.081C1062.22 407.081 1062.22 405.982 1061.46 405.982C1060.69 405.982 1060.69 407.081 1061.46 407.081Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1030.65 389.199C1030.39 388.964 1030.14 388.729 1029.88 388.494C1029.34 387.993 1028.51 388.769 1029.05 389.271C1029.3 389.506 1029.55 389.742 1029.81 389.977C1030.35 390.477 1031.19 389.701 1030.65 389.199Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1062.98 612.502C1063.74 612.502 1063.74 611.402 1062.98 611.402C1062.22 611.402 1062.21 612.502 1062.98 612.502Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1088.88 542.459C1090.4 542.459 1090.4 540.262 1088.88 540.262C1087.35 540.262 1087.35 542.459 1088.88 542.459Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1035.56 502.221C1037.08 502.221 1037.09 500.023 1035.56 500.023C1034.03 500.023 1034.03 502.221 1035.56 502.221Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1056.89 642.702C1058.41 642.702 1058.41 640.504 1056.89 640.504C1055.36 640.504 1055.36 642.702 1056.89 642.702Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1114.77 664.584C1116.3 664.584 1116.3 662.387 1114.77 662.387C1113.25 662.387 1113.24 664.584 1114.77 664.584Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1107.16 465.515C1108.68 465.515 1108.68 463.316 1107.16 463.316C1105.63 463.316 1105.63 465.515 1107.16 465.515Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1040.13 444.336C1041.65 444.336 1041.66 442.139 1040.13 442.139C1038.6 442.139 1038.6 444.336 1040.13 444.336Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1203.24 715.596C1204.51 715.596 1204.51 713.773 1203.24 713.773C1201.98 713.773 1201.97 715.596 1203.24 715.596Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1222.32 719.784C1223.59 719.784 1223.59 717.961 1222.32 717.961C1221.05 717.961 1221.05 719.784 1222.32 719.784Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1218.81 728.623C1220.07 728.623 1220.07 726.801 1218.81 726.801C1217.54 726.801 1217.54 728.623 1218.81 728.623Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245.92 788.65C1247.18 788.65 1247.18 786.828 1245.92 786.828C1244.65 786.828 1244.65 788.65 1245.92 788.65Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1262.99 829.136C1264.25 829.136 1264.26 827.312 1262.99 827.312C1261.72 827.312 1261.72 829.136 1262.99 829.136Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1258.47 766.315C1259.73 766.315 1259.74 764.492 1258.47 764.492C1257.2 764.492 1257.2 766.315 1258.47 766.315Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1152.53 695.588C1153.8 695.588 1153.8 693.766 1152.53 693.766C1151.27 693.766 1151.26 695.588 1152.53 695.588Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245.92 861.241C1247.18 861.241 1247.18 859.418 1245.92 859.418C1244.65 859.418 1244.65 861.241 1245.92 861.241Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1186.17 913.358C1187.44 913.358 1187.44 911.535 1186.17 911.535C1184.91 911.535 1184.9 913.358 1186.17 913.358Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1157.55 948.26C1157.72 948.26 1157.89 948.26 1158.05 948.26C1158.57 948.26 1159.06 947.841 1159.04 947.349C1159.01 946.855 1158.61 946.438 1158.05 946.438C1157.89 946.438 1157.72 946.438 1157.55 946.438C1157.04 946.438 1156.55 946.856 1156.57 947.349C1156.59 947.843 1157 948.26 1157.55 948.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1198.22 952.912C1199.49 952.912 1199.49 951.09 1198.22 951.09C1196.96 951.09 1196.95 952.912 1198.22 952.912Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1249.93 910.566C1251.2 910.566 1251.2 908.744 1249.93 908.744C1248.67 908.744 1248.67 910.566 1249.93 910.566Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1215.79 898.467C1217.06 898.467 1217.06 896.645 1215.79 896.645C1214.53 896.645 1214.53 898.467 1215.79 898.467Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1217.8 916.15C1219.07 916.15 1219.07 914.328 1217.8 914.328C1216.54 914.328 1216.53 916.15 1217.8 916.15Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1271.52 849.607C1272.79 849.607 1272.79 847.785 1271.52 847.785C1270.26 847.785 1270.26 849.607 1271.52 849.607Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1209.27 818.432C1210.53 818.432 1210.53 816.609 1209.27 816.609C1208 816.609 1208 818.432 1209.27 818.432Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1178.64 745.378C1179.9 745.378 1179.91 743.555 1178.64 743.555C1177.37 743.555 1177.37 745.378 1178.64 745.378Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1134.46 774.224C1135.72 774.224 1135.72 772.402 1134.46 772.402C1133.19 772.402 1133.19 774.224 1134.46 774.224Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1166.09 862.639C1167.35 862.639 1167.36 860.816 1166.09 860.816C1164.82 860.816 1164.82 862.639 1166.09 862.639Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1338.58 806.267C1339.34 806.267 1339.35 805.168 1338.58 805.168C1337.82 805.168 1337.82 806.267 1338.58 806.267Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1322.11 840.235C1322.88 840.235 1322.88 839.137 1322.11 839.137C1321.35 839.137 1321.35 840.235 1322.11 840.235Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1365.67 858.451C1366.43 858.451 1366.43 857.352 1365.67 857.352C1364.91 857.352 1364.91 858.451 1365.67 858.451Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1330.08 896.357C1330.85 896.357 1330.85 895.258 1330.08 895.258C1329.32 895.258 1329.32 896.357 1330.08 896.357Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1281.22 909.649C1281.98 909.649 1281.98 908.551 1281.22 908.551C1280.45 908.551 1280.45 909.649 1281.22 909.649Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.55 868.789C1313.32 868.789 1313.32 867.689 1312.55 867.689C1311.79 867.689 1311.79 868.789 1312.55 868.789Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1308.84 775.748C1309.6 775.748 1309.6 774.648 1308.84 774.648C1308.07 774.648 1308.07 775.748 1308.84 775.748Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1352.39 713.718C1353.15 713.718 1353.16 712.619 1352.39 712.619C1351.63 712.619 1351.63 713.718 1352.39 713.718Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1275.9 700.92C1276.08 700.92 1276.26 700.92 1276.43 700.92C1277.2 700.92 1277.2 699.82 1276.43 699.82C1276.26 699.82 1276.08 699.82 1275.9 699.82C1275.14 699.82 1275.14 700.92 1275.9 700.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1153.85 725.373C1154.03 725.536 1154.2 725.701 1154.38 725.864C1154.92 726.365 1155.76 725.588 1155.22 725.087C1155.04 724.923 1154.86 724.759 1154.69 724.595C1154.15 724.095 1153.31 724.871 1153.85 725.373Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1183.48 794.947C1184.24 794.947 1184.25 793.848 1183.48 793.848C1182.72 793.848 1182.72 794.947 1183.48 794.947Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1317.87 921.958C1318.63 921.958 1318.63 920.859 1317.87 920.859C1317.1 920.859 1317.1 921.958 1317.87 921.958Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1361.42 933.278C1362.18 933.278 1362.19 932.18 1361.42 932.18C1360.66 932.18 1360.66 933.278 1361.42 933.278Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1260.5 945.588C1261.26 945.588 1261.26 944.488 1260.5 944.488C1259.74 944.488 1259.74 945.588 1260.5 945.588Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1223.85 938.693C1224.61 938.693 1224.61 937.594 1223.85 937.594C1223.09 937.594 1223.09 938.693 1223.85 938.693Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1317.87 941.154C1318.63 941.154 1318.63 940.055 1317.87 940.055C1317.1 940.055 1317.1 941.154 1317.87 941.154Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1238.92 650.623C1239.69 650.623 1239.69 649.523 1238.92 649.523C1238.16 649.523 1238.16 650.623 1238.92 650.623Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1339.46 644.267C1340.23 644.267 1340.23 643.168 1339.46 643.168C1338.7 643.168 1338.7 644.267 1339.46 644.267Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1206.17 541.205C1206.93 541.205 1206.94 540.105 1206.17 540.105C1205.41 540.105 1205.41 541.205 1206.17 541.205Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1270.91 557.441C1271.68 557.441 1271.68 556.342 1270.91 556.342C1270.15 556.342 1270.15 557.441 1270.91 557.441Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1342.51 557.441C1343.27 557.441 1343.27 556.342 1342.51 556.342C1341.75 556.342 1341.75 557.441 1342.51 557.441Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1166.57 473.435C1167.33 473.435 1167.33 472.336 1166.57 472.336C1165.8 472.336 1165.8 473.435 1166.57 473.435Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1149.51 571.239C1149 571.475 1148.49 571.71 1147.99 571.946C1147.3 572.262 1147.9 573.21 1148.58 572.894C1149.09 572.659 1149.6 572.424 1150.11 572.188C1150.79 571.872 1150.19 570.923 1149.51 571.239Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1133.81 515.087C1134.58 515.087 1134.58 513.988 1133.81 513.988C1133.05 513.988 1133.05 515.087 1133.81 515.087Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1289.96 613.915C1290.72 613.915 1290.72 612.816 1289.96 612.816C1289.19 612.816 1289.19 613.915 1289.96 613.915Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1337.18 764.982C1337.94 764.982 1337.94 763.883 1337.18 763.883C1336.42 763.883 1336.41 764.982 1337.18 764.982Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1263.3 683.643C1264.82 683.643 1264.83 681.445 1263.3 681.445C1261.77 681.445 1261.77 683.643 1263.3 683.643Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1153.62 650.467C1155.14 650.467 1155.15 648.27 1153.62 648.27C1152.09 648.27 1152.09 650.467 1153.62 650.467Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1125.44 728.115C1126.96 728.115 1126.96 725.918 1125.44 725.918C1123.91 725.918 1123.91 728.115 1125.44 728.115Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1344.03 831.182C1345.56 831.182 1345.56 828.984 1344.03 828.984C1342.51 828.984 1342.51 831.182 1344.03 831.182Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1366.88 902.48C1368.41 902.48 1368.41 900.281 1366.88 900.281C1365.36 900.281 1365.36 902.48 1366.88 902.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1343.27 944.834C1344.8 944.834 1344.8 942.637 1343.27 942.637C1341.75 942.637 1341.74 944.834 1343.27 944.834Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1307.47 723.881C1309 723.881 1309 721.684 1307.47 721.684C1305.95 721.684 1305.94 723.881 1307.47 723.881Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1205.41 674.468C1206.94 674.468 1206.94 672.27 1205.41 672.27C1203.88 672.27 1203.88 674.468 1205.41 674.468Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1212.27 588.344C1213.79 588.344 1213.79 586.146 1212.27 586.146C1210.74 586.146 1210.74 588.344 1212.27 588.344Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1162.76 527.635C1164.28 527.635 1164.29 525.438 1162.76 525.438C1161.23 525.438 1161.23 527.635 1162.76 527.635Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187.89 635.641C1189.42 635.641 1189.42 633.443 1187.89 633.443C1186.37 633.443 1186.36 635.641 1187.89 635.641Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1289.19 646.936C1290.72 646.936 1290.72 644.738 1289.19 644.738C1287.67 644.738 1287.67 646.936 1289.19 646.936Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1349.7 580.893C1349.7 581.6 1349.7 582.305 1349.7 583.011C1349.7 584.425 1352.07 584.427 1352.07 583.011C1352.07 582.305 1352.07 581.6 1352.07 580.893C1352.07 579.479 1349.7 579.477 1349.7 580.893Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1237.14 512.267C1237.39 512.737 1237.65 513.208 1237.9 513.678C1238.58 514.943 1240.63 513.832 1239.95 512.57C1239.69 512.099 1239.44 511.628 1239.19 511.157C1238.5 509.892 1236.46 511.004 1237.14 512.267Z",
    fill: "#FFFFFE"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.597 713.268C685.867 713.268 685.867 711.445 684.597 711.445C683.337 711.445 683.327 713.268 684.597 713.268Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.499 759.335C660.759 759.335 660.759 757.512 659.499 757.512C658.229 757.512 658.229 759.335 659.499 759.335Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.863 691.398C749.133 691.398 749.133 689.576 747.863 689.576C746.603 689.576 746.593 691.398 747.863 691.398Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M658.57 676.739C659.34 676.739 659.34 675.641 658.57 675.641C657.81 675.641 657.81 676.739 658.57 676.739Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M660.863 570.852C661.623 570.852 661.623 569.754 660.863 569.754C660.103 569.754 660.093 570.852 660.863 570.852Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M753.781 613.915C754.541 613.915 754.551 612.816 753.781 612.816C753.021 612.816 753.021 613.915 753.781 613.915Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M715.699 485.438C716.459 485.438 716.459 484.34 715.699 484.34C714.939 484.34 714.929 485.438 715.699 485.438Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M700.468 407.081C701.228 407.081 701.228 405.982 700.468 405.982C699.698 405.982 699.698 407.081 700.468 407.081Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M669.658 389.199C669.398 388.964 669.148 388.729 668.888 388.494C668.348 387.993 667.518 388.769 668.058 389.271C668.308 389.506 668.558 389.742 668.818 389.977C669.358 390.477 670.198 389.701 669.658 389.199Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M701.988 612.502C702.748 612.502 702.748 611.402 701.988 611.402C701.228 611.402 701.218 612.502 701.988 612.502Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M727.89 542.459C729.41 542.459 729.41 540.262 727.89 540.262C726.36 540.262 726.36 542.459 727.89 542.459Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.569 502.221C676.089 502.221 676.099 500.023 674.569 500.023C673.039 500.023 673.039 502.221 674.569 502.221Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M695.898 642.702C697.418 642.702 697.418 640.504 695.898 640.504C694.368 640.504 694.368 642.702 695.898 642.702Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M753.78 664.584C755.31 664.584 755.31 662.387 753.78 662.387C752.26 662.387 752.25 664.584 753.78 664.584Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.171 465.515C747.691 465.515 747.691 463.316 746.171 463.316C744.641 463.316 744.641 465.515 746.171 465.515Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M679.14 444.336C680.66 444.336 680.67 442.139 679.14 442.139C677.61 442.139 677.61 444.336 679.14 444.336Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M842.25 715.596C843.52 715.596 843.52 713.773 842.25 713.773C840.99 713.773 840.98 715.596 842.25 715.596Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M861.327 719.784C862.597 719.784 862.597 717.961 861.327 717.961C860.058 717.961 860.058 719.784 861.327 719.784Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M857.82 728.623C859.08 728.623 859.08 726.801 857.82 726.801C856.55 726.801 856.55 728.623 857.82 728.623Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.929 788.65C886.189 788.65 886.189 786.828 884.929 786.828C883.659 786.828 883.659 788.65 884.929 788.65Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M901.999 829.136C903.259 829.136 903.269 827.312 901.999 827.312C900.729 827.312 900.729 829.136 901.999 829.136Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M897.48 766.315C898.74 766.315 898.75 764.492 897.48 764.492C896.21 764.492 896.21 766.315 897.48 766.315Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M791.543 695.588C792.813 695.588 792.813 693.766 791.543 693.766C790.283 693.766 790.273 695.588 791.543 695.588Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884.929 861.241C886.189 861.241 886.189 859.418 884.929 859.418C883.659 859.418 883.659 861.241 884.929 861.241Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M825.179 913.358C826.449 913.358 826.449 911.535 825.179 911.535C823.919 911.535 823.909 913.358 825.179 913.358Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M796.559 948.26C796.729 948.26 796.899 948.26 797.059 948.26C797.579 948.26 798.069 947.841 798.049 947.349C798.019 946.855 797.619 946.438 797.059 946.438C796.899 946.438 796.729 946.438 796.559 946.438C796.049 946.438 795.559 946.856 795.579 947.349C795.599 947.843 796.009 948.26 796.559 948.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M837.23 952.912C838.5 952.912 838.5 951.09 837.23 951.09C835.97 951.09 835.96 952.912 837.23 952.912Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M888.937 910.566C890.207 910.566 890.207 908.744 888.937 908.744C887.677 908.744 887.677 910.566 888.937 910.566Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M854.8 898.467C856.07 898.467 856.07 896.645 854.8 896.645C853.54 896.645 853.54 898.467 854.8 898.467Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M856.808 916.15C858.078 916.15 858.078 914.328 856.808 914.328C855.548 914.328 855.538 916.15 856.808 916.15Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M910.531 849.607C911.801 849.607 911.801 847.785 910.531 847.785C909.271 847.785 909.271 849.607 910.531 849.607Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M848.281 818.432C849.541 818.432 849.541 816.609 848.281 816.609C847.011 816.609 847.011 818.432 848.281 818.432Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M817.648 745.378C818.908 745.378 818.918 743.555 817.648 743.555C816.378 743.555 816.378 745.378 817.648 745.378Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M773.468 774.224C774.728 774.224 774.728 772.402 773.468 772.402C772.198 772.402 772.198 774.224 773.468 774.224Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M805.101 862.639C806.361 862.639 806.371 860.816 805.101 860.816C803.831 860.816 803.831 862.639 805.101 862.639Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M977.59 806.267C978.35 806.267 978.36 805.168 977.59 805.168C976.83 805.168 976.83 806.267 977.59 806.267Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M961.121 840.235C961.891 840.235 961.891 839.137 961.121 839.137C960.361 839.137 960.361 840.235 961.121 840.235Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1004.68 858.451C1005.44 858.451 1005.44 857.352 1004.68 857.352C1003.92 857.352 1003.92 858.451 1004.68 858.451Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M969.09 896.357C969.86 896.357 969.86 895.258 969.09 895.258C968.33 895.258 968.33 896.357 969.09 896.357Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M920.23 909.649C920.99 909.649 920.99 908.551 920.23 908.551C919.46 908.551 919.46 909.649 920.23 909.649Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M951.562 868.789C952.332 868.789 952.332 867.689 951.562 867.689C950.802 867.689 950.802 868.789 951.562 868.789Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M947.851 775.748C948.611 775.748 948.611 774.648 947.851 774.648C947.081 774.648 947.081 775.748 947.851 775.748Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M991.398 713.718C992.158 713.718 992.168 712.619 991.398 712.619C990.638 712.619 990.638 713.718 991.398 713.718Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.91 700.92C915.09 700.92 915.27 700.92 915.44 700.92C916.21 700.92 916.21 699.82 915.44 699.82C915.27 699.82 915.09 699.82 914.91 699.82C914.15 699.82 914.15 700.92 914.91 700.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M792.862 725.373C793.042 725.536 793.212 725.701 793.392 725.864C793.932 726.365 794.772 725.588 794.232 725.087C794.052 724.923 793.872 724.759 793.702 724.595C793.162 724.095 792.322 724.871 792.862 725.373Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.492 794.947C823.252 794.947 823.262 793.848 822.492 793.848C821.732 793.848 821.732 794.947 822.492 794.947Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M956.882 921.958C957.642 921.958 957.642 920.859 956.882 920.859C956.112 920.859 956.112 921.958 956.882 921.958Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1000.43 933.278C1001.19 933.278 1001.2 932.18 1000.43 932.18C999.669 932.18 999.669 933.278 1000.43 933.278Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M899.507 945.588C900.267 945.588 900.267 944.488 899.507 944.488C898.748 944.488 898.748 945.588 899.507 945.588Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M862.859 938.693C863.619 938.693 863.619 937.594 862.859 937.594C862.099 937.594 862.099 938.693 862.859 938.693Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M956.882 941.154C957.642 941.154 957.642 940.055 956.882 940.055C956.112 940.055 956.112 941.154 956.882 941.154Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M877.929 650.623C878.699 650.623 878.699 649.523 877.929 649.523C877.169 649.523 877.169 650.623 877.929 650.623Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.468 644.267C979.238 644.267 979.238 643.168 978.468 643.168C977.708 643.168 977.708 644.267 978.468 644.267Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M845.179 541.205C845.939 541.205 845.949 540.105 845.179 540.105C844.419 540.105 844.419 541.205 845.179 541.205Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M909.922 557.441C910.692 557.441 910.692 556.342 909.922 556.342C909.162 556.342 909.162 557.441 909.922 557.441Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M981.519 557.441C982.279 557.441 982.279 556.342 981.519 556.342C980.759 556.342 980.759 557.441 981.519 557.441Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M805.577 473.435C806.337 473.435 806.337 472.336 805.577 472.336C804.808 472.336 804.808 473.435 805.577 473.435Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M788.521 571.239C788.011 571.475 787.501 571.71 787.001 571.946C786.311 572.262 786.911 573.21 787.591 572.894C788.101 572.659 788.611 572.424 789.121 572.188C789.801 571.872 789.201 570.923 788.521 571.239Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M772.82 515.087C773.59 515.087 773.59 513.988 772.82 513.988C772.06 513.988 772.06 515.087 772.82 515.087Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.968 613.915C929.728 613.915 929.728 612.816 928.968 612.816C928.198 612.816 928.198 613.915 928.968 613.915Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M976.191 764.982C976.951 764.982 976.951 763.883 976.191 763.883C975.431 763.883 975.421 764.982 976.191 764.982Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M902.312 683.643C903.832 683.643 903.842 681.445 902.312 681.445C900.782 681.445 900.782 683.643 902.312 683.643Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M792.632 650.467C794.152 650.467 794.162 648.27 792.632 648.27C791.102 648.27 791.102 650.467 792.632 650.467Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M764.452 728.115C765.972 728.115 765.972 725.918 764.452 725.918C762.922 725.918 762.922 728.115 764.452 728.115Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M983.038 831.182C984.568 831.182 984.568 828.984 983.038 828.984C981.518 828.984 981.518 831.182 983.038 831.182Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1005.89 902.48C1007.42 902.48 1007.42 900.281 1005.89 900.281C1004.37 900.281 1004.37 902.48 1005.89 902.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M982.28 944.834C983.81 944.834 983.81 942.637 982.28 942.637C980.76 942.637 980.75 944.834 982.28 944.834Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M946.48 723.881C948.01 723.881 948.01 721.684 946.48 721.684C944.96 721.684 944.95 723.881 946.48 723.881Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.421 674.468C845.951 674.468 845.951 672.27 844.421 672.27C842.891 672.27 842.891 674.468 844.421 674.468Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.28 588.344C852.8 588.344 852.8 586.146 851.28 586.146C849.75 586.146 849.75 588.344 851.28 588.344Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M801.773 527.635C803.293 527.635 803.303 525.438 801.773 525.438C800.243 525.438 800.243 527.635 801.773 527.635Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.902 635.641C828.432 635.641 828.432 633.443 826.902 633.443C825.382 633.443 825.372 635.641 826.902 635.641Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.202 646.936C929.733 646.936 929.733 644.738 928.202 644.738C926.683 644.738 926.683 646.936 928.202 646.936Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M988.711 580.893C988.711 581.6 988.711 582.305 988.711 583.011C988.711 584.425 991.081 584.427 991.081 583.011C991.081 582.305 991.081 581.6 991.081 580.893C991.081 579.479 988.711 579.477 988.711 580.893Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M876.152 512.267C876.402 512.737 876.662 513.208 876.912 513.678C877.592 514.943 879.642 513.832 878.962 512.57C878.702 512.099 878.452 511.628 878.202 511.157C877.512 509.892 875.472 511.004 876.152 512.267Z",
    fill: "#FFFFFE"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.597 713.268C324.867 713.268 324.867 711.445 323.597 711.445C322.337 711.445 322.327 713.268 323.597 713.268Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.499 759.335C299.759 759.335 299.759 757.512 298.499 757.512C297.229 757.512 297.229 759.335 298.499 759.335Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.863 691.398C388.133 691.398 388.133 689.576 386.863 689.576C385.603 689.576 385.593 691.398 386.863 691.398Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.57 676.739C298.34 676.739 298.34 675.641 297.57 675.641C296.81 675.641 296.81 676.739 297.57 676.739Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.863 570.852C300.623 570.852 300.623 569.754 299.863 569.754C299.103 569.754 299.093 570.852 299.863 570.852Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.781 613.915C393.541 613.915 393.551 612.816 392.781 612.816C392.021 612.816 392.021 613.915 392.781 613.915Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.699 485.438C355.459 485.438 355.459 484.34 354.699 484.34C353.939 484.34 353.929 485.438 354.699 485.438Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.468 407.081C340.228 407.081 340.228 405.982 339.468 405.982C338.698 405.982 338.698 407.081 339.468 407.081Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.658 389.199C308.398 388.964 308.148 388.729 307.888 388.494C307.348 387.993 306.518 388.769 307.058 389.271C307.308 389.506 307.558 389.742 307.818 389.977C308.358 390.477 309.198 389.701 308.658 389.199Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.988 612.502C341.748 612.502 341.748 611.402 340.988 611.402C340.228 611.402 340.218 612.502 340.988 612.502Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.89 542.459C368.41 542.459 368.41 540.262 366.89 540.262C365.36 540.262 365.36 542.459 366.89 542.459Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.569 502.221C315.089 502.221 315.099 500.023 313.569 500.023C312.039 500.023 312.039 502.221 313.569 502.221Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.898 642.702C336.418 642.702 336.418 640.504 334.898 640.504C333.368 640.504 333.368 642.702 334.898 642.702Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.78 664.584C394.31 664.584 394.31 662.387 392.78 662.387C391.26 662.387 391.25 664.584 392.78 664.584Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.171 465.515C386.691 465.515 386.691 463.316 385.171 463.316C383.641 463.316 383.641 465.515 385.171 465.515Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.14 444.336C319.66 444.336 319.67 442.139 318.14 442.139C316.61 442.139 316.61 444.336 318.14 444.336Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M481.25 715.596C482.52 715.596 482.52 713.773 481.25 713.773C479.99 713.773 479.98 715.596 481.25 715.596Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.327 719.784C501.597 719.784 501.597 717.961 500.327 717.961C499.058 717.961 499.058 719.784 500.327 719.784Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.82 728.623C498.08 728.623 498.08 726.801 496.82 726.801C495.55 726.801 495.55 728.623 496.82 728.623Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.929 788.65C525.189 788.65 525.189 786.828 523.929 786.828C522.659 786.828 522.659 788.65 523.929 788.65Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.999 829.136C542.259 829.136 542.269 827.312 540.999 827.312C539.729 827.312 539.729 829.136 540.999 829.136Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.48 766.315C537.74 766.315 537.75 764.492 536.48 764.492C535.21 764.492 535.21 766.315 536.48 766.315Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.543 695.588C431.813 695.588 431.813 693.766 430.543 693.766C429.283 693.766 429.273 695.588 430.543 695.588Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.929 861.241C525.189 861.241 525.189 859.418 523.929 859.418C522.659 859.418 522.659 861.241 523.929 861.241Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.179 913.358C465.449 913.358 465.449 911.535 464.179 911.535C462.919 911.535 462.909 913.358 464.179 913.358Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.559 948.26C435.729 948.26 435.899 948.26 436.059 948.26C436.579 948.26 437.069 947.841 437.049 947.349C437.019 946.855 436.619 946.438 436.059 946.438C435.899 946.438 435.729 946.438 435.559 946.438C435.049 946.438 434.559 946.856 434.579 947.349C434.599 947.843 435.009 948.26 435.559 948.26Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.23 952.912C477.5 952.912 477.5 951.09 476.23 951.09C474.97 951.09 474.96 952.912 476.23 952.912Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.937 910.566C529.207 910.566 529.207 908.744 527.937 908.744C526.677 908.744 526.677 910.566 527.937 910.566Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.8 898.467C495.07 898.467 495.07 896.645 493.8 896.645C492.54 896.645 492.54 898.467 493.8 898.467Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.808 916.15C497.078 916.15 497.078 914.328 495.808 914.328C494.548 914.328 494.538 916.15 495.808 916.15Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M549.531 849.607C550.801 849.607 550.801 847.785 549.531 847.785C548.271 847.785 548.271 849.607 549.531 849.607Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.281 818.432C488.541 818.432 488.541 816.609 487.281 816.609C486.011 816.609 486.011 818.432 487.281 818.432Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.648 745.378C457.908 745.378 457.918 743.555 456.648 743.555C455.378 743.555 455.378 745.378 456.648 745.378Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.468 774.224C413.728 774.224 413.728 772.402 412.468 772.402C411.198 772.402 411.198 774.224 412.468 774.224Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.101 862.639C445.361 862.639 445.371 860.816 444.101 860.816C442.831 860.816 442.831 862.639 444.101 862.639Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616.59 806.267C617.35 806.267 617.36 805.168 616.59 805.168C615.83 805.168 615.83 806.267 616.59 806.267Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.121 840.235C600.891 840.235 600.891 839.137 600.121 839.137C599.361 839.137 599.361 840.235 600.121 840.235Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M643.679 858.451C644.439 858.451 644.439 857.352 643.679 857.352C642.919 857.352 642.919 858.451 643.679 858.451Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608.09 896.357C608.86 896.357 608.86 895.258 608.09 895.258C607.33 895.258 607.33 896.357 608.09 896.357Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.23 909.649C559.99 909.649 559.99 908.551 559.23 908.551C558.46 908.551 558.46 909.649 559.23 909.649Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.562 868.789C591.332 868.789 591.332 867.689 590.562 867.689C589.802 867.689 589.802 868.789 590.562 868.789Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.851 775.748C587.611 775.748 587.611 774.648 586.851 774.648C586.081 774.648 586.081 775.748 586.851 775.748Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M630.398 713.718C631.158 713.718 631.168 712.619 630.398 712.619C629.638 712.619 629.638 713.718 630.398 713.718Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.91 700.92C554.09 700.92 554.27 700.92 554.44 700.92C555.21 700.92 555.21 699.82 554.44 699.82C554.27 699.82 554.09 699.82 553.91 699.82C553.15 699.82 553.15 700.92 553.91 700.92Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.862 725.373C432.042 725.536 432.212 725.701 432.392 725.864C432.932 726.365 433.772 725.588 433.232 725.087C433.052 724.923 432.872 724.759 432.702 724.595C432.162 724.095 431.322 724.871 431.862 725.373Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.492 794.947C462.252 794.947 462.262 793.848 461.492 793.848C460.732 793.848 460.732 794.947 461.492 794.947Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.882 921.958C596.642 921.958 596.642 920.859 595.882 920.859C595.112 920.859 595.112 921.958 595.882 921.958Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639.429 933.278C640.189 933.278 640.199 932.18 639.429 932.18C638.669 932.18 638.669 933.278 639.429 933.278Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.507 945.588C539.267 945.588 539.267 944.488 538.507 944.488C537.748 944.488 537.748 945.588 538.507 945.588Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.859 938.693C502.619 938.693 502.619 937.594 501.859 937.594C501.099 937.594 501.099 938.693 501.859 938.693Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.882 941.154C596.642 941.154 596.642 940.055 595.882 940.055C595.112 940.055 595.112 941.154 595.882 941.154Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.929 650.623C517.699 650.623 517.699 649.523 516.929 649.523C516.169 649.523 516.169 650.623 516.929 650.623Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M617.468 644.267C618.238 644.267 618.238 643.168 617.468 643.168C616.708 643.168 616.708 644.267 617.468 644.267Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.179 541.205C484.939 541.205 484.949 540.105 484.179 540.105C483.419 540.105 483.419 541.205 484.179 541.205Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.922 557.441C549.692 557.441 549.692 556.342 548.922 556.342C548.162 556.342 548.162 557.441 548.922 557.441Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.519 557.441C621.279 557.441 621.279 556.342 620.519 556.342C619.759 556.342 619.759 557.441 620.519 557.441Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.577 473.435C445.337 473.435 445.337 472.336 444.577 472.336C443.808 472.336 443.808 473.435 444.577 473.435Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.521 571.239C427.011 571.475 426.501 571.71 426.001 571.946C425.311 572.262 425.911 573.21 426.591 572.894C427.101 572.659 427.611 572.424 428.121 572.188C428.801 571.872 428.201 570.923 427.521 571.239Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.82 515.087C412.59 515.087 412.59 513.988 411.82 513.988C411.06 513.988 411.06 515.087 411.82 515.087Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.968 613.915C568.728 613.915 568.728 612.816 567.968 612.816C567.198 612.816 567.198 613.915 567.968 613.915Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M615.191 764.982C615.951 764.982 615.951 763.883 615.191 763.883C614.431 763.883 614.421 764.982 615.191 764.982Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.312 683.643C542.832 683.643 542.842 681.445 541.312 681.445C539.782 681.445 539.782 683.643 541.312 683.643Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.632 650.467C433.152 650.467 433.162 648.27 431.632 648.27C430.102 648.27 430.102 650.467 431.632 650.467Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.452 728.115C404.972 728.115 404.972 725.918 403.452 725.918C401.922 725.918 401.922 728.115 403.452 728.115Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M622.038 831.182C623.568 831.182 623.568 828.984 622.038 828.984C620.518 828.984 620.518 831.182 622.038 831.182Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.89 902.48C646.42 902.48 646.42 900.281 644.89 900.281C643.37 900.281 643.37 902.48 644.89 902.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621.28 944.834C622.81 944.834 622.81 942.637 621.28 942.637C619.76 942.637 619.75 944.834 621.28 944.834Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.48 723.881C587.01 723.881 587.01 721.684 585.48 721.684C583.96 721.684 583.95 723.881 585.48 723.881Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.421 674.468C484.951 674.468 484.951 672.27 483.421 672.27C481.891 672.27 481.891 674.468 483.421 674.468Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.28 588.344C491.8 588.344 491.8 586.146 490.28 586.146C488.75 586.146 488.75 588.344 490.28 588.344Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.773 527.635C442.293 527.635 442.303 525.438 440.773 525.438C439.243 525.438 439.243 527.635 440.773 527.635Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.902 635.641C467.432 635.641 467.432 633.443 465.902 633.443C464.382 633.443 464.372 635.641 465.902 635.641Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.202 646.936C568.733 646.936 568.733 644.738 567.202 644.738C565.683 644.738 565.683 646.936 567.202 646.936Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M627.711 580.893C627.711 581.6 627.711 582.305 627.711 583.011C627.711 584.425 630.081 584.427 630.081 583.011C630.081 582.305 630.081 581.6 630.081 580.893C630.081 579.479 627.711 579.477 627.711 580.893Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.152 512.267C515.402 512.737 515.662 513.208 515.912 513.678C516.592 514.943 518.642 513.832 517.962 512.57C517.702 512.099 517.452 511.628 517.202 511.157C516.512 509.892 514.472 511.004 515.152 512.267Z",
    fill: "#FFFFFE"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.597 940.339C227.867 940.339 227.867 938.516 226.597 938.516C225.337 938.516 225.327 940.339 226.597 940.339Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.499 986.405C202.759 986.405 202.759 984.582 201.499 984.582C200.229 984.582 200.229 986.405 201.499 986.405Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.863 918.468C291.133 918.468 291.133 916.646 289.863 916.646C288.603 916.646 288.593 918.468 289.863 918.468Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.57 903.813C201.34 903.813 201.34 902.715 200.57 902.715C199.81 902.715 199.81 903.813 200.57 903.813Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.863 797.924C203.623 797.924 203.623 796.826 202.863 796.826C202.103 796.826 202.093 797.924 202.863 797.924Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.781 840.985C296.541 840.985 296.551 839.886 295.781 839.886C295.021 839.886 295.021 840.985 295.781 840.985Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.699 712.506C258.459 712.506 258.459 711.408 257.699 711.408C256.939 711.408 256.929 712.506 257.699 712.506Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.468 634.149C243.228 634.149 243.228 633.051 242.468 633.051C241.698 633.051 241.698 634.149 242.468 634.149Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.658 616.27C211.398 616.034 211.148 615.799 210.888 615.564C210.348 615.063 209.518 615.84 210.058 616.341C210.308 616.576 210.558 616.812 210.818 617.047C211.358 617.548 212.198 616.771 211.658 616.27Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.988 839.572C244.748 839.572 244.748 838.473 243.988 838.473C243.228 838.473 243.218 839.572 243.988 839.572Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.89 769.529C271.41 769.529 271.41 767.332 269.89 767.332C268.36 767.332 268.36 769.529 269.89 769.529Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.569 729.291C218.089 729.291 218.099 727.094 216.569 727.094C215.039 727.094 215.039 729.291 216.569 729.291Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.898 869.772C239.418 869.772 239.418 867.574 237.898 867.574C236.368 867.574 236.368 869.772 237.898 869.772Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.78 891.654C297.31 891.654 297.31 889.457 295.78 889.457C294.26 889.457 294.25 891.654 295.78 891.654Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.171 692.585C289.691 692.585 289.691 690.387 288.171 690.387C286.641 690.387 286.641 692.585 288.171 692.585Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.14 671.406C222.66 671.406 222.67 669.209 221.14 669.209C219.61 669.209 219.61 671.406 221.14 671.406Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.25 942.665C385.52 942.665 385.52 940.842 384.25 940.842C382.99 940.842 382.98 942.665 384.25 942.665Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.327 946.854C404.597 946.854 404.597 945.031 403.327 945.031C402.058 945.031 402.058 946.854 403.327 946.854Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.82 955.693C401.08 955.693 401.08 953.871 399.82 953.871C398.55 953.871 398.55 955.693 399.82 955.693Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.929 1015.72C428.189 1015.72 428.189 1013.9 426.929 1013.9C425.659 1013.9 425.659 1015.72 426.929 1015.72Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.999 1056.21C445.259 1056.21 445.269 1054.38 443.999 1054.38C442.729 1054.38 442.729 1056.21 443.999 1056.21Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.48 993.385C440.74 993.385 440.75 991.562 439.48 991.562C438.21 991.562 438.21 993.385 439.48 993.385Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.543 922.656C334.813 922.656 334.813 920.834 333.543 920.834C332.283 920.834 332.273 922.656 333.543 922.656Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.929 1088.31C428.189 1088.31 428.189 1086.49 426.929 1086.49C425.659 1086.49 425.659 1088.31 426.929 1088.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.179 1140.43C368.449 1140.43 368.449 1138.61 367.179 1138.61C365.919 1138.61 365.909 1140.43 367.179 1140.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.559 1175.33C338.729 1175.33 338.899 1175.33 339.059 1175.33C339.579 1175.33 340.069 1174.91 340.049 1174.42C340.019 1173.92 339.619 1173.51 339.059 1173.51C338.899 1173.51 338.729 1173.51 338.559 1173.51C338.049 1173.51 337.559 1173.92 337.579 1174.42C337.599 1174.91 338.009 1175.33 338.559 1175.33Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.23 1179.98C380.5 1179.98 380.5 1178.16 379.23 1178.16C377.97 1178.16 377.96 1179.98 379.23 1179.98Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.937 1137.64C432.207 1137.64 432.207 1135.81 430.937 1135.81C429.677 1135.81 429.677 1137.64 430.937 1137.64Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.8 1125.54C398.07 1125.54 398.07 1123.72 396.8 1123.72C395.54 1123.72 395.54 1125.54 396.8 1125.54Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.808 1143.22C400.078 1143.22 400.078 1141.4 398.808 1141.4C397.548 1141.4 397.538 1143.22 398.808 1143.22Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.531 1076.68C453.801 1076.68 453.801 1074.86 452.531 1074.86C451.271 1074.86 451.271 1076.68 452.531 1076.68Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.281 1045.5C391.541 1045.5 391.541 1043.68 390.281 1043.68C389.011 1043.68 389.011 1045.5 390.281 1045.5Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.648 972.446C360.908 972.446 360.918 970.623 359.648 970.623C358.378 970.623 358.378 972.446 359.648 972.446Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.468 1001.29C316.728 1001.29 316.728 999.473 315.468 999.473C314.198 999.473 314.198 1001.29 315.468 1001.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.101 1089.71C348.361 1089.71 348.371 1087.89 347.101 1087.89C345.831 1087.89 345.831 1089.71 347.101 1089.71Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M519.59 1033.34C520.35 1033.34 520.36 1032.24 519.59 1032.24C518.83 1032.24 518.83 1033.34 519.59 1033.34Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.121 1067.31C503.891 1067.31 503.891 1066.21 503.121 1066.21C502.361 1066.21 502.361 1067.31 503.121 1067.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.679 1085.52C547.439 1085.52 547.439 1084.42 546.679 1084.42C545.919 1084.42 545.919 1085.52 546.679 1085.52Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.09 1123.43C511.86 1123.43 511.86 1122.33 511.09 1122.33C510.33 1122.33 510.33 1123.43 511.09 1123.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.23 1136.72C462.99 1136.72 462.99 1135.62 462.23 1135.62C461.46 1135.62 461.46 1136.72 462.23 1136.72Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493.562 1095.86C494.332 1095.86 494.332 1094.76 493.562 1094.76C492.802 1094.76 492.802 1095.86 493.562 1095.86Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.851 1002.82C490.611 1002.82 490.611 1001.72 489.851 1001.72C489.081 1001.72 489.081 1002.82 489.851 1002.82Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.398 940.787C534.158 940.787 534.168 939.687 533.398 939.687C532.638 939.687 532.638 940.787 533.398 940.787Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.91 927.99C457.09 927.99 457.27 927.99 457.44 927.99C458.21 927.99 458.21 926.891 457.44 926.891C457.27 926.891 457.09 926.891 456.91 926.891C456.15 926.891 456.15 927.99 456.91 927.99Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.862 952.443C335.042 952.606 335.212 952.771 335.392 952.934C335.932 953.436 336.772 952.658 336.232 952.157C336.052 951.993 335.872 951.829 335.702 951.665C335.162 951.165 334.322 951.942 334.862 952.443Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.492 1022.02C365.252 1022.02 365.262 1020.92 364.492 1020.92C363.732 1020.92 363.732 1022.02 364.492 1022.02Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.882 1149.03C499.642 1149.03 499.642 1147.93 498.882 1147.93C498.112 1147.93 498.112 1149.03 498.882 1149.03Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.429 1160.35C543.189 1160.35 543.199 1159.25 542.429 1159.25C541.669 1159.25 541.669 1160.35 542.429 1160.35Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.507 1172.66C442.267 1172.66 442.267 1171.56 441.507 1171.56C440.748 1171.56 440.748 1172.66 441.507 1172.66Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.859 1165.76C405.619 1165.76 405.619 1164.66 404.859 1164.66C404.099 1164.66 404.099 1165.76 404.859 1165.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.882 1168.23C499.642 1168.23 499.642 1167.13 498.882 1167.13C498.112 1167.13 498.112 1168.23 498.882 1168.23Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.929 877.693C420.699 877.693 420.699 876.594 419.929 876.594C419.169 876.594 419.169 877.693 419.929 877.693Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.468 871.339C521.238 871.339 521.238 870.24 520.468 870.24C519.708 870.24 519.708 871.339 520.468 871.339Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.179 768.275C387.939 768.275 387.949 767.176 387.179 767.176C386.419 767.176 386.419 768.275 387.179 768.275Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.922 784.511C452.692 784.511 452.692 783.412 451.922 783.412C451.162 783.412 451.162 784.511 451.922 784.511Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.519 784.511C524.279 784.511 524.279 783.412 523.519 783.412C522.759 783.412 522.759 784.511 523.519 784.511Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.577 700.507C348.337 700.507 348.337 699.408 347.577 699.408C346.808 699.408 346.808 700.507 347.577 700.507Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.521 798.311C330.011 798.547 329.501 798.782 329.001 799.018C328.311 799.334 328.911 800.282 329.591 799.966C330.101 799.731 330.611 799.496 331.121 799.261C331.801 798.944 331.201 797.995 330.521 798.311Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.82 742.158C315.59 742.158 315.59 741.058 314.82 741.058C314.06 741.058 314.06 742.158 314.82 742.158Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.968 840.985C471.728 840.985 471.728 839.886 470.968 839.886C470.198 839.886 470.198 840.985 470.968 840.985Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M518.191 992.052C518.951 992.052 518.951 990.953 518.191 990.953C517.431 990.953 517.421 992.052 518.191 992.052Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.312 910.715C445.832 910.715 445.842 908.517 444.312 908.517C442.782 908.517 442.782 910.715 444.312 910.715Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.632 877.537C336.152 877.537 336.162 875.34 334.632 875.34C333.102 875.34 333.102 877.537 334.632 877.537Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.452 955.187C307.972 955.187 307.972 952.99 306.452 952.99C304.922 952.99 304.922 955.187 306.452 955.187Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M525.038 1058.25C526.568 1058.25 526.568 1056.05 525.038 1056.05C523.518 1056.05 523.518 1058.25 525.038 1058.25Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547.89 1129.55C549.42 1129.55 549.42 1127.35 547.89 1127.35C546.37 1127.35 546.37 1129.55 547.89 1129.55Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.28 1171.9C525.81 1171.9 525.81 1169.71 524.28 1169.71C522.76 1169.71 522.75 1171.9 524.28 1171.9Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.48 950.951C490.01 950.951 490.01 948.754 488.48 948.754C486.96 948.754 486.95 950.951 488.48 950.951Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.421 901.538C387.951 901.538 387.951 899.34 386.421 899.34C384.891 899.34 384.891 901.538 386.421 901.538Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.28 815.414C394.8 815.414 394.8 813.217 393.28 813.217C391.75 813.217 391.75 815.414 393.28 815.414Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.773 754.705C345.293 754.705 345.303 752.508 343.773 752.508C342.243 752.508 342.243 754.705 343.773 754.705Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.902 862.711C370.432 862.711 370.432 860.514 368.902 860.514C367.382 860.514 367.372 862.711 368.902 862.711Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.202 874.006C471.733 874.006 471.733 871.808 470.202 871.808C468.683 871.808 468.683 874.006 470.202 874.006Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M530.711 807.964C530.711 808.67 530.711 809.375 530.711 810.081C530.711 811.495 533.081 811.498 533.081 810.081C533.081 809.375 533.081 808.67 533.081 807.964C533.081 806.549 530.711 806.547 530.711 807.964Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.152 739.337C418.402 739.808 418.662 740.278 418.912 740.748C419.592 742.013 421.642 740.902 420.962 739.64C420.702 739.169 420.452 738.698 420.202 738.227C419.512 736.962 417.472 738.074 418.152 739.337Z",
    fill: "#FFFFFE"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M630.597 915.315C631.867 915.315 631.867 913.492 630.597 913.492C629.337 913.492 629.327 915.315 630.597 915.315Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M605.499 961.384C606.759 961.384 606.759 959.561 605.499 959.561C604.229 959.561 604.229 961.384 605.499 961.384Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M693.863 893.445C695.133 893.445 695.133 891.623 693.863 891.623C692.603 891.623 692.593 893.445 693.863 893.445Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.57 878.788C605.34 878.788 605.34 877.69 604.57 877.69C603.81 877.69 603.81 878.788 604.57 878.788Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M606.863 772.899C607.623 772.899 607.623 771.801 606.863 771.801C606.103 771.801 606.093 772.899 606.863 772.899Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M699.781 815.962C700.541 815.962 700.551 814.863 699.781 814.863C699.021 814.863 699.021 815.962 699.781 815.962Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M661.699 687.485C662.459 687.485 662.459 686.387 661.699 686.387C660.939 686.387 660.929 687.485 661.699 687.485Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M646.468 609.128C647.228 609.128 647.228 608.029 646.468 608.029C645.698 608.029 645.698 609.128 646.468 609.128Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M615.658 591.246C615.398 591.011 615.148 590.776 614.888 590.541C614.348 590.04 613.518 590.816 614.058 591.318C614.308 591.553 614.558 591.789 614.818 592.024C615.358 592.524 616.198 591.748 615.658 591.246Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647.988 814.549C648.748 814.549 648.748 813.449 647.988 813.449C647.228 813.449 647.218 814.549 647.988 814.549Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673.89 744.506C675.41 744.506 675.41 742.309 673.89 742.309C672.36 742.309 672.36 744.506 673.89 744.506Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M620.569 704.27C622.089 704.27 622.099 702.072 620.569 702.072C619.039 702.072 619.039 704.27 620.569 704.27Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M641.898 844.747C643.418 844.747 643.418 842.549 641.898 842.549C640.368 842.549 640.368 844.747 641.898 844.747Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M699.78 866.631C701.31 866.631 701.31 864.434 699.78 864.434C698.26 864.434 698.25 866.631 699.78 866.631Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M692.171 667.562C693.691 667.562 693.691 665.363 692.171 665.363C690.641 665.363 690.641 667.562 692.171 667.562Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M625.14 646.385C626.66 646.385 626.67 644.188 625.14 644.188C623.61 644.188 623.61 646.385 625.14 646.385Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M788.25 917.642C789.52 917.642 789.52 915.818 788.25 915.818C786.99 915.818 786.98 917.642 788.25 917.642Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M807.327 921.831C808.597 921.831 808.597 920.008 807.327 920.008C806.058 920.008 806.058 921.831 807.327 921.831Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M803.82 930.672C805.08 930.672 805.08 928.85 803.82 928.85C802.55 928.85 802.55 930.672 803.82 930.672Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M830.929 990.697C832.189 990.697 832.189 988.875 830.929 988.875C829.659 988.875 829.659 990.697 830.929 990.697Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.999 1031.18C849.259 1031.18 849.269 1029.36 847.999 1029.36C846.729 1029.36 846.729 1031.18 847.999 1031.18Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M843.48 968.362C844.74 968.362 844.75 966.539 843.48 966.539C842.21 966.539 842.21 968.362 843.48 968.362Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M737.543 897.633C738.813 897.633 738.813 895.811 737.543 895.811C736.283 895.811 736.273 897.633 737.543 897.633Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M830.929 1063.29C832.189 1063.29 832.189 1061.47 830.929 1061.47C829.659 1061.47 829.659 1063.29 830.929 1063.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M771.179 1115.41C772.449 1115.41 772.449 1113.58 771.179 1113.58C769.919 1113.58 769.909 1115.41 771.179 1115.41Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M742.559 1150.3C742.729 1150.3 742.899 1150.3 743.059 1150.3C743.579 1150.3 744.069 1149.89 744.049 1149.39C744.019 1148.9 743.619 1148.48 743.059 1148.48C742.899 1148.48 742.729 1148.48 742.559 1148.48C742.049 1148.48 741.559 1148.9 741.579 1149.39C741.599 1149.89 742.009 1150.3 742.559 1150.3Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M783.23 1154.96C784.5 1154.96 784.5 1153.14 783.23 1153.14C781.97 1153.14 781.96 1154.96 783.23 1154.96Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.937 1112.61C836.207 1112.61 836.207 1110.79 834.937 1110.79C833.677 1110.79 833.677 1112.61 834.937 1112.61Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M800.8 1100.51C802.07 1100.51 802.07 1098.69 800.8 1098.69C799.54 1098.69 799.54 1100.51 800.8 1100.51Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M802.808 1118.2C804.078 1118.2 804.078 1116.38 802.808 1116.38C801.548 1116.38 801.538 1118.2 802.808 1118.2Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M856.531 1051.66C857.801 1051.66 857.801 1049.83 856.531 1049.83C855.271 1049.83 855.271 1051.66 856.531 1051.66Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M794.281 1020.48C795.541 1020.48 795.541 1018.65 794.281 1018.65C793.011 1018.65 793.011 1020.48 794.281 1020.48Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M763.648 947.423C764.908 947.423 764.918 945.6 763.648 945.6C762.378 945.6 762.378 947.423 763.648 947.423Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M719.468 976.271C720.728 976.271 720.728 974.449 719.468 974.449C718.198 974.449 718.198 976.271 719.468 976.271Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M751.101 1064.69C752.361 1064.69 752.371 1062.86 751.101 1062.86C749.831 1062.86 749.831 1064.69 751.101 1064.69Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M923.59 1008.31C924.35 1008.31 924.36 1007.21 923.59 1007.21C922.83 1007.21 922.83 1008.31 923.59 1008.31Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M907.121 1042.28C907.891 1042.28 907.891 1041.19 907.121 1041.19C906.361 1041.19 906.361 1042.28 907.121 1042.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M950.679 1060.5C951.439 1060.5 951.439 1059.4 950.679 1059.4C949.919 1059.4 949.919 1060.5 950.679 1060.5Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M915.09 1098.4C915.86 1098.4 915.86 1097.3 915.09 1097.3C914.33 1097.3 914.33 1098.4 915.09 1098.4Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M866.23 1111.7C866.99 1111.7 866.99 1110.6 866.23 1110.6C865.46 1110.6 865.46 1111.7 866.23 1111.7Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M897.562 1070.84C898.332 1070.84 898.332 1069.74 897.562 1069.74C896.802 1069.74 896.802 1070.84 897.562 1070.84Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M893.851 977.795C894.611 977.795 894.611 976.695 893.851 976.695C893.081 976.695 893.081 977.795 893.851 977.795Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M937.398 915.765C938.158 915.765 938.168 914.666 937.398 914.666C936.638 914.666 936.638 915.765 937.398 915.765Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M860.91 902.967C861.09 902.967 861.27 902.967 861.44 902.967C862.21 902.967 862.21 901.867 861.44 901.867C861.27 901.867 861.09 901.867 860.91 901.867C860.15 901.867 860.15 902.967 860.91 902.967Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M738.862 927.42C739.042 927.583 739.212 927.748 739.392 927.911C739.932 928.412 740.772 927.635 740.232 927.134C740.052 926.97 739.872 926.806 739.702 926.642C739.162 926.142 738.322 926.918 738.862 927.42Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M768.492 996.992C769.252 996.992 769.262 995.893 768.492 995.893C767.732 995.893 767.732 996.992 768.492 996.992Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M902.882 1124C903.642 1124 903.642 1122.91 902.882 1122.91C902.112 1122.91 902.112 1124 902.882 1124Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M946.429 1135.33C947.189 1135.33 947.199 1134.23 946.429 1134.23C945.669 1134.23 945.669 1135.33 946.429 1135.33Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M845.507 1147.63C846.267 1147.63 846.267 1146.53 845.507 1146.53C844.748 1146.53 844.748 1147.63 845.507 1147.63Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M808.859 1140.74C809.619 1140.74 809.619 1139.64 808.859 1139.64C808.099 1139.64 808.099 1140.74 808.859 1140.74Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M902.882 1143.2C903.642 1143.2 903.642 1142.1 902.882 1142.1C902.112 1142.1 902.112 1143.2 902.882 1143.2Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M823.929 852.67C824.699 852.67 824.699 851.57 823.929 851.57C823.169 851.57 823.169 852.67 823.929 852.67Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M924.468 846.316C925.238 846.316 925.238 845.217 924.468 845.217C923.708 845.217 923.708 846.316 924.468 846.316Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M791.179 743.252C791.939 743.252 791.949 742.152 791.179 742.152C790.419 742.152 790.419 743.252 791.179 743.252Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M855.922 759.49C856.692 759.49 856.692 758.391 855.922 758.391C855.162 758.391 855.162 759.49 855.922 759.49Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M927.519 759.49C928.279 759.49 928.279 758.391 927.519 758.391C926.759 758.391 926.759 759.49 927.519 759.49Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M751.577 675.482C752.337 675.482 752.337 674.383 751.577 674.383C750.808 674.383 750.808 675.482 751.577 675.482Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M734.521 773.286C734.011 773.522 733.501 773.757 733.001 773.993C732.311 774.309 732.911 775.257 733.591 774.941C734.101 774.706 734.611 774.471 735.121 774.235C735.801 773.919 735.201 772.97 734.521 773.286Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718.82 717.132C719.59 717.132 719.59 716.033 718.82 716.033C718.06 716.033 718.06 717.132 718.82 717.132Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M874.968 815.962C875.728 815.962 875.728 814.863 874.968 814.863C874.198 814.863 874.198 815.962 874.968 815.962Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M922.191 967.029C922.951 967.029 922.951 965.93 922.191 965.93C921.431 965.93 921.421 967.029 922.191 967.029Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M848.312 885.69C849.832 885.69 849.842 883.492 848.312 883.492C846.782 883.492 846.782 885.69 848.312 885.69Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M738.632 852.514C740.152 852.514 740.162 850.317 738.632 850.317C737.102 850.317 737.102 852.514 738.632 852.514Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M710.452 930.165C711.972 930.165 711.972 927.967 710.452 927.967C708.922 927.967 708.922 930.165 710.452 930.165Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M929.038 1033.23C930.568 1033.23 930.568 1031.03 929.038 1031.03C927.518 1031.03 927.518 1033.23 929.038 1033.23Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M951.89 1104.53C953.42 1104.53 953.42 1102.33 951.89 1102.33C950.37 1102.33 950.37 1104.53 951.89 1104.53Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M928.28 1146.88C929.81 1146.88 929.81 1144.68 928.28 1144.68C926.76 1144.68 926.75 1146.88 928.28 1146.88Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M892.48 925.928C894.01 925.928 894.01 923.73 892.48 923.73C890.96 923.73 890.95 925.928 892.48 925.928Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M790.421 876.513C791.951 876.513 791.951 874.315 790.421 874.315C788.891 874.315 788.891 876.513 790.421 876.513Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M797.28 790.393C798.8 790.393 798.8 788.195 797.28 788.195C795.75 788.195 795.75 790.393 797.28 790.393Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747.773 729.682C749.293 729.682 749.303 727.484 747.773 727.484C746.243 727.484 746.243 729.682 747.773 729.682Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M772.902 837.688C774.432 837.688 774.432 835.49 772.902 835.49C771.382 835.49 771.372 837.688 772.902 837.688Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M874.202 848.985C875.733 848.985 875.733 846.787 874.202 846.787C872.683 846.787 872.683 848.985 874.202 848.985Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M934.711 782.939C934.711 783.645 934.711 784.35 934.711 785.056C934.711 786.47 937.081 786.472 937.081 785.056C937.081 784.35 937.081 783.645 937.081 782.939C937.081 781.524 934.711 781.522 934.711 782.939Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.152 714.313C822.402 714.784 822.662 715.255 822.912 715.725C823.592 716.99 825.642 715.879 824.962 714.616C824.702 714.146 824.452 713.675 824.202 713.204C823.512 711.939 821.472 713.051 822.152 714.313Z",
    fill: "#FFFFFE"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1334.6 940.339C1335.87 940.339 1335.87 938.516 1334.6 938.516C1333.34 938.516 1333.33 940.339 1334.6 940.339Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1309.5 986.405C1310.76 986.405 1310.76 984.582 1309.5 984.582C1308.23 984.582 1308.23 986.405 1309.5 986.405Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1397.86 918.468C1399.13 918.468 1399.13 916.646 1397.86 916.646C1396.6 916.646 1396.59 918.468 1397.86 918.468Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1308.57 903.813C1309.34 903.813 1309.34 902.715 1308.57 902.715C1307.81 902.715 1307.81 903.813 1308.57 903.813Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1310.86 797.924C1311.62 797.924 1311.62 796.826 1310.86 796.826C1310.1 796.826 1310.09 797.924 1310.86 797.924Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1403.78 840.985C1404.54 840.985 1404.55 839.886 1403.78 839.886C1403.02 839.886 1403.02 840.985 1403.78 840.985Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1365.7 712.506C1366.46 712.506 1366.46 711.408 1365.7 711.408C1364.94 711.408 1364.93 712.506 1365.7 712.506Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1350.47 634.149C1351.23 634.149 1351.23 633.051 1350.47 633.051C1349.7 633.051 1349.7 634.149 1350.47 634.149Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1319.66 616.27C1319.4 616.034 1319.15 615.799 1318.89 615.564C1318.35 615.063 1317.52 615.84 1318.06 616.341C1318.31 616.576 1318.56 616.812 1318.82 617.047C1319.36 617.548 1320.2 616.771 1319.66 616.27Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1351.99 839.572C1352.75 839.572 1352.75 838.473 1351.99 838.473C1351.23 838.473 1351.22 839.572 1351.99 839.572Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1377.89 769.529C1379.41 769.529 1379.41 767.332 1377.89 767.332C1376.36 767.332 1376.36 769.529 1377.89 769.529Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1324.57 729.291C1326.09 729.291 1326.1 727.094 1324.57 727.094C1323.04 727.094 1323.04 729.291 1324.57 729.291Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1345.9 869.772C1347.42 869.772 1347.42 867.574 1345.9 867.574C1344.37 867.574 1344.37 869.772 1345.9 869.772Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1403.78 891.654C1405.31 891.654 1405.31 889.457 1403.78 889.457C1402.26 889.457 1402.25 891.654 1403.78 891.654Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1396.17 692.585C1397.69 692.585 1397.69 690.387 1396.17 690.387C1394.64 690.387 1394.64 692.585 1396.17 692.585Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1329.14 671.406C1330.66 671.406 1330.67 669.209 1329.14 669.209C1327.61 669.209 1327.61 671.406 1329.14 671.406Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1423.47 1001.29C1424.73 1001.29 1424.73 999.473 1423.47 999.473C1422.2 999.473 1422.2 1001.29 1423.47 1001.29Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1438.52 798.311C1438.01 798.547 1437.5 798.782 1437 799.018C1436.31 799.334 1436.91 800.282 1437.59 799.966C1438.1 799.731 1438.61 799.496 1439.12 799.261C1439.8 798.944 1439.2 797.995 1438.52 798.311Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1422.82 742.158C1423.59 742.158 1423.59 741.058 1422.82 741.058C1422.06 741.058 1422.06 742.158 1422.82 742.158Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1414.45 955.187C1415.97 955.187 1415.97 952.99 1414.45 952.99C1412.92 952.99 1412.92 955.187 1414.45 955.187Z",
    fill: "#FFFFFE"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.597 399.081C270.867 399.081 270.867 397.258 269.597 397.258C268.337 397.258 268.327 399.081 269.597 399.081Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.499 445.147C245.759 445.147 245.759 443.324 244.499 443.324C243.229 443.324 243.229 445.147 244.499 445.147Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.863 377.211C334.133 377.211 334.133 375.389 332.863 375.389C331.603 375.389 331.593 377.211 332.863 377.211Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.57 362.553C244.34 362.553 244.34 361.455 243.57 361.455C242.81 361.455 242.81 362.553 243.57 362.553Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.863 256.665C246.623 256.665 246.623 255.566 245.863 255.566C245.103 255.566 245.093 256.665 245.863 256.665Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.781 299.727C339.541 299.727 339.551 298.629 338.781 298.629C338.021 298.629 338.021 299.727 338.781 299.727Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.699 171.251C301.459 171.251 301.459 170.152 300.699 170.152C299.939 170.152 299.929 171.251 300.699 171.251Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.468 92.8912C286.228 92.8912 286.228 91.793 285.468 91.793C284.698 91.793 284.698 92.8912 285.468 92.8912Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.658 75.0119C254.398 74.7765 254.148 74.5411 253.888 74.3066C253.348 73.8052 252.518 74.5818 253.058 75.0833C253.308 75.3187 253.558 75.5541 253.818 75.7895C254.358 76.29 255.198 75.5133 254.658 75.0119Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.988 298.316C287.748 298.316 287.748 297.217 286.988 297.217C286.228 297.217 286.218 298.316 286.988 298.316Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.89 228.272C314.41 228.272 314.41 226.074 312.89 226.074C311.36 226.074 311.36 228.272 312.89 228.272Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.569 188.033C261.089 188.033 261.099 185.836 259.569 185.836C258.039 185.836 258.039 188.033 259.569 188.033Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.898 328.515C282.418 328.515 282.418 326.316 280.898 326.316C279.368 326.316 279.368 328.515 280.898 328.515Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.78 350.397C340.31 350.397 340.31 348.199 338.78 348.199C337.26 348.199 337.25 350.397 338.78 350.397Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.171 151.327C332.691 151.327 332.691 149.129 331.171 149.129C329.641 149.129 329.641 151.327 331.171 151.327Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.14 130.149C265.66 130.149 265.67 127.951 264.14 127.951C262.61 127.951 262.61 130.149 264.14 130.149Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.25 401.407C428.52 401.407 428.52 399.584 427.25 399.584C425.99 399.584 425.98 401.407 427.25 401.407Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.327 405.595C447.597 405.595 447.597 403.771 446.327 403.771C445.058 403.771 445.058 405.595 446.327 405.595Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.82 414.435C444.08 414.435 444.08 412.613 442.82 412.613C441.55 412.613 441.55 414.435 442.82 414.435Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.929 474.463C471.189 474.463 471.189 472.641 469.929 472.641C468.659 472.641 468.659 474.463 469.929 474.463Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.999 514.948C488.259 514.948 488.269 513.125 486.999 513.125C485.729 513.125 485.729 514.948 486.999 514.948Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.48 452.128C483.74 452.128 483.75 450.305 482.48 450.305C481.21 450.305 481.21 452.128 482.48 452.128Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.543 381.398C377.813 381.398 377.813 379.576 376.543 379.576C375.283 379.576 375.273 381.398 376.543 381.398Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.929 547.055C471.189 547.055 471.189 545.232 469.929 545.232C468.659 545.232 468.659 547.055 469.929 547.055Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.179 599.171C411.449 599.171 411.449 597.348 410.179 597.348C408.919 597.348 408.909 599.171 410.179 599.171Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.559 634.068C381.729 634.068 381.899 634.068 382.059 634.068C382.579 634.068 383.069 633.649 383.049 633.157C383.019 632.663 382.619 632.246 382.059 632.246C381.899 632.246 381.729 632.246 381.559 632.246C381.049 632.246 380.559 632.665 380.579 633.157C380.599 633.651 381.009 634.068 381.559 634.068Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.23 638.724C423.5 638.724 423.5 636.902 422.23 636.902C420.97 636.902 420.96 638.724 422.23 638.724Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473.937 596.379C475.207 596.379 475.207 594.557 473.937 594.557C472.677 594.557 472.677 596.379 473.937 596.379Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.8 584.279C441.07 584.279 441.07 582.457 439.8 582.457C438.54 582.457 438.54 584.279 439.8 584.279Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.808 601.963C443.078 601.963 443.078 600.141 441.808 600.141C440.548 600.141 440.538 601.963 441.808 601.963Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.531 535.422C496.801 535.422 496.801 533.6 495.531 533.6C494.271 533.6 494.271 535.422 495.531 535.422Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.281 504.245C434.541 504.245 434.541 502.422 433.281 502.422C432.011 502.422 432.011 504.245 433.281 504.245Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.648 431.188C403.908 431.188 403.918 429.365 402.648 429.365C401.378 429.365 401.378 431.188 402.648 431.188Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.468 460.037C359.728 460.037 359.728 458.215 358.468 458.215C357.198 458.215 357.198 460.037 358.468 460.037Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.101 548.451C391.361 548.451 391.371 546.629 390.101 546.629C388.831 546.629 388.831 548.451 390.101 548.451Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M562.59 492.082C563.35 492.082 563.36 490.982 562.59 490.982C561.83 490.982 561.83 492.082 562.59 492.082Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.121 526.047C546.891 526.047 546.891 524.949 546.121 524.949C545.361 524.949 545.361 526.047 546.121 526.047Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M589.679 544.263C590.439 544.263 590.439 543.164 589.679 543.164C588.919 543.164 588.919 544.263 589.679 544.263Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M554.09 582.17C554.86 582.17 554.86 581.07 554.09 581.07C553.33 581.07 553.33 582.17 554.09 582.17Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.23 595.461C505.99 595.461 505.99 594.363 505.23 594.363C504.46 594.363 504.46 595.461 505.23 595.461Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.562 554.601C537.332 554.601 537.332 553.502 536.562 553.502C535.802 553.502 535.802 554.601 536.562 554.601Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.851 461.558C533.611 461.558 533.611 460.459 532.851 460.459C532.081 460.459 532.081 461.558 532.851 461.558Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M576.398 399.529C577.158 399.529 577.168 398.43 576.398 398.43C575.638 398.43 575.638 399.529 576.398 399.529Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M499.91 386.732C500.09 386.732 500.27 386.732 500.44 386.732C501.21 386.732 501.21 385.633 500.44 385.633C500.27 385.633 500.09 385.633 499.91 385.633C499.15 385.633 499.15 386.732 499.91 386.732Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.862 411.185C378.042 411.348 378.212 411.513 378.392 411.676C378.932 412.178 379.772 411.4 379.232 410.9C379.052 410.736 378.872 410.572 378.702 410.408C378.162 409.907 377.322 410.684 377.862 411.185Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.492 480.759C408.252 480.759 408.262 479.66 407.492 479.66C406.732 479.66 406.732 480.759 407.492 480.759Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.882 607.768C542.642 607.768 542.642 606.67 541.882 606.67C541.112 606.67 541.112 607.768 541.882 607.768Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.429 619.09C586.189 619.09 586.199 617.992 585.429 617.992C584.669 617.992 584.669 619.09 585.429 619.09Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.507 631.399C485.267 631.399 485.267 630.299 484.507 630.299C483.748 630.299 483.748 631.399 484.507 631.399Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.859 624.505C448.619 624.505 448.619 623.406 447.859 623.406C447.099 623.406 447.099 624.505 447.859 624.505Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.882 626.966C542.642 626.966 542.642 625.867 541.882 625.867C541.112 625.867 541.112 626.966 541.882 626.966Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.929 336.435C463.699 336.435 463.699 335.336 462.929 335.336C462.169 335.336 462.169 336.435 462.929 336.435Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.468 330.082C564.238 330.082 564.238 328.983 563.468 328.983C562.708 328.983 562.708 330.082 563.468 330.082Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.179 227.017C430.939 227.017 430.949 225.918 430.179 225.918C429.419 225.918 429.419 227.017 430.179 227.017Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.922 243.253C495.692 243.253 495.692 242.154 494.922 242.154C494.162 242.154 494.162 243.253 494.922 243.253Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M566.519 243.253C567.279 243.253 567.279 242.154 566.519 242.154C565.759 242.154 565.759 243.253 566.519 243.253Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.577 159.25C391.337 159.25 391.337 158.15 390.577 158.15C389.808 158.15 389.808 159.25 390.577 159.25Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.521 257.054C373.011 257.289 372.501 257.525 372.001 257.76C371.311 258.076 371.911 259.024 372.591 258.708C373.101 258.474 373.611 258.238 374.121 258.003C374.801 257.687 374.201 256.738 373.521 257.054Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.82 200.898C358.59 200.898 358.59 199.799 357.82 199.799C357.06 199.799 357.06 200.898 357.82 200.898Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.968 299.727C514.728 299.727 514.728 298.629 513.968 298.629C513.198 298.629 513.198 299.727 513.968 299.727Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.191 450.795C561.951 450.795 561.951 449.695 561.191 449.695C560.431 449.695 560.421 450.795 561.191 450.795Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.312 369.455C488.832 369.455 488.842 367.258 487.312 367.258C485.782 367.258 485.782 369.455 487.312 369.455Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.632 336.28C379.152 336.28 379.162 334.082 377.632 334.082C376.102 334.082 376.102 336.28 377.632 336.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.452 413.928C350.972 413.928 350.972 411.73 349.452 411.73C347.922 411.73 347.922 413.928 349.452 413.928Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.038 516.994C569.568 516.994 569.568 514.797 568.038 514.797C566.518 514.797 566.518 516.994 568.038 516.994Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.89 588.292C592.42 588.292 592.42 586.094 590.89 586.094C589.37 586.094 589.37 588.292 590.89 588.292Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.28 630.647C568.81 630.647 568.81 628.449 567.28 628.449C565.76 628.449 565.75 630.647 567.28 630.647Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M531.48 409.694C533.01 409.694 533.01 407.496 531.48 407.496C529.96 407.496 529.95 409.694 531.48 409.694Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.421 360.28C430.951 360.28 430.951 358.082 429.421 358.082C427.891 358.082 427.891 360.28 429.421 360.28Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.28 274.158C437.8 274.158 437.8 271.961 436.28 271.961C434.75 271.961 434.75 274.158 436.28 274.158Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.773 213.447C388.293 213.447 388.303 211.25 386.773 211.25C385.243 211.25 385.243 213.447 386.773 213.447Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.902 321.455C413.432 321.455 413.432 319.258 411.902 319.258C410.382 319.258 410.372 321.455 411.902 321.455Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.202 332.748C514.733 332.748 514.733 330.551 513.202 330.551C511.683 330.551 511.683 332.748 513.202 332.748Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M573.711 266.706C573.711 267.412 573.711 268.117 573.711 268.824C573.711 270.237 576.081 270.24 576.081 268.824C576.081 268.117 576.081 267.412 576.081 266.706C576.081 265.292 573.711 265.29 573.711 266.706Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.152 198.081C461.402 198.552 461.662 199.023 461.912 199.493C462.592 200.758 464.642 199.646 463.962 198.384C463.702 197.913 463.452 197.442 463.202 196.972C462.512 195.706 460.472 196.819 461.152 198.081Z",
    fill: "#FFFFFE"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.202866
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.597 597.419C169.867 597.419 169.867 595.596 168.597 595.596C167.337 595.596 167.327 597.419 168.597 597.419Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.499 643.487C144.759 643.487 144.759 641.664 143.499 641.664C142.229 641.664 142.229 643.487 143.499 643.487Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.863 575.549C233.133 575.549 233.133 573.727 231.863 573.727C230.603 573.727 230.593 575.549 231.863 575.549Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.57 560.891C143.34 560.891 143.34 559.793 142.57 559.793C141.81 559.793 141.81 560.891 142.57 560.891Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.863 455.003C145.623 455.003 145.623 453.904 144.863 453.904C144.103 453.904 144.093 455.003 144.863 455.003Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.781 498.065C238.541 498.065 238.551 496.967 237.781 496.967C237.021 496.967 237.021 498.065 237.781 498.065Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.699 369.587C200.459 369.587 200.459 368.488 199.699 368.488C198.939 368.488 198.929 369.587 199.699 369.587Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.468 291.229C185.228 291.229 185.228 290.131 184.468 290.131C183.698 290.131 183.698 291.229 184.468 291.229Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.658 273.35C153.398 273.114 153.148 272.879 152.888 272.644C152.348 272.143 151.518 272.92 152.058 273.421C152.308 273.657 152.558 273.892 152.818 274.127C153.358 274.628 154.198 273.851 153.658 273.35Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.988 496.654C186.748 496.654 186.748 495.555 185.988 495.555C185.228 495.555 185.218 496.654 185.988 496.654Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.89 426.61C213.41 426.61 213.41 424.412 211.89 424.412C210.36 424.412 210.36 426.61 211.89 426.61Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.569 386.373C160.089 386.373 160.099 384.176 158.569 384.176C157.039 384.176 157.039 386.373 158.569 386.373Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.898 526.851C181.418 526.851 181.418 524.652 179.898 524.652C178.368 524.652 178.368 526.851 179.898 526.851Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.78 548.735C239.31 548.735 239.31 546.537 237.78 546.537C236.26 546.537 236.25 548.735 237.78 548.735Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.171 349.665C231.691 349.665 231.691 347.467 230.171 347.467C228.641 347.467 228.641 349.665 230.171 349.665Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.14 328.487C164.66 328.487 164.67 326.289 163.14 326.289C161.61 326.289 161.61 328.487 163.14 328.487Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.25 599.745C327.52 599.745 327.52 597.922 326.25 597.922C324.99 597.922 324.98 599.745 326.25 599.745Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.327 603.934C346.597 603.934 346.597 602.111 345.327 602.111C344.058 602.111 344.058 603.934 345.327 603.934Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.82 612.775C343.08 612.775 343.08 610.953 341.82 610.953C340.55 610.953 340.55 612.775 341.82 612.775Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.929 672.801C370.189 672.801 370.189 670.979 368.929 670.979C367.659 670.979 367.659 672.801 368.929 672.801Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.999 713.286C387.259 713.286 387.269 711.463 385.999 711.463C384.729 711.463 384.729 713.286 385.999 713.286Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.48 650.468C382.74 650.468 382.75 648.645 381.48 648.645C380.21 648.645 380.21 650.468 381.48 650.468Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.543 579.736C276.813 579.736 276.813 577.914 275.543 577.914C274.283 577.914 274.273 579.736 275.543 579.736Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.929 745.393C370.189 745.393 370.189 743.57 368.929 743.57C367.659 743.57 367.659 745.393 368.929 745.393Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.179 797.509C310.449 797.509 310.449 795.686 309.179 795.686C307.919 795.686 307.909 797.509 309.179 797.509Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.559 832.408C280.729 832.408 280.899 832.408 281.059 832.408C281.579 832.408 282.069 831.989 282.049 831.497C282.019 831.003 281.619 830.586 281.059 830.586C280.899 830.586 280.729 830.586 280.559 830.586C280.049 830.586 279.559 831.005 279.579 831.497C279.599 831.991 280.009 832.408 280.559 832.408Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.23 837.062C322.5 837.062 322.5 835.24 321.23 835.24C319.97 835.24 319.96 837.062 321.23 837.062Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.937 794.717C374.207 794.717 374.207 792.895 372.937 792.895C371.677 792.895 371.677 794.717 372.937 794.717Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.8 782.619C340.07 782.619 340.07 780.797 338.8 780.797C337.54 780.797 337.54 782.619 338.8 782.619Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.808 800.301C342.078 800.301 342.078 798.479 340.808 798.479C339.548 798.479 339.538 800.301 340.808 800.301Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.531 733.76C395.801 733.76 395.801 731.938 394.531 731.938C393.271 731.938 393.271 733.76 394.531 733.76Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.281 702.583C333.541 702.583 333.541 700.76 332.281 700.76C331.011 700.76 331.011 702.583 332.281 702.583Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.648 629.526C302.908 629.526 302.918 627.703 301.648 627.703C300.378 627.703 300.378 629.526 301.648 629.526Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.468 658.375C258.728 658.375 258.728 656.553 257.468 656.553C256.198 656.553 256.198 658.375 257.468 658.375Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.101 746.789C290.361 746.789 290.371 744.967 289.101 744.967C287.831 744.967 287.831 746.789 289.101 746.789Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.59 690.42C462.35 690.42 462.36 689.32 461.59 689.32C460.83 689.32 460.83 690.42 461.59 690.42Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.121 724.387C445.891 724.387 445.891 723.289 445.121 723.289C444.361 723.289 444.361 724.387 445.121 724.387Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.679 742.601C489.439 742.601 489.439 741.502 488.679 741.502C487.919 741.502 487.919 742.601 488.679 742.601Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.09 780.507C453.86 780.507 453.86 779.408 453.09 779.408C452.33 779.408 452.33 780.507 453.09 780.507Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.23 793.799C404.99 793.799 404.99 792.701 404.23 792.701C403.46 792.701 403.46 793.799 404.23 793.799Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.562 752.939C436.332 752.939 436.332 751.84 435.562 751.84C434.802 751.84 434.802 752.939 435.562 752.939Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.851 659.898C432.611 659.898 432.611 658.799 431.851 658.799C431.081 658.799 431.081 659.898 431.851 659.898Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.398 597.869C476.158 597.869 476.168 596.77 475.398 596.77C474.638 596.77 474.638 597.869 475.398 597.869Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.91 585.07C399.09 585.07 399.27 585.07 399.44 585.07C400.21 585.07 400.21 583.971 399.44 583.971C399.27 583.971 399.09 583.971 398.91 583.971C398.15 583.971 398.15 585.07 398.91 585.07Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.862 609.523C277.042 609.686 277.212 609.851 277.392 610.014C277.932 610.516 278.772 609.738 278.232 609.238C278.052 609.074 277.872 608.91 277.702 608.746C277.162 608.245 276.322 609.022 276.862 609.523Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.492 679.095C307.252 679.095 307.262 677.996 306.492 677.996C305.732 677.996 305.732 679.095 306.492 679.095Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.882 806.106C441.642 806.106 441.642 805.008 440.882 805.008C440.112 805.008 440.112 806.106 440.882 806.106Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.429 817.43C485.189 817.43 485.199 816.332 484.429 816.332C483.669 816.332 483.669 817.43 484.429 817.43Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.507 829.737C384.267 829.737 384.267 828.637 383.507 828.637C382.748 828.637 382.748 829.737 383.507 829.737Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.859 822.843C347.619 822.843 347.619 821.744 346.859 821.744C346.099 821.744 346.099 822.843 346.859 822.843Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.882 825.306C441.642 825.306 441.642 824.207 440.882 824.207C440.112 824.207 440.112 825.306 440.882 825.306Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.929 534.771C362.699 534.771 362.699 533.672 361.929 533.672C361.169 533.672 361.169 534.771 361.929 534.771Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.468 528.42C463.238 528.42 463.238 527.32 462.468 527.32C461.708 527.32 461.708 528.42 462.468 528.42Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.179 425.355C329.939 425.355 329.949 424.256 329.179 424.256C328.419 424.256 328.419 425.355 329.179 425.355Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.922 441.591C394.692 441.591 394.692 440.492 393.922 440.492C393.162 440.492 393.162 441.591 393.922 441.591Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.519 441.591C466.279 441.591 466.279 440.492 465.519 440.492C464.759 440.492 464.759 441.591 465.519 441.591Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.577 357.587C290.337 357.587 290.337 356.488 289.577 356.488C288.808 356.488 288.808 357.587 289.577 357.587Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.521 455.392C272.011 455.627 271.501 455.863 271.001 456.098C270.311 456.414 270.911 457.362 271.591 457.046C272.101 456.812 272.611 456.576 273.121 456.341C273.801 456.025 273.201 455.076 272.521 455.392Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.82 399.236C257.59 399.236 257.59 398.137 256.82 398.137C256.06 398.137 256.06 399.236 256.82 399.236Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.968 498.065C413.728 498.065 413.728 496.967 412.968 496.967C412.198 496.967 412.198 498.065 412.968 498.065Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.191 649.132C460.951 649.132 460.951 648.033 460.191 648.033C459.431 648.033 459.421 649.132 460.191 649.132Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.312 567.795C387.832 567.795 387.842 565.598 386.312 565.598C384.782 565.598 384.782 567.795 386.312 567.795Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.632 534.615C278.152 534.615 278.162 532.418 276.632 532.418C275.102 532.418 275.102 534.615 276.632 534.615Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.452 612.268C249.972 612.268 249.972 610.07 248.452 610.07C246.922 610.07 246.922 612.268 248.452 612.268Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.038 715.332C468.568 715.332 468.568 713.135 467.038 713.135C465.518 713.135 465.518 715.332 467.038 715.332Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.89 786.63C491.42 786.63 491.42 784.432 489.89 784.432C488.37 784.432 488.37 786.63 489.89 786.63Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M466.28 828.987C467.81 828.987 467.81 826.789 466.28 826.789C464.76 826.789 464.75 828.987 466.28 828.987Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.48 608.031C432.01 608.031 432.01 605.834 430.48 605.834C428.96 605.834 428.95 608.031 430.48 608.031Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.421 558.616C329.951 558.616 329.951 556.418 328.421 556.418C326.891 556.418 326.891 558.616 328.421 558.616Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.28 472.494C336.8 472.494 336.8 470.297 335.28 470.297C333.75 470.297 333.75 472.494 335.28 472.494Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.773 411.785C287.293 411.785 287.303 409.588 285.773 409.588C284.243 409.588 284.243 411.785 285.773 411.785Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.902 519.791C312.432 519.791 312.432 517.594 310.902 517.594C309.382 517.594 309.372 519.791 310.902 519.791Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.202 531.088C413.733 531.088 413.733 528.891 412.202 528.891C410.683 528.891 410.683 531.088 412.202 531.088Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.711 465.044C472.711 465.75 472.711 466.455 472.711 467.162C472.711 468.575 475.081 468.578 475.081 467.162C475.081 466.455 475.081 465.75 475.081 465.044C475.081 463.63 472.711 463.628 472.711 465.044Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.152 396.417C360.402 396.888 360.662 397.359 360.912 397.828C361.592 399.094 363.642 397.982 362.962 396.72C362.702 396.249 362.452 395.778 362.202 395.308C361.512 394.042 359.472 395.155 360.152 396.417Z",
    fill: "#FFFFFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtoilesBackground);
export default __webpack_public_path__ + "static/media/etoiles-background.6368e914b9da620c8ceda1e31883e496.svg";
export { ForwardRef as ReactComponent };